/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Attachment:{

	},
	Boolean_comparison_exp:{

	},
	Int_comparison_exp:{

	},
	String_comparison_exp:{

	},
	active_shift_aggregate_bool_exp:{
		count:"active_shift_aggregate_bool_exp_count"
	},
	active_shift_aggregate_bool_exp_count:{
		arguments:"active_shift_select_column",
		filter:"active_shift_bool_exp",
		predicate:"Int_comparison_exp"
	},
	active_shift_aggregate_fields:{
		count:{
			columns:"active_shift_select_column"
		}
	},
	active_shift_aggregate_order_by:{
		count:"order_by",
		max:"active_shift_max_order_by",
		min:"active_shift_min_order_by"
	},
	active_shift_arr_rel_insert_input:{
		data:"active_shift_insert_input",
		on_conflict:"active_shift_on_conflict"
	},
	active_shift_bool_exp:{
		_and:"active_shift_bool_exp",
		_not:"active_shift_bool_exp",
		_or:"active_shift_bool_exp",
		id:"uuid_comparison_exp",
		shift:"shift_bool_exp",
		shift_id:"uuid_comparison_exp",
		shift_type:"shift_type_t_comparison_exp"
	},
	active_shift_constraint: "enum" as const,
	active_shift_insert_input:{
		id:"uuid",
		shift:"shift_obj_rel_insert_input",
		shift_id:"uuid",
		shift_type:"shift_type_t"
	},
	active_shift_max_order_by:{
		id:"order_by",
		shift_id:"order_by",
		shift_type:"order_by"
	},
	active_shift_min_order_by:{
		id:"order_by",
		shift_id:"order_by",
		shift_type:"order_by"
	},
	active_shift_obj_rel_insert_input:{
		data:"active_shift_insert_input",
		on_conflict:"active_shift_on_conflict"
	},
	active_shift_on_conflict:{
		constraint:"active_shift_constraint",
		update_columns:"active_shift_update_column",
		where:"active_shift_bool_exp"
	},
	active_shift_order_by:{
		id:"order_by",
		shift:"shift_order_by",
		shift_id:"order_by",
		shift_type:"order_by"
	},
	active_shift_pk_columns_input:{
		id:"uuid"
	},
	active_shift_select_column: "enum" as const,
	active_shift_set_input:{
		id:"uuid",
		shift_id:"uuid",
		shift_type:"shift_type_t"
	},
	active_shift_stream_cursor_input:{
		initial_value:"active_shift_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	active_shift_stream_cursor_value_input:{
		id:"uuid",
		shift_id:"uuid",
		shift_type:"shift_type_t"
	},
	active_shift_update_column: "enum" as const,
	active_shift_updates:{
		_set:"active_shift_set_input",
		where:"active_shift_bool_exp"
	},
	cost_object:{
		event_cost_object_created:{
			distinct_on:"event_cost_object_created_select_column",
			order_by:"event_cost_object_created_order_by",
			where:"event_cost_object_created_bool_exp"
		},
		event_cost_object_created_aggregate:{
			distinct_on:"event_cost_object_created_select_column",
			order_by:"event_cost_object_created_order_by",
			where:"event_cost_object_created_bool_exp"
		},
		event_cost_object_deleted:{
			distinct_on:"event_cost_object_deleted_select_column",
			order_by:"event_cost_object_deleted_order_by",
			where:"event_cost_object_deleted_bool_exp"
		},
		event_cost_object_deleted_aggregate:{
			distinct_on:"event_cost_object_deleted_select_column",
			order_by:"event_cost_object_deleted_order_by",
			where:"event_cost_object_deleted_bool_exp"
		},
		event_cost_object_reactivated:{
			distinct_on:"event_cost_object_reactivated_select_column",
			order_by:"event_cost_object_reactivated_order_by",
			where:"event_cost_object_reactivated_bool_exp"
		},
		event_cost_object_reactivated_aggregate:{
			distinct_on:"event_cost_object_reactivated_select_column",
			order_by:"event_cost_object_reactivated_order_by",
			where:"event_cost_object_reactivated_bool_exp"
		},
		event_cost_object_updated:{
			distinct_on:"event_cost_object_updated_select_column",
			order_by:"event_cost_object_updated_order_by",
			where:"event_cost_object_updated_bool_exp"
		},
		event_cost_object_updated_aggregate:{
			distinct_on:"event_cost_object_updated_select_column",
			order_by:"event_cost_object_updated_order_by",
			where:"event_cost_object_updated_bool_exp"
		},
		teams:{
			distinct_on:"team_select_column",
			order_by:"team_order_by",
			where:"team_bool_exp"
		},
		teams_aggregate:{
			distinct_on:"team_select_column",
			order_by:"team_order_by",
			where:"team_bool_exp"
		}
	},
	cost_object_aggregate_fields:{
		count:{
			columns:"cost_object_select_column"
		}
	},
	cost_object_bool_exp:{
		_and:"cost_object_bool_exp",
		_not:"cost_object_bool_exp",
		_or:"cost_object_bool_exp",
		description:"String_comparison_exp",
		event_cost_object_created:"event_cost_object_created_bool_exp",
		event_cost_object_created_aggregate:"event_cost_object_created_aggregate_bool_exp",
		event_cost_object_deleted:"event_cost_object_deleted_bool_exp",
		event_cost_object_deleted_aggregate:"event_cost_object_deleted_aggregate_bool_exp",
		event_cost_object_reactivated:"event_cost_object_reactivated_bool_exp",
		event_cost_object_reactivated_aggregate:"event_cost_object_reactivated_aggregate_bool_exp",
		event_cost_object_updated:"event_cost_object_updated_bool_exp",
		event_cost_object_updated_aggregate:"event_cost_object_updated_aggregate_bool_exp",
		id:"uuid_comparison_exp",
		internal_order_number:"String_comparison_exp",
		order_type:"String_comparison_exp",
		owner_number:"String_comparison_exp",
		record_status:"record_status_t_comparison_exp",
		teams:"team_bool_exp",
		teams_aggregate:"team_aggregate_bool_exp"
	},
	cost_object_constraint: "enum" as const,
	cost_object_insert_input:{
		event_cost_object_created:"event_cost_object_created_arr_rel_insert_input",
		event_cost_object_deleted:"event_cost_object_deleted_arr_rel_insert_input",
		event_cost_object_reactivated:"event_cost_object_reactivated_arr_rel_insert_input",
		event_cost_object_updated:"event_cost_object_updated_arr_rel_insert_input",
		id:"uuid",
		record_status:"record_status_t",
		teams:"team_arr_rel_insert_input"
	},
	cost_object_obj_rel_insert_input:{
		data:"cost_object_insert_input",
		on_conflict:"cost_object_on_conflict"
	},
	cost_object_on_conflict:{
		constraint:"cost_object_constraint",
		update_columns:"cost_object_update_column",
		where:"cost_object_bool_exp"
	},
	cost_object_order_by:{
		description:"order_by",
		event_cost_object_created_aggregate:"event_cost_object_created_aggregate_order_by",
		event_cost_object_deleted_aggregate:"event_cost_object_deleted_aggregate_order_by",
		event_cost_object_reactivated_aggregate:"event_cost_object_reactivated_aggregate_order_by",
		event_cost_object_updated_aggregate:"event_cost_object_updated_aggregate_order_by",
		id:"order_by",
		internal_order_number:"order_by",
		order_type:"order_by",
		owner_number:"order_by",
		record_status:"order_by",
		teams_aggregate:"team_aggregate_order_by"
	},
	cost_object_pk_columns_input:{
		id:"uuid"
	},
	cost_object_select_column: "enum" as const,
	cost_object_set_input:{
		id:"uuid",
		record_status:"record_status_t"
	},
	cost_object_stream_cursor_input:{
		initial_value:"cost_object_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	cost_object_stream_cursor_value_input:{
		id:"uuid",
		record_status:"record_status_t"
	},
	cost_object_update_column: "enum" as const,
	cost_object_updates:{
		_set:"cost_object_set_input",
		where:"cost_object_bool_exp"
	},
	cursor_ordering: "enum" as const,
	date: `scalar.date` as const,
	date_comparison_exp:{
		_eq:"date",
		_gt:"date",
		_gte:"date",
		_in:"date",
		_lt:"date",
		_lte:"date",
		_neq:"date",
		_nin:"date"
	},
	event:{
		new:{

		},
		old:{

		},
		payload:{

		},
		user_role_assignment_notifications:{
			distinct_on:"user_notification_select_column",
			order_by:"user_notification_order_by",
			where:"user_notification_bool_exp"
		},
		user_role_assignment_notifications_aggregate:{
			distinct_on:"user_notification_select_column",
			order_by:"user_notification_order_by",
			where:"user_notification_bool_exp"
		}
	},
	event_aggregate_bool_exp:{
		count:"event_aggregate_bool_exp_count"
	},
	event_aggregate_bool_exp_count:{
		arguments:"event_select_column",
		filter:"event_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_aggregate_fields:{
		count:{
			columns:"event_select_column"
		}
	},
	event_aggregate_order_by:{
		avg:"event_avg_order_by",
		count:"order_by",
		max:"event_max_order_by",
		min:"event_min_order_by",
		stddev:"event_stddev_order_by",
		stddev_pop:"event_stddev_pop_order_by",
		stddev_samp:"event_stddev_samp_order_by",
		sum:"event_sum_order_by",
		var_pop:"event_var_pop_order_by",
		var_samp:"event_var_samp_order_by",
		variance:"event_variance_order_by"
	},
	event_append_input:{
		new:"jsonb",
		old:"jsonb",
		payload:"jsonb"
	},
	event_arr_rel_insert_input:{
		data:"event_insert_input",
		on_conflict:"event_on_conflict"
	},
	event_avg_order_by:{
		id:"order_by"
	},
	event_bool_exp:{
		_and:"event_bool_exp",
		_not:"event_bool_exp",
		_or:"event_bool_exp",
		created_at:"timestamptz_comparison_exp",
		created_by:"uuid_comparison_exp",
		event_buffered_shift_ended:"event_buffered_shift_ended_bool_exp",
		event_buffered_shift_started:"event_buffered_shift_started_bool_exp",
		event_cost_object_created:"event_cost_object_created_bool_exp",
		event_cost_object_deleted:"event_cost_object_deleted_bool_exp",
		event_cost_object_reactivated:"event_cost_object_reactivated_bool_exp",
		event_cost_object_updated:"event_cost_object_updated_bool_exp",
		event_derived_shift_deleted:"event_derived_shift_deleted_bool_exp",
		event_derived_shift_updated:"event_derived_shift_updated_bool_exp",
		event_note_created:"event_note_created_bool_exp",
		event_note_deleted:"event_note_deleted_bool_exp",
		event_note_updated:"event_note_updated_bool_exp",
		event_recurring_shift_exception_created:"event_recurring_shift_exception_created_bool_exp",
		event_shift_created:"event_shift_created_bool_exp",
		event_shift_deleted:"event_shift_deleted_bool_exp",
		event_shift_ended:"event_shift_ended_bool_exp",
		event_shift_started:"event_shift_started_bool_exp",
		event_shift_updated:"event_shift_updated_bool_exp",
		event_team_created:"event_team_created_bool_exp",
		event_team_deleted:"event_team_deleted_bool_exp",
		event_team_reactivated:"event_team_reactivated_bool_exp",
		event_team_role_assignment_created:"event_team_role_assignment_created_bool_exp",
		event_team_role_assignment_deleted:"event_team_role_assignment_deleted_bool_exp",
		event_team_role_created:"event_team_role_created_bool_exp",
		event_team_role_deleted:"event_team_role_deleted_bool_exp",
		event_team_role_updated:"event_team_role_updated_bool_exp",
		event_team_updated:"event_team_updated_bool_exp",
		event_type:"event_type_t_comparison_exp",
		event_user_created:"event_user_created_bool_exp",
		event_user_deleted:"event_user_deleted_bool_exp",
		event_user_role_assignment_created:"event_user_role_assignment_created_bool_exp",
		event_user_role_assignment_deleted:"event_user_role_assignment_deleted_bool_exp",
		event_user_role_assignment_updated:"event_user_role_assignment_updated_bool_exp",
		event_user_updated:"event_user_updated_bool_exp",
		external_id:"String_comparison_exp",
		id:"Int_comparison_exp",
		new:"jsonb_comparison_exp",
		old:"jsonb_comparison_exp",
		payload:"jsonb_comparison_exp",
		team:"team_bool_exp",
		team_id:"uuid_comparison_exp",
		user:"user_bool_exp",
		user_created_by:"user_bool_exp",
		user_id:"uuid_comparison_exp",
		user_role_assignment_notifications:"user_notification_bool_exp",
		user_role_assignment_notifications_aggregate:"user_notification_aggregate_bool_exp"
	},
	event_buffered_shift_ended_aggregate_bool_exp:{
		count:"event_buffered_shift_ended_aggregate_bool_exp_count"
	},
	event_buffered_shift_ended_aggregate_bool_exp_count:{
		arguments:"event_buffered_shift_ended_select_column",
		filter:"event_buffered_shift_ended_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_buffered_shift_ended_aggregate_fields:{
		count:{
			columns:"event_buffered_shift_ended_select_column"
		}
	},
	event_buffered_shift_ended_aggregate_order_by:{
		avg:"event_buffered_shift_ended_avg_order_by",
		count:"order_by",
		max:"event_buffered_shift_ended_max_order_by",
		min:"event_buffered_shift_ended_min_order_by",
		stddev:"event_buffered_shift_ended_stddev_order_by",
		stddev_pop:"event_buffered_shift_ended_stddev_pop_order_by",
		stddev_samp:"event_buffered_shift_ended_stddev_samp_order_by",
		sum:"event_buffered_shift_ended_sum_order_by",
		var_pop:"event_buffered_shift_ended_var_pop_order_by",
		var_samp:"event_buffered_shift_ended_var_samp_order_by",
		variance:"event_buffered_shift_ended_variance_order_by"
	},
	event_buffered_shift_ended_arr_rel_insert_input:{
		data:"event_buffered_shift_ended_insert_input",
		on_conflict:"event_buffered_shift_ended_on_conflict"
	},
	event_buffered_shift_ended_avg_order_by:{
		id:"order_by"
	},
	event_buffered_shift_ended_bool_exp:{
		_and:"event_buffered_shift_ended_bool_exp",
		_not:"event_buffered_shift_ended_bool_exp",
		_or:"event_buffered_shift_ended_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		shift:"shift_bool_exp",
		shift_id:"uuid_comparison_exp"
	},
	event_buffered_shift_ended_constraint: "enum" as const,
	event_buffered_shift_ended_inc_input:{

	},
	event_buffered_shift_ended_insert_input:{
		event:"event_obj_rel_insert_input",
		shift:"shift_obj_rel_insert_input",
		shift_id:"uuid"
	},
	event_buffered_shift_ended_max_order_by:{
		id:"order_by",
		shift_id:"order_by"
	},
	event_buffered_shift_ended_min_order_by:{
		id:"order_by",
		shift_id:"order_by"
	},
	event_buffered_shift_ended_obj_rel_insert_input:{
		data:"event_buffered_shift_ended_insert_input",
		on_conflict:"event_buffered_shift_ended_on_conflict"
	},
	event_buffered_shift_ended_on_conflict:{
		constraint:"event_buffered_shift_ended_constraint",
		update_columns:"event_buffered_shift_ended_update_column",
		where:"event_buffered_shift_ended_bool_exp"
	},
	event_buffered_shift_ended_order_by:{
		event:"event_order_by",
		id:"order_by",
		shift:"shift_order_by",
		shift_id:"order_by"
	},
	event_buffered_shift_ended_pk_columns_input:{

	},
	event_buffered_shift_ended_select_column: "enum" as const,
	event_buffered_shift_ended_set_input:{
		shift_id:"uuid"
	},
	event_buffered_shift_ended_stddev_order_by:{
		id:"order_by"
	},
	event_buffered_shift_ended_stddev_pop_order_by:{
		id:"order_by"
	},
	event_buffered_shift_ended_stddev_samp_order_by:{
		id:"order_by"
	},
	event_buffered_shift_ended_stream_cursor_input:{
		initial_value:"event_buffered_shift_ended_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_buffered_shift_ended_stream_cursor_value_input:{
		shift_id:"uuid"
	},
	event_buffered_shift_ended_sum_order_by:{
		id:"order_by"
	},
	event_buffered_shift_ended_update_column: "enum" as const,
	event_buffered_shift_ended_updates:{
		_inc:"event_buffered_shift_ended_inc_input",
		_set:"event_buffered_shift_ended_set_input",
		where:"event_buffered_shift_ended_bool_exp"
	},
	event_buffered_shift_ended_var_pop_order_by:{
		id:"order_by"
	},
	event_buffered_shift_ended_var_samp_order_by:{
		id:"order_by"
	},
	event_buffered_shift_ended_variance_order_by:{
		id:"order_by"
	},
	event_buffered_shift_started_aggregate_bool_exp:{
		count:"event_buffered_shift_started_aggregate_bool_exp_count"
	},
	event_buffered_shift_started_aggregate_bool_exp_count:{
		arguments:"event_buffered_shift_started_select_column",
		filter:"event_buffered_shift_started_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_buffered_shift_started_aggregate_fields:{
		count:{
			columns:"event_buffered_shift_started_select_column"
		}
	},
	event_buffered_shift_started_aggregate_order_by:{
		avg:"event_buffered_shift_started_avg_order_by",
		count:"order_by",
		max:"event_buffered_shift_started_max_order_by",
		min:"event_buffered_shift_started_min_order_by",
		stddev:"event_buffered_shift_started_stddev_order_by",
		stddev_pop:"event_buffered_shift_started_stddev_pop_order_by",
		stddev_samp:"event_buffered_shift_started_stddev_samp_order_by",
		sum:"event_buffered_shift_started_sum_order_by",
		var_pop:"event_buffered_shift_started_var_pop_order_by",
		var_samp:"event_buffered_shift_started_var_samp_order_by",
		variance:"event_buffered_shift_started_variance_order_by"
	},
	event_buffered_shift_started_arr_rel_insert_input:{
		data:"event_buffered_shift_started_insert_input",
		on_conflict:"event_buffered_shift_started_on_conflict"
	},
	event_buffered_shift_started_avg_order_by:{
		id:"order_by"
	},
	event_buffered_shift_started_bool_exp:{
		_and:"event_buffered_shift_started_bool_exp",
		_not:"event_buffered_shift_started_bool_exp",
		_or:"event_buffered_shift_started_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		shift:"shift_bool_exp",
		shift_id:"uuid_comparison_exp"
	},
	event_buffered_shift_started_constraint: "enum" as const,
	event_buffered_shift_started_inc_input:{

	},
	event_buffered_shift_started_insert_input:{
		event:"event_obj_rel_insert_input",
		shift:"shift_obj_rel_insert_input",
		shift_id:"uuid"
	},
	event_buffered_shift_started_max_order_by:{
		id:"order_by",
		shift_id:"order_by"
	},
	event_buffered_shift_started_min_order_by:{
		id:"order_by",
		shift_id:"order_by"
	},
	event_buffered_shift_started_obj_rel_insert_input:{
		data:"event_buffered_shift_started_insert_input",
		on_conflict:"event_buffered_shift_started_on_conflict"
	},
	event_buffered_shift_started_on_conflict:{
		constraint:"event_buffered_shift_started_constraint",
		update_columns:"event_buffered_shift_started_update_column",
		where:"event_buffered_shift_started_bool_exp"
	},
	event_buffered_shift_started_order_by:{
		event:"event_order_by",
		id:"order_by",
		shift:"shift_order_by",
		shift_id:"order_by"
	},
	event_buffered_shift_started_pk_columns_input:{

	},
	event_buffered_shift_started_select_column: "enum" as const,
	event_buffered_shift_started_set_input:{
		shift_id:"uuid"
	},
	event_buffered_shift_started_stddev_order_by:{
		id:"order_by"
	},
	event_buffered_shift_started_stddev_pop_order_by:{
		id:"order_by"
	},
	event_buffered_shift_started_stddev_samp_order_by:{
		id:"order_by"
	},
	event_buffered_shift_started_stream_cursor_input:{
		initial_value:"event_buffered_shift_started_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_buffered_shift_started_stream_cursor_value_input:{
		shift_id:"uuid"
	},
	event_buffered_shift_started_sum_order_by:{
		id:"order_by"
	},
	event_buffered_shift_started_update_column: "enum" as const,
	event_buffered_shift_started_updates:{
		_inc:"event_buffered_shift_started_inc_input",
		_set:"event_buffered_shift_started_set_input",
		where:"event_buffered_shift_started_bool_exp"
	},
	event_buffered_shift_started_var_pop_order_by:{
		id:"order_by"
	},
	event_buffered_shift_started_var_samp_order_by:{
		id:"order_by"
	},
	event_buffered_shift_started_variance_order_by:{
		id:"order_by"
	},
	event_constraint: "enum" as const,
	event_cost_object_created_aggregate_bool_exp:{
		count:"event_cost_object_created_aggregate_bool_exp_count"
	},
	event_cost_object_created_aggregate_bool_exp_count:{
		arguments:"event_cost_object_created_select_column",
		filter:"event_cost_object_created_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_cost_object_created_aggregate_fields:{
		count:{
			columns:"event_cost_object_created_select_column"
		}
	},
	event_cost_object_created_aggregate_order_by:{
		avg:"event_cost_object_created_avg_order_by",
		count:"order_by",
		max:"event_cost_object_created_max_order_by",
		min:"event_cost_object_created_min_order_by",
		stddev:"event_cost_object_created_stddev_order_by",
		stddev_pop:"event_cost_object_created_stddev_pop_order_by",
		stddev_samp:"event_cost_object_created_stddev_samp_order_by",
		sum:"event_cost_object_created_sum_order_by",
		var_pop:"event_cost_object_created_var_pop_order_by",
		var_samp:"event_cost_object_created_var_samp_order_by",
		variance:"event_cost_object_created_variance_order_by"
	},
	event_cost_object_created_arr_rel_insert_input:{
		data:"event_cost_object_created_insert_input",
		on_conflict:"event_cost_object_created_on_conflict"
	},
	event_cost_object_created_avg_order_by:{
		id:"order_by"
	},
	event_cost_object_created_bool_exp:{
		_and:"event_cost_object_created_bool_exp",
		_not:"event_cost_object_created_bool_exp",
		_or:"event_cost_object_created_bool_exp",
		cost_object:"cost_object_bool_exp",
		cost_object_id:"uuid_comparison_exp",
		description:"String_comparison_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		internal_order_number:"String_comparison_exp",
		order_type:"String_comparison_exp",
		owner_number:"String_comparison_exp",
		record_status:"record_status_t_comparison_exp"
	},
	event_cost_object_created_constraint: "enum" as const,
	event_cost_object_created_inc_input:{

	},
	event_cost_object_created_insert_input:{
		cost_object:"cost_object_obj_rel_insert_input",
		cost_object_id:"uuid",
		event:"event_obj_rel_insert_input",
		record_status:"record_status_t"
	},
	event_cost_object_created_max_order_by:{
		cost_object_id:"order_by",
		description:"order_by",
		id:"order_by",
		internal_order_number:"order_by",
		order_type:"order_by",
		owner_number:"order_by",
		record_status:"order_by"
	},
	event_cost_object_created_min_order_by:{
		cost_object_id:"order_by",
		description:"order_by",
		id:"order_by",
		internal_order_number:"order_by",
		order_type:"order_by",
		owner_number:"order_by",
		record_status:"order_by"
	},
	event_cost_object_created_obj_rel_insert_input:{
		data:"event_cost_object_created_insert_input",
		on_conflict:"event_cost_object_created_on_conflict"
	},
	event_cost_object_created_on_conflict:{
		constraint:"event_cost_object_created_constraint",
		update_columns:"event_cost_object_created_update_column",
		where:"event_cost_object_created_bool_exp"
	},
	event_cost_object_created_order_by:{
		cost_object:"cost_object_order_by",
		cost_object_id:"order_by",
		description:"order_by",
		event:"event_order_by",
		id:"order_by",
		internal_order_number:"order_by",
		order_type:"order_by",
		owner_number:"order_by",
		record_status:"order_by"
	},
	event_cost_object_created_pk_columns_input:{

	},
	event_cost_object_created_select_column: "enum" as const,
	event_cost_object_created_set_input:{
		cost_object_id:"uuid",
		record_status:"record_status_t"
	},
	event_cost_object_created_stddev_order_by:{
		id:"order_by"
	},
	event_cost_object_created_stddev_pop_order_by:{
		id:"order_by"
	},
	event_cost_object_created_stddev_samp_order_by:{
		id:"order_by"
	},
	event_cost_object_created_stream_cursor_input:{
		initial_value:"event_cost_object_created_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_cost_object_created_stream_cursor_value_input:{
		cost_object_id:"uuid",
		record_status:"record_status_t"
	},
	event_cost_object_created_sum_order_by:{
		id:"order_by"
	},
	event_cost_object_created_update_column: "enum" as const,
	event_cost_object_created_updates:{
		_inc:"event_cost_object_created_inc_input",
		_set:"event_cost_object_created_set_input",
		where:"event_cost_object_created_bool_exp"
	},
	event_cost_object_created_var_pop_order_by:{
		id:"order_by"
	},
	event_cost_object_created_var_samp_order_by:{
		id:"order_by"
	},
	event_cost_object_created_variance_order_by:{
		id:"order_by"
	},
	event_cost_object_deleted_aggregate_bool_exp:{
		count:"event_cost_object_deleted_aggregate_bool_exp_count"
	},
	event_cost_object_deleted_aggregate_bool_exp_count:{
		arguments:"event_cost_object_deleted_select_column",
		filter:"event_cost_object_deleted_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_cost_object_deleted_aggregate_fields:{
		count:{
			columns:"event_cost_object_deleted_select_column"
		}
	},
	event_cost_object_deleted_aggregate_order_by:{
		avg:"event_cost_object_deleted_avg_order_by",
		count:"order_by",
		max:"event_cost_object_deleted_max_order_by",
		min:"event_cost_object_deleted_min_order_by",
		stddev:"event_cost_object_deleted_stddev_order_by",
		stddev_pop:"event_cost_object_deleted_stddev_pop_order_by",
		stddev_samp:"event_cost_object_deleted_stddev_samp_order_by",
		sum:"event_cost_object_deleted_sum_order_by",
		var_pop:"event_cost_object_deleted_var_pop_order_by",
		var_samp:"event_cost_object_deleted_var_samp_order_by",
		variance:"event_cost_object_deleted_variance_order_by"
	},
	event_cost_object_deleted_arr_rel_insert_input:{
		data:"event_cost_object_deleted_insert_input",
		on_conflict:"event_cost_object_deleted_on_conflict"
	},
	event_cost_object_deleted_avg_order_by:{
		id:"order_by"
	},
	event_cost_object_deleted_bool_exp:{
		_and:"event_cost_object_deleted_bool_exp",
		_not:"event_cost_object_deleted_bool_exp",
		_or:"event_cost_object_deleted_bool_exp",
		cost_object:"cost_object_bool_exp",
		cost_object_id:"uuid_comparison_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp"
	},
	event_cost_object_deleted_constraint: "enum" as const,
	event_cost_object_deleted_inc_input:{

	},
	event_cost_object_deleted_insert_input:{
		cost_object:"cost_object_obj_rel_insert_input",
		cost_object_id:"uuid",
		event:"event_obj_rel_insert_input"
	},
	event_cost_object_deleted_max_order_by:{
		cost_object_id:"order_by",
		id:"order_by"
	},
	event_cost_object_deleted_min_order_by:{
		cost_object_id:"order_by",
		id:"order_by"
	},
	event_cost_object_deleted_obj_rel_insert_input:{
		data:"event_cost_object_deleted_insert_input",
		on_conflict:"event_cost_object_deleted_on_conflict"
	},
	event_cost_object_deleted_on_conflict:{
		constraint:"event_cost_object_deleted_constraint",
		update_columns:"event_cost_object_deleted_update_column",
		where:"event_cost_object_deleted_bool_exp"
	},
	event_cost_object_deleted_order_by:{
		cost_object:"cost_object_order_by",
		cost_object_id:"order_by",
		event:"event_order_by",
		id:"order_by"
	},
	event_cost_object_deleted_pk_columns_input:{

	},
	event_cost_object_deleted_select_column: "enum" as const,
	event_cost_object_deleted_set_input:{
		cost_object_id:"uuid"
	},
	event_cost_object_deleted_stddev_order_by:{
		id:"order_by"
	},
	event_cost_object_deleted_stddev_pop_order_by:{
		id:"order_by"
	},
	event_cost_object_deleted_stddev_samp_order_by:{
		id:"order_by"
	},
	event_cost_object_deleted_stream_cursor_input:{
		initial_value:"event_cost_object_deleted_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_cost_object_deleted_stream_cursor_value_input:{
		cost_object_id:"uuid"
	},
	event_cost_object_deleted_sum_order_by:{
		id:"order_by"
	},
	event_cost_object_deleted_update_column: "enum" as const,
	event_cost_object_deleted_updates:{
		_inc:"event_cost_object_deleted_inc_input",
		_set:"event_cost_object_deleted_set_input",
		where:"event_cost_object_deleted_bool_exp"
	},
	event_cost_object_deleted_var_pop_order_by:{
		id:"order_by"
	},
	event_cost_object_deleted_var_samp_order_by:{
		id:"order_by"
	},
	event_cost_object_deleted_variance_order_by:{
		id:"order_by"
	},
	event_cost_object_reactivated_aggregate_bool_exp:{
		count:"event_cost_object_reactivated_aggregate_bool_exp_count"
	},
	event_cost_object_reactivated_aggregate_bool_exp_count:{
		arguments:"event_cost_object_reactivated_select_column",
		filter:"event_cost_object_reactivated_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_cost_object_reactivated_aggregate_fields:{
		count:{
			columns:"event_cost_object_reactivated_select_column"
		}
	},
	event_cost_object_reactivated_aggregate_order_by:{
		avg:"event_cost_object_reactivated_avg_order_by",
		count:"order_by",
		max:"event_cost_object_reactivated_max_order_by",
		min:"event_cost_object_reactivated_min_order_by",
		stddev:"event_cost_object_reactivated_stddev_order_by",
		stddev_pop:"event_cost_object_reactivated_stddev_pop_order_by",
		stddev_samp:"event_cost_object_reactivated_stddev_samp_order_by",
		sum:"event_cost_object_reactivated_sum_order_by",
		var_pop:"event_cost_object_reactivated_var_pop_order_by",
		var_samp:"event_cost_object_reactivated_var_samp_order_by",
		variance:"event_cost_object_reactivated_variance_order_by"
	},
	event_cost_object_reactivated_arr_rel_insert_input:{
		data:"event_cost_object_reactivated_insert_input",
		on_conflict:"event_cost_object_reactivated_on_conflict"
	},
	event_cost_object_reactivated_avg_order_by:{
		id:"order_by"
	},
	event_cost_object_reactivated_bool_exp:{
		_and:"event_cost_object_reactivated_bool_exp",
		_not:"event_cost_object_reactivated_bool_exp",
		_or:"event_cost_object_reactivated_bool_exp",
		cost_object:"cost_object_bool_exp",
		cost_object_id:"uuid_comparison_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp"
	},
	event_cost_object_reactivated_constraint: "enum" as const,
	event_cost_object_reactivated_inc_input:{

	},
	event_cost_object_reactivated_insert_input:{
		cost_object:"cost_object_obj_rel_insert_input",
		cost_object_id:"uuid",
		event:"event_obj_rel_insert_input"
	},
	event_cost_object_reactivated_max_order_by:{
		cost_object_id:"order_by",
		id:"order_by"
	},
	event_cost_object_reactivated_min_order_by:{
		cost_object_id:"order_by",
		id:"order_by"
	},
	event_cost_object_reactivated_obj_rel_insert_input:{
		data:"event_cost_object_reactivated_insert_input",
		on_conflict:"event_cost_object_reactivated_on_conflict"
	},
	event_cost_object_reactivated_on_conflict:{
		constraint:"event_cost_object_reactivated_constraint",
		update_columns:"event_cost_object_reactivated_update_column",
		where:"event_cost_object_reactivated_bool_exp"
	},
	event_cost_object_reactivated_order_by:{
		cost_object:"cost_object_order_by",
		cost_object_id:"order_by",
		event:"event_order_by",
		id:"order_by"
	},
	event_cost_object_reactivated_pk_columns_input:{

	},
	event_cost_object_reactivated_select_column: "enum" as const,
	event_cost_object_reactivated_set_input:{
		cost_object_id:"uuid"
	},
	event_cost_object_reactivated_stddev_order_by:{
		id:"order_by"
	},
	event_cost_object_reactivated_stddev_pop_order_by:{
		id:"order_by"
	},
	event_cost_object_reactivated_stddev_samp_order_by:{
		id:"order_by"
	},
	event_cost_object_reactivated_stream_cursor_input:{
		initial_value:"event_cost_object_reactivated_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_cost_object_reactivated_stream_cursor_value_input:{
		cost_object_id:"uuid"
	},
	event_cost_object_reactivated_sum_order_by:{
		id:"order_by"
	},
	event_cost_object_reactivated_update_column: "enum" as const,
	event_cost_object_reactivated_updates:{
		_inc:"event_cost_object_reactivated_inc_input",
		_set:"event_cost_object_reactivated_set_input",
		where:"event_cost_object_reactivated_bool_exp"
	},
	event_cost_object_reactivated_var_pop_order_by:{
		id:"order_by"
	},
	event_cost_object_reactivated_var_samp_order_by:{
		id:"order_by"
	},
	event_cost_object_reactivated_variance_order_by:{
		id:"order_by"
	},
	event_cost_object_updated_aggregate_bool_exp:{
		count:"event_cost_object_updated_aggregate_bool_exp_count"
	},
	event_cost_object_updated_aggregate_bool_exp_count:{
		arguments:"event_cost_object_updated_select_column",
		filter:"event_cost_object_updated_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_cost_object_updated_aggregate_fields:{
		count:{
			columns:"event_cost_object_updated_select_column"
		}
	},
	event_cost_object_updated_aggregate_order_by:{
		avg:"event_cost_object_updated_avg_order_by",
		count:"order_by",
		max:"event_cost_object_updated_max_order_by",
		min:"event_cost_object_updated_min_order_by",
		stddev:"event_cost_object_updated_stddev_order_by",
		stddev_pop:"event_cost_object_updated_stddev_pop_order_by",
		stddev_samp:"event_cost_object_updated_stddev_samp_order_by",
		sum:"event_cost_object_updated_sum_order_by",
		var_pop:"event_cost_object_updated_var_pop_order_by",
		var_samp:"event_cost_object_updated_var_samp_order_by",
		variance:"event_cost_object_updated_variance_order_by"
	},
	event_cost_object_updated_arr_rel_insert_input:{
		data:"event_cost_object_updated_insert_input",
		on_conflict:"event_cost_object_updated_on_conflict"
	},
	event_cost_object_updated_avg_order_by:{
		id:"order_by"
	},
	event_cost_object_updated_bool_exp:{
		_and:"event_cost_object_updated_bool_exp",
		_not:"event_cost_object_updated_bool_exp",
		_or:"event_cost_object_updated_bool_exp",
		cost_object:"cost_object_bool_exp",
		cost_object_id:"uuid_comparison_exp",
		description:"String_comparison_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		order_type:"String_comparison_exp",
		owner_number:"String_comparison_exp"
	},
	event_cost_object_updated_constraint: "enum" as const,
	event_cost_object_updated_inc_input:{

	},
	event_cost_object_updated_insert_input:{
		cost_object:"cost_object_obj_rel_insert_input",
		cost_object_id:"uuid",
		event:"event_obj_rel_insert_input"
	},
	event_cost_object_updated_max_order_by:{
		cost_object_id:"order_by",
		description:"order_by",
		id:"order_by",
		order_type:"order_by",
		owner_number:"order_by"
	},
	event_cost_object_updated_min_order_by:{
		cost_object_id:"order_by",
		description:"order_by",
		id:"order_by",
		order_type:"order_by",
		owner_number:"order_by"
	},
	event_cost_object_updated_obj_rel_insert_input:{
		data:"event_cost_object_updated_insert_input",
		on_conflict:"event_cost_object_updated_on_conflict"
	},
	event_cost_object_updated_on_conflict:{
		constraint:"event_cost_object_updated_constraint",
		update_columns:"event_cost_object_updated_update_column",
		where:"event_cost_object_updated_bool_exp"
	},
	event_cost_object_updated_order_by:{
		cost_object:"cost_object_order_by",
		cost_object_id:"order_by",
		description:"order_by",
		event:"event_order_by",
		id:"order_by",
		order_type:"order_by",
		owner_number:"order_by"
	},
	event_cost_object_updated_pk_columns_input:{

	},
	event_cost_object_updated_select_column: "enum" as const,
	event_cost_object_updated_set_input:{
		cost_object_id:"uuid"
	},
	event_cost_object_updated_stddev_order_by:{
		id:"order_by"
	},
	event_cost_object_updated_stddev_pop_order_by:{
		id:"order_by"
	},
	event_cost_object_updated_stddev_samp_order_by:{
		id:"order_by"
	},
	event_cost_object_updated_stream_cursor_input:{
		initial_value:"event_cost_object_updated_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_cost_object_updated_stream_cursor_value_input:{
		cost_object_id:"uuid"
	},
	event_cost_object_updated_sum_order_by:{
		id:"order_by"
	},
	event_cost_object_updated_update_column: "enum" as const,
	event_cost_object_updated_updates:{
		_inc:"event_cost_object_updated_inc_input",
		_set:"event_cost_object_updated_set_input",
		where:"event_cost_object_updated_bool_exp"
	},
	event_cost_object_updated_var_pop_order_by:{
		id:"order_by"
	},
	event_cost_object_updated_var_samp_order_by:{
		id:"order_by"
	},
	event_cost_object_updated_variance_order_by:{
		id:"order_by"
	},
	event_delete_at_path_input:{

	},
	event_delete_elem_input:{

	},
	event_delete_key_input:{

	},
	event_derived_shift_deleted_aggregate_bool_exp:{
		count:"event_derived_shift_deleted_aggregate_bool_exp_count"
	},
	event_derived_shift_deleted_aggregate_bool_exp_count:{
		arguments:"event_derived_shift_deleted_select_column",
		filter:"event_derived_shift_deleted_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_derived_shift_deleted_aggregate_fields:{
		count:{
			columns:"event_derived_shift_deleted_select_column"
		}
	},
	event_derived_shift_deleted_aggregate_order_by:{
		avg:"event_derived_shift_deleted_avg_order_by",
		count:"order_by",
		max:"event_derived_shift_deleted_max_order_by",
		min:"event_derived_shift_deleted_min_order_by",
		stddev:"event_derived_shift_deleted_stddev_order_by",
		stddev_pop:"event_derived_shift_deleted_stddev_pop_order_by",
		stddev_samp:"event_derived_shift_deleted_stddev_samp_order_by",
		sum:"event_derived_shift_deleted_sum_order_by",
		var_pop:"event_derived_shift_deleted_var_pop_order_by",
		var_samp:"event_derived_shift_deleted_var_samp_order_by",
		variance:"event_derived_shift_deleted_variance_order_by"
	},
	event_derived_shift_deleted_arr_rel_insert_input:{
		data:"event_derived_shift_deleted_insert_input",
		on_conflict:"event_derived_shift_deleted_on_conflict"
	},
	event_derived_shift_deleted_avg_order_by:{
		id:"order_by"
	},
	event_derived_shift_deleted_bool_exp:{
		_and:"event_derived_shift_deleted_bool_exp",
		_not:"event_derived_shift_deleted_bool_exp",
		_or:"event_derived_shift_deleted_bool_exp",
		event:"event_bool_exp",
		exception_date:"timestamptz_comparison_exp",
		id:"Int_comparison_exp",
		recurring_shift_exception_id:"uuid_comparison_exp",
		recurring_shift_id:"uuid_comparison_exp",
		shift:"shift_bool_exp"
	},
	event_derived_shift_deleted_constraint: "enum" as const,
	event_derived_shift_deleted_inc_input:{

	},
	event_derived_shift_deleted_insert_input:{
		event:"event_obj_rel_insert_input",
		exception_date:"timestamptz",
		recurring_shift_exception_id:"uuid",
		recurring_shift_id:"uuid",
		shift:"shift_obj_rel_insert_input"
	},
	event_derived_shift_deleted_max_order_by:{
		exception_date:"order_by",
		id:"order_by",
		recurring_shift_exception_id:"order_by",
		recurring_shift_id:"order_by"
	},
	event_derived_shift_deleted_min_order_by:{
		exception_date:"order_by",
		id:"order_by",
		recurring_shift_exception_id:"order_by",
		recurring_shift_id:"order_by"
	},
	event_derived_shift_deleted_obj_rel_insert_input:{
		data:"event_derived_shift_deleted_insert_input",
		on_conflict:"event_derived_shift_deleted_on_conflict"
	},
	event_derived_shift_deleted_on_conflict:{
		constraint:"event_derived_shift_deleted_constraint",
		update_columns:"event_derived_shift_deleted_update_column",
		where:"event_derived_shift_deleted_bool_exp"
	},
	event_derived_shift_deleted_order_by:{
		event:"event_order_by",
		exception_date:"order_by",
		id:"order_by",
		recurring_shift_exception_id:"order_by",
		recurring_shift_id:"order_by",
		shift:"shift_order_by"
	},
	event_derived_shift_deleted_pk_columns_input:{

	},
	event_derived_shift_deleted_select_column: "enum" as const,
	event_derived_shift_deleted_set_input:{
		exception_date:"timestamptz",
		recurring_shift_exception_id:"uuid",
		recurring_shift_id:"uuid"
	},
	event_derived_shift_deleted_stddev_order_by:{
		id:"order_by"
	},
	event_derived_shift_deleted_stddev_pop_order_by:{
		id:"order_by"
	},
	event_derived_shift_deleted_stddev_samp_order_by:{
		id:"order_by"
	},
	event_derived_shift_deleted_stream_cursor_input:{
		initial_value:"event_derived_shift_deleted_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_derived_shift_deleted_stream_cursor_value_input:{
		exception_date:"timestamptz",
		recurring_shift_exception_id:"uuid",
		recurring_shift_id:"uuid"
	},
	event_derived_shift_deleted_sum_order_by:{
		id:"order_by"
	},
	event_derived_shift_deleted_update_column: "enum" as const,
	event_derived_shift_deleted_updates:{
		_inc:"event_derived_shift_deleted_inc_input",
		_set:"event_derived_shift_deleted_set_input",
		where:"event_derived_shift_deleted_bool_exp"
	},
	event_derived_shift_deleted_var_pop_order_by:{
		id:"order_by"
	},
	event_derived_shift_deleted_var_samp_order_by:{
		id:"order_by"
	},
	event_derived_shift_deleted_variance_order_by:{
		id:"order_by"
	},
	event_derived_shift_updated:{
		note:{

		}
	},
	event_derived_shift_updated_aggregate_bool_exp:{
		count:"event_derived_shift_updated_aggregate_bool_exp_count"
	},
	event_derived_shift_updated_aggregate_bool_exp_count:{
		arguments:"event_derived_shift_updated_select_column",
		filter:"event_derived_shift_updated_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_derived_shift_updated_aggregate_fields:{
		count:{
			columns:"event_derived_shift_updated_select_column"
		}
	},
	event_derived_shift_updated_aggregate_order_by:{
		avg:"event_derived_shift_updated_avg_order_by",
		count:"order_by",
		max:"event_derived_shift_updated_max_order_by",
		min:"event_derived_shift_updated_min_order_by",
		stddev:"event_derived_shift_updated_stddev_order_by",
		stddev_pop:"event_derived_shift_updated_stddev_pop_order_by",
		stddev_samp:"event_derived_shift_updated_stddev_samp_order_by",
		sum:"event_derived_shift_updated_sum_order_by",
		var_pop:"event_derived_shift_updated_var_pop_order_by",
		var_samp:"event_derived_shift_updated_var_samp_order_by",
		variance:"event_derived_shift_updated_variance_order_by"
	},
	event_derived_shift_updated_append_input:{
		note:"jsonb"
	},
	event_derived_shift_updated_arr_rel_insert_input:{
		data:"event_derived_shift_updated_insert_input",
		on_conflict:"event_derived_shift_updated_on_conflict"
	},
	event_derived_shift_updated_avg_order_by:{
		id:"order_by"
	},
	event_derived_shift_updated_bool_exp:{
		_and:"event_derived_shift_updated_bool_exp",
		_not:"event_derived_shift_updated_bool_exp",
		_or:"event_derived_shift_updated_bool_exp",
		end_time:"timestamptz_comparison_exp",
		event:"event_bool_exp",
		exception_date:"timestamptz_comparison_exp",
		id:"Int_comparison_exp",
		note:"jsonb_comparison_exp",
		recurring_shift:"shift_bool_exp",
		recurring_shift_exception_id:"uuid_comparison_exp",
		recurring_shift_id:"uuid_comparison_exp",
		shift:"shift_bool_exp",
		shift_id:"uuid_comparison_exp",
		shift_status:"String_comparison_exp",
		start_time:"timestamptz_comparison_exp",
		team_role_assignment:"team_role_assignment_bool_exp",
		team_role_assignment_id:"uuid_comparison_exp",
		user:"user_bool_exp",
		user_id:"uuid_comparison_exp",
		user_role_assignment:"user_role_assignment_bool_exp",
		user_role_assignment_id:"uuid_comparison_exp"
	},
	event_derived_shift_updated_constraint: "enum" as const,
	event_derived_shift_updated_delete_at_path_input:{

	},
	event_derived_shift_updated_delete_elem_input:{

	},
	event_derived_shift_updated_delete_key_input:{

	},
	event_derived_shift_updated_inc_input:{

	},
	event_derived_shift_updated_insert_input:{
		end_time:"timestamptz",
		event:"event_obj_rel_insert_input",
		exception_date:"timestamptz",
		note:"jsonb",
		recurring_shift:"shift_obj_rel_insert_input",
		recurring_shift_exception_id:"uuid",
		recurring_shift_id:"uuid",
		shift:"shift_obj_rel_insert_input",
		shift_id:"uuid",
		start_time:"timestamptz",
		team_role_assignment:"team_role_assignment_obj_rel_insert_input",
		team_role_assignment_id:"uuid",
		user:"user_obj_rel_insert_input",
		user_id:"uuid",
		user_role_assignment:"user_role_assignment_obj_rel_insert_input",
		user_role_assignment_id:"uuid"
	},
	event_derived_shift_updated_max_order_by:{
		end_time:"order_by",
		exception_date:"order_by",
		id:"order_by",
		recurring_shift_exception_id:"order_by",
		recurring_shift_id:"order_by",
		shift_id:"order_by",
		shift_status:"order_by",
		start_time:"order_by",
		team_role_assignment_id:"order_by",
		user_id:"order_by",
		user_role_assignment_id:"order_by"
	},
	event_derived_shift_updated_min_order_by:{
		end_time:"order_by",
		exception_date:"order_by",
		id:"order_by",
		recurring_shift_exception_id:"order_by",
		recurring_shift_id:"order_by",
		shift_id:"order_by",
		shift_status:"order_by",
		start_time:"order_by",
		team_role_assignment_id:"order_by",
		user_id:"order_by",
		user_role_assignment_id:"order_by"
	},
	event_derived_shift_updated_obj_rel_insert_input:{
		data:"event_derived_shift_updated_insert_input",
		on_conflict:"event_derived_shift_updated_on_conflict"
	},
	event_derived_shift_updated_on_conflict:{
		constraint:"event_derived_shift_updated_constraint",
		update_columns:"event_derived_shift_updated_update_column",
		where:"event_derived_shift_updated_bool_exp"
	},
	event_derived_shift_updated_order_by:{
		end_time:"order_by",
		event:"event_order_by",
		exception_date:"order_by",
		id:"order_by",
		note:"order_by",
		recurring_shift:"shift_order_by",
		recurring_shift_exception_id:"order_by",
		recurring_shift_id:"order_by",
		shift:"shift_order_by",
		shift_id:"order_by",
		shift_status:"order_by",
		start_time:"order_by",
		team_role_assignment:"team_role_assignment_order_by",
		team_role_assignment_id:"order_by",
		user:"user_order_by",
		user_id:"order_by",
		user_role_assignment:"user_role_assignment_order_by",
		user_role_assignment_id:"order_by"
	},
	event_derived_shift_updated_pk_columns_input:{

	},
	event_derived_shift_updated_prepend_input:{
		note:"jsonb"
	},
	event_derived_shift_updated_select_column: "enum" as const,
	event_derived_shift_updated_set_input:{
		end_time:"timestamptz",
		exception_date:"timestamptz",
		note:"jsonb",
		recurring_shift_exception_id:"uuid",
		recurring_shift_id:"uuid",
		shift_id:"uuid",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_derived_shift_updated_stddev_order_by:{
		id:"order_by"
	},
	event_derived_shift_updated_stddev_pop_order_by:{
		id:"order_by"
	},
	event_derived_shift_updated_stddev_samp_order_by:{
		id:"order_by"
	},
	event_derived_shift_updated_stream_cursor_input:{
		initial_value:"event_derived_shift_updated_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_derived_shift_updated_stream_cursor_value_input:{
		end_time:"timestamptz",
		exception_date:"timestamptz",
		note:"jsonb",
		recurring_shift_exception_id:"uuid",
		recurring_shift_id:"uuid",
		shift_id:"uuid",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_derived_shift_updated_sum_order_by:{
		id:"order_by"
	},
	event_derived_shift_updated_update_column: "enum" as const,
	event_derived_shift_updated_updates:{
		_append:"event_derived_shift_updated_append_input",
		_delete_at_path:"event_derived_shift_updated_delete_at_path_input",
		_delete_elem:"event_derived_shift_updated_delete_elem_input",
		_delete_key:"event_derived_shift_updated_delete_key_input",
		_inc:"event_derived_shift_updated_inc_input",
		_prepend:"event_derived_shift_updated_prepend_input",
		_set:"event_derived_shift_updated_set_input",
		where:"event_derived_shift_updated_bool_exp"
	},
	event_derived_shift_updated_var_pop_order_by:{
		id:"order_by"
	},
	event_derived_shift_updated_var_samp_order_by:{
		id:"order_by"
	},
	event_derived_shift_updated_variance_order_by:{
		id:"order_by"
	},
	event_inc_input:{

	},
	event_insert_input:{
		created_at:"timestamptz",
		created_by:"uuid",
		event_buffered_shift_ended:"event_buffered_shift_ended_obj_rel_insert_input",
		event_buffered_shift_started:"event_buffered_shift_started_obj_rel_insert_input",
		event_cost_object_created:"event_cost_object_created_obj_rel_insert_input",
		event_cost_object_deleted:"event_cost_object_deleted_obj_rel_insert_input",
		event_cost_object_reactivated:"event_cost_object_reactivated_obj_rel_insert_input",
		event_cost_object_updated:"event_cost_object_updated_obj_rel_insert_input",
		event_derived_shift_deleted:"event_derived_shift_deleted_obj_rel_insert_input",
		event_derived_shift_updated:"event_derived_shift_updated_obj_rel_insert_input",
		event_note_created:"event_note_created_obj_rel_insert_input",
		event_note_deleted:"event_note_deleted_obj_rel_insert_input",
		event_note_updated:"event_note_updated_obj_rel_insert_input",
		event_recurring_shift_exception_created:"event_recurring_shift_exception_created_obj_rel_insert_input",
		event_shift_created:"event_shift_created_obj_rel_insert_input",
		event_shift_deleted:"event_shift_deleted_obj_rel_insert_input",
		event_shift_ended:"event_shift_ended_obj_rel_insert_input",
		event_shift_started:"event_shift_started_obj_rel_insert_input",
		event_shift_updated:"event_shift_updated_obj_rel_insert_input",
		event_team_created:"event_team_created_obj_rel_insert_input",
		event_team_deleted:"event_team_deleted_obj_rel_insert_input",
		event_team_reactivated:"event_team_reactivated_obj_rel_insert_input",
		event_team_role_assignment_created:"event_team_role_assignment_created_obj_rel_insert_input",
		event_team_role_assignment_deleted:"event_team_role_assignment_deleted_obj_rel_insert_input",
		event_team_role_created:"event_team_role_created_obj_rel_insert_input",
		event_team_role_deleted:"event_team_role_deleted_obj_rel_insert_input",
		event_team_role_updated:"event_team_role_updated_obj_rel_insert_input",
		event_team_updated:"event_team_updated_obj_rel_insert_input",
		event_type:"event_type_t",
		event_user_created:"event_user_created_obj_rel_insert_input",
		event_user_deleted:"event_user_deleted_obj_rel_insert_input",
		event_user_role_assignment_created:"event_user_role_assignment_created_obj_rel_insert_input",
		event_user_role_assignment_deleted:"event_user_role_assignment_deleted_obj_rel_insert_input",
		event_user_role_assignment_updated:"event_user_role_assignment_updated_obj_rel_insert_input",
		event_user_updated:"event_user_updated_obj_rel_insert_input",
		new:"jsonb",
		old:"jsonb",
		payload:"jsonb",
		team:"team_obj_rel_insert_input",
		team_id:"uuid",
		user:"user_obj_rel_insert_input",
		user_created_by:"user_obj_rel_insert_input",
		user_id:"uuid",
		user_role_assignment_notifications:"user_notification_arr_rel_insert_input"
	},
	event_max_order_by:{
		created_at:"order_by",
		created_by:"order_by",
		event_type:"order_by",
		external_id:"order_by",
		id:"order_by",
		team_id:"order_by",
		user_id:"order_by"
	},
	event_min_order_by:{
		created_at:"order_by",
		created_by:"order_by",
		event_type:"order_by",
		external_id:"order_by",
		id:"order_by",
		team_id:"order_by",
		user_id:"order_by"
	},
	event_note_created:{
		content:{

		}
	},
	event_note_created_aggregate_fields:{
		count:{
			columns:"event_note_created_select_column"
		}
	},
	event_note_created_append_input:{
		content:"jsonb"
	},
	event_note_created_bool_exp:{
		_and:"event_note_created_bool_exp",
		_not:"event_note_created_bool_exp",
		_or:"event_note_created_bool_exp",
		content:"jsonb_comparison_exp",
		event:"event_bool_exp",
		event_shift_created:"event_shift_created_bool_exp",
		id:"Int_comparison_exp",
		note:"note_bool_exp",
		note_id:"uuid_comparison_exp",
		object_id:"uuid_comparison_exp",
		related_event_id:"Int_comparison_exp"
	},
	event_note_created_constraint: "enum" as const,
	event_note_created_delete_at_path_input:{

	},
	event_note_created_delete_elem_input:{

	},
	event_note_created_delete_key_input:{

	},
	event_note_created_inc_input:{

	},
	event_note_created_insert_input:{
		content:"jsonb",
		event:"event_obj_rel_insert_input",
		event_shift_created:"event_shift_created_obj_rel_insert_input",
		note:"note_obj_rel_insert_input",
		note_id:"uuid",
		object_id:"uuid"
	},
	event_note_created_obj_rel_insert_input:{
		data:"event_note_created_insert_input",
		on_conflict:"event_note_created_on_conflict"
	},
	event_note_created_on_conflict:{
		constraint:"event_note_created_constraint",
		update_columns:"event_note_created_update_column",
		where:"event_note_created_bool_exp"
	},
	event_note_created_order_by:{
		content:"order_by",
		event:"event_order_by",
		event_shift_created:"event_shift_created_order_by",
		id:"order_by",
		note:"note_order_by",
		note_id:"order_by",
		object_id:"order_by",
		related_event_id:"order_by"
	},
	event_note_created_pk_columns_input:{

	},
	event_note_created_prepend_input:{
		content:"jsonb"
	},
	event_note_created_select_column: "enum" as const,
	event_note_created_set_input:{
		content:"jsonb",
		note_id:"uuid",
		object_id:"uuid"
	},
	event_note_created_stream_cursor_input:{
		initial_value:"event_note_created_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_note_created_stream_cursor_value_input:{
		content:"jsonb",
		note_id:"uuid",
		object_id:"uuid"
	},
	event_note_created_update_column: "enum" as const,
	event_note_created_updates:{
		_append:"event_note_created_append_input",
		_delete_at_path:"event_note_created_delete_at_path_input",
		_delete_elem:"event_note_created_delete_elem_input",
		_delete_key:"event_note_created_delete_key_input",
		_inc:"event_note_created_inc_input",
		_prepend:"event_note_created_prepend_input",
		_set:"event_note_created_set_input",
		where:"event_note_created_bool_exp"
	},
	event_note_deleted_aggregate_bool_exp:{
		count:"event_note_deleted_aggregate_bool_exp_count"
	},
	event_note_deleted_aggregate_bool_exp_count:{
		arguments:"event_note_deleted_select_column",
		filter:"event_note_deleted_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_note_deleted_aggregate_fields:{
		count:{
			columns:"event_note_deleted_select_column"
		}
	},
	event_note_deleted_aggregate_order_by:{
		avg:"event_note_deleted_avg_order_by",
		count:"order_by",
		max:"event_note_deleted_max_order_by",
		min:"event_note_deleted_min_order_by",
		stddev:"event_note_deleted_stddev_order_by",
		stddev_pop:"event_note_deleted_stddev_pop_order_by",
		stddev_samp:"event_note_deleted_stddev_samp_order_by",
		sum:"event_note_deleted_sum_order_by",
		var_pop:"event_note_deleted_var_pop_order_by",
		var_samp:"event_note_deleted_var_samp_order_by",
		variance:"event_note_deleted_variance_order_by"
	},
	event_note_deleted_arr_rel_insert_input:{
		data:"event_note_deleted_insert_input",
		on_conflict:"event_note_deleted_on_conflict"
	},
	event_note_deleted_avg_order_by:{
		id:"order_by"
	},
	event_note_deleted_bool_exp:{
		_and:"event_note_deleted_bool_exp",
		_not:"event_note_deleted_bool_exp",
		_or:"event_note_deleted_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		note:"note_bool_exp",
		note_id:"uuid_comparison_exp"
	},
	event_note_deleted_constraint: "enum" as const,
	event_note_deleted_inc_input:{

	},
	event_note_deleted_insert_input:{
		event:"event_obj_rel_insert_input",
		note:"note_obj_rel_insert_input",
		note_id:"uuid"
	},
	event_note_deleted_max_order_by:{
		id:"order_by",
		note_id:"order_by"
	},
	event_note_deleted_min_order_by:{
		id:"order_by",
		note_id:"order_by"
	},
	event_note_deleted_obj_rel_insert_input:{
		data:"event_note_deleted_insert_input",
		on_conflict:"event_note_deleted_on_conflict"
	},
	event_note_deleted_on_conflict:{
		constraint:"event_note_deleted_constraint",
		update_columns:"event_note_deleted_update_column",
		where:"event_note_deleted_bool_exp"
	},
	event_note_deleted_order_by:{
		event:"event_order_by",
		id:"order_by",
		note:"note_order_by",
		note_id:"order_by"
	},
	event_note_deleted_pk_columns_input:{

	},
	event_note_deleted_select_column: "enum" as const,
	event_note_deleted_set_input:{
		note_id:"uuid"
	},
	event_note_deleted_stddev_order_by:{
		id:"order_by"
	},
	event_note_deleted_stddev_pop_order_by:{
		id:"order_by"
	},
	event_note_deleted_stddev_samp_order_by:{
		id:"order_by"
	},
	event_note_deleted_stream_cursor_input:{
		initial_value:"event_note_deleted_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_note_deleted_stream_cursor_value_input:{
		note_id:"uuid"
	},
	event_note_deleted_sum_order_by:{
		id:"order_by"
	},
	event_note_deleted_update_column: "enum" as const,
	event_note_deleted_updates:{
		_inc:"event_note_deleted_inc_input",
		_set:"event_note_deleted_set_input",
		where:"event_note_deleted_bool_exp"
	},
	event_note_deleted_var_pop_order_by:{
		id:"order_by"
	},
	event_note_deleted_var_samp_order_by:{
		id:"order_by"
	},
	event_note_deleted_variance_order_by:{
		id:"order_by"
	},
	event_note_updated:{
		content:{

		}
	},
	event_note_updated_aggregate_bool_exp:{
		count:"event_note_updated_aggregate_bool_exp_count"
	},
	event_note_updated_aggregate_bool_exp_count:{
		arguments:"event_note_updated_select_column",
		filter:"event_note_updated_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_note_updated_aggregate_fields:{
		count:{
			columns:"event_note_updated_select_column"
		}
	},
	event_note_updated_aggregate_order_by:{
		avg:"event_note_updated_avg_order_by",
		count:"order_by",
		max:"event_note_updated_max_order_by",
		min:"event_note_updated_min_order_by",
		stddev:"event_note_updated_stddev_order_by",
		stddev_pop:"event_note_updated_stddev_pop_order_by",
		stddev_samp:"event_note_updated_stddev_samp_order_by",
		sum:"event_note_updated_sum_order_by",
		var_pop:"event_note_updated_var_pop_order_by",
		var_samp:"event_note_updated_var_samp_order_by",
		variance:"event_note_updated_variance_order_by"
	},
	event_note_updated_append_input:{
		content:"jsonb"
	},
	event_note_updated_arr_rel_insert_input:{
		data:"event_note_updated_insert_input",
		on_conflict:"event_note_updated_on_conflict"
	},
	event_note_updated_avg_order_by:{
		id:"order_by"
	},
	event_note_updated_bool_exp:{
		_and:"event_note_updated_bool_exp",
		_not:"event_note_updated_bool_exp",
		_or:"event_note_updated_bool_exp",
		content:"jsonb_comparison_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		note:"note_bool_exp",
		note_id:"uuid_comparison_exp"
	},
	event_note_updated_constraint: "enum" as const,
	event_note_updated_delete_at_path_input:{

	},
	event_note_updated_delete_elem_input:{

	},
	event_note_updated_delete_key_input:{

	},
	event_note_updated_inc_input:{

	},
	event_note_updated_insert_input:{
		content:"jsonb",
		event:"event_obj_rel_insert_input",
		note:"note_obj_rel_insert_input",
		note_id:"uuid"
	},
	event_note_updated_max_order_by:{
		id:"order_by",
		note_id:"order_by"
	},
	event_note_updated_min_order_by:{
		id:"order_by",
		note_id:"order_by"
	},
	event_note_updated_obj_rel_insert_input:{
		data:"event_note_updated_insert_input",
		on_conflict:"event_note_updated_on_conflict"
	},
	event_note_updated_on_conflict:{
		constraint:"event_note_updated_constraint",
		update_columns:"event_note_updated_update_column",
		where:"event_note_updated_bool_exp"
	},
	event_note_updated_order_by:{
		content:"order_by",
		event:"event_order_by",
		id:"order_by",
		note:"note_order_by",
		note_id:"order_by"
	},
	event_note_updated_pk_columns_input:{

	},
	event_note_updated_prepend_input:{
		content:"jsonb"
	},
	event_note_updated_select_column: "enum" as const,
	event_note_updated_set_input:{
		content:"jsonb",
		note_id:"uuid"
	},
	event_note_updated_stddev_order_by:{
		id:"order_by"
	},
	event_note_updated_stddev_pop_order_by:{
		id:"order_by"
	},
	event_note_updated_stddev_samp_order_by:{
		id:"order_by"
	},
	event_note_updated_stream_cursor_input:{
		initial_value:"event_note_updated_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_note_updated_stream_cursor_value_input:{
		content:"jsonb",
		note_id:"uuid"
	},
	event_note_updated_sum_order_by:{
		id:"order_by"
	},
	event_note_updated_update_column: "enum" as const,
	event_note_updated_updates:{
		_append:"event_note_updated_append_input",
		_delete_at_path:"event_note_updated_delete_at_path_input",
		_delete_elem:"event_note_updated_delete_elem_input",
		_delete_key:"event_note_updated_delete_key_input",
		_inc:"event_note_updated_inc_input",
		_prepend:"event_note_updated_prepend_input",
		_set:"event_note_updated_set_input",
		where:"event_note_updated_bool_exp"
	},
	event_note_updated_var_pop_order_by:{
		id:"order_by"
	},
	event_note_updated_var_samp_order_by:{
		id:"order_by"
	},
	event_note_updated_variance_order_by:{
		id:"order_by"
	},
	event_obj_rel_insert_input:{
		data:"event_insert_input",
		on_conflict:"event_on_conflict"
	},
	event_on_conflict:{
		constraint:"event_constraint",
		update_columns:"event_update_column",
		where:"event_bool_exp"
	},
	event_order_by:{
		created_at:"order_by",
		created_by:"order_by",
		event_buffered_shift_ended:"event_buffered_shift_ended_order_by",
		event_buffered_shift_started:"event_buffered_shift_started_order_by",
		event_cost_object_created:"event_cost_object_created_order_by",
		event_cost_object_deleted:"event_cost_object_deleted_order_by",
		event_cost_object_reactivated:"event_cost_object_reactivated_order_by",
		event_cost_object_updated:"event_cost_object_updated_order_by",
		event_derived_shift_deleted:"event_derived_shift_deleted_order_by",
		event_derived_shift_updated:"event_derived_shift_updated_order_by",
		event_note_created:"event_note_created_order_by",
		event_note_deleted:"event_note_deleted_order_by",
		event_note_updated:"event_note_updated_order_by",
		event_recurring_shift_exception_created:"event_recurring_shift_exception_created_order_by",
		event_shift_created:"event_shift_created_order_by",
		event_shift_deleted:"event_shift_deleted_order_by",
		event_shift_ended:"event_shift_ended_order_by",
		event_shift_started:"event_shift_started_order_by",
		event_shift_updated:"event_shift_updated_order_by",
		event_team_created:"event_team_created_order_by",
		event_team_deleted:"event_team_deleted_order_by",
		event_team_reactivated:"event_team_reactivated_order_by",
		event_team_role_assignment_created:"event_team_role_assignment_created_order_by",
		event_team_role_assignment_deleted:"event_team_role_assignment_deleted_order_by",
		event_team_role_created:"event_team_role_created_order_by",
		event_team_role_deleted:"event_team_role_deleted_order_by",
		event_team_role_updated:"event_team_role_updated_order_by",
		event_team_updated:"event_team_updated_order_by",
		event_type:"order_by",
		event_user_created:"event_user_created_order_by",
		event_user_deleted:"event_user_deleted_order_by",
		event_user_role_assignment_created:"event_user_role_assignment_created_order_by",
		event_user_role_assignment_deleted:"event_user_role_assignment_deleted_order_by",
		event_user_role_assignment_updated:"event_user_role_assignment_updated_order_by",
		event_user_updated:"event_user_updated_order_by",
		external_id:"order_by",
		id:"order_by",
		new:"order_by",
		old:"order_by",
		payload:"order_by",
		team:"team_order_by",
		team_id:"order_by",
		user:"user_order_by",
		user_created_by:"user_order_by",
		user_id:"order_by",
		user_role_assignment_notifications_aggregate:"user_notification_aggregate_order_by"
	},
	event_pk_columns_input:{

	},
	event_prepend_input:{
		new:"jsonb",
		old:"jsonb",
		payload:"jsonb"
	},
	event_recurring_shift_exception_created_aggregate_bool_exp:{
		count:"event_recurring_shift_exception_created_aggregate_bool_exp_count"
	},
	event_recurring_shift_exception_created_aggregate_bool_exp_count:{
		arguments:"event_recurring_shift_exception_created_select_column",
		filter:"event_recurring_shift_exception_created_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_recurring_shift_exception_created_aggregate_fields:{
		count:{
			columns:"event_recurring_shift_exception_created_select_column"
		}
	},
	event_recurring_shift_exception_created_aggregate_order_by:{
		avg:"event_recurring_shift_exception_created_avg_order_by",
		count:"order_by",
		max:"event_recurring_shift_exception_created_max_order_by",
		min:"event_recurring_shift_exception_created_min_order_by",
		stddev:"event_recurring_shift_exception_created_stddev_order_by",
		stddev_pop:"event_recurring_shift_exception_created_stddev_pop_order_by",
		stddev_samp:"event_recurring_shift_exception_created_stddev_samp_order_by",
		sum:"event_recurring_shift_exception_created_sum_order_by",
		var_pop:"event_recurring_shift_exception_created_var_pop_order_by",
		var_samp:"event_recurring_shift_exception_created_var_samp_order_by",
		variance:"event_recurring_shift_exception_created_variance_order_by"
	},
	event_recurring_shift_exception_created_arr_rel_insert_input:{
		data:"event_recurring_shift_exception_created_insert_input",
		on_conflict:"event_recurring_shift_exception_created_on_conflict"
	},
	event_recurring_shift_exception_created_avg_order_by:{
		id:"order_by"
	},
	event_recurring_shift_exception_created_bool_exp:{
		_and:"event_recurring_shift_exception_created_bool_exp",
		_not:"event_recurring_shift_exception_created_bool_exp",
		_or:"event_recurring_shift_exception_created_bool_exp",
		event:"event_bool_exp",
		exception_date:"timestamptz_comparison_exp",
		id:"Int_comparison_exp",
		recurring_shift_exception_id:"uuid_comparison_exp",
		shift:"shift_bool_exp",
		shift_id:"uuid_comparison_exp"
	},
	event_recurring_shift_exception_created_constraint: "enum" as const,
	event_recurring_shift_exception_created_inc_input:{

	},
	event_recurring_shift_exception_created_insert_input:{
		event:"event_obj_rel_insert_input",
		exception_date:"timestamptz",
		recurring_shift_exception_id:"uuid",
		shift:"shift_obj_rel_insert_input",
		shift_id:"uuid"
	},
	event_recurring_shift_exception_created_max_order_by:{
		exception_date:"order_by",
		id:"order_by",
		recurring_shift_exception_id:"order_by",
		shift_id:"order_by"
	},
	event_recurring_shift_exception_created_min_order_by:{
		exception_date:"order_by",
		id:"order_by",
		recurring_shift_exception_id:"order_by",
		shift_id:"order_by"
	},
	event_recurring_shift_exception_created_obj_rel_insert_input:{
		data:"event_recurring_shift_exception_created_insert_input",
		on_conflict:"event_recurring_shift_exception_created_on_conflict"
	},
	event_recurring_shift_exception_created_on_conflict:{
		constraint:"event_recurring_shift_exception_created_constraint",
		update_columns:"event_recurring_shift_exception_created_update_column",
		where:"event_recurring_shift_exception_created_bool_exp"
	},
	event_recurring_shift_exception_created_order_by:{
		event:"event_order_by",
		exception_date:"order_by",
		id:"order_by",
		recurring_shift_exception_id:"order_by",
		shift:"shift_order_by",
		shift_id:"order_by"
	},
	event_recurring_shift_exception_created_pk_columns_input:{

	},
	event_recurring_shift_exception_created_select_column: "enum" as const,
	event_recurring_shift_exception_created_set_input:{
		exception_date:"timestamptz",
		recurring_shift_exception_id:"uuid",
		shift_id:"uuid"
	},
	event_recurring_shift_exception_created_stddev_order_by:{
		id:"order_by"
	},
	event_recurring_shift_exception_created_stddev_pop_order_by:{
		id:"order_by"
	},
	event_recurring_shift_exception_created_stddev_samp_order_by:{
		id:"order_by"
	},
	event_recurring_shift_exception_created_stream_cursor_input:{
		initial_value:"event_recurring_shift_exception_created_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_recurring_shift_exception_created_stream_cursor_value_input:{
		exception_date:"timestamptz",
		recurring_shift_exception_id:"uuid",
		shift_id:"uuid"
	},
	event_recurring_shift_exception_created_sum_order_by:{
		id:"order_by"
	},
	event_recurring_shift_exception_created_update_column: "enum" as const,
	event_recurring_shift_exception_created_updates:{
		_inc:"event_recurring_shift_exception_created_inc_input",
		_set:"event_recurring_shift_exception_created_set_input",
		where:"event_recurring_shift_exception_created_bool_exp"
	},
	event_recurring_shift_exception_created_var_pop_order_by:{
		id:"order_by"
	},
	event_recurring_shift_exception_created_var_samp_order_by:{
		id:"order_by"
	},
	event_recurring_shift_exception_created_variance_order_by:{
		id:"order_by"
	},
	event_select_column: "enum" as const,
	event_set_input:{
		created_at:"timestamptz",
		created_by:"uuid",
		event_type:"event_type_t",
		new:"jsonb",
		old:"jsonb",
		payload:"jsonb",
		team_id:"uuid",
		user_id:"uuid"
	},
	event_shift_created:{
		note:{

		}
	},
	event_shift_created_aggregate_bool_exp:{
		bool_and:"event_shift_created_aggregate_bool_exp_bool_and",
		bool_or:"event_shift_created_aggregate_bool_exp_bool_or",
		count:"event_shift_created_aggregate_bool_exp_count"
	},
	event_shift_created_aggregate_bool_exp_bool_and:{
		arguments:"event_shift_created_select_column_event_shift_created_aggregate_bool_exp_bool_and_arguments_columns",
		filter:"event_shift_created_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	event_shift_created_aggregate_bool_exp_bool_or:{
		arguments:"event_shift_created_select_column_event_shift_created_aggregate_bool_exp_bool_or_arguments_columns",
		filter:"event_shift_created_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	event_shift_created_aggregate_bool_exp_count:{
		arguments:"event_shift_created_select_column",
		filter:"event_shift_created_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_shift_created_aggregate_fields:{
		count:{
			columns:"event_shift_created_select_column"
		}
	},
	event_shift_created_aggregate_order_by:{
		avg:"event_shift_created_avg_order_by",
		count:"order_by",
		max:"event_shift_created_max_order_by",
		min:"event_shift_created_min_order_by",
		stddev:"event_shift_created_stddev_order_by",
		stddev_pop:"event_shift_created_stddev_pop_order_by",
		stddev_samp:"event_shift_created_stddev_samp_order_by",
		sum:"event_shift_created_sum_order_by",
		var_pop:"event_shift_created_var_pop_order_by",
		var_samp:"event_shift_created_var_samp_order_by",
		variance:"event_shift_created_variance_order_by"
	},
	event_shift_created_append_input:{
		note:"jsonb"
	},
	event_shift_created_arr_rel_insert_input:{
		data:"event_shift_created_insert_input",
		on_conflict:"event_shift_created_on_conflict"
	},
	event_shift_created_avg_order_by:{
		id:"order_by"
	},
	event_shift_created_bool_exp:{
		_and:"event_shift_created_bool_exp",
		_not:"event_shift_created_bool_exp",
		_or:"event_shift_created_bool_exp",
		end_time:"timestamptz_comparison_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		is_recurring:"Boolean_comparison_exp",
		note:"jsonb_comparison_exp",
		recurrence_end_date:"timestamptz_comparison_exp",
		recurrence_pattern:"String_comparison_exp",
		root_id:"uuid_comparison_exp",
		shift:"shift_bool_exp",
		shift_id:"uuid_comparison_exp",
		shift_status:"String_comparison_exp",
		start_time:"timestamptz_comparison_exp",
		team_role_assignment_id:"uuid_comparison_exp",
		user:"user_bool_exp",
		user_id:"uuid_comparison_exp",
		user_role_assignment:"user_role_assignment_bool_exp",
		user_role_assignment_id:"uuid_comparison_exp"
	},
	event_shift_created_constraint: "enum" as const,
	event_shift_created_delete_at_path_input:{

	},
	event_shift_created_delete_elem_input:{

	},
	event_shift_created_delete_key_input:{

	},
	event_shift_created_inc_input:{

	},
	event_shift_created_insert_input:{
		end_time:"timestamptz",
		event:"event_obj_rel_insert_input",
		note:"jsonb",
		recurrence_end_date:"timestamptz",
		root_id:"uuid",
		shift:"shift_obj_rel_insert_input",
		shift_id:"uuid",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user:"user_obj_rel_insert_input",
		user_id:"uuid",
		user_role_assignment:"user_role_assignment_obj_rel_insert_input",
		user_role_assignment_id:"uuid"
	},
	event_shift_created_max_order_by:{
		end_time:"order_by",
		id:"order_by",
		recurrence_end_date:"order_by",
		recurrence_pattern:"order_by",
		root_id:"order_by",
		shift_id:"order_by",
		shift_status:"order_by",
		start_time:"order_by",
		team_role_assignment_id:"order_by",
		user_id:"order_by",
		user_role_assignment_id:"order_by"
	},
	event_shift_created_min_order_by:{
		end_time:"order_by",
		id:"order_by",
		recurrence_end_date:"order_by",
		recurrence_pattern:"order_by",
		root_id:"order_by",
		shift_id:"order_by",
		shift_status:"order_by",
		start_time:"order_by",
		team_role_assignment_id:"order_by",
		user_id:"order_by",
		user_role_assignment_id:"order_by"
	},
	event_shift_created_obj_rel_insert_input:{
		data:"event_shift_created_insert_input",
		on_conflict:"event_shift_created_on_conflict"
	},
	event_shift_created_on_conflict:{
		constraint:"event_shift_created_constraint",
		update_columns:"event_shift_created_update_column",
		where:"event_shift_created_bool_exp"
	},
	event_shift_created_order_by:{
		end_time:"order_by",
		event:"event_order_by",
		id:"order_by",
		is_recurring:"order_by",
		note:"order_by",
		recurrence_end_date:"order_by",
		recurrence_pattern:"order_by",
		root_id:"order_by",
		shift:"shift_order_by",
		shift_id:"order_by",
		shift_status:"order_by",
		start_time:"order_by",
		team_role_assignment_id:"order_by",
		user:"user_order_by",
		user_id:"order_by",
		user_role_assignment:"user_role_assignment_order_by",
		user_role_assignment_id:"order_by"
	},
	event_shift_created_pk_columns_input:{

	},
	event_shift_created_prepend_input:{
		note:"jsonb"
	},
	event_shift_created_select_column: "enum" as const,
	event_shift_created_select_column_event_shift_created_aggregate_bool_exp_bool_and_arguments_columns: "enum" as const,
	event_shift_created_select_column_event_shift_created_aggregate_bool_exp_bool_or_arguments_columns: "enum" as const,
	event_shift_created_set_input:{
		end_time:"timestamptz",
		note:"jsonb",
		recurrence_end_date:"timestamptz",
		root_id:"uuid",
		shift_id:"uuid",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_shift_created_stddev_order_by:{
		id:"order_by"
	},
	event_shift_created_stddev_pop_order_by:{
		id:"order_by"
	},
	event_shift_created_stddev_samp_order_by:{
		id:"order_by"
	},
	event_shift_created_stream_cursor_input:{
		initial_value:"event_shift_created_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_shift_created_stream_cursor_value_input:{
		end_time:"timestamptz",
		note:"jsonb",
		recurrence_end_date:"timestamptz",
		root_id:"uuid",
		shift_id:"uuid",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_shift_created_sum_order_by:{
		id:"order_by"
	},
	event_shift_created_update_column: "enum" as const,
	event_shift_created_updates:{
		_append:"event_shift_created_append_input",
		_delete_at_path:"event_shift_created_delete_at_path_input",
		_delete_elem:"event_shift_created_delete_elem_input",
		_delete_key:"event_shift_created_delete_key_input",
		_inc:"event_shift_created_inc_input",
		_prepend:"event_shift_created_prepend_input",
		_set:"event_shift_created_set_input",
		where:"event_shift_created_bool_exp"
	},
	event_shift_created_var_pop_order_by:{
		id:"order_by"
	},
	event_shift_created_var_samp_order_by:{
		id:"order_by"
	},
	event_shift_created_variance_order_by:{
		id:"order_by"
	},
	event_shift_deleted_aggregate_bool_exp:{
		count:"event_shift_deleted_aggregate_bool_exp_count"
	},
	event_shift_deleted_aggregate_bool_exp_count:{
		arguments:"event_shift_deleted_select_column",
		filter:"event_shift_deleted_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_shift_deleted_aggregate_fields:{
		count:{
			columns:"event_shift_deleted_select_column"
		}
	},
	event_shift_deleted_aggregate_order_by:{
		avg:"event_shift_deleted_avg_order_by",
		count:"order_by",
		max:"event_shift_deleted_max_order_by",
		min:"event_shift_deleted_min_order_by",
		stddev:"event_shift_deleted_stddev_order_by",
		stddev_pop:"event_shift_deleted_stddev_pop_order_by",
		stddev_samp:"event_shift_deleted_stddev_samp_order_by",
		sum:"event_shift_deleted_sum_order_by",
		var_pop:"event_shift_deleted_var_pop_order_by",
		var_samp:"event_shift_deleted_var_samp_order_by",
		variance:"event_shift_deleted_variance_order_by"
	},
	event_shift_deleted_arr_rel_insert_input:{
		data:"event_shift_deleted_insert_input",
		on_conflict:"event_shift_deleted_on_conflict"
	},
	event_shift_deleted_avg_order_by:{
		id:"order_by"
	},
	event_shift_deleted_bool_exp:{
		_and:"event_shift_deleted_bool_exp",
		_not:"event_shift_deleted_bool_exp",
		_or:"event_shift_deleted_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		shift:"shift_bool_exp",
		shift_id:"uuid_comparison_exp"
	},
	event_shift_deleted_constraint: "enum" as const,
	event_shift_deleted_inc_input:{

	},
	event_shift_deleted_insert_input:{
		event:"event_obj_rel_insert_input",
		shift:"shift_obj_rel_insert_input",
		shift_id:"uuid"
	},
	event_shift_deleted_max_order_by:{
		id:"order_by",
		shift_id:"order_by"
	},
	event_shift_deleted_min_order_by:{
		id:"order_by",
		shift_id:"order_by"
	},
	event_shift_deleted_obj_rel_insert_input:{
		data:"event_shift_deleted_insert_input",
		on_conflict:"event_shift_deleted_on_conflict"
	},
	event_shift_deleted_on_conflict:{
		constraint:"event_shift_deleted_constraint",
		update_columns:"event_shift_deleted_update_column",
		where:"event_shift_deleted_bool_exp"
	},
	event_shift_deleted_order_by:{
		event:"event_order_by",
		id:"order_by",
		shift:"shift_order_by",
		shift_id:"order_by"
	},
	event_shift_deleted_pk_columns_input:{

	},
	event_shift_deleted_select_column: "enum" as const,
	event_shift_deleted_set_input:{
		shift_id:"uuid"
	},
	event_shift_deleted_stddev_order_by:{
		id:"order_by"
	},
	event_shift_deleted_stddev_pop_order_by:{
		id:"order_by"
	},
	event_shift_deleted_stddev_samp_order_by:{
		id:"order_by"
	},
	event_shift_deleted_stream_cursor_input:{
		initial_value:"event_shift_deleted_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_shift_deleted_stream_cursor_value_input:{
		shift_id:"uuid"
	},
	event_shift_deleted_sum_order_by:{
		id:"order_by"
	},
	event_shift_deleted_update_column: "enum" as const,
	event_shift_deleted_updates:{
		_inc:"event_shift_deleted_inc_input",
		_set:"event_shift_deleted_set_input",
		where:"event_shift_deleted_bool_exp"
	},
	event_shift_deleted_var_pop_order_by:{
		id:"order_by"
	},
	event_shift_deleted_var_samp_order_by:{
		id:"order_by"
	},
	event_shift_deleted_variance_order_by:{
		id:"order_by"
	},
	event_shift_ended_aggregate_bool_exp:{
		count:"event_shift_ended_aggregate_bool_exp_count"
	},
	event_shift_ended_aggregate_bool_exp_count:{
		arguments:"event_shift_ended_select_column",
		filter:"event_shift_ended_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_shift_ended_aggregate_fields:{
		count:{
			columns:"event_shift_ended_select_column"
		}
	},
	event_shift_ended_aggregate_order_by:{
		avg:"event_shift_ended_avg_order_by",
		count:"order_by",
		max:"event_shift_ended_max_order_by",
		min:"event_shift_ended_min_order_by",
		stddev:"event_shift_ended_stddev_order_by",
		stddev_pop:"event_shift_ended_stddev_pop_order_by",
		stddev_samp:"event_shift_ended_stddev_samp_order_by",
		sum:"event_shift_ended_sum_order_by",
		var_pop:"event_shift_ended_var_pop_order_by",
		var_samp:"event_shift_ended_var_samp_order_by",
		variance:"event_shift_ended_variance_order_by"
	},
	event_shift_ended_arr_rel_insert_input:{
		data:"event_shift_ended_insert_input",
		on_conflict:"event_shift_ended_on_conflict"
	},
	event_shift_ended_avg_order_by:{
		id:"order_by"
	},
	event_shift_ended_bool_exp:{
		_and:"event_shift_ended_bool_exp",
		_not:"event_shift_ended_bool_exp",
		_or:"event_shift_ended_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		shift:"shift_bool_exp",
		shift_id:"uuid_comparison_exp"
	},
	event_shift_ended_constraint: "enum" as const,
	event_shift_ended_inc_input:{

	},
	event_shift_ended_insert_input:{
		event:"event_obj_rel_insert_input",
		shift:"shift_obj_rel_insert_input",
		shift_id:"uuid"
	},
	event_shift_ended_max_order_by:{
		id:"order_by",
		shift_id:"order_by"
	},
	event_shift_ended_min_order_by:{
		id:"order_by",
		shift_id:"order_by"
	},
	event_shift_ended_obj_rel_insert_input:{
		data:"event_shift_ended_insert_input",
		on_conflict:"event_shift_ended_on_conflict"
	},
	event_shift_ended_on_conflict:{
		constraint:"event_shift_ended_constraint",
		update_columns:"event_shift_ended_update_column",
		where:"event_shift_ended_bool_exp"
	},
	event_shift_ended_order_by:{
		event:"event_order_by",
		id:"order_by",
		shift:"shift_order_by",
		shift_id:"order_by"
	},
	event_shift_ended_pk_columns_input:{

	},
	event_shift_ended_select_column: "enum" as const,
	event_shift_ended_set_input:{
		shift_id:"uuid"
	},
	event_shift_ended_stddev_order_by:{
		id:"order_by"
	},
	event_shift_ended_stddev_pop_order_by:{
		id:"order_by"
	},
	event_shift_ended_stddev_samp_order_by:{
		id:"order_by"
	},
	event_shift_ended_stream_cursor_input:{
		initial_value:"event_shift_ended_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_shift_ended_stream_cursor_value_input:{
		shift_id:"uuid"
	},
	event_shift_ended_sum_order_by:{
		id:"order_by"
	},
	event_shift_ended_update_column: "enum" as const,
	event_shift_ended_updates:{
		_inc:"event_shift_ended_inc_input",
		_set:"event_shift_ended_set_input",
		where:"event_shift_ended_bool_exp"
	},
	event_shift_ended_var_pop_order_by:{
		id:"order_by"
	},
	event_shift_ended_var_samp_order_by:{
		id:"order_by"
	},
	event_shift_ended_variance_order_by:{
		id:"order_by"
	},
	event_shift_started_aggregate_bool_exp:{
		count:"event_shift_started_aggregate_bool_exp_count"
	},
	event_shift_started_aggregate_bool_exp_count:{
		arguments:"event_shift_started_select_column",
		filter:"event_shift_started_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_shift_started_aggregate_fields:{
		count:{
			columns:"event_shift_started_select_column"
		}
	},
	event_shift_started_aggregate_order_by:{
		avg:"event_shift_started_avg_order_by",
		count:"order_by",
		max:"event_shift_started_max_order_by",
		min:"event_shift_started_min_order_by",
		stddev:"event_shift_started_stddev_order_by",
		stddev_pop:"event_shift_started_stddev_pop_order_by",
		stddev_samp:"event_shift_started_stddev_samp_order_by",
		sum:"event_shift_started_sum_order_by",
		var_pop:"event_shift_started_var_pop_order_by",
		var_samp:"event_shift_started_var_samp_order_by",
		variance:"event_shift_started_variance_order_by"
	},
	event_shift_started_arr_rel_insert_input:{
		data:"event_shift_started_insert_input",
		on_conflict:"event_shift_started_on_conflict"
	},
	event_shift_started_avg_order_by:{
		id:"order_by"
	},
	event_shift_started_bool_exp:{
		_and:"event_shift_started_bool_exp",
		_not:"event_shift_started_bool_exp",
		_or:"event_shift_started_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		shift:"shift_bool_exp",
		shift_id:"uuid_comparison_exp"
	},
	event_shift_started_constraint: "enum" as const,
	event_shift_started_inc_input:{

	},
	event_shift_started_insert_input:{
		event:"event_obj_rel_insert_input",
		shift:"shift_obj_rel_insert_input",
		shift_id:"uuid"
	},
	event_shift_started_max_order_by:{
		id:"order_by",
		shift_id:"order_by"
	},
	event_shift_started_min_order_by:{
		id:"order_by",
		shift_id:"order_by"
	},
	event_shift_started_obj_rel_insert_input:{
		data:"event_shift_started_insert_input",
		on_conflict:"event_shift_started_on_conflict"
	},
	event_shift_started_on_conflict:{
		constraint:"event_shift_started_constraint",
		update_columns:"event_shift_started_update_column",
		where:"event_shift_started_bool_exp"
	},
	event_shift_started_order_by:{
		event:"event_order_by",
		id:"order_by",
		shift:"shift_order_by",
		shift_id:"order_by"
	},
	event_shift_started_pk_columns_input:{

	},
	event_shift_started_select_column: "enum" as const,
	event_shift_started_set_input:{
		shift_id:"uuid"
	},
	event_shift_started_stddev_order_by:{
		id:"order_by"
	},
	event_shift_started_stddev_pop_order_by:{
		id:"order_by"
	},
	event_shift_started_stddev_samp_order_by:{
		id:"order_by"
	},
	event_shift_started_stream_cursor_input:{
		initial_value:"event_shift_started_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_shift_started_stream_cursor_value_input:{
		shift_id:"uuid"
	},
	event_shift_started_sum_order_by:{
		id:"order_by"
	},
	event_shift_started_update_column: "enum" as const,
	event_shift_started_updates:{
		_inc:"event_shift_started_inc_input",
		_set:"event_shift_started_set_input",
		where:"event_shift_started_bool_exp"
	},
	event_shift_started_var_pop_order_by:{
		id:"order_by"
	},
	event_shift_started_var_samp_order_by:{
		id:"order_by"
	},
	event_shift_started_variance_order_by:{
		id:"order_by"
	},
	event_shift_updated:{
		note:{

		}
	},
	event_shift_updated_aggregate_bool_exp:{
		bool_and:"event_shift_updated_aggregate_bool_exp_bool_and",
		bool_or:"event_shift_updated_aggregate_bool_exp_bool_or",
		count:"event_shift_updated_aggregate_bool_exp_count"
	},
	event_shift_updated_aggregate_bool_exp_bool_and:{
		arguments:"event_shift_updated_select_column_event_shift_updated_aggregate_bool_exp_bool_and_arguments_columns",
		filter:"event_shift_updated_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	event_shift_updated_aggregate_bool_exp_bool_or:{
		arguments:"event_shift_updated_select_column_event_shift_updated_aggregate_bool_exp_bool_or_arguments_columns",
		filter:"event_shift_updated_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	event_shift_updated_aggregate_bool_exp_count:{
		arguments:"event_shift_updated_select_column",
		filter:"event_shift_updated_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_shift_updated_aggregate_fields:{
		count:{
			columns:"event_shift_updated_select_column"
		}
	},
	event_shift_updated_aggregate_order_by:{
		avg:"event_shift_updated_avg_order_by",
		count:"order_by",
		max:"event_shift_updated_max_order_by",
		min:"event_shift_updated_min_order_by",
		stddev:"event_shift_updated_stddev_order_by",
		stddev_pop:"event_shift_updated_stddev_pop_order_by",
		stddev_samp:"event_shift_updated_stddev_samp_order_by",
		sum:"event_shift_updated_sum_order_by",
		var_pop:"event_shift_updated_var_pop_order_by",
		var_samp:"event_shift_updated_var_samp_order_by",
		variance:"event_shift_updated_variance_order_by"
	},
	event_shift_updated_append_input:{
		note:"jsonb"
	},
	event_shift_updated_arr_rel_insert_input:{
		data:"event_shift_updated_insert_input",
		on_conflict:"event_shift_updated_on_conflict"
	},
	event_shift_updated_avg_order_by:{
		id:"order_by"
	},
	event_shift_updated_bool_exp:{
		_and:"event_shift_updated_bool_exp",
		_not:"event_shift_updated_bool_exp",
		_or:"event_shift_updated_bool_exp",
		end_time:"timestamptz_comparison_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		is_recurring:"Boolean_comparison_exp",
		note:"jsonb_comparison_exp",
		recurrence_end_date:"timestamptz_comparison_exp",
		recurrence_pattern:"String_comparison_exp",
		shift:"shift_bool_exp",
		shift_id:"uuid_comparison_exp",
		shift_status:"String_comparison_exp",
		start_time:"timestamptz_comparison_exp",
		team_role_assignment:"team_role_assignment_bool_exp",
		team_role_assignment_id:"uuid_comparison_exp",
		user:"user_bool_exp",
		user_id:"uuid_comparison_exp"
	},
	event_shift_updated_constraint: "enum" as const,
	event_shift_updated_delete_at_path_input:{

	},
	event_shift_updated_delete_elem_input:{

	},
	event_shift_updated_delete_key_input:{

	},
	event_shift_updated_inc_input:{

	},
	event_shift_updated_insert_input:{
		end_time:"timestamptz",
		event:"event_obj_rel_insert_input",
		note:"jsonb",
		recurrence_end_date:"timestamptz",
		shift:"shift_obj_rel_insert_input",
		shift_id:"uuid",
		start_time:"timestamptz",
		team_role_assignment:"team_role_assignment_obj_rel_insert_input",
		team_role_assignment_id:"uuid",
		user:"user_obj_rel_insert_input",
		user_id:"uuid"
	},
	event_shift_updated_max_order_by:{
		end_time:"order_by",
		id:"order_by",
		recurrence_end_date:"order_by",
		recurrence_pattern:"order_by",
		shift_id:"order_by",
		shift_status:"order_by",
		start_time:"order_by",
		team_role_assignment_id:"order_by",
		user_id:"order_by"
	},
	event_shift_updated_min_order_by:{
		end_time:"order_by",
		id:"order_by",
		recurrence_end_date:"order_by",
		recurrence_pattern:"order_by",
		shift_id:"order_by",
		shift_status:"order_by",
		start_time:"order_by",
		team_role_assignment_id:"order_by",
		user_id:"order_by"
	},
	event_shift_updated_obj_rel_insert_input:{
		data:"event_shift_updated_insert_input",
		on_conflict:"event_shift_updated_on_conflict"
	},
	event_shift_updated_on_conflict:{
		constraint:"event_shift_updated_constraint",
		update_columns:"event_shift_updated_update_column",
		where:"event_shift_updated_bool_exp"
	},
	event_shift_updated_order_by:{
		end_time:"order_by",
		event:"event_order_by",
		id:"order_by",
		is_recurring:"order_by",
		note:"order_by",
		recurrence_end_date:"order_by",
		recurrence_pattern:"order_by",
		shift:"shift_order_by",
		shift_id:"order_by",
		shift_status:"order_by",
		start_time:"order_by",
		team_role_assignment:"team_role_assignment_order_by",
		team_role_assignment_id:"order_by",
		user:"user_order_by",
		user_id:"order_by"
	},
	event_shift_updated_pk_columns_input:{

	},
	event_shift_updated_prepend_input:{
		note:"jsonb"
	},
	event_shift_updated_select_column: "enum" as const,
	event_shift_updated_select_column_event_shift_updated_aggregate_bool_exp_bool_and_arguments_columns: "enum" as const,
	event_shift_updated_select_column_event_shift_updated_aggregate_bool_exp_bool_or_arguments_columns: "enum" as const,
	event_shift_updated_set_input:{
		end_time:"timestamptz",
		note:"jsonb",
		recurrence_end_date:"timestamptz",
		shift_id:"uuid",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user_id:"uuid"
	},
	event_shift_updated_stddev_order_by:{
		id:"order_by"
	},
	event_shift_updated_stddev_pop_order_by:{
		id:"order_by"
	},
	event_shift_updated_stddev_samp_order_by:{
		id:"order_by"
	},
	event_shift_updated_stream_cursor_input:{
		initial_value:"event_shift_updated_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_shift_updated_stream_cursor_value_input:{
		end_time:"timestamptz",
		note:"jsonb",
		recurrence_end_date:"timestamptz",
		shift_id:"uuid",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user_id:"uuid"
	},
	event_shift_updated_sum_order_by:{
		id:"order_by"
	},
	event_shift_updated_update_column: "enum" as const,
	event_shift_updated_updates:{
		_append:"event_shift_updated_append_input",
		_delete_at_path:"event_shift_updated_delete_at_path_input",
		_delete_elem:"event_shift_updated_delete_elem_input",
		_delete_key:"event_shift_updated_delete_key_input",
		_inc:"event_shift_updated_inc_input",
		_prepend:"event_shift_updated_prepend_input",
		_set:"event_shift_updated_set_input",
		where:"event_shift_updated_bool_exp"
	},
	event_shift_updated_var_pop_order_by:{
		id:"order_by"
	},
	event_shift_updated_var_samp_order_by:{
		id:"order_by"
	},
	event_shift_updated_variance_order_by:{
		id:"order_by"
	},
	event_stddev_order_by:{
		id:"order_by"
	},
	event_stddev_pop_order_by:{
		id:"order_by"
	},
	event_stddev_samp_order_by:{
		id:"order_by"
	},
	event_stream_cursor_input:{
		initial_value:"event_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_stream_cursor_value_input:{
		created_at:"timestamptz",
		created_by:"uuid",
		event_type:"event_type_t",
		new:"jsonb",
		old:"jsonb",
		payload:"jsonb",
		team_id:"uuid",
		user_id:"uuid"
	},
	event_sum_order_by:{
		id:"order_by"
	},
	event_team_created:{
		team_role_assignments:{
			distinct_on:"event_team_role_assignment_created_select_column",
			order_by:"event_team_role_assignment_created_order_by",
			where:"event_team_role_assignment_created_bool_exp"
		},
		team_role_assignments_aggregate:{
			distinct_on:"event_team_role_assignment_created_select_column",
			order_by:"event_team_role_assignment_created_order_by",
			where:"event_team_role_assignment_created_bool_exp"
		},
		team_settings:{

		}
	},
	event_team_created_aggregate_fields:{
		count:{
			columns:"event_team_created_select_column"
		}
	},
	event_team_created_append_input:{
		team_settings:"jsonb"
	},
	event_team_created_bool_exp:{
		_and:"event_team_created_bool_exp",
		_not:"event_team_created_bool_exp",
		_or:"event_team_created_bool_exp",
		cost_object_description:"String_comparison_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		internal_order_number:"String_comparison_exp",
		name:"String_comparison_exp",
		team_id:"uuid_comparison_exp",
		team_role_assignments:"event_team_role_assignment_created_bool_exp",
		team_role_assignments_aggregate:"event_team_role_assignment_created_aggregate_bool_exp",
		team_settings:"jsonb_comparison_exp",
		team_type:"String_comparison_exp"
	},
	event_team_created_constraint: "enum" as const,
	event_team_created_delete_at_path_input:{

	},
	event_team_created_delete_elem_input:{

	},
	event_team_created_delete_key_input:{

	},
	event_team_created_inc_input:{

	},
	event_team_created_insert_input:{
		event:"event_obj_rel_insert_input",
		team_id:"uuid",
		team_role_assignments:"event_team_role_assignment_created_arr_rel_insert_input",
		team_settings:"jsonb"
	},
	event_team_created_obj_rel_insert_input:{
		data:"event_team_created_insert_input",
		on_conflict:"event_team_created_on_conflict"
	},
	event_team_created_on_conflict:{
		constraint:"event_team_created_constraint",
		update_columns:"event_team_created_update_column",
		where:"event_team_created_bool_exp"
	},
	event_team_created_order_by:{
		cost_object_description:"order_by",
		event:"event_order_by",
		id:"order_by",
		internal_order_number:"order_by",
		name:"order_by",
		team_id:"order_by",
		team_role_assignments_aggregate:"event_team_role_assignment_created_aggregate_order_by",
		team_settings:"order_by",
		team_type:"order_by"
	},
	event_team_created_pk_columns_input:{

	},
	event_team_created_prepend_input:{
		team_settings:"jsonb"
	},
	event_team_created_select_column: "enum" as const,
	event_team_created_set_input:{
		team_id:"uuid",
		team_settings:"jsonb"
	},
	event_team_created_stream_cursor_input:{
		initial_value:"event_team_created_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_team_created_stream_cursor_value_input:{
		team_id:"uuid",
		team_settings:"jsonb"
	},
	event_team_created_update_column: "enum" as const,
	event_team_created_updates:{
		_append:"event_team_created_append_input",
		_delete_at_path:"event_team_created_delete_at_path_input",
		_delete_elem:"event_team_created_delete_elem_input",
		_delete_key:"event_team_created_delete_key_input",
		_inc:"event_team_created_inc_input",
		_prepend:"event_team_created_prepend_input",
		_set:"event_team_created_set_input",
		where:"event_team_created_bool_exp"
	},
	event_team_deleted_aggregate_bool_exp:{
		count:"event_team_deleted_aggregate_bool_exp_count"
	},
	event_team_deleted_aggregate_bool_exp_count:{
		arguments:"event_team_deleted_select_column",
		filter:"event_team_deleted_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_team_deleted_aggregate_fields:{
		count:{
			columns:"event_team_deleted_select_column"
		}
	},
	event_team_deleted_aggregate_order_by:{
		avg:"event_team_deleted_avg_order_by",
		count:"order_by",
		max:"event_team_deleted_max_order_by",
		min:"event_team_deleted_min_order_by",
		stddev:"event_team_deleted_stddev_order_by",
		stddev_pop:"event_team_deleted_stddev_pop_order_by",
		stddev_samp:"event_team_deleted_stddev_samp_order_by",
		sum:"event_team_deleted_sum_order_by",
		var_pop:"event_team_deleted_var_pop_order_by",
		var_samp:"event_team_deleted_var_samp_order_by",
		variance:"event_team_deleted_variance_order_by"
	},
	event_team_deleted_arr_rel_insert_input:{
		data:"event_team_deleted_insert_input",
		on_conflict:"event_team_deleted_on_conflict"
	},
	event_team_deleted_avg_order_by:{
		id:"order_by"
	},
	event_team_deleted_bool_exp:{
		_and:"event_team_deleted_bool_exp",
		_not:"event_team_deleted_bool_exp",
		_or:"event_team_deleted_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		reason:"String_comparison_exp",
		team:"team_bool_exp",
		team_id:"uuid_comparison_exp"
	},
	event_team_deleted_constraint: "enum" as const,
	event_team_deleted_inc_input:{

	},
	event_team_deleted_insert_input:{
		event:"event_obj_rel_insert_input",
		team:"team_obj_rel_insert_input",
		team_id:"uuid"
	},
	event_team_deleted_max_order_by:{
		id:"order_by",
		reason:"order_by",
		team_id:"order_by"
	},
	event_team_deleted_min_order_by:{
		id:"order_by",
		reason:"order_by",
		team_id:"order_by"
	},
	event_team_deleted_obj_rel_insert_input:{
		data:"event_team_deleted_insert_input",
		on_conflict:"event_team_deleted_on_conflict"
	},
	event_team_deleted_on_conflict:{
		constraint:"event_team_deleted_constraint",
		update_columns:"event_team_deleted_update_column",
		where:"event_team_deleted_bool_exp"
	},
	event_team_deleted_order_by:{
		event:"event_order_by",
		id:"order_by",
		reason:"order_by",
		team:"team_order_by",
		team_id:"order_by"
	},
	event_team_deleted_pk_columns_input:{

	},
	event_team_deleted_select_column: "enum" as const,
	event_team_deleted_set_input:{
		team_id:"uuid"
	},
	event_team_deleted_stddev_order_by:{
		id:"order_by"
	},
	event_team_deleted_stddev_pop_order_by:{
		id:"order_by"
	},
	event_team_deleted_stddev_samp_order_by:{
		id:"order_by"
	},
	event_team_deleted_stream_cursor_input:{
		initial_value:"event_team_deleted_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_team_deleted_stream_cursor_value_input:{
		team_id:"uuid"
	},
	event_team_deleted_sum_order_by:{
		id:"order_by"
	},
	event_team_deleted_update_column: "enum" as const,
	event_team_deleted_updates:{
		_inc:"event_team_deleted_inc_input",
		_set:"event_team_deleted_set_input",
		where:"event_team_deleted_bool_exp"
	},
	event_team_deleted_var_pop_order_by:{
		id:"order_by"
	},
	event_team_deleted_var_samp_order_by:{
		id:"order_by"
	},
	event_team_deleted_variance_order_by:{
		id:"order_by"
	},
	event_team_reactivated_aggregate_bool_exp:{
		count:"event_team_reactivated_aggregate_bool_exp_count"
	},
	event_team_reactivated_aggregate_bool_exp_count:{
		arguments:"event_team_reactivated_select_column",
		filter:"event_team_reactivated_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_team_reactivated_aggregate_fields:{
		count:{
			columns:"event_team_reactivated_select_column"
		}
	},
	event_team_reactivated_aggregate_order_by:{
		avg:"event_team_reactivated_avg_order_by",
		count:"order_by",
		max:"event_team_reactivated_max_order_by",
		min:"event_team_reactivated_min_order_by",
		stddev:"event_team_reactivated_stddev_order_by",
		stddev_pop:"event_team_reactivated_stddev_pop_order_by",
		stddev_samp:"event_team_reactivated_stddev_samp_order_by",
		sum:"event_team_reactivated_sum_order_by",
		var_pop:"event_team_reactivated_var_pop_order_by",
		var_samp:"event_team_reactivated_var_samp_order_by",
		variance:"event_team_reactivated_variance_order_by"
	},
	event_team_reactivated_arr_rel_insert_input:{
		data:"event_team_reactivated_insert_input",
		on_conflict:"event_team_reactivated_on_conflict"
	},
	event_team_reactivated_avg_order_by:{
		id:"order_by"
	},
	event_team_reactivated_bool_exp:{
		_and:"event_team_reactivated_bool_exp",
		_not:"event_team_reactivated_bool_exp",
		_or:"event_team_reactivated_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		reason:"String_comparison_exp",
		team:"team_bool_exp",
		team_id:"uuid_comparison_exp"
	},
	event_team_reactivated_constraint: "enum" as const,
	event_team_reactivated_inc_input:{

	},
	event_team_reactivated_insert_input:{
		event:"event_obj_rel_insert_input",
		team:"team_obj_rel_insert_input",
		team_id:"uuid"
	},
	event_team_reactivated_max_order_by:{
		id:"order_by",
		reason:"order_by",
		team_id:"order_by"
	},
	event_team_reactivated_min_order_by:{
		id:"order_by",
		reason:"order_by",
		team_id:"order_by"
	},
	event_team_reactivated_obj_rel_insert_input:{
		data:"event_team_reactivated_insert_input",
		on_conflict:"event_team_reactivated_on_conflict"
	},
	event_team_reactivated_on_conflict:{
		constraint:"event_team_reactivated_constraint",
		update_columns:"event_team_reactivated_update_column",
		where:"event_team_reactivated_bool_exp"
	},
	event_team_reactivated_order_by:{
		event:"event_order_by",
		id:"order_by",
		reason:"order_by",
		team:"team_order_by",
		team_id:"order_by"
	},
	event_team_reactivated_pk_columns_input:{

	},
	event_team_reactivated_select_column: "enum" as const,
	event_team_reactivated_set_input:{
		team_id:"uuid"
	},
	event_team_reactivated_stddev_order_by:{
		id:"order_by"
	},
	event_team_reactivated_stddev_pop_order_by:{
		id:"order_by"
	},
	event_team_reactivated_stddev_samp_order_by:{
		id:"order_by"
	},
	event_team_reactivated_stream_cursor_input:{
		initial_value:"event_team_reactivated_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_team_reactivated_stream_cursor_value_input:{
		team_id:"uuid"
	},
	event_team_reactivated_sum_order_by:{
		id:"order_by"
	},
	event_team_reactivated_update_column: "enum" as const,
	event_team_reactivated_updates:{
		_inc:"event_team_reactivated_inc_input",
		_set:"event_team_reactivated_set_input",
		where:"event_team_reactivated_bool_exp"
	},
	event_team_reactivated_var_pop_order_by:{
		id:"order_by"
	},
	event_team_reactivated_var_samp_order_by:{
		id:"order_by"
	},
	event_team_reactivated_variance_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_created:{
		team:{
			distinct_on:"team_select_column",
			order_by:"team_order_by",
			where:"team_bool_exp"
		},
		team_aggregate:{
			distinct_on:"team_select_column",
			order_by:"team_order_by",
			where:"team_bool_exp"
		}
	},
	event_team_role_assignment_created_aggregate_bool_exp:{
		count:"event_team_role_assignment_created_aggregate_bool_exp_count"
	},
	event_team_role_assignment_created_aggregate_bool_exp_count:{
		arguments:"event_team_role_assignment_created_select_column",
		filter:"event_team_role_assignment_created_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_team_role_assignment_created_aggregate_fields:{
		count:{
			columns:"event_team_role_assignment_created_select_column"
		}
	},
	event_team_role_assignment_created_aggregate_order_by:{
		avg:"event_team_role_assignment_created_avg_order_by",
		count:"order_by",
		max:"event_team_role_assignment_created_max_order_by",
		min:"event_team_role_assignment_created_min_order_by",
		stddev:"event_team_role_assignment_created_stddev_order_by",
		stddev_pop:"event_team_role_assignment_created_stddev_pop_order_by",
		stddev_samp:"event_team_role_assignment_created_stddev_samp_order_by",
		sum:"event_team_role_assignment_created_sum_order_by",
		var_pop:"event_team_role_assignment_created_var_pop_order_by",
		var_samp:"event_team_role_assignment_created_var_samp_order_by",
		variance:"event_team_role_assignment_created_variance_order_by"
	},
	event_team_role_assignment_created_arr_rel_insert_input:{
		data:"event_team_role_assignment_created_insert_input",
		on_conflict:"event_team_role_assignment_created_on_conflict"
	},
	event_team_role_assignment_created_avg_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_created_bool_exp:{
		_and:"event_team_role_assignment_created_bool_exp",
		_not:"event_team_role_assignment_created_bool_exp",
		_or:"event_team_role_assignment_created_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		role:"team_role_bool_exp",
		team:"team_bool_exp",
		team_aggregate:"team_aggregate_bool_exp",
		team_id:"uuid_comparison_exp",
		team_role_assignment:"team_role_assignment_bool_exp",
		team_role_assignment_id:"uuid_comparison_exp",
		team_role_id:"uuid_comparison_exp"
	},
	event_team_role_assignment_created_constraint: "enum" as const,
	event_team_role_assignment_created_inc_input:{

	},
	event_team_role_assignment_created_insert_input:{
		event:"event_obj_rel_insert_input",
		role:"team_role_obj_rel_insert_input",
		team:"team_arr_rel_insert_input",
		team_id:"uuid",
		team_role_assignment:"team_role_assignment_obj_rel_insert_input",
		team_role_assignment_id:"uuid",
		team_role_id:"uuid"
	},
	event_team_role_assignment_created_max_order_by:{
		id:"order_by",
		team_id:"order_by",
		team_role_assignment_id:"order_by",
		team_role_id:"order_by"
	},
	event_team_role_assignment_created_min_order_by:{
		id:"order_by",
		team_id:"order_by",
		team_role_assignment_id:"order_by",
		team_role_id:"order_by"
	},
	event_team_role_assignment_created_obj_rel_insert_input:{
		data:"event_team_role_assignment_created_insert_input",
		on_conflict:"event_team_role_assignment_created_on_conflict"
	},
	event_team_role_assignment_created_on_conflict:{
		constraint:"event_team_role_assignment_created_constraint",
		update_columns:"event_team_role_assignment_created_update_column",
		where:"event_team_role_assignment_created_bool_exp"
	},
	event_team_role_assignment_created_order_by:{
		event:"event_order_by",
		id:"order_by",
		role:"team_role_order_by",
		team_aggregate:"team_aggregate_order_by",
		team_id:"order_by",
		team_role_assignment:"team_role_assignment_order_by",
		team_role_assignment_id:"order_by",
		team_role_id:"order_by"
	},
	event_team_role_assignment_created_pk_columns_input:{

	},
	event_team_role_assignment_created_select_column: "enum" as const,
	event_team_role_assignment_created_set_input:{
		team_id:"uuid",
		team_role_assignment_id:"uuid",
		team_role_id:"uuid"
	},
	event_team_role_assignment_created_stddev_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_created_stddev_pop_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_created_stddev_samp_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_created_stream_cursor_input:{
		initial_value:"event_team_role_assignment_created_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_team_role_assignment_created_stream_cursor_value_input:{
		team_id:"uuid",
		team_role_assignment_id:"uuid",
		team_role_id:"uuid"
	},
	event_team_role_assignment_created_sum_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_created_update_column: "enum" as const,
	event_team_role_assignment_created_updates:{
		_inc:"event_team_role_assignment_created_inc_input",
		_set:"event_team_role_assignment_created_set_input",
		where:"event_team_role_assignment_created_bool_exp"
	},
	event_team_role_assignment_created_var_pop_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_created_var_samp_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_created_variance_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_deleted_aggregate_bool_exp:{
		count:"event_team_role_assignment_deleted_aggregate_bool_exp_count"
	},
	event_team_role_assignment_deleted_aggregate_bool_exp_count:{
		arguments:"event_team_role_assignment_deleted_select_column",
		filter:"event_team_role_assignment_deleted_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_team_role_assignment_deleted_aggregate_fields:{
		count:{
			columns:"event_team_role_assignment_deleted_select_column"
		}
	},
	event_team_role_assignment_deleted_aggregate_order_by:{
		avg:"event_team_role_assignment_deleted_avg_order_by",
		count:"order_by",
		max:"event_team_role_assignment_deleted_max_order_by",
		min:"event_team_role_assignment_deleted_min_order_by",
		stddev:"event_team_role_assignment_deleted_stddev_order_by",
		stddev_pop:"event_team_role_assignment_deleted_stddev_pop_order_by",
		stddev_samp:"event_team_role_assignment_deleted_stddev_samp_order_by",
		sum:"event_team_role_assignment_deleted_sum_order_by",
		var_pop:"event_team_role_assignment_deleted_var_pop_order_by",
		var_samp:"event_team_role_assignment_deleted_var_samp_order_by",
		variance:"event_team_role_assignment_deleted_variance_order_by"
	},
	event_team_role_assignment_deleted_arr_rel_insert_input:{
		data:"event_team_role_assignment_deleted_insert_input",
		on_conflict:"event_team_role_assignment_deleted_on_conflict"
	},
	event_team_role_assignment_deleted_avg_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_deleted_bool_exp:{
		_and:"event_team_role_assignment_deleted_bool_exp",
		_not:"event_team_role_assignment_deleted_bool_exp",
		_or:"event_team_role_assignment_deleted_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		team_role_assignment:"team_role_assignment_bool_exp",
		team_role_assignment_id:"uuid_comparison_exp"
	},
	event_team_role_assignment_deleted_constraint: "enum" as const,
	event_team_role_assignment_deleted_inc_input:{

	},
	event_team_role_assignment_deleted_insert_input:{
		event:"event_obj_rel_insert_input",
		team_role_assignment:"team_role_assignment_obj_rel_insert_input",
		team_role_assignment_id:"uuid"
	},
	event_team_role_assignment_deleted_max_order_by:{
		id:"order_by",
		team_role_assignment_id:"order_by"
	},
	event_team_role_assignment_deleted_min_order_by:{
		id:"order_by",
		team_role_assignment_id:"order_by"
	},
	event_team_role_assignment_deleted_obj_rel_insert_input:{
		data:"event_team_role_assignment_deleted_insert_input",
		on_conflict:"event_team_role_assignment_deleted_on_conflict"
	},
	event_team_role_assignment_deleted_on_conflict:{
		constraint:"event_team_role_assignment_deleted_constraint",
		update_columns:"event_team_role_assignment_deleted_update_column",
		where:"event_team_role_assignment_deleted_bool_exp"
	},
	event_team_role_assignment_deleted_order_by:{
		event:"event_order_by",
		id:"order_by",
		team_role_assignment:"team_role_assignment_order_by",
		team_role_assignment_id:"order_by"
	},
	event_team_role_assignment_deleted_pk_columns_input:{

	},
	event_team_role_assignment_deleted_select_column: "enum" as const,
	event_team_role_assignment_deleted_set_input:{
		team_role_assignment_id:"uuid"
	},
	event_team_role_assignment_deleted_stddev_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_deleted_stddev_pop_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_deleted_stddev_samp_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_deleted_stream_cursor_input:{
		initial_value:"event_team_role_assignment_deleted_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_team_role_assignment_deleted_stream_cursor_value_input:{
		team_role_assignment_id:"uuid"
	},
	event_team_role_assignment_deleted_sum_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_deleted_update_column: "enum" as const,
	event_team_role_assignment_deleted_updates:{
		_inc:"event_team_role_assignment_deleted_inc_input",
		_set:"event_team_role_assignment_deleted_set_input",
		where:"event_team_role_assignment_deleted_bool_exp"
	},
	event_team_role_assignment_deleted_var_pop_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_deleted_var_samp_order_by:{
		id:"order_by"
	},
	event_team_role_assignment_deleted_variance_order_by:{
		id:"order_by"
	},
	event_team_role_created_aggregate_fields:{
		count:{
			columns:"event_team_role_created_select_column"
		}
	},
	event_team_role_created_bool_exp:{
		_and:"event_team_role_created_bool_exp",
		_not:"event_team_role_created_bool_exp",
		_or:"event_team_role_created_bool_exp",
		abbreviation:"String_comparison_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		name:"String_comparison_exp",
		read_only:"Boolean_comparison_exp",
		role_group:"role_group_t_comparison_exp",
		team_role_id:"uuid_comparison_exp"
	},
	event_team_role_created_constraint: "enum" as const,
	event_team_role_created_inc_input:{

	},
	event_team_role_created_insert_input:{
		event:"event_obj_rel_insert_input",
		role_group:"role_group_t",
		team_role_id:"uuid"
	},
	event_team_role_created_obj_rel_insert_input:{
		data:"event_team_role_created_insert_input",
		on_conflict:"event_team_role_created_on_conflict"
	},
	event_team_role_created_on_conflict:{
		constraint:"event_team_role_created_constraint",
		update_columns:"event_team_role_created_update_column",
		where:"event_team_role_created_bool_exp"
	},
	event_team_role_created_order_by:{
		abbreviation:"order_by",
		event:"event_order_by",
		id:"order_by",
		name:"order_by",
		read_only:"order_by",
		role_group:"order_by",
		team_role_id:"order_by"
	},
	event_team_role_created_pk_columns_input:{

	},
	event_team_role_created_select_column: "enum" as const,
	event_team_role_created_set_input:{
		role_group:"role_group_t",
		team_role_id:"uuid"
	},
	event_team_role_created_stream_cursor_input:{
		initial_value:"event_team_role_created_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_team_role_created_stream_cursor_value_input:{
		role_group:"role_group_t",
		team_role_id:"uuid"
	},
	event_team_role_created_update_column: "enum" as const,
	event_team_role_created_updates:{
		_inc:"event_team_role_created_inc_input",
		_set:"event_team_role_created_set_input",
		where:"event_team_role_created_bool_exp"
	},
	event_team_role_deleted_aggregate_bool_exp:{
		count:"event_team_role_deleted_aggregate_bool_exp_count"
	},
	event_team_role_deleted_aggregate_bool_exp_count:{
		arguments:"event_team_role_deleted_select_column",
		filter:"event_team_role_deleted_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_team_role_deleted_aggregate_fields:{
		count:{
			columns:"event_team_role_deleted_select_column"
		}
	},
	event_team_role_deleted_aggregate_order_by:{
		avg:"event_team_role_deleted_avg_order_by",
		count:"order_by",
		max:"event_team_role_deleted_max_order_by",
		min:"event_team_role_deleted_min_order_by",
		stddev:"event_team_role_deleted_stddev_order_by",
		stddev_pop:"event_team_role_deleted_stddev_pop_order_by",
		stddev_samp:"event_team_role_deleted_stddev_samp_order_by",
		sum:"event_team_role_deleted_sum_order_by",
		var_pop:"event_team_role_deleted_var_pop_order_by",
		var_samp:"event_team_role_deleted_var_samp_order_by",
		variance:"event_team_role_deleted_variance_order_by"
	},
	event_team_role_deleted_arr_rel_insert_input:{
		data:"event_team_role_deleted_insert_input",
		on_conflict:"event_team_role_deleted_on_conflict"
	},
	event_team_role_deleted_avg_order_by:{
		id:"order_by"
	},
	event_team_role_deleted_bool_exp:{
		_and:"event_team_role_deleted_bool_exp",
		_not:"event_team_role_deleted_bool_exp",
		_or:"event_team_role_deleted_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		team_role:"team_role_bool_exp",
		team_role_id:"uuid_comparison_exp"
	},
	event_team_role_deleted_constraint: "enum" as const,
	event_team_role_deleted_inc_input:{

	},
	event_team_role_deleted_insert_input:{
		event:"event_obj_rel_insert_input",
		team_role:"team_role_obj_rel_insert_input",
		team_role_id:"uuid"
	},
	event_team_role_deleted_max_order_by:{
		id:"order_by",
		team_role_id:"order_by"
	},
	event_team_role_deleted_min_order_by:{
		id:"order_by",
		team_role_id:"order_by"
	},
	event_team_role_deleted_obj_rel_insert_input:{
		data:"event_team_role_deleted_insert_input",
		on_conflict:"event_team_role_deleted_on_conflict"
	},
	event_team_role_deleted_on_conflict:{
		constraint:"event_team_role_deleted_constraint",
		update_columns:"event_team_role_deleted_update_column",
		where:"event_team_role_deleted_bool_exp"
	},
	event_team_role_deleted_order_by:{
		event:"event_order_by",
		id:"order_by",
		team_role:"team_role_order_by",
		team_role_id:"order_by"
	},
	event_team_role_deleted_pk_columns_input:{

	},
	event_team_role_deleted_select_column: "enum" as const,
	event_team_role_deleted_set_input:{
		team_role_id:"uuid"
	},
	event_team_role_deleted_stddev_order_by:{
		id:"order_by"
	},
	event_team_role_deleted_stddev_pop_order_by:{
		id:"order_by"
	},
	event_team_role_deleted_stddev_samp_order_by:{
		id:"order_by"
	},
	event_team_role_deleted_stream_cursor_input:{
		initial_value:"event_team_role_deleted_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_team_role_deleted_stream_cursor_value_input:{
		team_role_id:"uuid"
	},
	event_team_role_deleted_sum_order_by:{
		id:"order_by"
	},
	event_team_role_deleted_update_column: "enum" as const,
	event_team_role_deleted_updates:{
		_inc:"event_team_role_deleted_inc_input",
		_set:"event_team_role_deleted_set_input",
		where:"event_team_role_deleted_bool_exp"
	},
	event_team_role_deleted_var_pop_order_by:{
		id:"order_by"
	},
	event_team_role_deleted_var_samp_order_by:{
		id:"order_by"
	},
	event_team_role_deleted_variance_order_by:{
		id:"order_by"
	},
	event_team_role_updated_aggregate_bool_exp:{
		bool_and:"event_team_role_updated_aggregate_bool_exp_bool_and",
		bool_or:"event_team_role_updated_aggregate_bool_exp_bool_or",
		count:"event_team_role_updated_aggregate_bool_exp_count"
	},
	event_team_role_updated_aggregate_bool_exp_bool_and:{
		arguments:"event_team_role_updated_select_column_event_team_role_updated_aggregate_bool_exp_bool_and_arguments_columns",
		filter:"event_team_role_updated_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	event_team_role_updated_aggregate_bool_exp_bool_or:{
		arguments:"event_team_role_updated_select_column_event_team_role_updated_aggregate_bool_exp_bool_or_arguments_columns",
		filter:"event_team_role_updated_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	event_team_role_updated_aggregate_bool_exp_count:{
		arguments:"event_team_role_updated_select_column",
		filter:"event_team_role_updated_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_team_role_updated_aggregate_fields:{
		count:{
			columns:"event_team_role_updated_select_column"
		}
	},
	event_team_role_updated_aggregate_order_by:{
		avg:"event_team_role_updated_avg_order_by",
		count:"order_by",
		max:"event_team_role_updated_max_order_by",
		min:"event_team_role_updated_min_order_by",
		stddev:"event_team_role_updated_stddev_order_by",
		stddev_pop:"event_team_role_updated_stddev_pop_order_by",
		stddev_samp:"event_team_role_updated_stddev_samp_order_by",
		sum:"event_team_role_updated_sum_order_by",
		var_pop:"event_team_role_updated_var_pop_order_by",
		var_samp:"event_team_role_updated_var_samp_order_by",
		variance:"event_team_role_updated_variance_order_by"
	},
	event_team_role_updated_arr_rel_insert_input:{
		data:"event_team_role_updated_insert_input",
		on_conflict:"event_team_role_updated_on_conflict"
	},
	event_team_role_updated_avg_order_by:{
		id:"order_by"
	},
	event_team_role_updated_bool_exp:{
		_and:"event_team_role_updated_bool_exp",
		_not:"event_team_role_updated_bool_exp",
		_or:"event_team_role_updated_bool_exp",
		abbreviation:"String_comparison_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		name:"String_comparison_exp",
		read_only:"Boolean_comparison_exp",
		record_status:"record_status_t_comparison_exp",
		role_group:"role_group_t_comparison_exp",
		team_role:"team_role_bool_exp",
		team_role_id:"uuid_comparison_exp"
	},
	event_team_role_updated_constraint: "enum" as const,
	event_team_role_updated_inc_input:{

	},
	event_team_role_updated_insert_input:{
		event:"event_obj_rel_insert_input",
		record_status:"record_status_t",
		role_group:"role_group_t",
		team_role:"team_role_obj_rel_insert_input",
		team_role_id:"uuid"
	},
	event_team_role_updated_max_order_by:{
		abbreviation:"order_by",
		id:"order_by",
		name:"order_by",
		record_status:"order_by",
		role_group:"order_by",
		team_role_id:"order_by"
	},
	event_team_role_updated_min_order_by:{
		abbreviation:"order_by",
		id:"order_by",
		name:"order_by",
		record_status:"order_by",
		role_group:"order_by",
		team_role_id:"order_by"
	},
	event_team_role_updated_obj_rel_insert_input:{
		data:"event_team_role_updated_insert_input",
		on_conflict:"event_team_role_updated_on_conflict"
	},
	event_team_role_updated_on_conflict:{
		constraint:"event_team_role_updated_constraint",
		update_columns:"event_team_role_updated_update_column",
		where:"event_team_role_updated_bool_exp"
	},
	event_team_role_updated_order_by:{
		abbreviation:"order_by",
		event:"event_order_by",
		id:"order_by",
		name:"order_by",
		read_only:"order_by",
		record_status:"order_by",
		role_group:"order_by",
		team_role:"team_role_order_by",
		team_role_id:"order_by"
	},
	event_team_role_updated_pk_columns_input:{

	},
	event_team_role_updated_select_column: "enum" as const,
	event_team_role_updated_select_column_event_team_role_updated_aggregate_bool_exp_bool_and_arguments_columns: "enum" as const,
	event_team_role_updated_select_column_event_team_role_updated_aggregate_bool_exp_bool_or_arguments_columns: "enum" as const,
	event_team_role_updated_set_input:{
		record_status:"record_status_t",
		role_group:"role_group_t",
		team_role_id:"uuid"
	},
	event_team_role_updated_stddev_order_by:{
		id:"order_by"
	},
	event_team_role_updated_stddev_pop_order_by:{
		id:"order_by"
	},
	event_team_role_updated_stddev_samp_order_by:{
		id:"order_by"
	},
	event_team_role_updated_stream_cursor_input:{
		initial_value:"event_team_role_updated_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_team_role_updated_stream_cursor_value_input:{
		record_status:"record_status_t",
		role_group:"role_group_t",
		team_role_id:"uuid"
	},
	event_team_role_updated_sum_order_by:{
		id:"order_by"
	},
	event_team_role_updated_update_column: "enum" as const,
	event_team_role_updated_updates:{
		_inc:"event_team_role_updated_inc_input",
		_set:"event_team_role_updated_set_input",
		where:"event_team_role_updated_bool_exp"
	},
	event_team_role_updated_var_pop_order_by:{
		id:"order_by"
	},
	event_team_role_updated_var_samp_order_by:{
		id:"order_by"
	},
	event_team_role_updated_variance_order_by:{
		id:"order_by"
	},
	event_team_updated:{
		team_settings:{

		}
	},
	event_team_updated_aggregate_bool_exp:{
		count:"event_team_updated_aggregate_bool_exp_count"
	},
	event_team_updated_aggregate_bool_exp_count:{
		arguments:"event_team_updated_select_column",
		filter:"event_team_updated_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_team_updated_aggregate_fields:{
		count:{
			columns:"event_team_updated_select_column"
		}
	},
	event_team_updated_aggregate_order_by:{
		avg:"event_team_updated_avg_order_by",
		count:"order_by",
		max:"event_team_updated_max_order_by",
		min:"event_team_updated_min_order_by",
		stddev:"event_team_updated_stddev_order_by",
		stddev_pop:"event_team_updated_stddev_pop_order_by",
		stddev_samp:"event_team_updated_stddev_samp_order_by",
		sum:"event_team_updated_sum_order_by",
		var_pop:"event_team_updated_var_pop_order_by",
		var_samp:"event_team_updated_var_samp_order_by",
		variance:"event_team_updated_variance_order_by"
	},
	event_team_updated_append_input:{
		team_settings:"jsonb"
	},
	event_team_updated_arr_rel_insert_input:{
		data:"event_team_updated_insert_input",
		on_conflict:"event_team_updated_on_conflict"
	},
	event_team_updated_avg_order_by:{
		id:"order_by"
	},
	event_team_updated_bool_exp:{
		_and:"event_team_updated_bool_exp",
		_not:"event_team_updated_bool_exp",
		_or:"event_team_updated_bool_exp",
		cost_object_description:"String_comparison_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		internal_order_number:"String_comparison_exp",
		name:"String_comparison_exp",
		team:"team_bool_exp",
		team_id:"uuid_comparison_exp",
		team_settings:"jsonb_comparison_exp",
		team_type:"String_comparison_exp"
	},
	event_team_updated_constraint: "enum" as const,
	event_team_updated_delete_at_path_input:{

	},
	event_team_updated_delete_elem_input:{

	},
	event_team_updated_delete_key_input:{

	},
	event_team_updated_inc_input:{

	},
	event_team_updated_insert_input:{
		event:"event_obj_rel_insert_input",
		team:"team_obj_rel_insert_input",
		team_id:"uuid",
		team_settings:"jsonb"
	},
	event_team_updated_max_order_by:{
		cost_object_description:"order_by",
		id:"order_by",
		internal_order_number:"order_by",
		name:"order_by",
		team_id:"order_by",
		team_type:"order_by"
	},
	event_team_updated_min_order_by:{
		cost_object_description:"order_by",
		id:"order_by",
		internal_order_number:"order_by",
		name:"order_by",
		team_id:"order_by",
		team_type:"order_by"
	},
	event_team_updated_obj_rel_insert_input:{
		data:"event_team_updated_insert_input",
		on_conflict:"event_team_updated_on_conflict"
	},
	event_team_updated_on_conflict:{
		constraint:"event_team_updated_constraint",
		update_columns:"event_team_updated_update_column",
		where:"event_team_updated_bool_exp"
	},
	event_team_updated_order_by:{
		cost_object_description:"order_by",
		event:"event_order_by",
		id:"order_by",
		internal_order_number:"order_by",
		name:"order_by",
		team:"team_order_by",
		team_id:"order_by",
		team_settings:"order_by",
		team_type:"order_by"
	},
	event_team_updated_pk_columns_input:{

	},
	event_team_updated_prepend_input:{
		team_settings:"jsonb"
	},
	event_team_updated_select_column: "enum" as const,
	event_team_updated_set_input:{
		team_id:"uuid",
		team_settings:"jsonb"
	},
	event_team_updated_stddev_order_by:{
		id:"order_by"
	},
	event_team_updated_stddev_pop_order_by:{
		id:"order_by"
	},
	event_team_updated_stddev_samp_order_by:{
		id:"order_by"
	},
	event_team_updated_stream_cursor_input:{
		initial_value:"event_team_updated_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_team_updated_stream_cursor_value_input:{
		team_id:"uuid",
		team_settings:"jsonb"
	},
	event_team_updated_sum_order_by:{
		id:"order_by"
	},
	event_team_updated_update_column: "enum" as const,
	event_team_updated_updates:{
		_append:"event_team_updated_append_input",
		_delete_at_path:"event_team_updated_delete_at_path_input",
		_delete_elem:"event_team_updated_delete_elem_input",
		_delete_key:"event_team_updated_delete_key_input",
		_inc:"event_team_updated_inc_input",
		_prepend:"event_team_updated_prepend_input",
		_set:"event_team_updated_set_input",
		where:"event_team_updated_bool_exp"
	},
	event_team_updated_var_pop_order_by:{
		id:"order_by"
	},
	event_team_updated_var_samp_order_by:{
		id:"order_by"
	},
	event_team_updated_variance_order_by:{
		id:"order_by"
	},
	event_type_t: `scalar.event_type_t` as const,
	event_type_t_comparison_exp:{
		_eq:"event_type_t",
		_gt:"event_type_t",
		_gte:"event_type_t",
		_in:"event_type_t",
		_lt:"event_type_t",
		_lte:"event_type_t",
		_neq:"event_type_t",
		_nin:"event_type_t"
	},
	event_update_column: "enum" as const,
	event_updates:{
		_append:"event_append_input",
		_delete_at_path:"event_delete_at_path_input",
		_delete_elem:"event_delete_elem_input",
		_delete_key:"event_delete_key_input",
		_inc:"event_inc_input",
		_prepend:"event_prepend_input",
		_set:"event_set_input",
		where:"event_bool_exp"
	},
	event_user_created_aggregate_fields:{
		count:{
			columns:"event_user_created_select_column"
		}
	},
	event_user_created_bool_exp:{
		_and:"event_user_created_bool_exp",
		_not:"event_user_created_bool_exp",
		_or:"event_user_created_bool_exp",
		display_name:"String_comparison_exp",
		email_address:"String_comparison_exp",
		event:"event_bool_exp",
		external_id:"String_comparison_exp",
		first_name:"String_comparison_exp",
		id:"Int_comparison_exp",
		last_name:"String_comparison_exp",
		manager_email:"String_comparison_exp",
		phone_number:"String_comparison_exp",
		user_id:"uuid_comparison_exp",
		user_name:"String_comparison_exp",
		user_type:"String_comparison_exp"
	},
	event_user_created_constraint: "enum" as const,
	event_user_created_inc_input:{

	},
	event_user_created_insert_input:{
		event:"event_obj_rel_insert_input",
		user_id:"uuid"
	},
	event_user_created_obj_rel_insert_input:{
		data:"event_user_created_insert_input",
		on_conflict:"event_user_created_on_conflict"
	},
	event_user_created_on_conflict:{
		constraint:"event_user_created_constraint",
		update_columns:"event_user_created_update_column",
		where:"event_user_created_bool_exp"
	},
	event_user_created_order_by:{
		display_name:"order_by",
		email_address:"order_by",
		event:"event_order_by",
		external_id:"order_by",
		first_name:"order_by",
		id:"order_by",
		last_name:"order_by",
		manager_email:"order_by",
		phone_number:"order_by",
		user_id:"order_by",
		user_name:"order_by",
		user_type:"order_by"
	},
	event_user_created_pk_columns_input:{

	},
	event_user_created_select_column: "enum" as const,
	event_user_created_set_input:{
		user_id:"uuid"
	},
	event_user_created_stream_cursor_input:{
		initial_value:"event_user_created_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_user_created_stream_cursor_value_input:{
		user_id:"uuid"
	},
	event_user_created_update_column: "enum" as const,
	event_user_created_updates:{
		_inc:"event_user_created_inc_input",
		_set:"event_user_created_set_input",
		where:"event_user_created_bool_exp"
	},
	event_user_deleted_aggregate_fields:{
		count:{
			columns:"event_user_deleted_select_column"
		}
	},
	event_user_deleted_bool_exp:{
		_and:"event_user_deleted_bool_exp",
		_not:"event_user_deleted_bool_exp",
		_or:"event_user_deleted_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		user_id:"uuid_comparison_exp"
	},
	event_user_deleted_constraint: "enum" as const,
	event_user_deleted_inc_input:{

	},
	event_user_deleted_insert_input:{
		event:"event_obj_rel_insert_input",
		user_id:"uuid"
	},
	event_user_deleted_obj_rel_insert_input:{
		data:"event_user_deleted_insert_input",
		on_conflict:"event_user_deleted_on_conflict"
	},
	event_user_deleted_on_conflict:{
		constraint:"event_user_deleted_constraint",
		update_columns:"event_user_deleted_update_column",
		where:"event_user_deleted_bool_exp"
	},
	event_user_deleted_order_by:{
		event:"event_order_by",
		id:"order_by",
		user_id:"order_by"
	},
	event_user_deleted_pk_columns_input:{

	},
	event_user_deleted_select_column: "enum" as const,
	event_user_deleted_set_input:{
		user_id:"uuid"
	},
	event_user_deleted_stream_cursor_input:{
		initial_value:"event_user_deleted_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_user_deleted_stream_cursor_value_input:{
		user_id:"uuid"
	},
	event_user_deleted_update_column: "enum" as const,
	event_user_deleted_updates:{
		_inc:"event_user_deleted_inc_input",
		_set:"event_user_deleted_set_input",
		where:"event_user_deleted_bool_exp"
	},
	event_user_role_assignment_created_aggregate_bool_exp:{
		count:"event_user_role_assignment_created_aggregate_bool_exp_count"
	},
	event_user_role_assignment_created_aggregate_bool_exp_count:{
		arguments:"event_user_role_assignment_created_select_column",
		filter:"event_user_role_assignment_created_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_user_role_assignment_created_aggregate_fields:{
		count:{
			columns:"event_user_role_assignment_created_select_column"
		}
	},
	event_user_role_assignment_created_aggregate_order_by:{
		avg:"event_user_role_assignment_created_avg_order_by",
		count:"order_by",
		max:"event_user_role_assignment_created_max_order_by",
		min:"event_user_role_assignment_created_min_order_by",
		stddev:"event_user_role_assignment_created_stddev_order_by",
		stddev_pop:"event_user_role_assignment_created_stddev_pop_order_by",
		stddev_samp:"event_user_role_assignment_created_stddev_samp_order_by",
		sum:"event_user_role_assignment_created_sum_order_by",
		var_pop:"event_user_role_assignment_created_var_pop_order_by",
		var_samp:"event_user_role_assignment_created_var_samp_order_by",
		variance:"event_user_role_assignment_created_variance_order_by"
	},
	event_user_role_assignment_created_arr_rel_insert_input:{
		data:"event_user_role_assignment_created_insert_input",
		on_conflict:"event_user_role_assignment_created_on_conflict"
	},
	event_user_role_assignment_created_avg_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_created_bool_exp:{
		_and:"event_user_role_assignment_created_bool_exp",
		_not:"event_user_role_assignment_created_bool_exp",
		_or:"event_user_role_assignment_created_bool_exp",
		event:"event_bool_exp",
		event_team_role_assignment_created:"team_role_assignment_bool_exp",
		id:"Int_comparison_exp",
		team_role_assignment_id:"uuid_comparison_exp",
		user:"user_bool_exp",
		user_id:"uuid_comparison_exp",
		user_role_assignment:"user_role_assignment_bool_exp",
		user_role_assignment_id:"uuid_comparison_exp"
	},
	event_user_role_assignment_created_constraint: "enum" as const,
	event_user_role_assignment_created_inc_input:{

	},
	event_user_role_assignment_created_insert_input:{
		event:"event_obj_rel_insert_input",
		event_team_role_assignment_created:"team_role_assignment_obj_rel_insert_input",
		team_role_assignment_id:"uuid",
		user:"user_obj_rel_insert_input",
		user_id:"uuid",
		user_role_assignment:"user_role_assignment_obj_rel_insert_input",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_created_max_order_by:{
		id:"order_by",
		team_role_assignment_id:"order_by",
		user_id:"order_by",
		user_role_assignment_id:"order_by"
	},
	event_user_role_assignment_created_min_order_by:{
		id:"order_by",
		team_role_assignment_id:"order_by",
		user_id:"order_by",
		user_role_assignment_id:"order_by"
	},
	event_user_role_assignment_created_obj_rel_insert_input:{
		data:"event_user_role_assignment_created_insert_input",
		on_conflict:"event_user_role_assignment_created_on_conflict"
	},
	event_user_role_assignment_created_on_conflict:{
		constraint:"event_user_role_assignment_created_constraint",
		update_columns:"event_user_role_assignment_created_update_column",
		where:"event_user_role_assignment_created_bool_exp"
	},
	event_user_role_assignment_created_order_by:{
		event:"event_order_by",
		event_team_role_assignment_created:"team_role_assignment_order_by",
		id:"order_by",
		team_role_assignment_id:"order_by",
		user:"user_order_by",
		user_id:"order_by",
		user_role_assignment:"user_role_assignment_order_by",
		user_role_assignment_id:"order_by"
	},
	event_user_role_assignment_created_pk_columns_input:{

	},
	event_user_role_assignment_created_select_column: "enum" as const,
	event_user_role_assignment_created_set_input:{
		team_role_assignment_id:"uuid",
		user_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_created_stddev_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_created_stddev_pop_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_created_stddev_samp_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_created_stream_cursor_input:{
		initial_value:"event_user_role_assignment_created_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_user_role_assignment_created_stream_cursor_value_input:{
		team_role_assignment_id:"uuid",
		user_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_created_sum_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_created_update_column: "enum" as const,
	event_user_role_assignment_created_updates:{
		_inc:"event_user_role_assignment_created_inc_input",
		_set:"event_user_role_assignment_created_set_input",
		where:"event_user_role_assignment_created_bool_exp"
	},
	event_user_role_assignment_created_var_pop_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_created_var_samp_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_created_variance_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_deleted_aggregate_bool_exp:{
		count:"event_user_role_assignment_deleted_aggregate_bool_exp_count"
	},
	event_user_role_assignment_deleted_aggregate_bool_exp_count:{
		arguments:"event_user_role_assignment_deleted_select_column",
		filter:"event_user_role_assignment_deleted_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_user_role_assignment_deleted_aggregate_fields:{
		count:{
			columns:"event_user_role_assignment_deleted_select_column"
		}
	},
	event_user_role_assignment_deleted_aggregate_order_by:{
		avg:"event_user_role_assignment_deleted_avg_order_by",
		count:"order_by",
		max:"event_user_role_assignment_deleted_max_order_by",
		min:"event_user_role_assignment_deleted_min_order_by",
		stddev:"event_user_role_assignment_deleted_stddev_order_by",
		stddev_pop:"event_user_role_assignment_deleted_stddev_pop_order_by",
		stddev_samp:"event_user_role_assignment_deleted_stddev_samp_order_by",
		sum:"event_user_role_assignment_deleted_sum_order_by",
		var_pop:"event_user_role_assignment_deleted_var_pop_order_by",
		var_samp:"event_user_role_assignment_deleted_var_samp_order_by",
		variance:"event_user_role_assignment_deleted_variance_order_by"
	},
	event_user_role_assignment_deleted_arr_rel_insert_input:{
		data:"event_user_role_assignment_deleted_insert_input",
		on_conflict:"event_user_role_assignment_deleted_on_conflict"
	},
	event_user_role_assignment_deleted_avg_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_deleted_bool_exp:{
		_and:"event_user_role_assignment_deleted_bool_exp",
		_not:"event_user_role_assignment_deleted_bool_exp",
		_or:"event_user_role_assignment_deleted_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		user_role_assignment:"user_role_assignment_bool_exp",
		user_role_assignment_id:"uuid_comparison_exp"
	},
	event_user_role_assignment_deleted_constraint: "enum" as const,
	event_user_role_assignment_deleted_inc_input:{

	},
	event_user_role_assignment_deleted_insert_input:{
		event:"event_obj_rel_insert_input",
		user_role_assignment:"user_role_assignment_obj_rel_insert_input",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_deleted_max_order_by:{
		id:"order_by",
		user_role_assignment_id:"order_by"
	},
	event_user_role_assignment_deleted_min_order_by:{
		id:"order_by",
		user_role_assignment_id:"order_by"
	},
	event_user_role_assignment_deleted_obj_rel_insert_input:{
		data:"event_user_role_assignment_deleted_insert_input",
		on_conflict:"event_user_role_assignment_deleted_on_conflict"
	},
	event_user_role_assignment_deleted_on_conflict:{
		constraint:"event_user_role_assignment_deleted_constraint",
		update_columns:"event_user_role_assignment_deleted_update_column",
		where:"event_user_role_assignment_deleted_bool_exp"
	},
	event_user_role_assignment_deleted_order_by:{
		event:"event_order_by",
		id:"order_by",
		user_role_assignment:"user_role_assignment_order_by",
		user_role_assignment_id:"order_by"
	},
	event_user_role_assignment_deleted_pk_columns_input:{

	},
	event_user_role_assignment_deleted_select_column: "enum" as const,
	event_user_role_assignment_deleted_set_input:{
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_deleted_stddev_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_deleted_stddev_pop_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_deleted_stddev_samp_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_deleted_stream_cursor_input:{
		initial_value:"event_user_role_assignment_deleted_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_user_role_assignment_deleted_stream_cursor_value_input:{
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_deleted_sum_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_deleted_update_column: "enum" as const,
	event_user_role_assignment_deleted_updates:{
		_inc:"event_user_role_assignment_deleted_inc_input",
		_set:"event_user_role_assignment_deleted_set_input",
		where:"event_user_role_assignment_deleted_bool_exp"
	},
	event_user_role_assignment_deleted_var_pop_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_deleted_var_samp_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_deleted_variance_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_updated_aggregate_bool_exp:{
		count:"event_user_role_assignment_updated_aggregate_bool_exp_count"
	},
	event_user_role_assignment_updated_aggregate_bool_exp_count:{
		arguments:"event_user_role_assignment_updated_select_column",
		filter:"event_user_role_assignment_updated_bool_exp",
		predicate:"Int_comparison_exp"
	},
	event_user_role_assignment_updated_aggregate_fields:{
		count:{
			columns:"event_user_role_assignment_updated_select_column"
		}
	},
	event_user_role_assignment_updated_aggregate_order_by:{
		avg:"event_user_role_assignment_updated_avg_order_by",
		count:"order_by",
		max:"event_user_role_assignment_updated_max_order_by",
		min:"event_user_role_assignment_updated_min_order_by",
		stddev:"event_user_role_assignment_updated_stddev_order_by",
		stddev_pop:"event_user_role_assignment_updated_stddev_pop_order_by",
		stddev_samp:"event_user_role_assignment_updated_stddev_samp_order_by",
		sum:"event_user_role_assignment_updated_sum_order_by",
		var_pop:"event_user_role_assignment_updated_var_pop_order_by",
		var_samp:"event_user_role_assignment_updated_var_samp_order_by",
		variance:"event_user_role_assignment_updated_variance_order_by"
	},
	event_user_role_assignment_updated_arr_rel_insert_input:{
		data:"event_user_role_assignment_updated_insert_input",
		on_conflict:"event_user_role_assignment_updated_on_conflict"
	},
	event_user_role_assignment_updated_avg_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_updated_bool_exp:{
		_and:"event_user_role_assignment_updated_bool_exp",
		_not:"event_user_role_assignment_updated_bool_exp",
		_or:"event_user_role_assignment_updated_bool_exp",
		event:"event_bool_exp",
		id:"Int_comparison_exp",
		team_role_assignment:"team_role_assignment_bool_exp",
		team_role_assignment_id:"uuid_comparison_exp",
		user_role_assignment:"user_role_assignment_bool_exp",
		user_role_assignment_id:"uuid_comparison_exp"
	},
	event_user_role_assignment_updated_constraint: "enum" as const,
	event_user_role_assignment_updated_inc_input:{

	},
	event_user_role_assignment_updated_insert_input:{
		event:"event_obj_rel_insert_input",
		team_role_assignment:"team_role_assignment_obj_rel_insert_input",
		team_role_assignment_id:"uuid",
		user_role_assignment:"user_role_assignment_obj_rel_insert_input",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_updated_max_order_by:{
		id:"order_by",
		team_role_assignment_id:"order_by",
		user_role_assignment_id:"order_by"
	},
	event_user_role_assignment_updated_min_order_by:{
		id:"order_by",
		team_role_assignment_id:"order_by",
		user_role_assignment_id:"order_by"
	},
	event_user_role_assignment_updated_obj_rel_insert_input:{
		data:"event_user_role_assignment_updated_insert_input",
		on_conflict:"event_user_role_assignment_updated_on_conflict"
	},
	event_user_role_assignment_updated_on_conflict:{
		constraint:"event_user_role_assignment_updated_constraint",
		update_columns:"event_user_role_assignment_updated_update_column",
		where:"event_user_role_assignment_updated_bool_exp"
	},
	event_user_role_assignment_updated_order_by:{
		event:"event_order_by",
		id:"order_by",
		team_role_assignment:"team_role_assignment_order_by",
		team_role_assignment_id:"order_by",
		user_role_assignment:"user_role_assignment_order_by",
		user_role_assignment_id:"order_by"
	},
	event_user_role_assignment_updated_pk_columns_input:{

	},
	event_user_role_assignment_updated_select_column: "enum" as const,
	event_user_role_assignment_updated_set_input:{
		team_role_assignment_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_updated_stddev_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_updated_stddev_pop_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_updated_stddev_samp_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_updated_stream_cursor_input:{
		initial_value:"event_user_role_assignment_updated_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_user_role_assignment_updated_stream_cursor_value_input:{
		team_role_assignment_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_updated_sum_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_updated_update_column: "enum" as const,
	event_user_role_assignment_updated_updates:{
		_inc:"event_user_role_assignment_updated_inc_input",
		_set:"event_user_role_assignment_updated_set_input",
		where:"event_user_role_assignment_updated_bool_exp"
	},
	event_user_role_assignment_updated_var_pop_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_updated_var_samp_order_by:{
		id:"order_by"
	},
	event_user_role_assignment_updated_variance_order_by:{
		id:"order_by"
	},
	event_user_updated_aggregate_fields:{
		count:{
			columns:"event_user_updated_select_column"
		}
	},
	event_user_updated_bool_exp:{
		_and:"event_user_updated_bool_exp",
		_not:"event_user_updated_bool_exp",
		_or:"event_user_updated_bool_exp",
		display_name:"String_comparison_exp",
		email_address:"String_comparison_exp",
		event:"event_bool_exp",
		external_id:"String_comparison_exp",
		first_name:"String_comparison_exp",
		id:"Int_comparison_exp",
		last_name:"String_comparison_exp",
		manager_email:"String_comparison_exp",
		phone_number:"String_comparison_exp",
		user_id:"uuid_comparison_exp",
		user_name:"String_comparison_exp",
		user_type:"String_comparison_exp"
	},
	event_user_updated_constraint: "enum" as const,
	event_user_updated_inc_input:{

	},
	event_user_updated_insert_input:{
		event:"event_obj_rel_insert_input",
		user_id:"uuid"
	},
	event_user_updated_obj_rel_insert_input:{
		data:"event_user_updated_insert_input",
		on_conflict:"event_user_updated_on_conflict"
	},
	event_user_updated_on_conflict:{
		constraint:"event_user_updated_constraint",
		update_columns:"event_user_updated_update_column",
		where:"event_user_updated_bool_exp"
	},
	event_user_updated_order_by:{
		display_name:"order_by",
		email_address:"order_by",
		event:"event_order_by",
		external_id:"order_by",
		first_name:"order_by",
		id:"order_by",
		last_name:"order_by",
		manager_email:"order_by",
		phone_number:"order_by",
		user_id:"order_by",
		user_name:"order_by",
		user_type:"order_by"
	},
	event_user_updated_pk_columns_input:{

	},
	event_user_updated_select_column: "enum" as const,
	event_user_updated_set_input:{
		user_id:"uuid"
	},
	event_user_updated_stream_cursor_input:{
		initial_value:"event_user_updated_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	event_user_updated_stream_cursor_value_input:{
		user_id:"uuid"
	},
	event_user_updated_update_column: "enum" as const,
	event_user_updated_updates:{
		_inc:"event_user_updated_inc_input",
		_set:"event_user_updated_set_input",
		where:"event_user_updated_bool_exp"
	},
	event_var_pop_order_by:{
		id:"order_by"
	},
	event_var_samp_order_by:{
		id:"order_by"
	},
	event_variance_order_by:{
		id:"order_by"
	},
	group:{
		group_membership:{
			distinct_on:"group_membership_select_column",
			order_by:"group_membership_order_by",
			where:"group_membership_bool_exp"
		},
		group_membership_aggregate:{
			distinct_on:"group_membership_select_column",
			order_by:"group_membership_order_by",
			where:"group_membership_bool_exp"
		},
		qualifications:{
			distinct_on:"qualification_select_column",
			order_by:"qualification_order_by",
			where:"qualification_bool_exp"
		},
		qualifications_aggregate:{
			distinct_on:"qualification_select_column",
			order_by:"qualification_order_by",
			where:"qualification_bool_exp"
		}
	},
	group_aggregate_fields:{
		count:{
			columns:"group_select_column"
		}
	},
	group_bool_exp:{
		_and:"group_bool_exp",
		_not:"group_bool_exp",
		_or:"group_bool_exp",
		created_at:"timestamptz_comparison_exp",
		display_name:"String_comparison_exp",
		group_membership:"group_membership_bool_exp",
		group_membership_aggregate:"group_membership_aggregate_bool_exp",
		id:"uuid_comparison_exp",
		qualification:"qualification_bool_exp",
		qualifications:"qualification_bool_exp",
		qualifications_aggregate:"qualification_aggregate_bool_exp",
		record_status:"record_status_t_comparison_exp",
		updated_at:"timestamptz_comparison_exp"
	},
	group_constraint: "enum" as const,
	group_insert_input:{
		created_at:"timestamptz",
		group_membership:"group_membership_arr_rel_insert_input",
		id:"uuid",
		qualification:"qualification_obj_rel_insert_input",
		qualifications:"qualification_arr_rel_insert_input",
		record_status:"record_status_t",
		updated_at:"timestamptz"
	},
	group_membership_aggregate_bool_exp:{
		count:"group_membership_aggregate_bool_exp_count"
	},
	group_membership_aggregate_bool_exp_count:{
		arguments:"group_membership_select_column",
		filter:"group_membership_bool_exp",
		predicate:"Int_comparison_exp"
	},
	group_membership_aggregate_fields:{
		count:{
			columns:"group_membership_select_column"
		}
	},
	group_membership_aggregate_order_by:{
		count:"order_by",
		max:"group_membership_max_order_by",
		min:"group_membership_min_order_by"
	},
	group_membership_arr_rel_insert_input:{
		data:"group_membership_insert_input",
		on_conflict:"group_membership_on_conflict"
	},
	group_membership_bool_exp:{
		_and:"group_membership_bool_exp",
		_not:"group_membership_bool_exp",
		_or:"group_membership_bool_exp",
		created_at:"timestamptz_comparison_exp",
		group:"group_bool_exp",
		group_id:"uuid_comparison_exp",
		id:"uuid_comparison_exp",
		updated_at:"timestamptz_comparison_exp",
		user:"user_bool_exp",
		user_id:"uuid_comparison_exp"
	},
	group_membership_constraint: "enum" as const,
	group_membership_insert_input:{
		created_at:"timestamptz",
		group:"group_obj_rel_insert_input",
		group_id:"uuid",
		id:"uuid",
		updated_at:"timestamptz",
		user:"user_obj_rel_insert_input",
		user_id:"uuid"
	},
	group_membership_max_order_by:{
		created_at:"order_by",
		group_id:"order_by",
		id:"order_by",
		updated_at:"order_by",
		user_id:"order_by"
	},
	group_membership_min_order_by:{
		created_at:"order_by",
		group_id:"order_by",
		id:"order_by",
		updated_at:"order_by",
		user_id:"order_by"
	},
	group_membership_on_conflict:{
		constraint:"group_membership_constraint",
		update_columns:"group_membership_update_column",
		where:"group_membership_bool_exp"
	},
	group_membership_order_by:{
		created_at:"order_by",
		group:"group_order_by",
		group_id:"order_by",
		id:"order_by",
		updated_at:"order_by",
		user:"user_order_by",
		user_id:"order_by"
	},
	group_membership_pk_columns_input:{
		id:"uuid"
	},
	group_membership_select_column: "enum" as const,
	group_membership_set_input:{
		created_at:"timestamptz",
		group_id:"uuid",
		id:"uuid",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	group_membership_stream_cursor_input:{
		initial_value:"group_membership_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	group_membership_stream_cursor_value_input:{
		created_at:"timestamptz",
		group_id:"uuid",
		id:"uuid",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	group_membership_update_column: "enum" as const,
	group_membership_updates:{
		_set:"group_membership_set_input",
		where:"group_membership_bool_exp"
	},
	group_obj_rel_insert_input:{
		data:"group_insert_input",
		on_conflict:"group_on_conflict"
	},
	group_on_conflict:{
		constraint:"group_constraint",
		update_columns:"group_update_column",
		where:"group_bool_exp"
	},
	group_order_by:{
		created_at:"order_by",
		display_name:"order_by",
		group_membership_aggregate:"group_membership_aggregate_order_by",
		id:"order_by",
		qualification:"qualification_order_by",
		qualifications_aggregate:"qualification_aggregate_order_by",
		record_status:"order_by",
		updated_at:"order_by"
	},
	group_pk_columns_input:{
		id:"uuid"
	},
	group_select_column: "enum" as const,
	group_set_input:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		updated_at:"timestamptz"
	},
	group_stream_cursor_input:{
		initial_value:"group_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	group_stream_cursor_value_input:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		updated_at:"timestamptz"
	},
	group_update_column: "enum" as const,
	group_updates:{
		_set:"group_set_input",
		where:"group_bool_exp"
	},
	jsonb: `scalar.jsonb` as const,
	jsonb_cast_exp:{
		String:"String_comparison_exp"
	},
	jsonb_comparison_exp:{
		_cast:"jsonb_cast_exp",
		_contained_in:"jsonb",
		_contains:"jsonb",
		_eq:"jsonb",
		_gt:"jsonb",
		_gte:"jsonb",
		_in:"jsonb",
		_lt:"jsonb",
		_lte:"jsonb",
		_neq:"jsonb",
		_nin:"jsonb"
	},
	mutation_root:{
		delete_active_shift:{
			where:"active_shift_bool_exp"
		},
		delete_active_shift_by_pk:{
			id:"uuid"
		},
		delete_cost_object:{
			where:"cost_object_bool_exp"
		},
		delete_cost_object_by_pk:{
			id:"uuid"
		},
		delete_event:{
			where:"event_bool_exp"
		},
		delete_event_buffered_shift_ended:{
			where:"event_buffered_shift_ended_bool_exp"
		},
		delete_event_buffered_shift_ended_by_pk:{

		},
		delete_event_buffered_shift_started:{
			where:"event_buffered_shift_started_bool_exp"
		},
		delete_event_buffered_shift_started_by_pk:{

		},
		delete_event_by_pk:{

		},
		delete_event_cost_object_created:{
			where:"event_cost_object_created_bool_exp"
		},
		delete_event_cost_object_created_by_pk:{

		},
		delete_event_cost_object_deleted:{
			where:"event_cost_object_deleted_bool_exp"
		},
		delete_event_cost_object_deleted_by_pk:{

		},
		delete_event_cost_object_reactivated:{
			where:"event_cost_object_reactivated_bool_exp"
		},
		delete_event_cost_object_reactivated_by_pk:{

		},
		delete_event_cost_object_updated:{
			where:"event_cost_object_updated_bool_exp"
		},
		delete_event_cost_object_updated_by_pk:{

		},
		delete_event_derived_shift_deleted:{
			where:"event_derived_shift_deleted_bool_exp"
		},
		delete_event_derived_shift_deleted_by_pk:{

		},
		delete_event_derived_shift_updated:{
			where:"event_derived_shift_updated_bool_exp"
		},
		delete_event_derived_shift_updated_by_pk:{

		},
		delete_event_note_created:{
			where:"event_note_created_bool_exp"
		},
		delete_event_note_created_by_pk:{

		},
		delete_event_note_deleted:{
			where:"event_note_deleted_bool_exp"
		},
		delete_event_note_deleted_by_pk:{

		},
		delete_event_note_updated:{
			where:"event_note_updated_bool_exp"
		},
		delete_event_note_updated_by_pk:{

		},
		delete_event_recurring_shift_exception_created:{
			where:"event_recurring_shift_exception_created_bool_exp"
		},
		delete_event_recurring_shift_exception_created_by_pk:{

		},
		delete_event_shift_created:{
			where:"event_shift_created_bool_exp"
		},
		delete_event_shift_created_by_pk:{

		},
		delete_event_shift_deleted:{
			where:"event_shift_deleted_bool_exp"
		},
		delete_event_shift_deleted_by_pk:{

		},
		delete_event_shift_ended:{
			where:"event_shift_ended_bool_exp"
		},
		delete_event_shift_ended_by_pk:{

		},
		delete_event_shift_started:{
			where:"event_shift_started_bool_exp"
		},
		delete_event_shift_started_by_pk:{

		},
		delete_event_shift_updated:{
			where:"event_shift_updated_bool_exp"
		},
		delete_event_shift_updated_by_pk:{

		},
		delete_event_team_created:{
			where:"event_team_created_bool_exp"
		},
		delete_event_team_created_by_pk:{

		},
		delete_event_team_deleted:{
			where:"event_team_deleted_bool_exp"
		},
		delete_event_team_deleted_by_pk:{

		},
		delete_event_team_reactivated:{
			where:"event_team_reactivated_bool_exp"
		},
		delete_event_team_reactivated_by_pk:{

		},
		delete_event_team_role_assignment_created:{
			where:"event_team_role_assignment_created_bool_exp"
		},
		delete_event_team_role_assignment_created_by_pk:{

		},
		delete_event_team_role_assignment_deleted:{
			where:"event_team_role_assignment_deleted_bool_exp"
		},
		delete_event_team_role_assignment_deleted_by_pk:{

		},
		delete_event_team_role_created:{
			where:"event_team_role_created_bool_exp"
		},
		delete_event_team_role_created_by_pk:{

		},
		delete_event_team_role_deleted:{
			where:"event_team_role_deleted_bool_exp"
		},
		delete_event_team_role_deleted_by_pk:{

		},
		delete_event_team_role_updated:{
			where:"event_team_role_updated_bool_exp"
		},
		delete_event_team_role_updated_by_pk:{

		},
		delete_event_team_updated:{
			where:"event_team_updated_bool_exp"
		},
		delete_event_team_updated_by_pk:{

		},
		delete_event_user_created:{
			where:"event_user_created_bool_exp"
		},
		delete_event_user_created_by_pk:{

		},
		delete_event_user_deleted:{
			where:"event_user_deleted_bool_exp"
		},
		delete_event_user_deleted_by_pk:{

		},
		delete_event_user_role_assignment_created:{
			where:"event_user_role_assignment_created_bool_exp"
		},
		delete_event_user_role_assignment_created_by_pk:{

		},
		delete_event_user_role_assignment_deleted:{
			where:"event_user_role_assignment_deleted_bool_exp"
		},
		delete_event_user_role_assignment_deleted_by_pk:{

		},
		delete_event_user_role_assignment_updated:{
			where:"event_user_role_assignment_updated_bool_exp"
		},
		delete_event_user_role_assignment_updated_by_pk:{

		},
		delete_event_user_updated:{
			where:"event_user_updated_bool_exp"
		},
		delete_event_user_updated_by_pk:{

		},
		delete_group:{
			where:"group_bool_exp"
		},
		delete_group_by_pk:{
			id:"uuid"
		},
		delete_group_membership:{
			where:"group_membership_bool_exp"
		},
		delete_group_membership_by_pk:{
			id:"uuid"
		},
		delete_note:{
			where:"note_bool_exp"
		},
		delete_note_by_pk:{
			id:"uuid"
		},
		delete_permissions_shift_config:{
			where:"permissions_shift_config_bool_exp"
		},
		delete_permissions_shift_config_by_pk:{
			id:"uuid"
		},
		delete_permissions_team_config:{
			where:"permissions_team_config_bool_exp"
		},
		delete_permissions_team_config_by_pk:{
			id:"uuid"
		},
		delete_permissions_team_role_config:{
			where:"permissions_team_role_config_bool_exp"
		},
		delete_permissions_team_role_config_by_pk:{
			id:"uuid"
		},
		delete_qualification:{
			where:"qualification_bool_exp"
		},
		delete_qualification_by_pk:{
			id:"uuid"
		},
		delete_recurring_shift_exception:{
			where:"recurring_shift_exception_bool_exp"
		},
		delete_recurring_shift_exception_by_pk:{
			id:"uuid"
		},
		delete_shift:{
			where:"shift_bool_exp"
		},
		delete_shift_by_pk:{
			id:"uuid"
		},
		delete_team:{
			where:"team_bool_exp"
		},
		delete_team_by_pk:{
			id:"uuid"
		},
		delete_team_role:{
			where:"team_role_bool_exp"
		},
		delete_team_role_assignment:{
			where:"team_role_assignment_bool_exp"
		},
		delete_team_role_assignment_by_pk:{
			id:"uuid"
		},
		delete_team_role_by_pk:{
			id:"uuid"
		},
		delete_user:{
			where:"user_bool_exp"
		},
		delete_user_by_pk:{
			id:"uuid"
		},
		delete_user_notification:{
			where:"user_notification_bool_exp"
		},
		delete_user_notification_by_pk:{
			id:"uuid"
		},
		delete_user_role_assignment:{
			where:"user_role_assignment_bool_exp"
		},
		delete_user_role_assignment_by_pk:{
			id:"uuid"
		},
		delete_user_shift_notification:{
			where:"user_shift_notification_bool_exp"
		},
		delete_user_shift_notification_by_pk:{
			id:"uuid"
		},
		delete_user_shift_notification_event:{
			where:"user_shift_notification_event_bool_exp"
		},
		delete_user_shift_notification_event_by_pk:{
			id:"uuid"
		},
		insert_active_shift:{
			objects:"active_shift_insert_input",
			on_conflict:"active_shift_on_conflict"
		},
		insert_active_shift_one:{
			object:"active_shift_insert_input",
			on_conflict:"active_shift_on_conflict"
		},
		insert_cost_object:{
			objects:"cost_object_insert_input",
			on_conflict:"cost_object_on_conflict"
		},
		insert_cost_object_one:{
			object:"cost_object_insert_input",
			on_conflict:"cost_object_on_conflict"
		},
		insert_event:{
			objects:"event_insert_input",
			on_conflict:"event_on_conflict"
		},
		insert_event_buffered_shift_ended:{
			objects:"event_buffered_shift_ended_insert_input",
			on_conflict:"event_buffered_shift_ended_on_conflict"
		},
		insert_event_buffered_shift_ended_one:{
			object:"event_buffered_shift_ended_insert_input",
			on_conflict:"event_buffered_shift_ended_on_conflict"
		},
		insert_event_buffered_shift_started:{
			objects:"event_buffered_shift_started_insert_input",
			on_conflict:"event_buffered_shift_started_on_conflict"
		},
		insert_event_buffered_shift_started_one:{
			object:"event_buffered_shift_started_insert_input",
			on_conflict:"event_buffered_shift_started_on_conflict"
		},
		insert_event_cost_object_created:{
			objects:"event_cost_object_created_insert_input",
			on_conflict:"event_cost_object_created_on_conflict"
		},
		insert_event_cost_object_created_one:{
			object:"event_cost_object_created_insert_input",
			on_conflict:"event_cost_object_created_on_conflict"
		},
		insert_event_cost_object_deleted:{
			objects:"event_cost_object_deleted_insert_input",
			on_conflict:"event_cost_object_deleted_on_conflict"
		},
		insert_event_cost_object_deleted_one:{
			object:"event_cost_object_deleted_insert_input",
			on_conflict:"event_cost_object_deleted_on_conflict"
		},
		insert_event_cost_object_reactivated:{
			objects:"event_cost_object_reactivated_insert_input",
			on_conflict:"event_cost_object_reactivated_on_conflict"
		},
		insert_event_cost_object_reactivated_one:{
			object:"event_cost_object_reactivated_insert_input",
			on_conflict:"event_cost_object_reactivated_on_conflict"
		},
		insert_event_cost_object_updated:{
			objects:"event_cost_object_updated_insert_input",
			on_conflict:"event_cost_object_updated_on_conflict"
		},
		insert_event_cost_object_updated_one:{
			object:"event_cost_object_updated_insert_input",
			on_conflict:"event_cost_object_updated_on_conflict"
		},
		insert_event_derived_shift_deleted:{
			objects:"event_derived_shift_deleted_insert_input",
			on_conflict:"event_derived_shift_deleted_on_conflict"
		},
		insert_event_derived_shift_deleted_one:{
			object:"event_derived_shift_deleted_insert_input",
			on_conflict:"event_derived_shift_deleted_on_conflict"
		},
		insert_event_derived_shift_updated:{
			objects:"event_derived_shift_updated_insert_input",
			on_conflict:"event_derived_shift_updated_on_conflict"
		},
		insert_event_derived_shift_updated_one:{
			object:"event_derived_shift_updated_insert_input",
			on_conflict:"event_derived_shift_updated_on_conflict"
		},
		insert_event_note_created:{
			objects:"event_note_created_insert_input",
			on_conflict:"event_note_created_on_conflict"
		},
		insert_event_note_created_one:{
			object:"event_note_created_insert_input",
			on_conflict:"event_note_created_on_conflict"
		},
		insert_event_note_deleted:{
			objects:"event_note_deleted_insert_input",
			on_conflict:"event_note_deleted_on_conflict"
		},
		insert_event_note_deleted_one:{
			object:"event_note_deleted_insert_input",
			on_conflict:"event_note_deleted_on_conflict"
		},
		insert_event_note_updated:{
			objects:"event_note_updated_insert_input",
			on_conflict:"event_note_updated_on_conflict"
		},
		insert_event_note_updated_one:{
			object:"event_note_updated_insert_input",
			on_conflict:"event_note_updated_on_conflict"
		},
		insert_event_one:{
			object:"event_insert_input",
			on_conflict:"event_on_conflict"
		},
		insert_event_recurring_shift_exception_created:{
			objects:"event_recurring_shift_exception_created_insert_input",
			on_conflict:"event_recurring_shift_exception_created_on_conflict"
		},
		insert_event_recurring_shift_exception_created_one:{
			object:"event_recurring_shift_exception_created_insert_input",
			on_conflict:"event_recurring_shift_exception_created_on_conflict"
		},
		insert_event_shift_created:{
			objects:"event_shift_created_insert_input",
			on_conflict:"event_shift_created_on_conflict"
		},
		insert_event_shift_created_one:{
			object:"event_shift_created_insert_input",
			on_conflict:"event_shift_created_on_conflict"
		},
		insert_event_shift_deleted:{
			objects:"event_shift_deleted_insert_input",
			on_conflict:"event_shift_deleted_on_conflict"
		},
		insert_event_shift_deleted_one:{
			object:"event_shift_deleted_insert_input",
			on_conflict:"event_shift_deleted_on_conflict"
		},
		insert_event_shift_ended:{
			objects:"event_shift_ended_insert_input",
			on_conflict:"event_shift_ended_on_conflict"
		},
		insert_event_shift_ended_one:{
			object:"event_shift_ended_insert_input",
			on_conflict:"event_shift_ended_on_conflict"
		},
		insert_event_shift_started:{
			objects:"event_shift_started_insert_input",
			on_conflict:"event_shift_started_on_conflict"
		},
		insert_event_shift_started_one:{
			object:"event_shift_started_insert_input",
			on_conflict:"event_shift_started_on_conflict"
		},
		insert_event_shift_updated:{
			objects:"event_shift_updated_insert_input",
			on_conflict:"event_shift_updated_on_conflict"
		},
		insert_event_shift_updated_one:{
			object:"event_shift_updated_insert_input",
			on_conflict:"event_shift_updated_on_conflict"
		},
		insert_event_team_created:{
			objects:"event_team_created_insert_input",
			on_conflict:"event_team_created_on_conflict"
		},
		insert_event_team_created_one:{
			object:"event_team_created_insert_input",
			on_conflict:"event_team_created_on_conflict"
		},
		insert_event_team_deleted:{
			objects:"event_team_deleted_insert_input",
			on_conflict:"event_team_deleted_on_conflict"
		},
		insert_event_team_deleted_one:{
			object:"event_team_deleted_insert_input",
			on_conflict:"event_team_deleted_on_conflict"
		},
		insert_event_team_reactivated:{
			objects:"event_team_reactivated_insert_input",
			on_conflict:"event_team_reactivated_on_conflict"
		},
		insert_event_team_reactivated_one:{
			object:"event_team_reactivated_insert_input",
			on_conflict:"event_team_reactivated_on_conflict"
		},
		insert_event_team_role_assignment_created:{
			objects:"event_team_role_assignment_created_insert_input",
			on_conflict:"event_team_role_assignment_created_on_conflict"
		},
		insert_event_team_role_assignment_created_one:{
			object:"event_team_role_assignment_created_insert_input",
			on_conflict:"event_team_role_assignment_created_on_conflict"
		},
		insert_event_team_role_assignment_deleted:{
			objects:"event_team_role_assignment_deleted_insert_input",
			on_conflict:"event_team_role_assignment_deleted_on_conflict"
		},
		insert_event_team_role_assignment_deleted_one:{
			object:"event_team_role_assignment_deleted_insert_input",
			on_conflict:"event_team_role_assignment_deleted_on_conflict"
		},
		insert_event_team_role_created:{
			objects:"event_team_role_created_insert_input",
			on_conflict:"event_team_role_created_on_conflict"
		},
		insert_event_team_role_created_one:{
			object:"event_team_role_created_insert_input",
			on_conflict:"event_team_role_created_on_conflict"
		},
		insert_event_team_role_deleted:{
			objects:"event_team_role_deleted_insert_input",
			on_conflict:"event_team_role_deleted_on_conflict"
		},
		insert_event_team_role_deleted_one:{
			object:"event_team_role_deleted_insert_input",
			on_conflict:"event_team_role_deleted_on_conflict"
		},
		insert_event_team_role_updated:{
			objects:"event_team_role_updated_insert_input",
			on_conflict:"event_team_role_updated_on_conflict"
		},
		insert_event_team_role_updated_one:{
			object:"event_team_role_updated_insert_input",
			on_conflict:"event_team_role_updated_on_conflict"
		},
		insert_event_team_updated:{
			objects:"event_team_updated_insert_input",
			on_conflict:"event_team_updated_on_conflict"
		},
		insert_event_team_updated_one:{
			object:"event_team_updated_insert_input",
			on_conflict:"event_team_updated_on_conflict"
		},
		insert_event_user_created:{
			objects:"event_user_created_insert_input",
			on_conflict:"event_user_created_on_conflict"
		},
		insert_event_user_created_one:{
			object:"event_user_created_insert_input",
			on_conflict:"event_user_created_on_conflict"
		},
		insert_event_user_deleted:{
			objects:"event_user_deleted_insert_input",
			on_conflict:"event_user_deleted_on_conflict"
		},
		insert_event_user_deleted_one:{
			object:"event_user_deleted_insert_input",
			on_conflict:"event_user_deleted_on_conflict"
		},
		insert_event_user_role_assignment_created:{
			objects:"event_user_role_assignment_created_insert_input",
			on_conflict:"event_user_role_assignment_created_on_conflict"
		},
		insert_event_user_role_assignment_created_one:{
			object:"event_user_role_assignment_created_insert_input",
			on_conflict:"event_user_role_assignment_created_on_conflict"
		},
		insert_event_user_role_assignment_deleted:{
			objects:"event_user_role_assignment_deleted_insert_input",
			on_conflict:"event_user_role_assignment_deleted_on_conflict"
		},
		insert_event_user_role_assignment_deleted_one:{
			object:"event_user_role_assignment_deleted_insert_input",
			on_conflict:"event_user_role_assignment_deleted_on_conflict"
		},
		insert_event_user_role_assignment_updated:{
			objects:"event_user_role_assignment_updated_insert_input",
			on_conflict:"event_user_role_assignment_updated_on_conflict"
		},
		insert_event_user_role_assignment_updated_one:{
			object:"event_user_role_assignment_updated_insert_input",
			on_conflict:"event_user_role_assignment_updated_on_conflict"
		},
		insert_event_user_updated:{
			objects:"event_user_updated_insert_input",
			on_conflict:"event_user_updated_on_conflict"
		},
		insert_event_user_updated_one:{
			object:"event_user_updated_insert_input",
			on_conflict:"event_user_updated_on_conflict"
		},
		insert_group:{
			objects:"group_insert_input",
			on_conflict:"group_on_conflict"
		},
		insert_group_membership:{
			objects:"group_membership_insert_input",
			on_conflict:"group_membership_on_conflict"
		},
		insert_group_membership_one:{
			object:"group_membership_insert_input",
			on_conflict:"group_membership_on_conflict"
		},
		insert_group_one:{
			object:"group_insert_input",
			on_conflict:"group_on_conflict"
		},
		insert_note:{
			objects:"note_insert_input",
			on_conflict:"note_on_conflict"
		},
		insert_note_one:{
			object:"note_insert_input",
			on_conflict:"note_on_conflict"
		},
		insert_permissions_shift_config:{
			objects:"permissions_shift_config_insert_input",
			on_conflict:"permissions_shift_config_on_conflict"
		},
		insert_permissions_shift_config_one:{
			object:"permissions_shift_config_insert_input",
			on_conflict:"permissions_shift_config_on_conflict"
		},
		insert_permissions_team_config:{
			objects:"permissions_team_config_insert_input",
			on_conflict:"permissions_team_config_on_conflict"
		},
		insert_permissions_team_config_one:{
			object:"permissions_team_config_insert_input",
			on_conflict:"permissions_team_config_on_conflict"
		},
		insert_permissions_team_role_config:{
			objects:"permissions_team_role_config_insert_input",
			on_conflict:"permissions_team_role_config_on_conflict"
		},
		insert_permissions_team_role_config_one:{
			object:"permissions_team_role_config_insert_input",
			on_conflict:"permissions_team_role_config_on_conflict"
		},
		insert_qualification:{
			objects:"qualification_insert_input",
			on_conflict:"qualification_on_conflict"
		},
		insert_qualification_one:{
			object:"qualification_insert_input",
			on_conflict:"qualification_on_conflict"
		},
		insert_recurring_shift_exception:{
			objects:"recurring_shift_exception_insert_input",
			on_conflict:"recurring_shift_exception_on_conflict"
		},
		insert_recurring_shift_exception_one:{
			object:"recurring_shift_exception_insert_input",
			on_conflict:"recurring_shift_exception_on_conflict"
		},
		insert_shift:{
			objects:"shift_insert_input",
			on_conflict:"shift_on_conflict"
		},
		insert_shift_one:{
			object:"shift_insert_input",
			on_conflict:"shift_on_conflict"
		},
		insert_team:{
			objects:"team_insert_input",
			on_conflict:"team_on_conflict"
		},
		insert_team_one:{
			object:"team_insert_input",
			on_conflict:"team_on_conflict"
		},
		insert_team_role:{
			objects:"team_role_insert_input",
			on_conflict:"team_role_on_conflict"
		},
		insert_team_role_assignment:{
			objects:"team_role_assignment_insert_input",
			on_conflict:"team_role_assignment_on_conflict"
		},
		insert_team_role_assignment_one:{
			object:"team_role_assignment_insert_input",
			on_conflict:"team_role_assignment_on_conflict"
		},
		insert_team_role_one:{
			object:"team_role_insert_input",
			on_conflict:"team_role_on_conflict"
		},
		insert_user:{
			objects:"user_insert_input",
			on_conflict:"user_on_conflict"
		},
		insert_user_notification:{
			objects:"user_notification_insert_input",
			on_conflict:"user_notification_on_conflict"
		},
		insert_user_notification_one:{
			object:"user_notification_insert_input",
			on_conflict:"user_notification_on_conflict"
		},
		insert_user_one:{
			object:"user_insert_input",
			on_conflict:"user_on_conflict"
		},
		insert_user_role_assignment:{
			objects:"user_role_assignment_insert_input",
			on_conflict:"user_role_assignment_on_conflict"
		},
		insert_user_role_assignment_one:{
			object:"user_role_assignment_insert_input",
			on_conflict:"user_role_assignment_on_conflict"
		},
		insert_user_shift_notification:{
			objects:"user_shift_notification_insert_input",
			on_conflict:"user_shift_notification_on_conflict"
		},
		insert_user_shift_notification_event:{
			objects:"user_shift_notification_event_insert_input",
			on_conflict:"user_shift_notification_event_on_conflict"
		},
		insert_user_shift_notification_event_one:{
			object:"user_shift_notification_event_insert_input",
			on_conflict:"user_shift_notification_event_on_conflict"
		},
		insert_user_shift_notification_one:{
			object:"user_shift_notification_insert_input",
			on_conflict:"user_shift_notification_on_conflict"
		},
		update_active_shift:{
			_set:"active_shift_set_input",
			where:"active_shift_bool_exp"
		},
		update_active_shift_by_pk:{
			_set:"active_shift_set_input",
			pk_columns:"active_shift_pk_columns_input"
		},
		update_active_shift_many:{
			updates:"active_shift_updates"
		},
		update_cost_object:{
			_set:"cost_object_set_input",
			where:"cost_object_bool_exp"
		},
		update_cost_object_by_pk:{
			_set:"cost_object_set_input",
			pk_columns:"cost_object_pk_columns_input"
		},
		update_cost_object_many:{
			updates:"cost_object_updates"
		},
		update_event:{
			_append:"event_append_input",
			_delete_at_path:"event_delete_at_path_input",
			_delete_elem:"event_delete_elem_input",
			_delete_key:"event_delete_key_input",
			_inc:"event_inc_input",
			_prepend:"event_prepend_input",
			_set:"event_set_input",
			where:"event_bool_exp"
		},
		update_event_buffered_shift_ended:{
			_inc:"event_buffered_shift_ended_inc_input",
			_set:"event_buffered_shift_ended_set_input",
			where:"event_buffered_shift_ended_bool_exp"
		},
		update_event_buffered_shift_ended_by_pk:{
			_inc:"event_buffered_shift_ended_inc_input",
			_set:"event_buffered_shift_ended_set_input",
			pk_columns:"event_buffered_shift_ended_pk_columns_input"
		},
		update_event_buffered_shift_ended_many:{
			updates:"event_buffered_shift_ended_updates"
		},
		update_event_buffered_shift_started:{
			_inc:"event_buffered_shift_started_inc_input",
			_set:"event_buffered_shift_started_set_input",
			where:"event_buffered_shift_started_bool_exp"
		},
		update_event_buffered_shift_started_by_pk:{
			_inc:"event_buffered_shift_started_inc_input",
			_set:"event_buffered_shift_started_set_input",
			pk_columns:"event_buffered_shift_started_pk_columns_input"
		},
		update_event_buffered_shift_started_many:{
			updates:"event_buffered_shift_started_updates"
		},
		update_event_by_pk:{
			_append:"event_append_input",
			_delete_at_path:"event_delete_at_path_input",
			_delete_elem:"event_delete_elem_input",
			_delete_key:"event_delete_key_input",
			_inc:"event_inc_input",
			_prepend:"event_prepend_input",
			_set:"event_set_input",
			pk_columns:"event_pk_columns_input"
		},
		update_event_cost_object_created:{
			_inc:"event_cost_object_created_inc_input",
			_set:"event_cost_object_created_set_input",
			where:"event_cost_object_created_bool_exp"
		},
		update_event_cost_object_created_by_pk:{
			_inc:"event_cost_object_created_inc_input",
			_set:"event_cost_object_created_set_input",
			pk_columns:"event_cost_object_created_pk_columns_input"
		},
		update_event_cost_object_created_many:{
			updates:"event_cost_object_created_updates"
		},
		update_event_cost_object_deleted:{
			_inc:"event_cost_object_deleted_inc_input",
			_set:"event_cost_object_deleted_set_input",
			where:"event_cost_object_deleted_bool_exp"
		},
		update_event_cost_object_deleted_by_pk:{
			_inc:"event_cost_object_deleted_inc_input",
			_set:"event_cost_object_deleted_set_input",
			pk_columns:"event_cost_object_deleted_pk_columns_input"
		},
		update_event_cost_object_deleted_many:{
			updates:"event_cost_object_deleted_updates"
		},
		update_event_cost_object_reactivated:{
			_inc:"event_cost_object_reactivated_inc_input",
			_set:"event_cost_object_reactivated_set_input",
			where:"event_cost_object_reactivated_bool_exp"
		},
		update_event_cost_object_reactivated_by_pk:{
			_inc:"event_cost_object_reactivated_inc_input",
			_set:"event_cost_object_reactivated_set_input",
			pk_columns:"event_cost_object_reactivated_pk_columns_input"
		},
		update_event_cost_object_reactivated_many:{
			updates:"event_cost_object_reactivated_updates"
		},
		update_event_cost_object_updated:{
			_inc:"event_cost_object_updated_inc_input",
			_set:"event_cost_object_updated_set_input",
			where:"event_cost_object_updated_bool_exp"
		},
		update_event_cost_object_updated_by_pk:{
			_inc:"event_cost_object_updated_inc_input",
			_set:"event_cost_object_updated_set_input",
			pk_columns:"event_cost_object_updated_pk_columns_input"
		},
		update_event_cost_object_updated_many:{
			updates:"event_cost_object_updated_updates"
		},
		update_event_derived_shift_deleted:{
			_inc:"event_derived_shift_deleted_inc_input",
			_set:"event_derived_shift_deleted_set_input",
			where:"event_derived_shift_deleted_bool_exp"
		},
		update_event_derived_shift_deleted_by_pk:{
			_inc:"event_derived_shift_deleted_inc_input",
			_set:"event_derived_shift_deleted_set_input",
			pk_columns:"event_derived_shift_deleted_pk_columns_input"
		},
		update_event_derived_shift_deleted_many:{
			updates:"event_derived_shift_deleted_updates"
		},
		update_event_derived_shift_updated:{
			_append:"event_derived_shift_updated_append_input",
			_delete_at_path:"event_derived_shift_updated_delete_at_path_input",
			_delete_elem:"event_derived_shift_updated_delete_elem_input",
			_delete_key:"event_derived_shift_updated_delete_key_input",
			_inc:"event_derived_shift_updated_inc_input",
			_prepend:"event_derived_shift_updated_prepend_input",
			_set:"event_derived_shift_updated_set_input",
			where:"event_derived_shift_updated_bool_exp"
		},
		update_event_derived_shift_updated_by_pk:{
			_append:"event_derived_shift_updated_append_input",
			_delete_at_path:"event_derived_shift_updated_delete_at_path_input",
			_delete_elem:"event_derived_shift_updated_delete_elem_input",
			_delete_key:"event_derived_shift_updated_delete_key_input",
			_inc:"event_derived_shift_updated_inc_input",
			_prepend:"event_derived_shift_updated_prepend_input",
			_set:"event_derived_shift_updated_set_input",
			pk_columns:"event_derived_shift_updated_pk_columns_input"
		},
		update_event_derived_shift_updated_many:{
			updates:"event_derived_shift_updated_updates"
		},
		update_event_many:{
			updates:"event_updates"
		},
		update_event_note_created:{
			_append:"event_note_created_append_input",
			_delete_at_path:"event_note_created_delete_at_path_input",
			_delete_elem:"event_note_created_delete_elem_input",
			_delete_key:"event_note_created_delete_key_input",
			_inc:"event_note_created_inc_input",
			_prepend:"event_note_created_prepend_input",
			_set:"event_note_created_set_input",
			where:"event_note_created_bool_exp"
		},
		update_event_note_created_by_pk:{
			_append:"event_note_created_append_input",
			_delete_at_path:"event_note_created_delete_at_path_input",
			_delete_elem:"event_note_created_delete_elem_input",
			_delete_key:"event_note_created_delete_key_input",
			_inc:"event_note_created_inc_input",
			_prepend:"event_note_created_prepend_input",
			_set:"event_note_created_set_input",
			pk_columns:"event_note_created_pk_columns_input"
		},
		update_event_note_created_many:{
			updates:"event_note_created_updates"
		},
		update_event_note_deleted:{
			_inc:"event_note_deleted_inc_input",
			_set:"event_note_deleted_set_input",
			where:"event_note_deleted_bool_exp"
		},
		update_event_note_deleted_by_pk:{
			_inc:"event_note_deleted_inc_input",
			_set:"event_note_deleted_set_input",
			pk_columns:"event_note_deleted_pk_columns_input"
		},
		update_event_note_deleted_many:{
			updates:"event_note_deleted_updates"
		},
		update_event_note_updated:{
			_append:"event_note_updated_append_input",
			_delete_at_path:"event_note_updated_delete_at_path_input",
			_delete_elem:"event_note_updated_delete_elem_input",
			_delete_key:"event_note_updated_delete_key_input",
			_inc:"event_note_updated_inc_input",
			_prepend:"event_note_updated_prepend_input",
			_set:"event_note_updated_set_input",
			where:"event_note_updated_bool_exp"
		},
		update_event_note_updated_by_pk:{
			_append:"event_note_updated_append_input",
			_delete_at_path:"event_note_updated_delete_at_path_input",
			_delete_elem:"event_note_updated_delete_elem_input",
			_delete_key:"event_note_updated_delete_key_input",
			_inc:"event_note_updated_inc_input",
			_prepend:"event_note_updated_prepend_input",
			_set:"event_note_updated_set_input",
			pk_columns:"event_note_updated_pk_columns_input"
		},
		update_event_note_updated_many:{
			updates:"event_note_updated_updates"
		},
		update_event_recurring_shift_exception_created:{
			_inc:"event_recurring_shift_exception_created_inc_input",
			_set:"event_recurring_shift_exception_created_set_input",
			where:"event_recurring_shift_exception_created_bool_exp"
		},
		update_event_recurring_shift_exception_created_by_pk:{
			_inc:"event_recurring_shift_exception_created_inc_input",
			_set:"event_recurring_shift_exception_created_set_input",
			pk_columns:"event_recurring_shift_exception_created_pk_columns_input"
		},
		update_event_recurring_shift_exception_created_many:{
			updates:"event_recurring_shift_exception_created_updates"
		},
		update_event_shift_created:{
			_append:"event_shift_created_append_input",
			_delete_at_path:"event_shift_created_delete_at_path_input",
			_delete_elem:"event_shift_created_delete_elem_input",
			_delete_key:"event_shift_created_delete_key_input",
			_inc:"event_shift_created_inc_input",
			_prepend:"event_shift_created_prepend_input",
			_set:"event_shift_created_set_input",
			where:"event_shift_created_bool_exp"
		},
		update_event_shift_created_by_pk:{
			_append:"event_shift_created_append_input",
			_delete_at_path:"event_shift_created_delete_at_path_input",
			_delete_elem:"event_shift_created_delete_elem_input",
			_delete_key:"event_shift_created_delete_key_input",
			_inc:"event_shift_created_inc_input",
			_prepend:"event_shift_created_prepend_input",
			_set:"event_shift_created_set_input",
			pk_columns:"event_shift_created_pk_columns_input"
		},
		update_event_shift_created_many:{
			updates:"event_shift_created_updates"
		},
		update_event_shift_deleted:{
			_inc:"event_shift_deleted_inc_input",
			_set:"event_shift_deleted_set_input",
			where:"event_shift_deleted_bool_exp"
		},
		update_event_shift_deleted_by_pk:{
			_inc:"event_shift_deleted_inc_input",
			_set:"event_shift_deleted_set_input",
			pk_columns:"event_shift_deleted_pk_columns_input"
		},
		update_event_shift_deleted_many:{
			updates:"event_shift_deleted_updates"
		},
		update_event_shift_ended:{
			_inc:"event_shift_ended_inc_input",
			_set:"event_shift_ended_set_input",
			where:"event_shift_ended_bool_exp"
		},
		update_event_shift_ended_by_pk:{
			_inc:"event_shift_ended_inc_input",
			_set:"event_shift_ended_set_input",
			pk_columns:"event_shift_ended_pk_columns_input"
		},
		update_event_shift_ended_many:{
			updates:"event_shift_ended_updates"
		},
		update_event_shift_started:{
			_inc:"event_shift_started_inc_input",
			_set:"event_shift_started_set_input",
			where:"event_shift_started_bool_exp"
		},
		update_event_shift_started_by_pk:{
			_inc:"event_shift_started_inc_input",
			_set:"event_shift_started_set_input",
			pk_columns:"event_shift_started_pk_columns_input"
		},
		update_event_shift_started_many:{
			updates:"event_shift_started_updates"
		},
		update_event_shift_updated:{
			_append:"event_shift_updated_append_input",
			_delete_at_path:"event_shift_updated_delete_at_path_input",
			_delete_elem:"event_shift_updated_delete_elem_input",
			_delete_key:"event_shift_updated_delete_key_input",
			_inc:"event_shift_updated_inc_input",
			_prepend:"event_shift_updated_prepend_input",
			_set:"event_shift_updated_set_input",
			where:"event_shift_updated_bool_exp"
		},
		update_event_shift_updated_by_pk:{
			_append:"event_shift_updated_append_input",
			_delete_at_path:"event_shift_updated_delete_at_path_input",
			_delete_elem:"event_shift_updated_delete_elem_input",
			_delete_key:"event_shift_updated_delete_key_input",
			_inc:"event_shift_updated_inc_input",
			_prepend:"event_shift_updated_prepend_input",
			_set:"event_shift_updated_set_input",
			pk_columns:"event_shift_updated_pk_columns_input"
		},
		update_event_shift_updated_many:{
			updates:"event_shift_updated_updates"
		},
		update_event_team_created:{
			_append:"event_team_created_append_input",
			_delete_at_path:"event_team_created_delete_at_path_input",
			_delete_elem:"event_team_created_delete_elem_input",
			_delete_key:"event_team_created_delete_key_input",
			_inc:"event_team_created_inc_input",
			_prepend:"event_team_created_prepend_input",
			_set:"event_team_created_set_input",
			where:"event_team_created_bool_exp"
		},
		update_event_team_created_by_pk:{
			_append:"event_team_created_append_input",
			_delete_at_path:"event_team_created_delete_at_path_input",
			_delete_elem:"event_team_created_delete_elem_input",
			_delete_key:"event_team_created_delete_key_input",
			_inc:"event_team_created_inc_input",
			_prepend:"event_team_created_prepend_input",
			_set:"event_team_created_set_input",
			pk_columns:"event_team_created_pk_columns_input"
		},
		update_event_team_created_many:{
			updates:"event_team_created_updates"
		},
		update_event_team_deleted:{
			_inc:"event_team_deleted_inc_input",
			_set:"event_team_deleted_set_input",
			where:"event_team_deleted_bool_exp"
		},
		update_event_team_deleted_by_pk:{
			_inc:"event_team_deleted_inc_input",
			_set:"event_team_deleted_set_input",
			pk_columns:"event_team_deleted_pk_columns_input"
		},
		update_event_team_deleted_many:{
			updates:"event_team_deleted_updates"
		},
		update_event_team_reactivated:{
			_inc:"event_team_reactivated_inc_input",
			_set:"event_team_reactivated_set_input",
			where:"event_team_reactivated_bool_exp"
		},
		update_event_team_reactivated_by_pk:{
			_inc:"event_team_reactivated_inc_input",
			_set:"event_team_reactivated_set_input",
			pk_columns:"event_team_reactivated_pk_columns_input"
		},
		update_event_team_reactivated_many:{
			updates:"event_team_reactivated_updates"
		},
		update_event_team_role_assignment_created:{
			_inc:"event_team_role_assignment_created_inc_input",
			_set:"event_team_role_assignment_created_set_input",
			where:"event_team_role_assignment_created_bool_exp"
		},
		update_event_team_role_assignment_created_by_pk:{
			_inc:"event_team_role_assignment_created_inc_input",
			_set:"event_team_role_assignment_created_set_input",
			pk_columns:"event_team_role_assignment_created_pk_columns_input"
		},
		update_event_team_role_assignment_created_many:{
			updates:"event_team_role_assignment_created_updates"
		},
		update_event_team_role_assignment_deleted:{
			_inc:"event_team_role_assignment_deleted_inc_input",
			_set:"event_team_role_assignment_deleted_set_input",
			where:"event_team_role_assignment_deleted_bool_exp"
		},
		update_event_team_role_assignment_deleted_by_pk:{
			_inc:"event_team_role_assignment_deleted_inc_input",
			_set:"event_team_role_assignment_deleted_set_input",
			pk_columns:"event_team_role_assignment_deleted_pk_columns_input"
		},
		update_event_team_role_assignment_deleted_many:{
			updates:"event_team_role_assignment_deleted_updates"
		},
		update_event_team_role_created:{
			_inc:"event_team_role_created_inc_input",
			_set:"event_team_role_created_set_input",
			where:"event_team_role_created_bool_exp"
		},
		update_event_team_role_created_by_pk:{
			_inc:"event_team_role_created_inc_input",
			_set:"event_team_role_created_set_input",
			pk_columns:"event_team_role_created_pk_columns_input"
		},
		update_event_team_role_created_many:{
			updates:"event_team_role_created_updates"
		},
		update_event_team_role_deleted:{
			_inc:"event_team_role_deleted_inc_input",
			_set:"event_team_role_deleted_set_input",
			where:"event_team_role_deleted_bool_exp"
		},
		update_event_team_role_deleted_by_pk:{
			_inc:"event_team_role_deleted_inc_input",
			_set:"event_team_role_deleted_set_input",
			pk_columns:"event_team_role_deleted_pk_columns_input"
		},
		update_event_team_role_deleted_many:{
			updates:"event_team_role_deleted_updates"
		},
		update_event_team_role_updated:{
			_inc:"event_team_role_updated_inc_input",
			_set:"event_team_role_updated_set_input",
			where:"event_team_role_updated_bool_exp"
		},
		update_event_team_role_updated_by_pk:{
			_inc:"event_team_role_updated_inc_input",
			_set:"event_team_role_updated_set_input",
			pk_columns:"event_team_role_updated_pk_columns_input"
		},
		update_event_team_role_updated_many:{
			updates:"event_team_role_updated_updates"
		},
		update_event_team_updated:{
			_append:"event_team_updated_append_input",
			_delete_at_path:"event_team_updated_delete_at_path_input",
			_delete_elem:"event_team_updated_delete_elem_input",
			_delete_key:"event_team_updated_delete_key_input",
			_inc:"event_team_updated_inc_input",
			_prepend:"event_team_updated_prepend_input",
			_set:"event_team_updated_set_input",
			where:"event_team_updated_bool_exp"
		},
		update_event_team_updated_by_pk:{
			_append:"event_team_updated_append_input",
			_delete_at_path:"event_team_updated_delete_at_path_input",
			_delete_elem:"event_team_updated_delete_elem_input",
			_delete_key:"event_team_updated_delete_key_input",
			_inc:"event_team_updated_inc_input",
			_prepend:"event_team_updated_prepend_input",
			_set:"event_team_updated_set_input",
			pk_columns:"event_team_updated_pk_columns_input"
		},
		update_event_team_updated_many:{
			updates:"event_team_updated_updates"
		},
		update_event_user_created:{
			_inc:"event_user_created_inc_input",
			_set:"event_user_created_set_input",
			where:"event_user_created_bool_exp"
		},
		update_event_user_created_by_pk:{
			_inc:"event_user_created_inc_input",
			_set:"event_user_created_set_input",
			pk_columns:"event_user_created_pk_columns_input"
		},
		update_event_user_created_many:{
			updates:"event_user_created_updates"
		},
		update_event_user_deleted:{
			_inc:"event_user_deleted_inc_input",
			_set:"event_user_deleted_set_input",
			where:"event_user_deleted_bool_exp"
		},
		update_event_user_deleted_by_pk:{
			_inc:"event_user_deleted_inc_input",
			_set:"event_user_deleted_set_input",
			pk_columns:"event_user_deleted_pk_columns_input"
		},
		update_event_user_deleted_many:{
			updates:"event_user_deleted_updates"
		},
		update_event_user_role_assignment_created:{
			_inc:"event_user_role_assignment_created_inc_input",
			_set:"event_user_role_assignment_created_set_input",
			where:"event_user_role_assignment_created_bool_exp"
		},
		update_event_user_role_assignment_created_by_pk:{
			_inc:"event_user_role_assignment_created_inc_input",
			_set:"event_user_role_assignment_created_set_input",
			pk_columns:"event_user_role_assignment_created_pk_columns_input"
		},
		update_event_user_role_assignment_created_many:{
			updates:"event_user_role_assignment_created_updates"
		},
		update_event_user_role_assignment_deleted:{
			_inc:"event_user_role_assignment_deleted_inc_input",
			_set:"event_user_role_assignment_deleted_set_input",
			where:"event_user_role_assignment_deleted_bool_exp"
		},
		update_event_user_role_assignment_deleted_by_pk:{
			_inc:"event_user_role_assignment_deleted_inc_input",
			_set:"event_user_role_assignment_deleted_set_input",
			pk_columns:"event_user_role_assignment_deleted_pk_columns_input"
		},
		update_event_user_role_assignment_deleted_many:{
			updates:"event_user_role_assignment_deleted_updates"
		},
		update_event_user_role_assignment_updated:{
			_inc:"event_user_role_assignment_updated_inc_input",
			_set:"event_user_role_assignment_updated_set_input",
			where:"event_user_role_assignment_updated_bool_exp"
		},
		update_event_user_role_assignment_updated_by_pk:{
			_inc:"event_user_role_assignment_updated_inc_input",
			_set:"event_user_role_assignment_updated_set_input",
			pk_columns:"event_user_role_assignment_updated_pk_columns_input"
		},
		update_event_user_role_assignment_updated_many:{
			updates:"event_user_role_assignment_updated_updates"
		},
		update_event_user_updated:{
			_inc:"event_user_updated_inc_input",
			_set:"event_user_updated_set_input",
			where:"event_user_updated_bool_exp"
		},
		update_event_user_updated_by_pk:{
			_inc:"event_user_updated_inc_input",
			_set:"event_user_updated_set_input",
			pk_columns:"event_user_updated_pk_columns_input"
		},
		update_event_user_updated_many:{
			updates:"event_user_updated_updates"
		},
		update_group:{
			_set:"group_set_input",
			where:"group_bool_exp"
		},
		update_group_by_pk:{
			_set:"group_set_input",
			pk_columns:"group_pk_columns_input"
		},
		update_group_many:{
			updates:"group_updates"
		},
		update_group_membership:{
			_set:"group_membership_set_input",
			where:"group_membership_bool_exp"
		},
		update_group_membership_by_pk:{
			_set:"group_membership_set_input",
			pk_columns:"group_membership_pk_columns_input"
		},
		update_group_membership_many:{
			updates:"group_membership_updates"
		},
		update_note:{
			_append:"note_append_input",
			_delete_at_path:"note_delete_at_path_input",
			_delete_elem:"note_delete_elem_input",
			_delete_key:"note_delete_key_input",
			_prepend:"note_prepend_input",
			_set:"note_set_input",
			where:"note_bool_exp"
		},
		update_note_by_pk:{
			_append:"note_append_input",
			_delete_at_path:"note_delete_at_path_input",
			_delete_elem:"note_delete_elem_input",
			_delete_key:"note_delete_key_input",
			_prepend:"note_prepend_input",
			_set:"note_set_input",
			pk_columns:"note_pk_columns_input"
		},
		update_note_many:{
			updates:"note_updates"
		},
		update_permissions_shift_config:{
			_set:"permissions_shift_config_set_input",
			where:"permissions_shift_config_bool_exp"
		},
		update_permissions_shift_config_by_pk:{
			_set:"permissions_shift_config_set_input",
			pk_columns:"permissions_shift_config_pk_columns_input"
		},
		update_permissions_shift_config_many:{
			updates:"permissions_shift_config_updates"
		},
		update_permissions_team_config:{
			_set:"permissions_team_config_set_input",
			where:"permissions_team_config_bool_exp"
		},
		update_permissions_team_config_by_pk:{
			_set:"permissions_team_config_set_input",
			pk_columns:"permissions_team_config_pk_columns_input"
		},
		update_permissions_team_config_many:{
			updates:"permissions_team_config_updates"
		},
		update_permissions_team_role_config:{
			_set:"permissions_team_role_config_set_input",
			where:"permissions_team_role_config_bool_exp"
		},
		update_permissions_team_role_config_by_pk:{
			_set:"permissions_team_role_config_set_input",
			pk_columns:"permissions_team_role_config_pk_columns_input"
		},
		update_permissions_team_role_config_many:{
			updates:"permissions_team_role_config_updates"
		},
		update_qualification:{
			_set:"qualification_set_input",
			where:"qualification_bool_exp"
		},
		update_qualification_by_pk:{
			_set:"qualification_set_input",
			pk_columns:"qualification_pk_columns_input"
		},
		update_qualification_many:{
			updates:"qualification_updates"
		},
		update_recurring_shift_exception:{
			_set:"recurring_shift_exception_set_input",
			where:"recurring_shift_exception_bool_exp"
		},
		update_recurring_shift_exception_by_pk:{
			_set:"recurring_shift_exception_set_input",
			pk_columns:"recurring_shift_exception_pk_columns_input"
		},
		update_recurring_shift_exception_many:{
			updates:"recurring_shift_exception_updates"
		},
		update_shift:{
			_set:"shift_set_input",
			where:"shift_bool_exp"
		},
		update_shift_by_pk:{
			_set:"shift_set_input",
			pk_columns:"shift_pk_columns_input"
		},
		update_shift_many:{
			updates:"shift_updates"
		},
		update_team:{
			_append:"team_append_input",
			_delete_at_path:"team_delete_at_path_input",
			_delete_elem:"team_delete_elem_input",
			_delete_key:"team_delete_key_input",
			_prepend:"team_prepend_input",
			_set:"team_set_input",
			where:"team_bool_exp"
		},
		update_team_by_pk:{
			_append:"team_append_input",
			_delete_at_path:"team_delete_at_path_input",
			_delete_elem:"team_delete_elem_input",
			_delete_key:"team_delete_key_input",
			_prepend:"team_prepend_input",
			_set:"team_set_input",
			pk_columns:"team_pk_columns_input"
		},
		update_team_many:{
			updates:"team_updates"
		},
		update_team_role:{
			_set:"team_role_set_input",
			where:"team_role_bool_exp"
		},
		update_team_role_assignment:{
			_set:"team_role_assignment_set_input",
			where:"team_role_assignment_bool_exp"
		},
		update_team_role_assignment_by_pk:{
			_set:"team_role_assignment_set_input",
			pk_columns:"team_role_assignment_pk_columns_input"
		},
		update_team_role_assignment_many:{
			updates:"team_role_assignment_updates"
		},
		update_team_role_by_pk:{
			_set:"team_role_set_input",
			pk_columns:"team_role_pk_columns_input"
		},
		update_team_role_many:{
			updates:"team_role_updates"
		},
		update_user:{
			_set:"user_set_input",
			where:"user_bool_exp"
		},
		update_user_by_pk:{
			_set:"user_set_input",
			pk_columns:"user_pk_columns_input"
		},
		update_user_many:{
			updates:"user_updates"
		},
		update_user_notification:{
			_inc:"user_notification_inc_input",
			_set:"user_notification_set_input",
			where:"user_notification_bool_exp"
		},
		update_user_notification_by_pk:{
			_inc:"user_notification_inc_input",
			_set:"user_notification_set_input",
			pk_columns:"user_notification_pk_columns_input"
		},
		update_user_notification_many:{
			updates:"user_notification_updates"
		},
		update_user_role_assignment:{
			_set:"user_role_assignment_set_input",
			where:"user_role_assignment_bool_exp"
		},
		update_user_role_assignment_by_pk:{
			_set:"user_role_assignment_set_input",
			pk_columns:"user_role_assignment_pk_columns_input"
		},
		update_user_role_assignment_many:{
			updates:"user_role_assignment_updates"
		},
		update_user_shift_notification:{
			_set:"user_shift_notification_set_input",
			where:"user_shift_notification_bool_exp"
		},
		update_user_shift_notification_by_pk:{
			_set:"user_shift_notification_set_input",
			pk_columns:"user_shift_notification_pk_columns_input"
		},
		update_user_shift_notification_event:{
			_inc:"user_shift_notification_event_inc_input",
			_set:"user_shift_notification_event_set_input",
			where:"user_shift_notification_event_bool_exp"
		},
		update_user_shift_notification_event_by_pk:{
			_inc:"user_shift_notification_event_inc_input",
			_set:"user_shift_notification_event_set_input",
			pk_columns:"user_shift_notification_event_pk_columns_input"
		},
		update_user_shift_notification_event_many:{
			updates:"user_shift_notification_event_updates"
		},
		update_user_shift_notification_many:{
			updates:"user_shift_notification_updates"
		}
	},
	note:{
		content:{

		},
		event_note_deleted:{
			distinct_on:"event_note_deleted_select_column",
			order_by:"event_note_deleted_order_by",
			where:"event_note_deleted_bool_exp"
		},
		event_note_deleted_aggregate:{
			distinct_on:"event_note_deleted_select_column",
			order_by:"event_note_deleted_order_by",
			where:"event_note_deleted_bool_exp"
		},
		event_note_updated:{
			distinct_on:"event_note_updated_select_column",
			order_by:"event_note_updated_order_by",
			where:"event_note_updated_bool_exp"
		},
		event_note_updated_aggregate:{
			distinct_on:"event_note_updated_select_column",
			order_by:"event_note_updated_order_by",
			where:"event_note_updated_bool_exp"
		}
	},
	note_aggregate_bool_exp:{
		count:"note_aggregate_bool_exp_count"
	},
	note_aggregate_bool_exp_count:{
		arguments:"note_select_column",
		filter:"note_bool_exp",
		predicate:"Int_comparison_exp"
	},
	note_aggregate_fields:{
		count:{
			columns:"note_select_column"
		}
	},
	note_aggregate_order_by:{
		count:"order_by",
		max:"note_max_order_by",
		min:"note_min_order_by"
	},
	note_append_input:{
		content:"jsonb"
	},
	note_arr_rel_insert_input:{
		data:"note_insert_input",
		on_conflict:"note_on_conflict"
	},
	note_bool_exp:{
		_and:"note_bool_exp",
		_not:"note_bool_exp",
		_or:"note_bool_exp",
		content:"jsonb_comparison_exp",
		created_at:"timestamptz_comparison_exp",
		date:"date_comparison_exp",
		event_note_created:"event_note_created_bool_exp",
		event_note_deleted:"event_note_deleted_bool_exp",
		event_note_deleted_aggregate:"event_note_deleted_aggregate_bool_exp",
		event_note_updated:"event_note_updated_bool_exp",
		event_note_updated_aggregate:"event_note_updated_aggregate_bool_exp",
		id:"uuid_comparison_exp",
		object_id:"uuid_comparison_exp",
		record_status:"record_status_t_comparison_exp",
		shift:"shift_bool_exp",
		updated_at:"timestamptz_comparison_exp",
		user:"user_bool_exp",
		user_id:"uuid_comparison_exp"
	},
	note_constraint: "enum" as const,
	note_delete_at_path_input:{

	},
	note_delete_elem_input:{

	},
	note_delete_key_input:{

	},
	note_insert_input:{
		content:"jsonb",
		created_at:"timestamptz",
		date:"date",
		event_note_created:"event_note_created_obj_rel_insert_input",
		event_note_deleted:"event_note_deleted_arr_rel_insert_input",
		event_note_updated:"event_note_updated_arr_rel_insert_input",
		id:"uuid",
		object_id:"uuid",
		record_status:"record_status_t",
		shift:"shift_obj_rel_insert_input",
		updated_at:"timestamptz",
		user:"user_obj_rel_insert_input",
		user_id:"uuid"
	},
	note_max_order_by:{
		created_at:"order_by",
		date:"order_by",
		id:"order_by",
		object_id:"order_by",
		record_status:"order_by",
		updated_at:"order_by",
		user_id:"order_by"
	},
	note_min_order_by:{
		created_at:"order_by",
		date:"order_by",
		id:"order_by",
		object_id:"order_by",
		record_status:"order_by",
		updated_at:"order_by",
		user_id:"order_by"
	},
	note_obj_rel_insert_input:{
		data:"note_insert_input",
		on_conflict:"note_on_conflict"
	},
	note_on_conflict:{
		constraint:"note_constraint",
		update_columns:"note_update_column",
		where:"note_bool_exp"
	},
	note_order_by:{
		content:"order_by",
		created_at:"order_by",
		date:"order_by",
		event_note_created:"event_note_created_order_by",
		event_note_deleted_aggregate:"event_note_deleted_aggregate_order_by",
		event_note_updated_aggregate:"event_note_updated_aggregate_order_by",
		id:"order_by",
		object_id:"order_by",
		record_status:"order_by",
		shift:"shift_order_by",
		updated_at:"order_by",
		user:"user_order_by",
		user_id:"order_by"
	},
	note_pk_columns_input:{
		id:"uuid"
	},
	note_prepend_input:{
		content:"jsonb"
	},
	note_select_column: "enum" as const,
	note_set_input:{
		content:"jsonb",
		created_at:"timestamptz",
		date:"date",
		id:"uuid",
		object_id:"uuid",
		record_status:"record_status_t",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	note_stream_cursor_input:{
		initial_value:"note_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	note_stream_cursor_value_input:{
		content:"jsonb",
		created_at:"timestamptz",
		date:"date",
		id:"uuid",
		object_id:"uuid",
		record_status:"record_status_t",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	note_update_column: "enum" as const,
	note_updates:{
		_append:"note_append_input",
		_delete_at_path:"note_delete_at_path_input",
		_delete_elem:"note_delete_elem_input",
		_delete_key:"note_delete_key_input",
		_prepend:"note_prepend_input",
		_set:"note_set_input",
		where:"note_bool_exp"
	},
	notification_status_t: `scalar.notification_status_t` as const,
	notification_status_t_comparison_exp:{
		_eq:"notification_status_t",
		_gt:"notification_status_t",
		_gte:"notification_status_t",
		_in:"notification_status_t",
		_lt:"notification_status_t",
		_lte:"notification_status_t",
		_neq:"notification_status_t",
		_nin:"notification_status_t"
	},
	notification_type_t: `scalar.notification_type_t` as const,
	notification_type_t_comparison_exp:{
		_eq:"notification_type_t",
		_gt:"notification_type_t",
		_gte:"notification_type_t",
		_in:"notification_type_t",
		_lt:"notification_type_t",
		_lte:"notification_type_t",
		_neq:"notification_type_t",
		_nin:"notification_type_t"
	},
	order_by: "enum" as const,
	permissions_shift_aggregate_fields:{
		count:{
			columns:"permissions_shift_select_column"
		}
	},
	permissions_shift_bool_exp:{
		_and:"permissions_shift_bool_exp",
		_not:"permissions_shift_bool_exp",
		_or:"permissions_shift_bool_exp",
		action:"String_comparison_exp",
		external_id:"String_comparison_exp",
		target_entity:"String_comparison_exp",
		target_entity_id:"uuid_comparison_exp",
		team_role_assignment_id:"uuid_comparison_exp"
	},
	permissions_shift_config_aggregate_bool_exp:{
		bool_and:"permissions_shift_config_aggregate_bool_exp_bool_and",
		bool_or:"permissions_shift_config_aggregate_bool_exp_bool_or",
		count:"permissions_shift_config_aggregate_bool_exp_count"
	},
	permissions_shift_config_aggregate_bool_exp_bool_and:{
		arguments:"permissions_shift_config_select_column_permissions_shift_config_aggregate_bool_exp_bool_and_arguments_columns",
		filter:"permissions_shift_config_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	permissions_shift_config_aggregate_bool_exp_bool_or:{
		arguments:"permissions_shift_config_select_column_permissions_shift_config_aggregate_bool_exp_bool_or_arguments_columns",
		filter:"permissions_shift_config_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	permissions_shift_config_aggregate_bool_exp_count:{
		arguments:"permissions_shift_config_select_column",
		filter:"permissions_shift_config_bool_exp",
		predicate:"Int_comparison_exp"
	},
	permissions_shift_config_aggregate_fields:{
		count:{
			columns:"permissions_shift_config_select_column"
		}
	},
	permissions_shift_config_aggregate_order_by:{
		count:"order_by",
		max:"permissions_shift_config_max_order_by",
		min:"permissions_shift_config_min_order_by"
	},
	permissions_shift_config_arr_rel_insert_input:{
		data:"permissions_shift_config_insert_input",
		on_conflict:"permissions_shift_config_on_conflict"
	},
	permissions_shift_config_bool_exp:{
		_and:"permissions_shift_config_bool_exp",
		_not:"permissions_shift_config_bool_exp",
		_or:"permissions_shift_config_bool_exp",
		action:"String_comparison_exp",
		id:"uuid_comparison_exp",
		is_power_user:"Boolean_comparison_exp",
		team_role:"team_role_bool_exp",
		team_role_id:"uuid_comparison_exp",
		team_type:"String_comparison_exp"
	},
	permissions_shift_config_constraint: "enum" as const,
	permissions_shift_config_insert_input:{
		id:"uuid",
		team_role:"team_role_obj_rel_insert_input",
		team_role_id:"uuid"
	},
	permissions_shift_config_max_order_by:{
		action:"order_by",
		id:"order_by",
		team_role_id:"order_by",
		team_type:"order_by"
	},
	permissions_shift_config_min_order_by:{
		action:"order_by",
		id:"order_by",
		team_role_id:"order_by",
		team_type:"order_by"
	},
	permissions_shift_config_on_conflict:{
		constraint:"permissions_shift_config_constraint",
		update_columns:"permissions_shift_config_update_column",
		where:"permissions_shift_config_bool_exp"
	},
	permissions_shift_config_order_by:{
		action:"order_by",
		id:"order_by",
		is_power_user:"order_by",
		team_role:"team_role_order_by",
		team_role_id:"order_by",
		team_type:"order_by"
	},
	permissions_shift_config_pk_columns_input:{
		id:"uuid"
	},
	permissions_shift_config_select_column: "enum" as const,
	permissions_shift_config_select_column_permissions_shift_config_aggregate_bool_exp_bool_and_arguments_columns: "enum" as const,
	permissions_shift_config_select_column_permissions_shift_config_aggregate_bool_exp_bool_or_arguments_columns: "enum" as const,
	permissions_shift_config_set_input:{
		id:"uuid",
		team_role_id:"uuid"
	},
	permissions_shift_config_stream_cursor_input:{
		initial_value:"permissions_shift_config_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	permissions_shift_config_stream_cursor_value_input:{
		id:"uuid",
		team_role_id:"uuid"
	},
	permissions_shift_config_update_column: "enum" as const,
	permissions_shift_config_updates:{
		_set:"permissions_shift_config_set_input",
		where:"permissions_shift_config_bool_exp"
	},
	permissions_shift_order_by:{
		action:"order_by",
		external_id:"order_by",
		target_entity:"order_by",
		target_entity_id:"order_by",
		team_role_assignment_id:"order_by"
	},
	permissions_shift_select_column: "enum" as const,
	permissions_shift_stream_cursor_input:{
		initial_value:"permissions_shift_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	permissions_shift_stream_cursor_value_input:{
		target_entity_id:"uuid",
		team_role_assignment_id:"uuid"
	},
	permissions_team_aggregate_fields:{
		count:{
			columns:"permissions_team_select_column"
		}
	},
	permissions_team_bool_exp:{
		_and:"permissions_team_bool_exp",
		_not:"permissions_team_bool_exp",
		_or:"permissions_team_bool_exp",
		action:"String_comparison_exp",
		external_id:"String_comparison_exp",
		is_power_user:"Boolean_comparison_exp",
		target_entity:"String_comparison_exp",
		target_entity_id:"uuid_comparison_exp",
		team_type:"String_comparison_exp"
	},
	permissions_team_config_aggregate_bool_exp:{
		bool_and:"permissions_team_config_aggregate_bool_exp_bool_and",
		bool_or:"permissions_team_config_aggregate_bool_exp_bool_or",
		count:"permissions_team_config_aggregate_bool_exp_count"
	},
	permissions_team_config_aggregate_bool_exp_bool_and:{
		arguments:"permissions_team_config_select_column_permissions_team_config_aggregate_bool_exp_bool_and_arguments_columns",
		filter:"permissions_team_config_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	permissions_team_config_aggregate_bool_exp_bool_or:{
		arguments:"permissions_team_config_select_column_permissions_team_config_aggregate_bool_exp_bool_or_arguments_columns",
		filter:"permissions_team_config_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	permissions_team_config_aggregate_bool_exp_count:{
		arguments:"permissions_team_config_select_column",
		filter:"permissions_team_config_bool_exp",
		predicate:"Int_comparison_exp"
	},
	permissions_team_config_aggregate_fields:{
		count:{
			columns:"permissions_team_config_select_column"
		}
	},
	permissions_team_config_aggregate_order_by:{
		count:"order_by",
		max:"permissions_team_config_max_order_by",
		min:"permissions_team_config_min_order_by"
	},
	permissions_team_config_arr_rel_insert_input:{
		data:"permissions_team_config_insert_input",
		on_conflict:"permissions_team_config_on_conflict"
	},
	permissions_team_config_bool_exp:{
		_and:"permissions_team_config_bool_exp",
		_not:"permissions_team_config_bool_exp",
		_or:"permissions_team_config_bool_exp",
		action:"String_comparison_exp",
		id:"uuid_comparison_exp",
		is_power_user:"Boolean_comparison_exp",
		team_role:"team_role_bool_exp",
		team_role_id:"uuid_comparison_exp",
		team_type:"String_comparison_exp"
	},
	permissions_team_config_constraint: "enum" as const,
	permissions_team_config_insert_input:{
		id:"uuid",
		team_role:"team_role_obj_rel_insert_input",
		team_role_id:"uuid"
	},
	permissions_team_config_max_order_by:{
		action:"order_by",
		id:"order_by",
		team_role_id:"order_by",
		team_type:"order_by"
	},
	permissions_team_config_min_order_by:{
		action:"order_by",
		id:"order_by",
		team_role_id:"order_by",
		team_type:"order_by"
	},
	permissions_team_config_on_conflict:{
		constraint:"permissions_team_config_constraint",
		update_columns:"permissions_team_config_update_column",
		where:"permissions_team_config_bool_exp"
	},
	permissions_team_config_order_by:{
		action:"order_by",
		id:"order_by",
		is_power_user:"order_by",
		team_role:"team_role_order_by",
		team_role_id:"order_by",
		team_type:"order_by"
	},
	permissions_team_config_pk_columns_input:{
		id:"uuid"
	},
	permissions_team_config_select_column: "enum" as const,
	permissions_team_config_select_column_permissions_team_config_aggregate_bool_exp_bool_and_arguments_columns: "enum" as const,
	permissions_team_config_select_column_permissions_team_config_aggregate_bool_exp_bool_or_arguments_columns: "enum" as const,
	permissions_team_config_set_input:{
		id:"uuid",
		team_role_id:"uuid"
	},
	permissions_team_config_stream_cursor_input:{
		initial_value:"permissions_team_config_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	permissions_team_config_stream_cursor_value_input:{
		id:"uuid",
		team_role_id:"uuid"
	},
	permissions_team_config_update_column: "enum" as const,
	permissions_team_config_updates:{
		_set:"permissions_team_config_set_input",
		where:"permissions_team_config_bool_exp"
	},
	permissions_team_order_by:{
		action:"order_by",
		external_id:"order_by",
		is_power_user:"order_by",
		target_entity:"order_by",
		target_entity_id:"order_by",
		team_type:"order_by"
	},
	permissions_team_role_aggregate_bool_exp:{
		bool_and:"permissions_team_role_aggregate_bool_exp_bool_and",
		bool_or:"permissions_team_role_aggregate_bool_exp_bool_or",
		count:"permissions_team_role_aggregate_bool_exp_count"
	},
	permissions_team_role_aggregate_bool_exp_bool_and:{
		arguments:"permissions_team_role_select_column_permissions_team_role_aggregate_bool_exp_bool_and_arguments_columns",
		filter:"permissions_team_role_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	permissions_team_role_aggregate_bool_exp_bool_or:{
		arguments:"permissions_team_role_select_column_permissions_team_role_aggregate_bool_exp_bool_or_arguments_columns",
		filter:"permissions_team_role_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	permissions_team_role_aggregate_bool_exp_count:{
		arguments:"permissions_team_role_select_column",
		filter:"permissions_team_role_bool_exp",
		predicate:"Int_comparison_exp"
	},
	permissions_team_role_aggregate_fields:{
		count:{
			columns:"permissions_team_role_select_column"
		}
	},
	permissions_team_role_aggregate_order_by:{
		count:"order_by",
		max:"permissions_team_role_max_order_by",
		min:"permissions_team_role_min_order_by"
	},
	permissions_team_role_arr_rel_insert_input:{
		data:"permissions_team_role_insert_input"
	},
	permissions_team_role_assignment_aggregate_fields:{
		count:{
			columns:"permissions_team_role_assignment_select_column"
		}
	},
	permissions_team_role_assignment_bool_exp:{
		_and:"permissions_team_role_assignment_bool_exp",
		_not:"permissions_team_role_assignment_bool_exp",
		_or:"permissions_team_role_assignment_bool_exp",
		action:"String_comparison_exp",
		external_id:"String_comparison_exp",
		target_entity:"String_comparison_exp",
		target_entity_id:"uuid_comparison_exp",
		team_id:"uuid_comparison_exp",
		team_role_id:"uuid_comparison_exp"
	},
	permissions_team_role_assignment_order_by:{
		action:"order_by",
		external_id:"order_by",
		target_entity:"order_by",
		target_entity_id:"order_by",
		team_id:"order_by",
		team_role_id:"order_by"
	},
	permissions_team_role_assignment_select_column: "enum" as const,
	permissions_team_role_assignment_stream_cursor_input:{
		initial_value:"permissions_team_role_assignment_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	permissions_team_role_assignment_stream_cursor_value_input:{
		target_entity_id:"uuid",
		team_id:"uuid",
		team_role_id:"uuid"
	},
	permissions_team_role_bool_exp:{
		_and:"permissions_team_role_bool_exp",
		_not:"permissions_team_role_bool_exp",
		_or:"permissions_team_role_bool_exp",
		action:"String_comparison_exp",
		external_id:"String_comparison_exp",
		is_power_user:"Boolean_comparison_exp",
		target_team_role_id:"uuid_comparison_exp",
		team_id:"uuid_comparison_exp"
	},
	permissions_team_role_config_aggregate_bool_exp:{
		bool_and:"permissions_team_role_config_aggregate_bool_exp_bool_and",
		bool_or:"permissions_team_role_config_aggregate_bool_exp_bool_or",
		count:"permissions_team_role_config_aggregate_bool_exp_count"
	},
	permissions_team_role_config_aggregate_bool_exp_bool_and:{
		arguments:"permissions_team_role_config_select_column_permissions_team_role_config_aggregate_bool_exp_bool_and_arguments_columns",
		filter:"permissions_team_role_config_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	permissions_team_role_config_aggregate_bool_exp_bool_or:{
		arguments:"permissions_team_role_config_select_column_permissions_team_role_config_aggregate_bool_exp_bool_or_arguments_columns",
		filter:"permissions_team_role_config_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	permissions_team_role_config_aggregate_bool_exp_count:{
		arguments:"permissions_team_role_config_select_column",
		filter:"permissions_team_role_config_bool_exp",
		predicate:"Int_comparison_exp"
	},
	permissions_team_role_config_aggregate_fields:{
		count:{
			columns:"permissions_team_role_config_select_column"
		}
	},
	permissions_team_role_config_aggregate_order_by:{
		count:"order_by",
		max:"permissions_team_role_config_max_order_by",
		min:"permissions_team_role_config_min_order_by"
	},
	permissions_team_role_config_arr_rel_insert_input:{
		data:"permissions_team_role_config_insert_input",
		on_conflict:"permissions_team_role_config_on_conflict"
	},
	permissions_team_role_config_bool_exp:{
		_and:"permissions_team_role_config_bool_exp",
		_not:"permissions_team_role_config_bool_exp",
		_or:"permissions_team_role_config_bool_exp",
		action:"String_comparison_exp",
		id:"uuid_comparison_exp",
		is_power_user:"Boolean_comparison_exp",
		target_team_role_id:"uuid_comparison_exp",
		teamRoleByTeamRoleId:"team_role_bool_exp",
		team_role:"team_role_bool_exp",
		team_role_id:"uuid_comparison_exp",
		team_type:"String_comparison_exp"
	},
	permissions_team_role_config_constraint: "enum" as const,
	permissions_team_role_config_insert_input:{
		id:"uuid",
		target_team_role_id:"uuid",
		teamRoleByTeamRoleId:"team_role_obj_rel_insert_input",
		team_role:"team_role_obj_rel_insert_input",
		team_role_id:"uuid"
	},
	permissions_team_role_config_max_order_by:{
		action:"order_by",
		id:"order_by",
		target_team_role_id:"order_by",
		team_role_id:"order_by",
		team_type:"order_by"
	},
	permissions_team_role_config_min_order_by:{
		action:"order_by",
		id:"order_by",
		target_team_role_id:"order_by",
		team_role_id:"order_by",
		team_type:"order_by"
	},
	permissions_team_role_config_on_conflict:{
		constraint:"permissions_team_role_config_constraint",
		update_columns:"permissions_team_role_config_update_column",
		where:"permissions_team_role_config_bool_exp"
	},
	permissions_team_role_config_order_by:{
		action:"order_by",
		id:"order_by",
		is_power_user:"order_by",
		target_team_role_id:"order_by",
		teamRoleByTeamRoleId:"team_role_order_by",
		team_role:"team_role_order_by",
		team_role_id:"order_by",
		team_type:"order_by"
	},
	permissions_team_role_config_pk_columns_input:{
		id:"uuid"
	},
	permissions_team_role_config_select_column: "enum" as const,
	permissions_team_role_config_select_column_permissions_team_role_config_aggregate_bool_exp_bool_and_arguments_columns: "enum" as const,
	permissions_team_role_config_select_column_permissions_team_role_config_aggregate_bool_exp_bool_or_arguments_columns: "enum" as const,
	permissions_team_role_config_set_input:{
		id:"uuid",
		target_team_role_id:"uuid",
		team_role_id:"uuid"
	},
	permissions_team_role_config_stream_cursor_input:{
		initial_value:"permissions_team_role_config_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	permissions_team_role_config_stream_cursor_value_input:{
		id:"uuid",
		target_team_role_id:"uuid",
		team_role_id:"uuid"
	},
	permissions_team_role_config_update_column: "enum" as const,
	permissions_team_role_config_updates:{
		_set:"permissions_team_role_config_set_input",
		where:"permissions_team_role_config_bool_exp"
	},
	permissions_team_role_insert_input:{
		target_team_role_id:"uuid",
		team_id:"uuid"
	},
	permissions_team_role_max_order_by:{
		action:"order_by",
		external_id:"order_by",
		target_team_role_id:"order_by",
		team_id:"order_by"
	},
	permissions_team_role_min_order_by:{
		action:"order_by",
		external_id:"order_by",
		target_team_role_id:"order_by",
		team_id:"order_by"
	},
	permissions_team_role_order_by:{
		action:"order_by",
		external_id:"order_by",
		is_power_user:"order_by",
		target_team_role_id:"order_by",
		team_id:"order_by"
	},
	permissions_team_role_select_column: "enum" as const,
	permissions_team_role_select_column_permissions_team_role_aggregate_bool_exp_bool_and_arguments_columns: "enum" as const,
	permissions_team_role_select_column_permissions_team_role_aggregate_bool_exp_bool_or_arguments_columns: "enum" as const,
	permissions_team_role_stream_cursor_input:{
		initial_value:"permissions_team_role_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	permissions_team_role_stream_cursor_value_input:{
		target_team_role_id:"uuid",
		team_id:"uuid"
	},
	permissions_team_select_column: "enum" as const,
	permissions_team_stream_cursor_input:{
		initial_value:"permissions_team_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	permissions_team_stream_cursor_value_input:{
		target_entity_id:"uuid"
	},
	permissions_user_role_assignment_aggregate_fields:{
		count:{
			columns:"permissions_user_role_assignment_select_column"
		}
	},
	permissions_user_role_assignment_bool_exp:{
		_and:"permissions_user_role_assignment_bool_exp",
		_not:"permissions_user_role_assignment_bool_exp",
		_or:"permissions_user_role_assignment_bool_exp",
		action:"String_comparison_exp",
		external_id:"String_comparison_exp",
		target_entity:"String_comparison_exp",
		target_entity_id:"uuid_comparison_exp",
		team_role_assignment_id:"uuid_comparison_exp"
	},
	permissions_user_role_assignment_order_by:{
		action:"order_by",
		external_id:"order_by",
		target_entity:"order_by",
		target_entity_id:"order_by",
		team_role_assignment_id:"order_by"
	},
	permissions_user_role_assignment_select_column: "enum" as const,
	permissions_user_role_assignment_stream_cursor_input:{
		initial_value:"permissions_user_role_assignment_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	permissions_user_role_assignment_stream_cursor_value_input:{
		target_entity_id:"uuid",
		team_role_assignment_id:"uuid"
	},
	qualification_aggregate_bool_exp:{
		count:"qualification_aggregate_bool_exp_count"
	},
	qualification_aggregate_bool_exp_count:{
		arguments:"qualification_select_column",
		filter:"qualification_bool_exp",
		predicate:"Int_comparison_exp"
	},
	qualification_aggregate_fields:{
		count:{
			columns:"qualification_select_column"
		}
	},
	qualification_aggregate_order_by:{
		count:"order_by",
		max:"qualification_max_order_by",
		min:"qualification_min_order_by"
	},
	qualification_arr_rel_insert_input:{
		data:"qualification_insert_input",
		on_conflict:"qualification_on_conflict"
	},
	qualification_bool_exp:{
		_and:"qualification_bool_exp",
		_not:"qualification_bool_exp",
		_or:"qualification_bool_exp",
		abbrev:"String_comparison_exp",
		group:"group_bool_exp",
		group_id:"uuid_comparison_exp",
		id:"uuid_comparison_exp",
		name:"String_comparison_exp",
		qualification_id:"String_comparison_exp"
	},
	qualification_constraint: "enum" as const,
	qualification_insert_input:{
		group:"group_obj_rel_insert_input",
		group_id:"uuid",
		id:"uuid"
	},
	qualification_max_order_by:{
		abbrev:"order_by",
		group_id:"order_by",
		id:"order_by",
		name:"order_by",
		qualification_id:"order_by"
	},
	qualification_min_order_by:{
		abbrev:"order_by",
		group_id:"order_by",
		id:"order_by",
		name:"order_by",
		qualification_id:"order_by"
	},
	qualification_obj_rel_insert_input:{
		data:"qualification_insert_input",
		on_conflict:"qualification_on_conflict"
	},
	qualification_on_conflict:{
		constraint:"qualification_constraint",
		update_columns:"qualification_update_column",
		where:"qualification_bool_exp"
	},
	qualification_order_by:{
		abbrev:"order_by",
		group:"group_order_by",
		group_id:"order_by",
		id:"order_by",
		name:"order_by",
		qualification_id:"order_by"
	},
	qualification_pk_columns_input:{
		id:"uuid"
	},
	qualification_select_column: "enum" as const,
	qualification_set_input:{
		group_id:"uuid",
		id:"uuid"
	},
	qualification_stream_cursor_input:{
		initial_value:"qualification_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	qualification_stream_cursor_value_input:{
		group_id:"uuid",
		id:"uuid"
	},
	qualification_update_column: "enum" as const,
	qualification_updates:{
		_set:"qualification_set_input",
		where:"qualification_bool_exp"
	},
	query_root:{
		active_shift:{
			distinct_on:"active_shift_select_column",
			order_by:"active_shift_order_by",
			where:"active_shift_bool_exp"
		},
		active_shift_aggregate:{
			distinct_on:"active_shift_select_column",
			order_by:"active_shift_order_by",
			where:"active_shift_bool_exp"
		},
		active_shift_by_pk:{
			id:"uuid"
		},
		cost_object:{
			distinct_on:"cost_object_select_column",
			order_by:"cost_object_order_by",
			where:"cost_object_bool_exp"
		},
		cost_object_aggregate:{
			distinct_on:"cost_object_select_column",
			order_by:"cost_object_order_by",
			where:"cost_object_bool_exp"
		},
		cost_object_by_pk:{
			id:"uuid"
		},
		event:{
			distinct_on:"event_select_column",
			order_by:"event_order_by",
			where:"event_bool_exp"
		},
		event_aggregate:{
			distinct_on:"event_select_column",
			order_by:"event_order_by",
			where:"event_bool_exp"
		},
		event_buffered_shift_ended:{
			distinct_on:"event_buffered_shift_ended_select_column",
			order_by:"event_buffered_shift_ended_order_by",
			where:"event_buffered_shift_ended_bool_exp"
		},
		event_buffered_shift_ended_aggregate:{
			distinct_on:"event_buffered_shift_ended_select_column",
			order_by:"event_buffered_shift_ended_order_by",
			where:"event_buffered_shift_ended_bool_exp"
		},
		event_buffered_shift_ended_by_pk:{

		},
		event_buffered_shift_started:{
			distinct_on:"event_buffered_shift_started_select_column",
			order_by:"event_buffered_shift_started_order_by",
			where:"event_buffered_shift_started_bool_exp"
		},
		event_buffered_shift_started_aggregate:{
			distinct_on:"event_buffered_shift_started_select_column",
			order_by:"event_buffered_shift_started_order_by",
			where:"event_buffered_shift_started_bool_exp"
		},
		event_buffered_shift_started_by_pk:{

		},
		event_by_pk:{

		},
		event_cost_object_created:{
			distinct_on:"event_cost_object_created_select_column",
			order_by:"event_cost_object_created_order_by",
			where:"event_cost_object_created_bool_exp"
		},
		event_cost_object_created_aggregate:{
			distinct_on:"event_cost_object_created_select_column",
			order_by:"event_cost_object_created_order_by",
			where:"event_cost_object_created_bool_exp"
		},
		event_cost_object_created_by_pk:{

		},
		event_cost_object_deleted:{
			distinct_on:"event_cost_object_deleted_select_column",
			order_by:"event_cost_object_deleted_order_by",
			where:"event_cost_object_deleted_bool_exp"
		},
		event_cost_object_deleted_aggregate:{
			distinct_on:"event_cost_object_deleted_select_column",
			order_by:"event_cost_object_deleted_order_by",
			where:"event_cost_object_deleted_bool_exp"
		},
		event_cost_object_deleted_by_pk:{

		},
		event_cost_object_reactivated:{
			distinct_on:"event_cost_object_reactivated_select_column",
			order_by:"event_cost_object_reactivated_order_by",
			where:"event_cost_object_reactivated_bool_exp"
		},
		event_cost_object_reactivated_aggregate:{
			distinct_on:"event_cost_object_reactivated_select_column",
			order_by:"event_cost_object_reactivated_order_by",
			where:"event_cost_object_reactivated_bool_exp"
		},
		event_cost_object_reactivated_by_pk:{

		},
		event_cost_object_updated:{
			distinct_on:"event_cost_object_updated_select_column",
			order_by:"event_cost_object_updated_order_by",
			where:"event_cost_object_updated_bool_exp"
		},
		event_cost_object_updated_aggregate:{
			distinct_on:"event_cost_object_updated_select_column",
			order_by:"event_cost_object_updated_order_by",
			where:"event_cost_object_updated_bool_exp"
		},
		event_cost_object_updated_by_pk:{

		},
		event_derived_shift_deleted:{
			distinct_on:"event_derived_shift_deleted_select_column",
			order_by:"event_derived_shift_deleted_order_by",
			where:"event_derived_shift_deleted_bool_exp"
		},
		event_derived_shift_deleted_aggregate:{
			distinct_on:"event_derived_shift_deleted_select_column",
			order_by:"event_derived_shift_deleted_order_by",
			where:"event_derived_shift_deleted_bool_exp"
		},
		event_derived_shift_deleted_by_pk:{

		},
		event_derived_shift_updated:{
			distinct_on:"event_derived_shift_updated_select_column",
			order_by:"event_derived_shift_updated_order_by",
			where:"event_derived_shift_updated_bool_exp"
		},
		event_derived_shift_updated_aggregate:{
			distinct_on:"event_derived_shift_updated_select_column",
			order_by:"event_derived_shift_updated_order_by",
			where:"event_derived_shift_updated_bool_exp"
		},
		event_derived_shift_updated_by_pk:{

		},
		event_note_created:{
			distinct_on:"event_note_created_select_column",
			order_by:"event_note_created_order_by",
			where:"event_note_created_bool_exp"
		},
		event_note_created_aggregate:{
			distinct_on:"event_note_created_select_column",
			order_by:"event_note_created_order_by",
			where:"event_note_created_bool_exp"
		},
		event_note_created_by_pk:{

		},
		event_note_deleted:{
			distinct_on:"event_note_deleted_select_column",
			order_by:"event_note_deleted_order_by",
			where:"event_note_deleted_bool_exp"
		},
		event_note_deleted_aggregate:{
			distinct_on:"event_note_deleted_select_column",
			order_by:"event_note_deleted_order_by",
			where:"event_note_deleted_bool_exp"
		},
		event_note_deleted_by_pk:{

		},
		event_note_updated:{
			distinct_on:"event_note_updated_select_column",
			order_by:"event_note_updated_order_by",
			where:"event_note_updated_bool_exp"
		},
		event_note_updated_aggregate:{
			distinct_on:"event_note_updated_select_column",
			order_by:"event_note_updated_order_by",
			where:"event_note_updated_bool_exp"
		},
		event_note_updated_by_pk:{

		},
		event_recurring_shift_exception_created:{
			distinct_on:"event_recurring_shift_exception_created_select_column",
			order_by:"event_recurring_shift_exception_created_order_by",
			where:"event_recurring_shift_exception_created_bool_exp"
		},
		event_recurring_shift_exception_created_aggregate:{
			distinct_on:"event_recurring_shift_exception_created_select_column",
			order_by:"event_recurring_shift_exception_created_order_by",
			where:"event_recurring_shift_exception_created_bool_exp"
		},
		event_recurring_shift_exception_created_by_pk:{

		},
		event_shift_created:{
			distinct_on:"event_shift_created_select_column",
			order_by:"event_shift_created_order_by",
			where:"event_shift_created_bool_exp"
		},
		event_shift_created_aggregate:{
			distinct_on:"event_shift_created_select_column",
			order_by:"event_shift_created_order_by",
			where:"event_shift_created_bool_exp"
		},
		event_shift_created_by_pk:{

		},
		event_shift_deleted:{
			distinct_on:"event_shift_deleted_select_column",
			order_by:"event_shift_deleted_order_by",
			where:"event_shift_deleted_bool_exp"
		},
		event_shift_deleted_aggregate:{
			distinct_on:"event_shift_deleted_select_column",
			order_by:"event_shift_deleted_order_by",
			where:"event_shift_deleted_bool_exp"
		},
		event_shift_deleted_by_pk:{

		},
		event_shift_ended:{
			distinct_on:"event_shift_ended_select_column",
			order_by:"event_shift_ended_order_by",
			where:"event_shift_ended_bool_exp"
		},
		event_shift_ended_aggregate:{
			distinct_on:"event_shift_ended_select_column",
			order_by:"event_shift_ended_order_by",
			where:"event_shift_ended_bool_exp"
		},
		event_shift_ended_by_pk:{

		},
		event_shift_started:{
			distinct_on:"event_shift_started_select_column",
			order_by:"event_shift_started_order_by",
			where:"event_shift_started_bool_exp"
		},
		event_shift_started_aggregate:{
			distinct_on:"event_shift_started_select_column",
			order_by:"event_shift_started_order_by",
			where:"event_shift_started_bool_exp"
		},
		event_shift_started_by_pk:{

		},
		event_shift_updated:{
			distinct_on:"event_shift_updated_select_column",
			order_by:"event_shift_updated_order_by",
			where:"event_shift_updated_bool_exp"
		},
		event_shift_updated_aggregate:{
			distinct_on:"event_shift_updated_select_column",
			order_by:"event_shift_updated_order_by",
			where:"event_shift_updated_bool_exp"
		},
		event_shift_updated_by_pk:{

		},
		event_team_created:{
			distinct_on:"event_team_created_select_column",
			order_by:"event_team_created_order_by",
			where:"event_team_created_bool_exp"
		},
		event_team_created_aggregate:{
			distinct_on:"event_team_created_select_column",
			order_by:"event_team_created_order_by",
			where:"event_team_created_bool_exp"
		},
		event_team_created_by_pk:{

		},
		event_team_deleted:{
			distinct_on:"event_team_deleted_select_column",
			order_by:"event_team_deleted_order_by",
			where:"event_team_deleted_bool_exp"
		},
		event_team_deleted_aggregate:{
			distinct_on:"event_team_deleted_select_column",
			order_by:"event_team_deleted_order_by",
			where:"event_team_deleted_bool_exp"
		},
		event_team_deleted_by_pk:{

		},
		event_team_reactivated:{
			distinct_on:"event_team_reactivated_select_column",
			order_by:"event_team_reactivated_order_by",
			where:"event_team_reactivated_bool_exp"
		},
		event_team_reactivated_aggregate:{
			distinct_on:"event_team_reactivated_select_column",
			order_by:"event_team_reactivated_order_by",
			where:"event_team_reactivated_bool_exp"
		},
		event_team_reactivated_by_pk:{

		},
		event_team_role_assignment_created:{
			distinct_on:"event_team_role_assignment_created_select_column",
			order_by:"event_team_role_assignment_created_order_by",
			where:"event_team_role_assignment_created_bool_exp"
		},
		event_team_role_assignment_created_aggregate:{
			distinct_on:"event_team_role_assignment_created_select_column",
			order_by:"event_team_role_assignment_created_order_by",
			where:"event_team_role_assignment_created_bool_exp"
		},
		event_team_role_assignment_created_by_pk:{

		},
		event_team_role_assignment_deleted:{
			distinct_on:"event_team_role_assignment_deleted_select_column",
			order_by:"event_team_role_assignment_deleted_order_by",
			where:"event_team_role_assignment_deleted_bool_exp"
		},
		event_team_role_assignment_deleted_aggregate:{
			distinct_on:"event_team_role_assignment_deleted_select_column",
			order_by:"event_team_role_assignment_deleted_order_by",
			where:"event_team_role_assignment_deleted_bool_exp"
		},
		event_team_role_assignment_deleted_by_pk:{

		},
		event_team_role_created:{
			distinct_on:"event_team_role_created_select_column",
			order_by:"event_team_role_created_order_by",
			where:"event_team_role_created_bool_exp"
		},
		event_team_role_created_aggregate:{
			distinct_on:"event_team_role_created_select_column",
			order_by:"event_team_role_created_order_by",
			where:"event_team_role_created_bool_exp"
		},
		event_team_role_created_by_pk:{

		},
		event_team_role_deleted:{
			distinct_on:"event_team_role_deleted_select_column",
			order_by:"event_team_role_deleted_order_by",
			where:"event_team_role_deleted_bool_exp"
		},
		event_team_role_deleted_aggregate:{
			distinct_on:"event_team_role_deleted_select_column",
			order_by:"event_team_role_deleted_order_by",
			where:"event_team_role_deleted_bool_exp"
		},
		event_team_role_deleted_by_pk:{

		},
		event_team_role_updated:{
			distinct_on:"event_team_role_updated_select_column",
			order_by:"event_team_role_updated_order_by",
			where:"event_team_role_updated_bool_exp"
		},
		event_team_role_updated_aggregate:{
			distinct_on:"event_team_role_updated_select_column",
			order_by:"event_team_role_updated_order_by",
			where:"event_team_role_updated_bool_exp"
		},
		event_team_role_updated_by_pk:{

		},
		event_team_updated:{
			distinct_on:"event_team_updated_select_column",
			order_by:"event_team_updated_order_by",
			where:"event_team_updated_bool_exp"
		},
		event_team_updated_aggregate:{
			distinct_on:"event_team_updated_select_column",
			order_by:"event_team_updated_order_by",
			where:"event_team_updated_bool_exp"
		},
		event_team_updated_by_pk:{

		},
		event_user_created:{
			distinct_on:"event_user_created_select_column",
			order_by:"event_user_created_order_by",
			where:"event_user_created_bool_exp"
		},
		event_user_created_aggregate:{
			distinct_on:"event_user_created_select_column",
			order_by:"event_user_created_order_by",
			where:"event_user_created_bool_exp"
		},
		event_user_created_by_pk:{

		},
		event_user_deleted:{
			distinct_on:"event_user_deleted_select_column",
			order_by:"event_user_deleted_order_by",
			where:"event_user_deleted_bool_exp"
		},
		event_user_deleted_aggregate:{
			distinct_on:"event_user_deleted_select_column",
			order_by:"event_user_deleted_order_by",
			where:"event_user_deleted_bool_exp"
		},
		event_user_deleted_by_pk:{

		},
		event_user_role_assignment_created:{
			distinct_on:"event_user_role_assignment_created_select_column",
			order_by:"event_user_role_assignment_created_order_by",
			where:"event_user_role_assignment_created_bool_exp"
		},
		event_user_role_assignment_created_aggregate:{
			distinct_on:"event_user_role_assignment_created_select_column",
			order_by:"event_user_role_assignment_created_order_by",
			where:"event_user_role_assignment_created_bool_exp"
		},
		event_user_role_assignment_created_by_pk:{

		},
		event_user_role_assignment_deleted:{
			distinct_on:"event_user_role_assignment_deleted_select_column",
			order_by:"event_user_role_assignment_deleted_order_by",
			where:"event_user_role_assignment_deleted_bool_exp"
		},
		event_user_role_assignment_deleted_aggregate:{
			distinct_on:"event_user_role_assignment_deleted_select_column",
			order_by:"event_user_role_assignment_deleted_order_by",
			where:"event_user_role_assignment_deleted_bool_exp"
		},
		event_user_role_assignment_deleted_by_pk:{

		},
		event_user_role_assignment_updated:{
			distinct_on:"event_user_role_assignment_updated_select_column",
			order_by:"event_user_role_assignment_updated_order_by",
			where:"event_user_role_assignment_updated_bool_exp"
		},
		event_user_role_assignment_updated_aggregate:{
			distinct_on:"event_user_role_assignment_updated_select_column",
			order_by:"event_user_role_assignment_updated_order_by",
			where:"event_user_role_assignment_updated_bool_exp"
		},
		event_user_role_assignment_updated_by_pk:{

		},
		event_user_updated:{
			distinct_on:"event_user_updated_select_column",
			order_by:"event_user_updated_order_by",
			where:"event_user_updated_bool_exp"
		},
		event_user_updated_aggregate:{
			distinct_on:"event_user_updated_select_column",
			order_by:"event_user_updated_order_by",
			where:"event_user_updated_bool_exp"
		},
		event_user_updated_by_pk:{

		},
		group:{
			distinct_on:"group_select_column",
			order_by:"group_order_by",
			where:"group_bool_exp"
		},
		group_aggregate:{
			distinct_on:"group_select_column",
			order_by:"group_order_by",
			where:"group_bool_exp"
		},
		group_by_pk:{
			id:"uuid"
		},
		group_membership:{
			distinct_on:"group_membership_select_column",
			order_by:"group_membership_order_by",
			where:"group_membership_bool_exp"
		},
		group_membership_aggregate:{
			distinct_on:"group_membership_select_column",
			order_by:"group_membership_order_by",
			where:"group_membership_bool_exp"
		},
		group_membership_by_pk:{
			id:"uuid"
		},
		note:{
			distinct_on:"note_select_column",
			order_by:"note_order_by",
			where:"note_bool_exp"
		},
		note_aggregate:{
			distinct_on:"note_select_column",
			order_by:"note_order_by",
			where:"note_bool_exp"
		},
		note_by_pk:{
			id:"uuid"
		},
		permissions_shift:{
			distinct_on:"permissions_shift_select_column",
			order_by:"permissions_shift_order_by",
			where:"permissions_shift_bool_exp"
		},
		permissions_shift_aggregate:{
			distinct_on:"permissions_shift_select_column",
			order_by:"permissions_shift_order_by",
			where:"permissions_shift_bool_exp"
		},
		permissions_shift_config:{
			distinct_on:"permissions_shift_config_select_column",
			order_by:"permissions_shift_config_order_by",
			where:"permissions_shift_config_bool_exp"
		},
		permissions_shift_config_aggregate:{
			distinct_on:"permissions_shift_config_select_column",
			order_by:"permissions_shift_config_order_by",
			where:"permissions_shift_config_bool_exp"
		},
		permissions_shift_config_by_pk:{
			id:"uuid"
		},
		permissions_team:{
			distinct_on:"permissions_team_select_column",
			order_by:"permissions_team_order_by",
			where:"permissions_team_bool_exp"
		},
		permissions_team_aggregate:{
			distinct_on:"permissions_team_select_column",
			order_by:"permissions_team_order_by",
			where:"permissions_team_bool_exp"
		},
		permissions_team_config:{
			distinct_on:"permissions_team_config_select_column",
			order_by:"permissions_team_config_order_by",
			where:"permissions_team_config_bool_exp"
		},
		permissions_team_config_aggregate:{
			distinct_on:"permissions_team_config_select_column",
			order_by:"permissions_team_config_order_by",
			where:"permissions_team_config_bool_exp"
		},
		permissions_team_config_by_pk:{
			id:"uuid"
		},
		permissions_team_role:{
			distinct_on:"permissions_team_role_select_column",
			order_by:"permissions_team_role_order_by",
			where:"permissions_team_role_bool_exp"
		},
		permissions_team_role_aggregate:{
			distinct_on:"permissions_team_role_select_column",
			order_by:"permissions_team_role_order_by",
			where:"permissions_team_role_bool_exp"
		},
		permissions_team_role_assignment:{
			distinct_on:"permissions_team_role_assignment_select_column",
			order_by:"permissions_team_role_assignment_order_by",
			where:"permissions_team_role_assignment_bool_exp"
		},
		permissions_team_role_assignment_aggregate:{
			distinct_on:"permissions_team_role_assignment_select_column",
			order_by:"permissions_team_role_assignment_order_by",
			where:"permissions_team_role_assignment_bool_exp"
		},
		permissions_team_role_config:{
			distinct_on:"permissions_team_role_config_select_column",
			order_by:"permissions_team_role_config_order_by",
			where:"permissions_team_role_config_bool_exp"
		},
		permissions_team_role_config_aggregate:{
			distinct_on:"permissions_team_role_config_select_column",
			order_by:"permissions_team_role_config_order_by",
			where:"permissions_team_role_config_bool_exp"
		},
		permissions_team_role_config_by_pk:{
			id:"uuid"
		},
		permissions_user_role_assignment:{
			distinct_on:"permissions_user_role_assignment_select_column",
			order_by:"permissions_user_role_assignment_order_by",
			where:"permissions_user_role_assignment_bool_exp"
		},
		permissions_user_role_assignment_aggregate:{
			distinct_on:"permissions_user_role_assignment_select_column",
			order_by:"permissions_user_role_assignment_order_by",
			where:"permissions_user_role_assignment_bool_exp"
		},
		qualification:{
			distinct_on:"qualification_select_column",
			order_by:"qualification_order_by",
			where:"qualification_bool_exp"
		},
		qualification_aggregate:{
			distinct_on:"qualification_select_column",
			order_by:"qualification_order_by",
			where:"qualification_bool_exp"
		},
		qualification_by_pk:{
			id:"uuid"
		},
		queryShiftClashReport:{
			fromDate:"timestamptz",
			toDate:"timestamptz"
		},
		queryShiftEvent:{
			fromDate:"timestamptz",
			toDate:"timestamptz"
		},
		queryTeamRoster:{
			fromDate:"timestamptz",
			toDate:"timestamptz"
		},
		queryTeamRosterAudit:{
			fromDate:"timestamptz",
			toDate:"timestamptz"
		},
		queryUserFatigueReport:{
			fromDate:"timestamptz",
			toDate:"timestamptz"
		},
		recurring_shift_exception:{
			distinct_on:"recurring_shift_exception_select_column",
			order_by:"recurring_shift_exception_order_by",
			where:"recurring_shift_exception_bool_exp"
		},
		recurring_shift_exception_aggregate:{
			distinct_on:"recurring_shift_exception_select_column",
			order_by:"recurring_shift_exception_order_by",
			where:"recurring_shift_exception_bool_exp"
		},
		recurring_shift_exception_by_pk:{
			id:"uuid"
		},
		search_user:{
			args:"search_user_args",
			distinct_on:"user_select_column",
			order_by:"user_order_by",
			where:"user_bool_exp"
		},
		search_user_aggregate:{
			args:"search_user_args",
			distinct_on:"user_select_column",
			order_by:"user_order_by",
			where:"user_bool_exp"
		},
		sendUserFeedback:{
			attachments:"Attachment"
		},
		shift:{
			distinct_on:"shift_select_column",
			order_by:"shift_order_by",
			where:"shift_bool_exp"
		},
		shift_aggregate:{
			distinct_on:"shift_select_column",
			order_by:"shift_order_by",
			where:"shift_bool_exp"
		},
		shift_by_pk:{
			id:"uuid"
		},
		shift_related_note:{
			distinct_on:"shift_related_note_select_column",
			order_by:"shift_related_note_order_by",
			where:"shift_related_note_bool_exp"
		},
		shift_related_note_aggregate:{
			distinct_on:"shift_related_note_select_column",
			order_by:"shift_related_note_order_by",
			where:"shift_related_note_bool_exp"
		},
		team:{
			distinct_on:"team_select_column",
			order_by:"team_order_by",
			where:"team_bool_exp"
		},
		team_aggregate:{
			distinct_on:"team_select_column",
			order_by:"team_order_by",
			where:"team_bool_exp"
		},
		team_by_pk:{
			id:"uuid"
		},
		team_role:{
			distinct_on:"team_role_select_column",
			order_by:"team_role_order_by",
			where:"team_role_bool_exp"
		},
		team_role_aggregate:{
			distinct_on:"team_role_select_column",
			order_by:"team_role_order_by",
			where:"team_role_bool_exp"
		},
		team_role_assignment:{
			distinct_on:"team_role_assignment_select_column",
			order_by:"team_role_assignment_order_by",
			where:"team_role_assignment_bool_exp"
		},
		team_role_assignment_aggregate:{
			distinct_on:"team_role_assignment_select_column",
			order_by:"team_role_assignment_order_by",
			where:"team_role_assignment_bool_exp"
		},
		team_role_assignment_by_pk:{
			id:"uuid"
		},
		team_role_by_pk:{
			id:"uuid"
		},
		user:{
			distinct_on:"user_select_column",
			order_by:"user_order_by",
			where:"user_bool_exp"
		},
		user_aggregate:{
			distinct_on:"user_select_column",
			order_by:"user_order_by",
			where:"user_bool_exp"
		},
		user_by_pk:{
			id:"uuid"
		},
		user_notification:{
			distinct_on:"user_notification_select_column",
			order_by:"user_notification_order_by",
			where:"user_notification_bool_exp"
		},
		user_notification_aggregate:{
			distinct_on:"user_notification_select_column",
			order_by:"user_notification_order_by",
			where:"user_notification_bool_exp"
		},
		user_notification_by_pk:{
			id:"uuid"
		},
		user_role_assignment:{
			distinct_on:"user_role_assignment_select_column",
			order_by:"user_role_assignment_order_by",
			where:"user_role_assignment_bool_exp"
		},
		user_role_assignment_aggregate:{
			distinct_on:"user_role_assignment_select_column",
			order_by:"user_role_assignment_order_by",
			where:"user_role_assignment_bool_exp"
		},
		user_role_assignment_by_pk:{
			id:"uuid"
		},
		user_shift_notification:{
			distinct_on:"user_shift_notification_select_column",
			order_by:"user_shift_notification_order_by",
			where:"user_shift_notification_bool_exp"
		},
		user_shift_notification_aggregate:{
			distinct_on:"user_shift_notification_select_column",
			order_by:"user_shift_notification_order_by",
			where:"user_shift_notification_bool_exp"
		},
		user_shift_notification_by_pk:{
			id:"uuid"
		},
		user_shift_notification_event:{
			distinct_on:"user_shift_notification_event_select_column",
			order_by:"user_shift_notification_event_order_by",
			where:"user_shift_notification_event_bool_exp"
		},
		user_shift_notification_event_aggregate:{
			distinct_on:"user_shift_notification_event_select_column",
			order_by:"user_shift_notification_event_order_by",
			where:"user_shift_notification_event_bool_exp"
		},
		user_shift_notification_event_by_pk:{
			id:"uuid"
		}
	},
	record_status_t: `scalar.record_status_t` as const,
	record_status_t_comparison_exp:{
		_eq:"record_status_t",
		_gt:"record_status_t",
		_gte:"record_status_t",
		_in:"record_status_t",
		_lt:"record_status_t",
		_lte:"record_status_t",
		_neq:"record_status_t",
		_nin:"record_status_t"
	},
	recurring_shift_exception_aggregate_bool_exp:{
		count:"recurring_shift_exception_aggregate_bool_exp_count"
	},
	recurring_shift_exception_aggregate_bool_exp_count:{
		arguments:"recurring_shift_exception_select_column",
		filter:"recurring_shift_exception_bool_exp",
		predicate:"Int_comparison_exp"
	},
	recurring_shift_exception_aggregate_fields:{
		count:{
			columns:"recurring_shift_exception_select_column"
		}
	},
	recurring_shift_exception_aggregate_order_by:{
		count:"order_by",
		max:"recurring_shift_exception_max_order_by",
		min:"recurring_shift_exception_min_order_by"
	},
	recurring_shift_exception_arr_rel_insert_input:{
		data:"recurring_shift_exception_insert_input",
		on_conflict:"recurring_shift_exception_on_conflict"
	},
	recurring_shift_exception_bool_exp:{
		_and:"recurring_shift_exception_bool_exp",
		_not:"recurring_shift_exception_bool_exp",
		_or:"recurring_shift_exception_bool_exp",
		exception_date:"timestamptz_comparison_exp",
		id:"uuid_comparison_exp",
		shift:"shift_bool_exp",
		shift_id:"uuid_comparison_exp"
	},
	recurring_shift_exception_constraint: "enum" as const,
	recurring_shift_exception_insert_input:{
		exception_date:"timestamptz",
		id:"uuid",
		shift:"shift_obj_rel_insert_input",
		shift_id:"uuid"
	},
	recurring_shift_exception_max_order_by:{
		exception_date:"order_by",
		id:"order_by",
		shift_id:"order_by"
	},
	recurring_shift_exception_min_order_by:{
		exception_date:"order_by",
		id:"order_by",
		shift_id:"order_by"
	},
	recurring_shift_exception_on_conflict:{
		constraint:"recurring_shift_exception_constraint",
		update_columns:"recurring_shift_exception_update_column",
		where:"recurring_shift_exception_bool_exp"
	},
	recurring_shift_exception_order_by:{
		exception_date:"order_by",
		id:"order_by",
		shift:"shift_order_by",
		shift_id:"order_by"
	},
	recurring_shift_exception_pk_columns_input:{
		id:"uuid"
	},
	recurring_shift_exception_select_column: "enum" as const,
	recurring_shift_exception_set_input:{
		exception_date:"timestamptz",
		id:"uuid",
		shift_id:"uuid"
	},
	recurring_shift_exception_stream_cursor_input:{
		initial_value:"recurring_shift_exception_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	recurring_shift_exception_stream_cursor_value_input:{
		exception_date:"timestamptz",
		id:"uuid",
		shift_id:"uuid"
	},
	recurring_shift_exception_update_column: "enum" as const,
	recurring_shift_exception_updates:{
		_set:"recurring_shift_exception_set_input",
		where:"recurring_shift_exception_bool_exp"
	},
	role_group_t: `scalar.role_group_t` as const,
	role_group_t_comparison_exp:{
		_eq:"role_group_t",
		_gt:"role_group_t",
		_gte:"role_group_t",
		_in:"role_group_t",
		_lt:"role_group_t",
		_lte:"role_group_t",
		_neq:"role_group_t",
		_nin:"role_group_t"
	},
	search_user_args:{

	},
	shift:{
		active_shifts:{
			distinct_on:"active_shift_select_column",
			order_by:"active_shift_order_by",
			where:"active_shift_bool_exp"
		},
		active_shifts_aggregate:{
			distinct_on:"active_shift_select_column",
			order_by:"active_shift_order_by",
			where:"active_shift_bool_exp"
		},
		event_buffered_shift_ended:{
			distinct_on:"event_buffered_shift_ended_select_column",
			order_by:"event_buffered_shift_ended_order_by",
			where:"event_buffered_shift_ended_bool_exp"
		},
		event_buffered_shift_ended_aggregate:{
			distinct_on:"event_buffered_shift_ended_select_column",
			order_by:"event_buffered_shift_ended_order_by",
			where:"event_buffered_shift_ended_bool_exp"
		},
		event_buffered_shift_started:{
			distinct_on:"event_buffered_shift_started_select_column",
			order_by:"event_buffered_shift_started_order_by",
			where:"event_buffered_shift_started_bool_exp"
		},
		event_buffered_shift_started_aggregate:{
			distinct_on:"event_buffered_shift_started_select_column",
			order_by:"event_buffered_shift_started_order_by",
			where:"event_buffered_shift_started_bool_exp"
		},
		event_derived_shift_deleted:{
			distinct_on:"event_derived_shift_deleted_select_column",
			order_by:"event_derived_shift_deleted_order_by",
			where:"event_derived_shift_deleted_bool_exp"
		},
		event_derived_shift_deleted_aggregate:{
			distinct_on:"event_derived_shift_deleted_select_column",
			order_by:"event_derived_shift_deleted_order_by",
			where:"event_derived_shift_deleted_bool_exp"
		},
		event_derived_shift_updated_recurring_shift:{
			distinct_on:"event_derived_shift_updated_select_column",
			order_by:"event_derived_shift_updated_order_by",
			where:"event_derived_shift_updated_bool_exp"
		},
		event_derived_shift_updated_recurring_shift_aggregate:{
			distinct_on:"event_derived_shift_updated_select_column",
			order_by:"event_derived_shift_updated_order_by",
			where:"event_derived_shift_updated_bool_exp"
		},
		event_recurring_shift_exception_created:{
			distinct_on:"event_recurring_shift_exception_created_select_column",
			order_by:"event_recurring_shift_exception_created_order_by",
			where:"event_recurring_shift_exception_created_bool_exp"
		},
		event_recurring_shift_exception_created_aggregate:{
			distinct_on:"event_recurring_shift_exception_created_select_column",
			order_by:"event_recurring_shift_exception_created_order_by",
			where:"event_recurring_shift_exception_created_bool_exp"
		},
		event_shift_deleted:{
			distinct_on:"event_shift_deleted_select_column",
			order_by:"event_shift_deleted_order_by",
			where:"event_shift_deleted_bool_exp"
		},
		event_shift_deleted_aggregate:{
			distinct_on:"event_shift_deleted_select_column",
			order_by:"event_shift_deleted_order_by",
			where:"event_shift_deleted_bool_exp"
		},
		event_shift_ended:{
			distinct_on:"event_shift_ended_select_column",
			order_by:"event_shift_ended_order_by",
			where:"event_shift_ended_bool_exp"
		},
		event_shift_ended_aggregate:{
			distinct_on:"event_shift_ended_select_column",
			order_by:"event_shift_ended_order_by",
			where:"event_shift_ended_bool_exp"
		},
		event_shift_started:{
			distinct_on:"event_shift_started_select_column",
			order_by:"event_shift_started_order_by",
			where:"event_shift_started_bool_exp"
		},
		event_shift_started_aggregate:{
			distinct_on:"event_shift_started_select_column",
			order_by:"event_shift_started_order_by",
			where:"event_shift_started_bool_exp"
		},
		event_shift_updated:{
			distinct_on:"event_shift_updated_select_column",
			order_by:"event_shift_updated_order_by",
			where:"event_shift_updated_bool_exp"
		},
		event_shift_updated_aggregate:{
			distinct_on:"event_shift_updated_select_column",
			order_by:"event_shift_updated_order_by",
			where:"event_shift_updated_bool_exp"
		},
		note:{
			distinct_on:"note_select_column",
			order_by:"note_order_by",
			where:"note_bool_exp"
		},
		note_aggregate:{
			distinct_on:"note_select_column",
			order_by:"note_order_by",
			where:"note_bool_exp"
		},
		recurring_shift_exceptions:{
			distinct_on:"recurring_shift_exception_select_column",
			order_by:"recurring_shift_exception_order_by",
			where:"recurring_shift_exception_bool_exp"
		},
		recurring_shift_exceptions_aggregate:{
			distinct_on:"recurring_shift_exception_select_column",
			order_by:"recurring_shift_exception_order_by",
			where:"recurring_shift_exception_bool_exp"
		},
		related_notes:{
			distinct_on:"shift_related_note_select_column",
			order_by:"shift_related_note_order_by",
			where:"shift_related_note_bool_exp"
		},
		related_notes_aggregate:{
			distinct_on:"shift_related_note_select_column",
			order_by:"shift_related_note_order_by",
			where:"shift_related_note_bool_exp"
		}
	},
	shift_aggregate_bool_exp:{
		bool_and:"shift_aggregate_bool_exp_bool_and",
		bool_or:"shift_aggregate_bool_exp_bool_or",
		count:"shift_aggregate_bool_exp_count"
	},
	shift_aggregate_bool_exp_bool_and:{
		arguments:"shift_select_column_shift_aggregate_bool_exp_bool_and_arguments_columns",
		filter:"shift_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	shift_aggregate_bool_exp_bool_or:{
		arguments:"shift_select_column_shift_aggregate_bool_exp_bool_or_arguments_columns",
		filter:"shift_bool_exp",
		predicate:"Boolean_comparison_exp"
	},
	shift_aggregate_bool_exp_count:{
		arguments:"shift_select_column",
		filter:"shift_bool_exp",
		predicate:"Int_comparison_exp"
	},
	shift_aggregate_fields:{
		count:{
			columns:"shift_select_column"
		}
	},
	shift_aggregate_order_by:{
		count:"order_by",
		max:"shift_max_order_by",
		min:"shift_min_order_by"
	},
	shift_arr_rel_insert_input:{
		data:"shift_insert_input",
		on_conflict:"shift_on_conflict"
	},
	shift_bool_exp:{
		_and:"shift_bool_exp",
		_not:"shift_bool_exp",
		_or:"shift_bool_exp",
		active_shift:"active_shift_bool_exp",
		active_shifts:"active_shift_bool_exp",
		active_shifts_aggregate:"active_shift_aggregate_bool_exp",
		created_at:"timestamptz_comparison_exp",
		end_time:"timestamptz_comparison_exp",
		event_buffered_shift_ended:"event_buffered_shift_ended_bool_exp",
		event_buffered_shift_ended_aggregate:"event_buffered_shift_ended_aggregate_bool_exp",
		event_buffered_shift_started:"event_buffered_shift_started_bool_exp",
		event_buffered_shift_started_aggregate:"event_buffered_shift_started_aggregate_bool_exp",
		event_derived_shift_deleted:"event_derived_shift_deleted_bool_exp",
		event_derived_shift_deleted_aggregate:"event_derived_shift_deleted_aggregate_bool_exp",
		event_derived_shift_updated:"event_derived_shift_updated_bool_exp",
		event_derived_shift_updated_recurring_shift:"event_derived_shift_updated_bool_exp",
		event_derived_shift_updated_recurring_shift_aggregate:"event_derived_shift_updated_aggregate_bool_exp",
		event_recurring_shift_exception_created:"event_recurring_shift_exception_created_bool_exp",
		event_recurring_shift_exception_created_aggregate:"event_recurring_shift_exception_created_aggregate_bool_exp",
		event_shift_created:"event_shift_created_bool_exp",
		event_shift_deleted:"event_shift_deleted_bool_exp",
		event_shift_deleted_aggregate:"event_shift_deleted_aggregate_bool_exp",
		event_shift_ended:"event_shift_ended_bool_exp",
		event_shift_ended_aggregate:"event_shift_ended_aggregate_bool_exp",
		event_shift_started:"event_shift_started_bool_exp",
		event_shift_started_aggregate:"event_shift_started_aggregate_bool_exp",
		event_shift_updated:"event_shift_updated_bool_exp",
		event_shift_updated_aggregate:"event_shift_updated_aggregate_bool_exp",
		id:"uuid_comparison_exp",
		is_recurring:"Boolean_comparison_exp",
		note:"note_bool_exp",
		note_aggregate:"note_aggregate_bool_exp",
		record_status:"record_status_t_comparison_exp",
		recurrence_end_date:"timestamptz_comparison_exp",
		recurrence_pattern:"String_comparison_exp",
		recurring_shift_exceptions:"recurring_shift_exception_bool_exp",
		recurring_shift_exceptions_aggregate:"recurring_shift_exception_aggregate_bool_exp",
		related_notes:"shift_related_note_bool_exp",
		related_notes_aggregate:"shift_related_note_aggregate_bool_exp",
		root_id:"uuid_comparison_exp",
		root_shift:"shift_bool_exp",
		shift_status:"String_comparison_exp",
		start_time:"timestamptz_comparison_exp",
		team_role_assignment:"team_role_assignment_bool_exp",
		team_role_assignment_id:"uuid_comparison_exp",
		updated_at:"timestamptz_comparison_exp",
		user_role_assignment:"user_role_assignment_bool_exp",
		user_role_assignment_id:"uuid_comparison_exp"
	},
	shift_constraint: "enum" as const,
	shift_insert_input:{
		active_shift:"active_shift_obj_rel_insert_input",
		active_shifts:"active_shift_arr_rel_insert_input",
		created_at:"timestamptz",
		end_time:"timestamptz",
		event_buffered_shift_ended:"event_buffered_shift_ended_arr_rel_insert_input",
		event_buffered_shift_started:"event_buffered_shift_started_arr_rel_insert_input",
		event_derived_shift_deleted:"event_derived_shift_deleted_arr_rel_insert_input",
		event_derived_shift_updated:"event_derived_shift_updated_obj_rel_insert_input",
		event_derived_shift_updated_recurring_shift:"event_derived_shift_updated_arr_rel_insert_input",
		event_recurring_shift_exception_created:"event_recurring_shift_exception_created_arr_rel_insert_input",
		event_shift_created:"event_shift_created_obj_rel_insert_input",
		event_shift_deleted:"event_shift_deleted_arr_rel_insert_input",
		event_shift_ended:"event_shift_ended_arr_rel_insert_input",
		event_shift_started:"event_shift_started_arr_rel_insert_input",
		event_shift_updated:"event_shift_updated_arr_rel_insert_input",
		id:"uuid",
		note:"note_arr_rel_insert_input",
		record_status:"record_status_t",
		recurrence_end_date:"timestamptz",
		recurring_shift_exceptions:"recurring_shift_exception_arr_rel_insert_input",
		related_notes:"shift_related_note_arr_rel_insert_input",
		root_id:"uuid",
		root_shift:"shift_obj_rel_insert_input",
		start_time:"timestamptz",
		team_role_assignment:"team_role_assignment_obj_rel_insert_input",
		team_role_assignment_id:"uuid",
		updated_at:"timestamptz",
		user_role_assignment:"user_role_assignment_obj_rel_insert_input",
		user_role_assignment_id:"uuid"
	},
	shift_max_order_by:{
		created_at:"order_by",
		end_time:"order_by",
		id:"order_by",
		record_status:"order_by",
		recurrence_end_date:"order_by",
		recurrence_pattern:"order_by",
		root_id:"order_by",
		shift_status:"order_by",
		start_time:"order_by",
		team_role_assignment_id:"order_by",
		updated_at:"order_by",
		user_role_assignment_id:"order_by"
	},
	shift_min_order_by:{
		created_at:"order_by",
		end_time:"order_by",
		id:"order_by",
		record_status:"order_by",
		recurrence_end_date:"order_by",
		recurrence_pattern:"order_by",
		root_id:"order_by",
		shift_status:"order_by",
		start_time:"order_by",
		team_role_assignment_id:"order_by",
		updated_at:"order_by",
		user_role_assignment_id:"order_by"
	},
	shift_obj_rel_insert_input:{
		data:"shift_insert_input",
		on_conflict:"shift_on_conflict"
	},
	shift_on_conflict:{
		constraint:"shift_constraint",
		update_columns:"shift_update_column",
		where:"shift_bool_exp"
	},
	shift_order_by:{
		active_shift:"active_shift_order_by",
		active_shifts_aggregate:"active_shift_aggregate_order_by",
		created_at:"order_by",
		end_time:"order_by",
		event_buffered_shift_ended_aggregate:"event_buffered_shift_ended_aggregate_order_by",
		event_buffered_shift_started_aggregate:"event_buffered_shift_started_aggregate_order_by",
		event_derived_shift_deleted_aggregate:"event_derived_shift_deleted_aggregate_order_by",
		event_derived_shift_updated:"event_derived_shift_updated_order_by",
		event_derived_shift_updated_recurring_shift_aggregate:"event_derived_shift_updated_aggregate_order_by",
		event_recurring_shift_exception_created_aggregate:"event_recurring_shift_exception_created_aggregate_order_by",
		event_shift_created:"event_shift_created_order_by",
		event_shift_deleted_aggregate:"event_shift_deleted_aggregate_order_by",
		event_shift_ended_aggregate:"event_shift_ended_aggregate_order_by",
		event_shift_started_aggregate:"event_shift_started_aggregate_order_by",
		event_shift_updated_aggregate:"event_shift_updated_aggregate_order_by",
		id:"order_by",
		is_recurring:"order_by",
		note_aggregate:"note_aggregate_order_by",
		record_status:"order_by",
		recurrence_end_date:"order_by",
		recurrence_pattern:"order_by",
		recurring_shift_exceptions_aggregate:"recurring_shift_exception_aggregate_order_by",
		related_notes_aggregate:"shift_related_note_aggregate_order_by",
		root_id:"order_by",
		root_shift:"shift_order_by",
		shift_status:"order_by",
		start_time:"order_by",
		team_role_assignment:"team_role_assignment_order_by",
		team_role_assignment_id:"order_by",
		updated_at:"order_by",
		user_role_assignment:"user_role_assignment_order_by",
		user_role_assignment_id:"order_by"
	},
	shift_pk_columns_input:{
		id:"uuid"
	},
	shift_related_note:{
		metadata:{

		}
	},
	shift_related_note_aggregate_bool_exp:{
		count:"shift_related_note_aggregate_bool_exp_count"
	},
	shift_related_note_aggregate_bool_exp_count:{
		arguments:"shift_related_note_select_column",
		filter:"shift_related_note_bool_exp",
		predicate:"Int_comparison_exp"
	},
	shift_related_note_aggregate_fields:{
		count:{
			columns:"shift_related_note_select_column"
		}
	},
	shift_related_note_aggregate_order_by:{
		count:"order_by",
		max:"shift_related_note_max_order_by",
		min:"shift_related_note_min_order_by"
	},
	shift_related_note_arr_rel_insert_input:{
		data:"shift_related_note_insert_input"
	},
	shift_related_note_bool_exp:{
		_and:"shift_related_note_bool_exp",
		_not:"shift_related_note_bool_exp",
		_or:"shift_related_note_bool_exp",
		content:"String_comparison_exp",
		date:"date_comparison_exp",
		metadata:"jsonb_comparison_exp",
		note:"note_bool_exp",
		note_created_at:"timestamptz_comparison_exp",
		note_id:"uuid_comparison_exp",
		object_id:"uuid_comparison_exp",
		shift_created_at:"timestamptz_comparison_exp",
		shift_id:"uuid_comparison_exp"
	},
	shift_related_note_insert_input:{
		date:"date",
		metadata:"jsonb",
		note:"note_obj_rel_insert_input",
		note_created_at:"timestamptz",
		note_id:"uuid",
		object_id:"uuid",
		shift_created_at:"timestamptz",
		shift_id:"uuid"
	},
	shift_related_note_max_order_by:{
		content:"order_by",
		date:"order_by",
		note_created_at:"order_by",
		note_id:"order_by",
		object_id:"order_by",
		shift_created_at:"order_by",
		shift_id:"order_by"
	},
	shift_related_note_min_order_by:{
		content:"order_by",
		date:"order_by",
		note_created_at:"order_by",
		note_id:"order_by",
		object_id:"order_by",
		shift_created_at:"order_by",
		shift_id:"order_by"
	},
	shift_related_note_order_by:{
		content:"order_by",
		date:"order_by",
		metadata:"order_by",
		note:"note_order_by",
		note_created_at:"order_by",
		note_id:"order_by",
		object_id:"order_by",
		shift_created_at:"order_by",
		shift_id:"order_by"
	},
	shift_related_note_select_column: "enum" as const,
	shift_related_note_stream_cursor_input:{
		initial_value:"shift_related_note_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	shift_related_note_stream_cursor_value_input:{
		date:"date",
		metadata:"jsonb",
		note_created_at:"timestamptz",
		note_id:"uuid",
		object_id:"uuid",
		shift_created_at:"timestamptz",
		shift_id:"uuid"
	},
	shift_select_column: "enum" as const,
	shift_select_column_shift_aggregate_bool_exp_bool_and_arguments_columns: "enum" as const,
	shift_select_column_shift_aggregate_bool_exp_bool_or_arguments_columns: "enum" as const,
	shift_set_input:{
		created_at:"timestamptz",
		end_time:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		recurrence_end_date:"timestamptz",
		root_id:"uuid",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		updated_at:"timestamptz",
		user_role_assignment_id:"uuid"
	},
	shift_stream_cursor_input:{
		initial_value:"shift_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	shift_stream_cursor_value_input:{
		created_at:"timestamptz",
		end_time:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		recurrence_end_date:"timestamptz",
		root_id:"uuid",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		updated_at:"timestamptz",
		user_role_assignment_id:"uuid"
	},
	shift_type_t: `scalar.shift_type_t` as const,
	shift_type_t_comparison_exp:{
		_eq:"shift_type_t",
		_gt:"shift_type_t",
		_gte:"shift_type_t",
		_in:"shift_type_t",
		_lt:"shift_type_t",
		_lte:"shift_type_t",
		_neq:"shift_type_t",
		_nin:"shift_type_t"
	},
	shift_update_column: "enum" as const,
	shift_updates:{
		_set:"shift_set_input",
		where:"shift_bool_exp"
	},
	subscription_root:{
		active_shift:{
			distinct_on:"active_shift_select_column",
			order_by:"active_shift_order_by",
			where:"active_shift_bool_exp"
		},
		active_shift_aggregate:{
			distinct_on:"active_shift_select_column",
			order_by:"active_shift_order_by",
			where:"active_shift_bool_exp"
		},
		active_shift_by_pk:{
			id:"uuid"
		},
		active_shift_stream:{
			cursor:"active_shift_stream_cursor_input",
			where:"active_shift_bool_exp"
		},
		cost_object:{
			distinct_on:"cost_object_select_column",
			order_by:"cost_object_order_by",
			where:"cost_object_bool_exp"
		},
		cost_object_aggregate:{
			distinct_on:"cost_object_select_column",
			order_by:"cost_object_order_by",
			where:"cost_object_bool_exp"
		},
		cost_object_by_pk:{
			id:"uuid"
		},
		cost_object_stream:{
			cursor:"cost_object_stream_cursor_input",
			where:"cost_object_bool_exp"
		},
		event:{
			distinct_on:"event_select_column",
			order_by:"event_order_by",
			where:"event_bool_exp"
		},
		event_aggregate:{
			distinct_on:"event_select_column",
			order_by:"event_order_by",
			where:"event_bool_exp"
		},
		event_buffered_shift_ended:{
			distinct_on:"event_buffered_shift_ended_select_column",
			order_by:"event_buffered_shift_ended_order_by",
			where:"event_buffered_shift_ended_bool_exp"
		},
		event_buffered_shift_ended_aggregate:{
			distinct_on:"event_buffered_shift_ended_select_column",
			order_by:"event_buffered_shift_ended_order_by",
			where:"event_buffered_shift_ended_bool_exp"
		},
		event_buffered_shift_ended_by_pk:{

		},
		event_buffered_shift_ended_stream:{
			cursor:"event_buffered_shift_ended_stream_cursor_input",
			where:"event_buffered_shift_ended_bool_exp"
		},
		event_buffered_shift_started:{
			distinct_on:"event_buffered_shift_started_select_column",
			order_by:"event_buffered_shift_started_order_by",
			where:"event_buffered_shift_started_bool_exp"
		},
		event_buffered_shift_started_aggregate:{
			distinct_on:"event_buffered_shift_started_select_column",
			order_by:"event_buffered_shift_started_order_by",
			where:"event_buffered_shift_started_bool_exp"
		},
		event_buffered_shift_started_by_pk:{

		},
		event_buffered_shift_started_stream:{
			cursor:"event_buffered_shift_started_stream_cursor_input",
			where:"event_buffered_shift_started_bool_exp"
		},
		event_by_pk:{

		},
		event_cost_object_created:{
			distinct_on:"event_cost_object_created_select_column",
			order_by:"event_cost_object_created_order_by",
			where:"event_cost_object_created_bool_exp"
		},
		event_cost_object_created_aggregate:{
			distinct_on:"event_cost_object_created_select_column",
			order_by:"event_cost_object_created_order_by",
			where:"event_cost_object_created_bool_exp"
		},
		event_cost_object_created_by_pk:{

		},
		event_cost_object_created_stream:{
			cursor:"event_cost_object_created_stream_cursor_input",
			where:"event_cost_object_created_bool_exp"
		},
		event_cost_object_deleted:{
			distinct_on:"event_cost_object_deleted_select_column",
			order_by:"event_cost_object_deleted_order_by",
			where:"event_cost_object_deleted_bool_exp"
		},
		event_cost_object_deleted_aggregate:{
			distinct_on:"event_cost_object_deleted_select_column",
			order_by:"event_cost_object_deleted_order_by",
			where:"event_cost_object_deleted_bool_exp"
		},
		event_cost_object_deleted_by_pk:{

		},
		event_cost_object_deleted_stream:{
			cursor:"event_cost_object_deleted_stream_cursor_input",
			where:"event_cost_object_deleted_bool_exp"
		},
		event_cost_object_reactivated:{
			distinct_on:"event_cost_object_reactivated_select_column",
			order_by:"event_cost_object_reactivated_order_by",
			where:"event_cost_object_reactivated_bool_exp"
		},
		event_cost_object_reactivated_aggregate:{
			distinct_on:"event_cost_object_reactivated_select_column",
			order_by:"event_cost_object_reactivated_order_by",
			where:"event_cost_object_reactivated_bool_exp"
		},
		event_cost_object_reactivated_by_pk:{

		},
		event_cost_object_reactivated_stream:{
			cursor:"event_cost_object_reactivated_stream_cursor_input",
			where:"event_cost_object_reactivated_bool_exp"
		},
		event_cost_object_updated:{
			distinct_on:"event_cost_object_updated_select_column",
			order_by:"event_cost_object_updated_order_by",
			where:"event_cost_object_updated_bool_exp"
		},
		event_cost_object_updated_aggregate:{
			distinct_on:"event_cost_object_updated_select_column",
			order_by:"event_cost_object_updated_order_by",
			where:"event_cost_object_updated_bool_exp"
		},
		event_cost_object_updated_by_pk:{

		},
		event_cost_object_updated_stream:{
			cursor:"event_cost_object_updated_stream_cursor_input",
			where:"event_cost_object_updated_bool_exp"
		},
		event_derived_shift_deleted:{
			distinct_on:"event_derived_shift_deleted_select_column",
			order_by:"event_derived_shift_deleted_order_by",
			where:"event_derived_shift_deleted_bool_exp"
		},
		event_derived_shift_deleted_aggregate:{
			distinct_on:"event_derived_shift_deleted_select_column",
			order_by:"event_derived_shift_deleted_order_by",
			where:"event_derived_shift_deleted_bool_exp"
		},
		event_derived_shift_deleted_by_pk:{

		},
		event_derived_shift_deleted_stream:{
			cursor:"event_derived_shift_deleted_stream_cursor_input",
			where:"event_derived_shift_deleted_bool_exp"
		},
		event_derived_shift_updated:{
			distinct_on:"event_derived_shift_updated_select_column",
			order_by:"event_derived_shift_updated_order_by",
			where:"event_derived_shift_updated_bool_exp"
		},
		event_derived_shift_updated_aggregate:{
			distinct_on:"event_derived_shift_updated_select_column",
			order_by:"event_derived_shift_updated_order_by",
			where:"event_derived_shift_updated_bool_exp"
		},
		event_derived_shift_updated_by_pk:{

		},
		event_derived_shift_updated_stream:{
			cursor:"event_derived_shift_updated_stream_cursor_input",
			where:"event_derived_shift_updated_bool_exp"
		},
		event_note_created:{
			distinct_on:"event_note_created_select_column",
			order_by:"event_note_created_order_by",
			where:"event_note_created_bool_exp"
		},
		event_note_created_aggregate:{
			distinct_on:"event_note_created_select_column",
			order_by:"event_note_created_order_by",
			where:"event_note_created_bool_exp"
		},
		event_note_created_by_pk:{

		},
		event_note_created_stream:{
			cursor:"event_note_created_stream_cursor_input",
			where:"event_note_created_bool_exp"
		},
		event_note_deleted:{
			distinct_on:"event_note_deleted_select_column",
			order_by:"event_note_deleted_order_by",
			where:"event_note_deleted_bool_exp"
		},
		event_note_deleted_aggregate:{
			distinct_on:"event_note_deleted_select_column",
			order_by:"event_note_deleted_order_by",
			where:"event_note_deleted_bool_exp"
		},
		event_note_deleted_by_pk:{

		},
		event_note_deleted_stream:{
			cursor:"event_note_deleted_stream_cursor_input",
			where:"event_note_deleted_bool_exp"
		},
		event_note_updated:{
			distinct_on:"event_note_updated_select_column",
			order_by:"event_note_updated_order_by",
			where:"event_note_updated_bool_exp"
		},
		event_note_updated_aggregate:{
			distinct_on:"event_note_updated_select_column",
			order_by:"event_note_updated_order_by",
			where:"event_note_updated_bool_exp"
		},
		event_note_updated_by_pk:{

		},
		event_note_updated_stream:{
			cursor:"event_note_updated_stream_cursor_input",
			where:"event_note_updated_bool_exp"
		},
		event_recurring_shift_exception_created:{
			distinct_on:"event_recurring_shift_exception_created_select_column",
			order_by:"event_recurring_shift_exception_created_order_by",
			where:"event_recurring_shift_exception_created_bool_exp"
		},
		event_recurring_shift_exception_created_aggregate:{
			distinct_on:"event_recurring_shift_exception_created_select_column",
			order_by:"event_recurring_shift_exception_created_order_by",
			where:"event_recurring_shift_exception_created_bool_exp"
		},
		event_recurring_shift_exception_created_by_pk:{

		},
		event_recurring_shift_exception_created_stream:{
			cursor:"event_recurring_shift_exception_created_stream_cursor_input",
			where:"event_recurring_shift_exception_created_bool_exp"
		},
		event_shift_created:{
			distinct_on:"event_shift_created_select_column",
			order_by:"event_shift_created_order_by",
			where:"event_shift_created_bool_exp"
		},
		event_shift_created_aggregate:{
			distinct_on:"event_shift_created_select_column",
			order_by:"event_shift_created_order_by",
			where:"event_shift_created_bool_exp"
		},
		event_shift_created_by_pk:{

		},
		event_shift_created_stream:{
			cursor:"event_shift_created_stream_cursor_input",
			where:"event_shift_created_bool_exp"
		},
		event_shift_deleted:{
			distinct_on:"event_shift_deleted_select_column",
			order_by:"event_shift_deleted_order_by",
			where:"event_shift_deleted_bool_exp"
		},
		event_shift_deleted_aggregate:{
			distinct_on:"event_shift_deleted_select_column",
			order_by:"event_shift_deleted_order_by",
			where:"event_shift_deleted_bool_exp"
		},
		event_shift_deleted_by_pk:{

		},
		event_shift_deleted_stream:{
			cursor:"event_shift_deleted_stream_cursor_input",
			where:"event_shift_deleted_bool_exp"
		},
		event_shift_ended:{
			distinct_on:"event_shift_ended_select_column",
			order_by:"event_shift_ended_order_by",
			where:"event_shift_ended_bool_exp"
		},
		event_shift_ended_aggregate:{
			distinct_on:"event_shift_ended_select_column",
			order_by:"event_shift_ended_order_by",
			where:"event_shift_ended_bool_exp"
		},
		event_shift_ended_by_pk:{

		},
		event_shift_ended_stream:{
			cursor:"event_shift_ended_stream_cursor_input",
			where:"event_shift_ended_bool_exp"
		},
		event_shift_started:{
			distinct_on:"event_shift_started_select_column",
			order_by:"event_shift_started_order_by",
			where:"event_shift_started_bool_exp"
		},
		event_shift_started_aggregate:{
			distinct_on:"event_shift_started_select_column",
			order_by:"event_shift_started_order_by",
			where:"event_shift_started_bool_exp"
		},
		event_shift_started_by_pk:{

		},
		event_shift_started_stream:{
			cursor:"event_shift_started_stream_cursor_input",
			where:"event_shift_started_bool_exp"
		},
		event_shift_updated:{
			distinct_on:"event_shift_updated_select_column",
			order_by:"event_shift_updated_order_by",
			where:"event_shift_updated_bool_exp"
		},
		event_shift_updated_aggregate:{
			distinct_on:"event_shift_updated_select_column",
			order_by:"event_shift_updated_order_by",
			where:"event_shift_updated_bool_exp"
		},
		event_shift_updated_by_pk:{

		},
		event_shift_updated_stream:{
			cursor:"event_shift_updated_stream_cursor_input",
			where:"event_shift_updated_bool_exp"
		},
		event_stream:{
			cursor:"event_stream_cursor_input",
			where:"event_bool_exp"
		},
		event_team_created:{
			distinct_on:"event_team_created_select_column",
			order_by:"event_team_created_order_by",
			where:"event_team_created_bool_exp"
		},
		event_team_created_aggregate:{
			distinct_on:"event_team_created_select_column",
			order_by:"event_team_created_order_by",
			where:"event_team_created_bool_exp"
		},
		event_team_created_by_pk:{

		},
		event_team_created_stream:{
			cursor:"event_team_created_stream_cursor_input",
			where:"event_team_created_bool_exp"
		},
		event_team_deleted:{
			distinct_on:"event_team_deleted_select_column",
			order_by:"event_team_deleted_order_by",
			where:"event_team_deleted_bool_exp"
		},
		event_team_deleted_aggregate:{
			distinct_on:"event_team_deleted_select_column",
			order_by:"event_team_deleted_order_by",
			where:"event_team_deleted_bool_exp"
		},
		event_team_deleted_by_pk:{

		},
		event_team_deleted_stream:{
			cursor:"event_team_deleted_stream_cursor_input",
			where:"event_team_deleted_bool_exp"
		},
		event_team_reactivated:{
			distinct_on:"event_team_reactivated_select_column",
			order_by:"event_team_reactivated_order_by",
			where:"event_team_reactivated_bool_exp"
		},
		event_team_reactivated_aggregate:{
			distinct_on:"event_team_reactivated_select_column",
			order_by:"event_team_reactivated_order_by",
			where:"event_team_reactivated_bool_exp"
		},
		event_team_reactivated_by_pk:{

		},
		event_team_reactivated_stream:{
			cursor:"event_team_reactivated_stream_cursor_input",
			where:"event_team_reactivated_bool_exp"
		},
		event_team_role_assignment_created:{
			distinct_on:"event_team_role_assignment_created_select_column",
			order_by:"event_team_role_assignment_created_order_by",
			where:"event_team_role_assignment_created_bool_exp"
		},
		event_team_role_assignment_created_aggregate:{
			distinct_on:"event_team_role_assignment_created_select_column",
			order_by:"event_team_role_assignment_created_order_by",
			where:"event_team_role_assignment_created_bool_exp"
		},
		event_team_role_assignment_created_by_pk:{

		},
		event_team_role_assignment_created_stream:{
			cursor:"event_team_role_assignment_created_stream_cursor_input",
			where:"event_team_role_assignment_created_bool_exp"
		},
		event_team_role_assignment_deleted:{
			distinct_on:"event_team_role_assignment_deleted_select_column",
			order_by:"event_team_role_assignment_deleted_order_by",
			where:"event_team_role_assignment_deleted_bool_exp"
		},
		event_team_role_assignment_deleted_aggregate:{
			distinct_on:"event_team_role_assignment_deleted_select_column",
			order_by:"event_team_role_assignment_deleted_order_by",
			where:"event_team_role_assignment_deleted_bool_exp"
		},
		event_team_role_assignment_deleted_by_pk:{

		},
		event_team_role_assignment_deleted_stream:{
			cursor:"event_team_role_assignment_deleted_stream_cursor_input",
			where:"event_team_role_assignment_deleted_bool_exp"
		},
		event_team_role_created:{
			distinct_on:"event_team_role_created_select_column",
			order_by:"event_team_role_created_order_by",
			where:"event_team_role_created_bool_exp"
		},
		event_team_role_created_aggregate:{
			distinct_on:"event_team_role_created_select_column",
			order_by:"event_team_role_created_order_by",
			where:"event_team_role_created_bool_exp"
		},
		event_team_role_created_by_pk:{

		},
		event_team_role_created_stream:{
			cursor:"event_team_role_created_stream_cursor_input",
			where:"event_team_role_created_bool_exp"
		},
		event_team_role_deleted:{
			distinct_on:"event_team_role_deleted_select_column",
			order_by:"event_team_role_deleted_order_by",
			where:"event_team_role_deleted_bool_exp"
		},
		event_team_role_deleted_aggregate:{
			distinct_on:"event_team_role_deleted_select_column",
			order_by:"event_team_role_deleted_order_by",
			where:"event_team_role_deleted_bool_exp"
		},
		event_team_role_deleted_by_pk:{

		},
		event_team_role_deleted_stream:{
			cursor:"event_team_role_deleted_stream_cursor_input",
			where:"event_team_role_deleted_bool_exp"
		},
		event_team_role_updated:{
			distinct_on:"event_team_role_updated_select_column",
			order_by:"event_team_role_updated_order_by",
			where:"event_team_role_updated_bool_exp"
		},
		event_team_role_updated_aggregate:{
			distinct_on:"event_team_role_updated_select_column",
			order_by:"event_team_role_updated_order_by",
			where:"event_team_role_updated_bool_exp"
		},
		event_team_role_updated_by_pk:{

		},
		event_team_role_updated_stream:{
			cursor:"event_team_role_updated_stream_cursor_input",
			where:"event_team_role_updated_bool_exp"
		},
		event_team_updated:{
			distinct_on:"event_team_updated_select_column",
			order_by:"event_team_updated_order_by",
			where:"event_team_updated_bool_exp"
		},
		event_team_updated_aggregate:{
			distinct_on:"event_team_updated_select_column",
			order_by:"event_team_updated_order_by",
			where:"event_team_updated_bool_exp"
		},
		event_team_updated_by_pk:{

		},
		event_team_updated_stream:{
			cursor:"event_team_updated_stream_cursor_input",
			where:"event_team_updated_bool_exp"
		},
		event_user_created:{
			distinct_on:"event_user_created_select_column",
			order_by:"event_user_created_order_by",
			where:"event_user_created_bool_exp"
		},
		event_user_created_aggregate:{
			distinct_on:"event_user_created_select_column",
			order_by:"event_user_created_order_by",
			where:"event_user_created_bool_exp"
		},
		event_user_created_by_pk:{

		},
		event_user_created_stream:{
			cursor:"event_user_created_stream_cursor_input",
			where:"event_user_created_bool_exp"
		},
		event_user_deleted:{
			distinct_on:"event_user_deleted_select_column",
			order_by:"event_user_deleted_order_by",
			where:"event_user_deleted_bool_exp"
		},
		event_user_deleted_aggregate:{
			distinct_on:"event_user_deleted_select_column",
			order_by:"event_user_deleted_order_by",
			where:"event_user_deleted_bool_exp"
		},
		event_user_deleted_by_pk:{

		},
		event_user_deleted_stream:{
			cursor:"event_user_deleted_stream_cursor_input",
			where:"event_user_deleted_bool_exp"
		},
		event_user_role_assignment_created:{
			distinct_on:"event_user_role_assignment_created_select_column",
			order_by:"event_user_role_assignment_created_order_by",
			where:"event_user_role_assignment_created_bool_exp"
		},
		event_user_role_assignment_created_aggregate:{
			distinct_on:"event_user_role_assignment_created_select_column",
			order_by:"event_user_role_assignment_created_order_by",
			where:"event_user_role_assignment_created_bool_exp"
		},
		event_user_role_assignment_created_by_pk:{

		},
		event_user_role_assignment_created_stream:{
			cursor:"event_user_role_assignment_created_stream_cursor_input",
			where:"event_user_role_assignment_created_bool_exp"
		},
		event_user_role_assignment_deleted:{
			distinct_on:"event_user_role_assignment_deleted_select_column",
			order_by:"event_user_role_assignment_deleted_order_by",
			where:"event_user_role_assignment_deleted_bool_exp"
		},
		event_user_role_assignment_deleted_aggregate:{
			distinct_on:"event_user_role_assignment_deleted_select_column",
			order_by:"event_user_role_assignment_deleted_order_by",
			where:"event_user_role_assignment_deleted_bool_exp"
		},
		event_user_role_assignment_deleted_by_pk:{

		},
		event_user_role_assignment_deleted_stream:{
			cursor:"event_user_role_assignment_deleted_stream_cursor_input",
			where:"event_user_role_assignment_deleted_bool_exp"
		},
		event_user_role_assignment_updated:{
			distinct_on:"event_user_role_assignment_updated_select_column",
			order_by:"event_user_role_assignment_updated_order_by",
			where:"event_user_role_assignment_updated_bool_exp"
		},
		event_user_role_assignment_updated_aggregate:{
			distinct_on:"event_user_role_assignment_updated_select_column",
			order_by:"event_user_role_assignment_updated_order_by",
			where:"event_user_role_assignment_updated_bool_exp"
		},
		event_user_role_assignment_updated_by_pk:{

		},
		event_user_role_assignment_updated_stream:{
			cursor:"event_user_role_assignment_updated_stream_cursor_input",
			where:"event_user_role_assignment_updated_bool_exp"
		},
		event_user_updated:{
			distinct_on:"event_user_updated_select_column",
			order_by:"event_user_updated_order_by",
			where:"event_user_updated_bool_exp"
		},
		event_user_updated_aggregate:{
			distinct_on:"event_user_updated_select_column",
			order_by:"event_user_updated_order_by",
			where:"event_user_updated_bool_exp"
		},
		event_user_updated_by_pk:{

		},
		event_user_updated_stream:{
			cursor:"event_user_updated_stream_cursor_input",
			where:"event_user_updated_bool_exp"
		},
		group:{
			distinct_on:"group_select_column",
			order_by:"group_order_by",
			where:"group_bool_exp"
		},
		group_aggregate:{
			distinct_on:"group_select_column",
			order_by:"group_order_by",
			where:"group_bool_exp"
		},
		group_by_pk:{
			id:"uuid"
		},
		group_membership:{
			distinct_on:"group_membership_select_column",
			order_by:"group_membership_order_by",
			where:"group_membership_bool_exp"
		},
		group_membership_aggregate:{
			distinct_on:"group_membership_select_column",
			order_by:"group_membership_order_by",
			where:"group_membership_bool_exp"
		},
		group_membership_by_pk:{
			id:"uuid"
		},
		group_membership_stream:{
			cursor:"group_membership_stream_cursor_input",
			where:"group_membership_bool_exp"
		},
		group_stream:{
			cursor:"group_stream_cursor_input",
			where:"group_bool_exp"
		},
		note:{
			distinct_on:"note_select_column",
			order_by:"note_order_by",
			where:"note_bool_exp"
		},
		note_aggregate:{
			distinct_on:"note_select_column",
			order_by:"note_order_by",
			where:"note_bool_exp"
		},
		note_by_pk:{
			id:"uuid"
		},
		note_stream:{
			cursor:"note_stream_cursor_input",
			where:"note_bool_exp"
		},
		permissions_shift:{
			distinct_on:"permissions_shift_select_column",
			order_by:"permissions_shift_order_by",
			where:"permissions_shift_bool_exp"
		},
		permissions_shift_aggregate:{
			distinct_on:"permissions_shift_select_column",
			order_by:"permissions_shift_order_by",
			where:"permissions_shift_bool_exp"
		},
		permissions_shift_config:{
			distinct_on:"permissions_shift_config_select_column",
			order_by:"permissions_shift_config_order_by",
			where:"permissions_shift_config_bool_exp"
		},
		permissions_shift_config_aggregate:{
			distinct_on:"permissions_shift_config_select_column",
			order_by:"permissions_shift_config_order_by",
			where:"permissions_shift_config_bool_exp"
		},
		permissions_shift_config_by_pk:{
			id:"uuid"
		},
		permissions_shift_config_stream:{
			cursor:"permissions_shift_config_stream_cursor_input",
			where:"permissions_shift_config_bool_exp"
		},
		permissions_shift_stream:{
			cursor:"permissions_shift_stream_cursor_input",
			where:"permissions_shift_bool_exp"
		},
		permissions_team:{
			distinct_on:"permissions_team_select_column",
			order_by:"permissions_team_order_by",
			where:"permissions_team_bool_exp"
		},
		permissions_team_aggregate:{
			distinct_on:"permissions_team_select_column",
			order_by:"permissions_team_order_by",
			where:"permissions_team_bool_exp"
		},
		permissions_team_config:{
			distinct_on:"permissions_team_config_select_column",
			order_by:"permissions_team_config_order_by",
			where:"permissions_team_config_bool_exp"
		},
		permissions_team_config_aggregate:{
			distinct_on:"permissions_team_config_select_column",
			order_by:"permissions_team_config_order_by",
			where:"permissions_team_config_bool_exp"
		},
		permissions_team_config_by_pk:{
			id:"uuid"
		},
		permissions_team_config_stream:{
			cursor:"permissions_team_config_stream_cursor_input",
			where:"permissions_team_config_bool_exp"
		},
		permissions_team_role:{
			distinct_on:"permissions_team_role_select_column",
			order_by:"permissions_team_role_order_by",
			where:"permissions_team_role_bool_exp"
		},
		permissions_team_role_aggregate:{
			distinct_on:"permissions_team_role_select_column",
			order_by:"permissions_team_role_order_by",
			where:"permissions_team_role_bool_exp"
		},
		permissions_team_role_assignment:{
			distinct_on:"permissions_team_role_assignment_select_column",
			order_by:"permissions_team_role_assignment_order_by",
			where:"permissions_team_role_assignment_bool_exp"
		},
		permissions_team_role_assignment_aggregate:{
			distinct_on:"permissions_team_role_assignment_select_column",
			order_by:"permissions_team_role_assignment_order_by",
			where:"permissions_team_role_assignment_bool_exp"
		},
		permissions_team_role_assignment_stream:{
			cursor:"permissions_team_role_assignment_stream_cursor_input",
			where:"permissions_team_role_assignment_bool_exp"
		},
		permissions_team_role_config:{
			distinct_on:"permissions_team_role_config_select_column",
			order_by:"permissions_team_role_config_order_by",
			where:"permissions_team_role_config_bool_exp"
		},
		permissions_team_role_config_aggregate:{
			distinct_on:"permissions_team_role_config_select_column",
			order_by:"permissions_team_role_config_order_by",
			where:"permissions_team_role_config_bool_exp"
		},
		permissions_team_role_config_by_pk:{
			id:"uuid"
		},
		permissions_team_role_config_stream:{
			cursor:"permissions_team_role_config_stream_cursor_input",
			where:"permissions_team_role_config_bool_exp"
		},
		permissions_team_role_stream:{
			cursor:"permissions_team_role_stream_cursor_input",
			where:"permissions_team_role_bool_exp"
		},
		permissions_team_stream:{
			cursor:"permissions_team_stream_cursor_input",
			where:"permissions_team_bool_exp"
		},
		permissions_user_role_assignment:{
			distinct_on:"permissions_user_role_assignment_select_column",
			order_by:"permissions_user_role_assignment_order_by",
			where:"permissions_user_role_assignment_bool_exp"
		},
		permissions_user_role_assignment_aggregate:{
			distinct_on:"permissions_user_role_assignment_select_column",
			order_by:"permissions_user_role_assignment_order_by",
			where:"permissions_user_role_assignment_bool_exp"
		},
		permissions_user_role_assignment_stream:{
			cursor:"permissions_user_role_assignment_stream_cursor_input",
			where:"permissions_user_role_assignment_bool_exp"
		},
		qualification:{
			distinct_on:"qualification_select_column",
			order_by:"qualification_order_by",
			where:"qualification_bool_exp"
		},
		qualification_aggregate:{
			distinct_on:"qualification_select_column",
			order_by:"qualification_order_by",
			where:"qualification_bool_exp"
		},
		qualification_by_pk:{
			id:"uuid"
		},
		qualification_stream:{
			cursor:"qualification_stream_cursor_input",
			where:"qualification_bool_exp"
		},
		recurring_shift_exception:{
			distinct_on:"recurring_shift_exception_select_column",
			order_by:"recurring_shift_exception_order_by",
			where:"recurring_shift_exception_bool_exp"
		},
		recurring_shift_exception_aggregate:{
			distinct_on:"recurring_shift_exception_select_column",
			order_by:"recurring_shift_exception_order_by",
			where:"recurring_shift_exception_bool_exp"
		},
		recurring_shift_exception_by_pk:{
			id:"uuid"
		},
		recurring_shift_exception_stream:{
			cursor:"recurring_shift_exception_stream_cursor_input",
			where:"recurring_shift_exception_bool_exp"
		},
		search_user:{
			args:"search_user_args",
			distinct_on:"user_select_column",
			order_by:"user_order_by",
			where:"user_bool_exp"
		},
		search_user_aggregate:{
			args:"search_user_args",
			distinct_on:"user_select_column",
			order_by:"user_order_by",
			where:"user_bool_exp"
		},
		shift:{
			distinct_on:"shift_select_column",
			order_by:"shift_order_by",
			where:"shift_bool_exp"
		},
		shift_aggregate:{
			distinct_on:"shift_select_column",
			order_by:"shift_order_by",
			where:"shift_bool_exp"
		},
		shift_by_pk:{
			id:"uuid"
		},
		shift_related_note:{
			distinct_on:"shift_related_note_select_column",
			order_by:"shift_related_note_order_by",
			where:"shift_related_note_bool_exp"
		},
		shift_related_note_aggregate:{
			distinct_on:"shift_related_note_select_column",
			order_by:"shift_related_note_order_by",
			where:"shift_related_note_bool_exp"
		},
		shift_related_note_stream:{
			cursor:"shift_related_note_stream_cursor_input",
			where:"shift_related_note_bool_exp"
		},
		shift_stream:{
			cursor:"shift_stream_cursor_input",
			where:"shift_bool_exp"
		},
		team:{
			distinct_on:"team_select_column",
			order_by:"team_order_by",
			where:"team_bool_exp"
		},
		team_aggregate:{
			distinct_on:"team_select_column",
			order_by:"team_order_by",
			where:"team_bool_exp"
		},
		team_by_pk:{
			id:"uuid"
		},
		team_role:{
			distinct_on:"team_role_select_column",
			order_by:"team_role_order_by",
			where:"team_role_bool_exp"
		},
		team_role_aggregate:{
			distinct_on:"team_role_select_column",
			order_by:"team_role_order_by",
			where:"team_role_bool_exp"
		},
		team_role_assignment:{
			distinct_on:"team_role_assignment_select_column",
			order_by:"team_role_assignment_order_by",
			where:"team_role_assignment_bool_exp"
		},
		team_role_assignment_aggregate:{
			distinct_on:"team_role_assignment_select_column",
			order_by:"team_role_assignment_order_by",
			where:"team_role_assignment_bool_exp"
		},
		team_role_assignment_by_pk:{
			id:"uuid"
		},
		team_role_assignment_stream:{
			cursor:"team_role_assignment_stream_cursor_input",
			where:"team_role_assignment_bool_exp"
		},
		team_role_by_pk:{
			id:"uuid"
		},
		team_role_stream:{
			cursor:"team_role_stream_cursor_input",
			where:"team_role_bool_exp"
		},
		team_stream:{
			cursor:"team_stream_cursor_input",
			where:"team_bool_exp"
		},
		user:{
			distinct_on:"user_select_column",
			order_by:"user_order_by",
			where:"user_bool_exp"
		},
		user_aggregate:{
			distinct_on:"user_select_column",
			order_by:"user_order_by",
			where:"user_bool_exp"
		},
		user_by_pk:{
			id:"uuid"
		},
		user_notification:{
			distinct_on:"user_notification_select_column",
			order_by:"user_notification_order_by",
			where:"user_notification_bool_exp"
		},
		user_notification_aggregate:{
			distinct_on:"user_notification_select_column",
			order_by:"user_notification_order_by",
			where:"user_notification_bool_exp"
		},
		user_notification_by_pk:{
			id:"uuid"
		},
		user_notification_stream:{
			cursor:"user_notification_stream_cursor_input",
			where:"user_notification_bool_exp"
		},
		user_role_assignment:{
			distinct_on:"user_role_assignment_select_column",
			order_by:"user_role_assignment_order_by",
			where:"user_role_assignment_bool_exp"
		},
		user_role_assignment_aggregate:{
			distinct_on:"user_role_assignment_select_column",
			order_by:"user_role_assignment_order_by",
			where:"user_role_assignment_bool_exp"
		},
		user_role_assignment_by_pk:{
			id:"uuid"
		},
		user_role_assignment_stream:{
			cursor:"user_role_assignment_stream_cursor_input",
			where:"user_role_assignment_bool_exp"
		},
		user_shift_notification:{
			distinct_on:"user_shift_notification_select_column",
			order_by:"user_shift_notification_order_by",
			where:"user_shift_notification_bool_exp"
		},
		user_shift_notification_aggregate:{
			distinct_on:"user_shift_notification_select_column",
			order_by:"user_shift_notification_order_by",
			where:"user_shift_notification_bool_exp"
		},
		user_shift_notification_by_pk:{
			id:"uuid"
		},
		user_shift_notification_event:{
			distinct_on:"user_shift_notification_event_select_column",
			order_by:"user_shift_notification_event_order_by",
			where:"user_shift_notification_event_bool_exp"
		},
		user_shift_notification_event_aggregate:{
			distinct_on:"user_shift_notification_event_select_column",
			order_by:"user_shift_notification_event_order_by",
			where:"user_shift_notification_event_bool_exp"
		},
		user_shift_notification_event_by_pk:{
			id:"uuid"
		},
		user_shift_notification_event_stream:{
			cursor:"user_shift_notification_event_stream_cursor_input",
			where:"user_shift_notification_event_bool_exp"
		},
		user_shift_notification_stream:{
			cursor:"user_shift_notification_stream_cursor_input",
			where:"user_shift_notification_bool_exp"
		},
		user_stream:{
			cursor:"user_stream_cursor_input",
			where:"user_bool_exp"
		}
	},
	team:{
		event_team_deleted:{
			distinct_on:"event_team_deleted_select_column",
			order_by:"event_team_deleted_order_by",
			where:"event_team_deleted_bool_exp"
		},
		event_team_deleted_aggregate:{
			distinct_on:"event_team_deleted_select_column",
			order_by:"event_team_deleted_order_by",
			where:"event_team_deleted_bool_exp"
		},
		event_team_reactivated:{
			distinct_on:"event_team_reactivated_select_column",
			order_by:"event_team_reactivated_order_by",
			where:"event_team_reactivated_bool_exp"
		},
		event_team_reactivated_aggregate:{
			distinct_on:"event_team_reactivated_select_column",
			order_by:"event_team_reactivated_order_by",
			where:"event_team_reactivated_bool_exp"
		},
		event_team_updated:{
			distinct_on:"event_team_updated_select_column",
			order_by:"event_team_updated_order_by",
			where:"event_team_updated_bool_exp"
		},
		event_team_updated_aggregate:{
			distinct_on:"event_team_updated_select_column",
			order_by:"event_team_updated_order_by",
			where:"event_team_updated_bool_exp"
		},
		events:{
			distinct_on:"event_select_column",
			order_by:"event_order_by",
			where:"event_bool_exp"
		},
		events_aggregate:{
			distinct_on:"event_select_column",
			order_by:"event_order_by",
			where:"event_bool_exp"
		},
		team_role_assignments:{
			distinct_on:"team_role_assignment_select_column",
			order_by:"team_role_assignment_order_by",
			where:"team_role_assignment_bool_exp"
		},
		team_role_assignments_aggregate:{
			distinct_on:"team_role_assignment_select_column",
			order_by:"team_role_assignment_order_by",
			where:"team_role_assignment_bool_exp"
		},
		team_settings:{

		}
	},
	team_aggregate_bool_exp:{
		count:"team_aggregate_bool_exp_count"
	},
	team_aggregate_bool_exp_count:{
		arguments:"team_select_column",
		filter:"team_bool_exp",
		predicate:"Int_comparison_exp"
	},
	team_aggregate_fields:{
		count:{
			columns:"team_select_column"
		}
	},
	team_aggregate_order_by:{
		count:"order_by",
		max:"team_max_order_by",
		min:"team_min_order_by"
	},
	team_append_input:{
		team_settings:"jsonb"
	},
	team_arr_rel_insert_input:{
		data:"team_insert_input",
		on_conflict:"team_on_conflict"
	},
	team_bool_exp:{
		_and:"team_bool_exp",
		_not:"team_bool_exp",
		_or:"team_bool_exp",
		cost_object:"cost_object_bool_exp",
		created_at:"timestamptz_comparison_exp",
		event_team_deleted:"event_team_deleted_bool_exp",
		event_team_deleted_aggregate:"event_team_deleted_aggregate_bool_exp",
		event_team_reactivated:"event_team_reactivated_bool_exp",
		event_team_reactivated_aggregate:"event_team_reactivated_aggregate_bool_exp",
		event_team_updated:"event_team_updated_bool_exp",
		event_team_updated_aggregate:"event_team_updated_aggregate_bool_exp",
		events:"event_bool_exp",
		events_aggregate:"event_aggregate_bool_exp",
		id:"uuid_comparison_exp",
		internal_order_number:"String_comparison_exp",
		name:"String_comparison_exp",
		record_status:"record_status_t_comparison_exp",
		team_role_assignments:"team_role_assignment_bool_exp",
		team_role_assignments_aggregate:"team_role_assignment_aggregate_bool_exp",
		team_settings:"jsonb_comparison_exp",
		team_type:"String_comparison_exp",
		updated_at:"timestamptz_comparison_exp"
	},
	team_constraint: "enum" as const,
	team_delete_at_path_input:{

	},
	team_delete_elem_input:{

	},
	team_delete_key_input:{

	},
	team_insert_input:{
		cost_object:"cost_object_obj_rel_insert_input",
		created_at:"timestamptz",
		event_team_deleted:"event_team_deleted_arr_rel_insert_input",
		event_team_reactivated:"event_team_reactivated_arr_rel_insert_input",
		event_team_updated:"event_team_updated_arr_rel_insert_input",
		events:"event_arr_rel_insert_input",
		id:"uuid",
		record_status:"record_status_t",
		team_role_assignments:"team_role_assignment_arr_rel_insert_input",
		team_settings:"jsonb",
		updated_at:"timestamptz"
	},
	team_max_order_by:{
		created_at:"order_by",
		id:"order_by",
		internal_order_number:"order_by",
		name:"order_by",
		record_status:"order_by",
		team_type:"order_by",
		updated_at:"order_by"
	},
	team_min_order_by:{
		created_at:"order_by",
		id:"order_by",
		internal_order_number:"order_by",
		name:"order_by",
		record_status:"order_by",
		team_type:"order_by",
		updated_at:"order_by"
	},
	team_obj_rel_insert_input:{
		data:"team_insert_input",
		on_conflict:"team_on_conflict"
	},
	team_on_conflict:{
		constraint:"team_constraint",
		update_columns:"team_update_column",
		where:"team_bool_exp"
	},
	team_order_by:{
		cost_object:"cost_object_order_by",
		created_at:"order_by",
		event_team_deleted_aggregate:"event_team_deleted_aggregate_order_by",
		event_team_reactivated_aggregate:"event_team_reactivated_aggregate_order_by",
		event_team_updated_aggregate:"event_team_updated_aggregate_order_by",
		events_aggregate:"event_aggregate_order_by",
		id:"order_by",
		internal_order_number:"order_by",
		name:"order_by",
		record_status:"order_by",
		team_role_assignments_aggregate:"team_role_assignment_aggregate_order_by",
		team_settings:"order_by",
		team_type:"order_by",
		updated_at:"order_by"
	},
	team_pk_columns_input:{
		id:"uuid"
	},
	team_prepend_input:{
		team_settings:"jsonb"
	},
	team_role:{
		event_team_role_deleted:{
			distinct_on:"event_team_role_deleted_select_column",
			order_by:"event_team_role_deleted_order_by",
			where:"event_team_role_deleted_bool_exp"
		},
		event_team_role_deleted_aggregate:{
			distinct_on:"event_team_role_deleted_select_column",
			order_by:"event_team_role_deleted_order_by",
			where:"event_team_role_deleted_bool_exp"
		},
		event_team_role_updated:{
			distinct_on:"event_team_role_updated_select_column",
			order_by:"event_team_role_updated_order_by",
			where:"event_team_role_updated_bool_exp"
		},
		event_team_role_updated_aggregate:{
			distinct_on:"event_team_role_updated_select_column",
			order_by:"event_team_role_updated_order_by",
			where:"event_team_role_updated_bool_exp"
		},
		permissionsTeamRoleConfigsByTeamRoleId:{
			distinct_on:"permissions_team_role_config_select_column",
			order_by:"permissions_team_role_config_order_by",
			where:"permissions_team_role_config_bool_exp"
		},
		permissionsTeamRoleConfigsByTeamRoleId_aggregate:{
			distinct_on:"permissions_team_role_config_select_column",
			order_by:"permissions_team_role_config_order_by",
			where:"permissions_team_role_config_bool_exp"
		},
		permissions_shift_configs:{
			distinct_on:"permissions_shift_config_select_column",
			order_by:"permissions_shift_config_order_by",
			where:"permissions_shift_config_bool_exp"
		},
		permissions_shift_configs_aggregate:{
			distinct_on:"permissions_shift_config_select_column",
			order_by:"permissions_shift_config_order_by",
			where:"permissions_shift_config_bool_exp"
		},
		permissions_team_configs:{
			distinct_on:"permissions_team_config_select_column",
			order_by:"permissions_team_config_order_by",
			where:"permissions_team_config_bool_exp"
		},
		permissions_team_configs_aggregate:{
			distinct_on:"permissions_team_config_select_column",
			order_by:"permissions_team_config_order_by",
			where:"permissions_team_config_bool_exp"
		},
		permissions_team_role:{
			distinct_on:"permissions_team_role_select_column",
			order_by:"permissions_team_role_order_by",
			where:"permissions_team_role_bool_exp"
		},
		permissions_team_role_aggregate:{
			distinct_on:"permissions_team_role_select_column",
			order_by:"permissions_team_role_order_by",
			where:"permissions_team_role_bool_exp"
		},
		permissions_team_role_configs:{
			distinct_on:"permissions_team_role_config_select_column",
			order_by:"permissions_team_role_config_order_by",
			where:"permissions_team_role_config_bool_exp"
		},
		permissions_team_role_configs_aggregate:{
			distinct_on:"permissions_team_role_config_select_column",
			order_by:"permissions_team_role_config_order_by",
			where:"permissions_team_role_config_bool_exp"
		},
		team_role_assignment:{
			distinct_on:"team_role_assignment_select_column",
			order_by:"team_role_assignment_order_by",
			where:"team_role_assignment_bool_exp"
		},
		team_role_assignment_aggregate:{
			distinct_on:"team_role_assignment_select_column",
			order_by:"team_role_assignment_order_by",
			where:"team_role_assignment_bool_exp"
		}
	},
	team_role_aggregate_fields:{
		count:{
			columns:"team_role_select_column"
		}
	},
	team_role_assignment:{
		event_shift_updated:{
			distinct_on:"event_shift_updated_select_column",
			order_by:"event_shift_updated_order_by",
			where:"event_shift_updated_bool_exp"
		},
		event_shift_updated_aggregate:{
			distinct_on:"event_shift_updated_select_column",
			order_by:"event_shift_updated_order_by",
			where:"event_shift_updated_bool_exp"
		},
		event_team_role_assignment_created:{
			distinct_on:"event_team_role_assignment_created_select_column",
			order_by:"event_team_role_assignment_created_order_by",
			where:"event_team_role_assignment_created_bool_exp"
		},
		event_team_role_assignment_created_aggregate:{
			distinct_on:"event_team_role_assignment_created_select_column",
			order_by:"event_team_role_assignment_created_order_by",
			where:"event_team_role_assignment_created_bool_exp"
		},
		event_team_role_assignment_deleted:{
			distinct_on:"event_team_role_assignment_deleted_select_column",
			order_by:"event_team_role_assignment_deleted_order_by",
			where:"event_team_role_assignment_deleted_bool_exp"
		},
		event_team_role_assignment_deleted_aggregate:{
			distinct_on:"event_team_role_assignment_deleted_select_column",
			order_by:"event_team_role_assignment_deleted_order_by",
			where:"event_team_role_assignment_deleted_bool_exp"
		},
		event_user_role_assignment_created:{
			distinct_on:"event_user_role_assignment_created_select_column",
			order_by:"event_user_role_assignment_created_order_by",
			where:"event_user_role_assignment_created_bool_exp"
		},
		event_user_role_assignment_created_aggregate:{
			distinct_on:"event_user_role_assignment_created_select_column",
			order_by:"event_user_role_assignment_created_order_by",
			where:"event_user_role_assignment_created_bool_exp"
		},
		event_user_role_assignment_updated:{
			distinct_on:"event_user_role_assignment_updated_select_column",
			order_by:"event_user_role_assignment_updated_order_by",
			where:"event_user_role_assignment_updated_bool_exp"
		},
		event_user_role_assignment_updated_aggregate:{
			distinct_on:"event_user_role_assignment_updated_select_column",
			order_by:"event_user_role_assignment_updated_order_by",
			where:"event_user_role_assignment_updated_bool_exp"
		},
		shifts:{
			distinct_on:"shift_select_column",
			order_by:"shift_order_by",
			where:"shift_bool_exp"
		},
		shifts_aggregate:{
			distinct_on:"shift_select_column",
			order_by:"shift_order_by",
			where:"shift_bool_exp"
		},
		user_role_assignments:{
			distinct_on:"user_role_assignment_select_column",
			order_by:"user_role_assignment_order_by",
			where:"user_role_assignment_bool_exp"
		},
		user_role_assignments_aggregate:{
			distinct_on:"user_role_assignment_select_column",
			order_by:"user_role_assignment_order_by",
			where:"user_role_assignment_bool_exp"
		}
	},
	team_role_assignment_aggregate_bool_exp:{
		count:"team_role_assignment_aggregate_bool_exp_count"
	},
	team_role_assignment_aggregate_bool_exp_count:{
		arguments:"team_role_assignment_select_column",
		filter:"team_role_assignment_bool_exp",
		predicate:"Int_comparison_exp"
	},
	team_role_assignment_aggregate_fields:{
		count:{
			columns:"team_role_assignment_select_column"
		}
	},
	team_role_assignment_aggregate_order_by:{
		count:"order_by",
		max:"team_role_assignment_max_order_by",
		min:"team_role_assignment_min_order_by"
	},
	team_role_assignment_arr_rel_insert_input:{
		data:"team_role_assignment_insert_input",
		on_conflict:"team_role_assignment_on_conflict"
	},
	team_role_assignment_bool_exp:{
		_and:"team_role_assignment_bool_exp",
		_not:"team_role_assignment_bool_exp",
		_or:"team_role_assignment_bool_exp",
		created_at:"timestamptz_comparison_exp",
		event_shift_updated:"event_shift_updated_bool_exp",
		event_shift_updated_aggregate:"event_shift_updated_aggregate_bool_exp",
		event_team_role_assignment_created:"event_team_role_assignment_created_bool_exp",
		event_team_role_assignment_created_aggregate:"event_team_role_assignment_created_aggregate_bool_exp",
		event_team_role_assignment_deleted:"event_team_role_assignment_deleted_bool_exp",
		event_team_role_assignment_deleted_aggregate:"event_team_role_assignment_deleted_aggregate_bool_exp",
		event_user_role_assignment_created:"event_user_role_assignment_created_bool_exp",
		event_user_role_assignment_created_aggregate:"event_user_role_assignment_created_aggregate_bool_exp",
		event_user_role_assignment_updated:"event_user_role_assignment_updated_bool_exp",
		event_user_role_assignment_updated_aggregate:"event_user_role_assignment_updated_aggregate_bool_exp",
		id:"uuid_comparison_exp",
		record_status:"record_status_t_comparison_exp",
		shifts:"shift_bool_exp",
		shifts_aggregate:"shift_aggregate_bool_exp",
		team:"team_bool_exp",
		team_id:"uuid_comparison_exp",
		team_role:"team_role_bool_exp",
		team_role_id:"uuid_comparison_exp",
		updated_at:"timestamptz_comparison_exp",
		user_role_assignments:"user_role_assignment_bool_exp",
		user_role_assignments_aggregate:"user_role_assignment_aggregate_bool_exp"
	},
	team_role_assignment_constraint: "enum" as const,
	team_role_assignment_insert_input:{
		created_at:"timestamptz",
		event_shift_updated:"event_shift_updated_arr_rel_insert_input",
		event_team_role_assignment_created:"event_team_role_assignment_created_arr_rel_insert_input",
		event_team_role_assignment_deleted:"event_team_role_assignment_deleted_arr_rel_insert_input",
		event_user_role_assignment_created:"event_user_role_assignment_created_arr_rel_insert_input",
		event_user_role_assignment_updated:"event_user_role_assignment_updated_arr_rel_insert_input",
		id:"uuid",
		record_status:"record_status_t",
		shifts:"shift_arr_rel_insert_input",
		team:"team_obj_rel_insert_input",
		team_id:"uuid",
		team_role:"team_role_obj_rel_insert_input",
		team_role_id:"uuid",
		updated_at:"timestamptz",
		user_role_assignments:"user_role_assignment_arr_rel_insert_input"
	},
	team_role_assignment_max_order_by:{
		created_at:"order_by",
		id:"order_by",
		record_status:"order_by",
		team_id:"order_by",
		team_role_id:"order_by",
		updated_at:"order_by"
	},
	team_role_assignment_min_order_by:{
		created_at:"order_by",
		id:"order_by",
		record_status:"order_by",
		team_id:"order_by",
		team_role_id:"order_by",
		updated_at:"order_by"
	},
	team_role_assignment_obj_rel_insert_input:{
		data:"team_role_assignment_insert_input",
		on_conflict:"team_role_assignment_on_conflict"
	},
	team_role_assignment_on_conflict:{
		constraint:"team_role_assignment_constraint",
		update_columns:"team_role_assignment_update_column",
		where:"team_role_assignment_bool_exp"
	},
	team_role_assignment_order_by:{
		created_at:"order_by",
		event_shift_updated_aggregate:"event_shift_updated_aggregate_order_by",
		event_team_role_assignment_created_aggregate:"event_team_role_assignment_created_aggregate_order_by",
		event_team_role_assignment_deleted_aggregate:"event_team_role_assignment_deleted_aggregate_order_by",
		event_user_role_assignment_created_aggregate:"event_user_role_assignment_created_aggregate_order_by",
		event_user_role_assignment_updated_aggregate:"event_user_role_assignment_updated_aggregate_order_by",
		id:"order_by",
		record_status:"order_by",
		shifts_aggregate:"shift_aggregate_order_by",
		team:"team_order_by",
		team_id:"order_by",
		team_role:"team_role_order_by",
		team_role_id:"order_by",
		updated_at:"order_by",
		user_role_assignments_aggregate:"user_role_assignment_aggregate_order_by"
	},
	team_role_assignment_pk_columns_input:{
		id:"uuid"
	},
	team_role_assignment_select_column: "enum" as const,
	team_role_assignment_set_input:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		team_id:"uuid",
		team_role_id:"uuid",
		updated_at:"timestamptz"
	},
	team_role_assignment_stream_cursor_input:{
		initial_value:"team_role_assignment_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	team_role_assignment_stream_cursor_value_input:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		team_id:"uuid",
		team_role_id:"uuid",
		updated_at:"timestamptz"
	},
	team_role_assignment_update_column: "enum" as const,
	team_role_assignment_updates:{
		_set:"team_role_assignment_set_input",
		where:"team_role_assignment_bool_exp"
	},
	team_role_bool_exp:{
		_and:"team_role_bool_exp",
		_not:"team_role_bool_exp",
		_or:"team_role_bool_exp",
		abbreviation:"String_comparison_exp",
		created_at:"timestamptz_comparison_exp",
		event_team_role_deleted:"event_team_role_deleted_bool_exp",
		event_team_role_deleted_aggregate:"event_team_role_deleted_aggregate_bool_exp",
		event_team_role_updated:"event_team_role_updated_bool_exp",
		event_team_role_updated_aggregate:"event_team_role_updated_aggregate_bool_exp",
		id:"uuid_comparison_exp",
		name:"String_comparison_exp",
		permissionsTeamRoleConfigsByTeamRoleId:"permissions_team_role_config_bool_exp",
		permissionsTeamRoleConfigsByTeamRoleId_aggregate:"permissions_team_role_config_aggregate_bool_exp",
		permissions_shift_configs:"permissions_shift_config_bool_exp",
		permissions_shift_configs_aggregate:"permissions_shift_config_aggregate_bool_exp",
		permissions_team_configs:"permissions_team_config_bool_exp",
		permissions_team_configs_aggregate:"permissions_team_config_aggregate_bool_exp",
		permissions_team_role:"permissions_team_role_bool_exp",
		permissions_team_role_aggregate:"permissions_team_role_aggregate_bool_exp",
		permissions_team_role_configs:"permissions_team_role_config_bool_exp",
		permissions_team_role_configs_aggregate:"permissions_team_role_config_aggregate_bool_exp",
		read_only:"Boolean_comparison_exp",
		record_status:"record_status_t_comparison_exp",
		role_group:"role_group_t_comparison_exp",
		team_role_assignment:"team_role_assignment_bool_exp",
		team_role_assignment_aggregate:"team_role_assignment_aggregate_bool_exp",
		updated_at:"timestamptz_comparison_exp"
	},
	team_role_constraint: "enum" as const,
	team_role_insert_input:{
		created_at:"timestamptz",
		event_team_role_deleted:"event_team_role_deleted_arr_rel_insert_input",
		event_team_role_updated:"event_team_role_updated_arr_rel_insert_input",
		id:"uuid",
		permissionsTeamRoleConfigsByTeamRoleId:"permissions_team_role_config_arr_rel_insert_input",
		permissions_shift_configs:"permissions_shift_config_arr_rel_insert_input",
		permissions_team_configs:"permissions_team_config_arr_rel_insert_input",
		permissions_team_role:"permissions_team_role_arr_rel_insert_input",
		permissions_team_role_configs:"permissions_team_role_config_arr_rel_insert_input",
		record_status:"record_status_t",
		role_group:"role_group_t",
		team_role_assignment:"team_role_assignment_arr_rel_insert_input",
		updated_at:"timestamptz"
	},
	team_role_obj_rel_insert_input:{
		data:"team_role_insert_input",
		on_conflict:"team_role_on_conflict"
	},
	team_role_on_conflict:{
		constraint:"team_role_constraint",
		update_columns:"team_role_update_column",
		where:"team_role_bool_exp"
	},
	team_role_order_by:{
		abbreviation:"order_by",
		created_at:"order_by",
		event_team_role_deleted_aggregate:"event_team_role_deleted_aggregate_order_by",
		event_team_role_updated_aggregate:"event_team_role_updated_aggregate_order_by",
		id:"order_by",
		name:"order_by",
		permissionsTeamRoleConfigsByTeamRoleId_aggregate:"permissions_team_role_config_aggregate_order_by",
		permissions_shift_configs_aggregate:"permissions_shift_config_aggregate_order_by",
		permissions_team_configs_aggregate:"permissions_team_config_aggregate_order_by",
		permissions_team_role_aggregate:"permissions_team_role_aggregate_order_by",
		permissions_team_role_configs_aggregate:"permissions_team_role_config_aggregate_order_by",
		read_only:"order_by",
		record_status:"order_by",
		role_group:"order_by",
		team_role_assignment_aggregate:"team_role_assignment_aggregate_order_by",
		updated_at:"order_by"
	},
	team_role_pk_columns_input:{
		id:"uuid"
	},
	team_role_select_column: "enum" as const,
	team_role_set_input:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		role_group:"role_group_t",
		updated_at:"timestamptz"
	},
	team_role_stream_cursor_input:{
		initial_value:"team_role_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	team_role_stream_cursor_value_input:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		role_group:"role_group_t",
		updated_at:"timestamptz"
	},
	team_role_update_column: "enum" as const,
	team_role_updates:{
		_set:"team_role_set_input",
		where:"team_role_bool_exp"
	},
	team_select_column: "enum" as const,
	team_set_input:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		team_settings:"jsonb",
		updated_at:"timestamptz"
	},
	team_stream_cursor_input:{
		initial_value:"team_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	team_stream_cursor_value_input:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		team_settings:"jsonb",
		updated_at:"timestamptz"
	},
	team_update_column: "enum" as const,
	team_updates:{
		_append:"team_append_input",
		_delete_at_path:"team_delete_at_path_input",
		_delete_elem:"team_delete_elem_input",
		_delete_key:"team_delete_key_input",
		_prepend:"team_prepend_input",
		_set:"team_set_input",
		where:"team_bool_exp"
	},
	timestamptz: `scalar.timestamptz` as const,
	timestamptz_comparison_exp:{
		_eq:"timestamptz",
		_gt:"timestamptz",
		_gte:"timestamptz",
		_in:"timestamptz",
		_lt:"timestamptz",
		_lte:"timestamptz",
		_neq:"timestamptz",
		_nin:"timestamptz"
	},
	user:{
		event_shift_updated:{
			distinct_on:"event_shift_updated_select_column",
			order_by:"event_shift_updated_order_by",
			where:"event_shift_updated_bool_exp"
		},
		event_shift_updated_aggregate:{
			distinct_on:"event_shift_updated_select_column",
			order_by:"event_shift_updated_order_by",
			where:"event_shift_updated_bool_exp"
		},
		event_user_role_assignment_created:{
			distinct_on:"event_user_role_assignment_created_select_column",
			order_by:"event_user_role_assignment_created_order_by",
			where:"event_user_role_assignment_created_bool_exp"
		},
		event_user_role_assignment_created_aggregate:{
			distinct_on:"event_user_role_assignment_created_select_column",
			order_by:"event_user_role_assignment_created_order_by",
			where:"event_user_role_assignment_created_bool_exp"
		},
		events:{
			distinct_on:"event_select_column",
			order_by:"event_order_by",
			where:"event_bool_exp"
		},
		events_aggregate:{
			distinct_on:"event_select_column",
			order_by:"event_order_by",
			where:"event_bool_exp"
		},
		events_created_by_user:{
			distinct_on:"event_select_column",
			order_by:"event_order_by",
			where:"event_bool_exp"
		},
		events_created_by_user_aggregate:{
			distinct_on:"event_select_column",
			order_by:"event_order_by",
			where:"event_bool_exp"
		},
		group_membership:{
			distinct_on:"group_membership_select_column",
			order_by:"group_membership_order_by",
			where:"group_membership_bool_exp"
		},
		group_membership_aggregate:{
			distinct_on:"group_membership_select_column",
			order_by:"group_membership_order_by",
			where:"group_membership_bool_exp"
		},
		notes:{
			distinct_on:"note_select_column",
			order_by:"note_order_by",
			where:"note_bool_exp"
		},
		notes_aggregate:{
			distinct_on:"note_select_column",
			order_by:"note_order_by",
			where:"note_bool_exp"
		},
		user_role_assignments:{
			distinct_on:"user_role_assignment_select_column",
			order_by:"user_role_assignment_order_by",
			where:"user_role_assignment_bool_exp"
		},
		user_role_assignments_aggregate:{
			distinct_on:"user_role_assignment_select_column",
			order_by:"user_role_assignment_order_by",
			where:"user_role_assignment_bool_exp"
		}
	},
	user_aggregate_fields:{
		count:{
			columns:"user_select_column"
		}
	},
	user_bool_exp:{
		_and:"user_bool_exp",
		_not:"user_bool_exp",
		_or:"user_bool_exp",
		calendar_id:"uuid_comparison_exp",
		created_at:"timestamptz_comparison_exp",
		display_name:"String_comparison_exp",
		email_address:"String_comparison_exp",
		event_shift_updated:"event_shift_updated_bool_exp",
		event_shift_updated_aggregate:"event_shift_updated_aggregate_bool_exp",
		event_user_role_assignment_created:"event_user_role_assignment_created_bool_exp",
		event_user_role_assignment_created_aggregate:"event_user_role_assignment_created_aggregate_bool_exp",
		events:"event_bool_exp",
		events_aggregate:"event_aggregate_bool_exp",
		events_created_by_user:"event_bool_exp",
		events_created_by_user_aggregate:"event_aggregate_bool_exp",
		external_id:"String_comparison_exp",
		first_name:"String_comparison_exp",
		group_membership:"group_membership_bool_exp",
		group_membership_aggregate:"group_membership_aggregate_bool_exp",
		id:"uuid_comparison_exp",
		last_name:"String_comparison_exp",
		manager_email:"String_comparison_exp",
		notes:"note_bool_exp",
		notes_aggregate:"note_aggregate_bool_exp",
		phone_number:"String_comparison_exp",
		private_calendar_id:"uuid_comparison_exp",
		record_status:"record_status_t_comparison_exp",
		updated_at:"timestamptz_comparison_exp",
		user_name:"String_comparison_exp",
		user_role_assignments:"user_role_assignment_bool_exp",
		user_role_assignments_aggregate:"user_role_assignment_aggregate_bool_exp",
		user_type:"String_comparison_exp"
	},
	user_constraint: "enum" as const,
	user_insert_input:{
		calendar_id:"uuid",
		created_at:"timestamptz",
		event_shift_updated:"event_shift_updated_arr_rel_insert_input",
		event_user_role_assignment_created:"event_user_role_assignment_created_arr_rel_insert_input",
		events:"event_arr_rel_insert_input",
		events_created_by_user:"event_arr_rel_insert_input",
		group_membership:"group_membership_arr_rel_insert_input",
		id:"uuid",
		notes:"note_arr_rel_insert_input",
		record_status:"record_status_t",
		updated_at:"timestamptz",
		user_role_assignments:"user_role_assignment_arr_rel_insert_input"
	},
	user_notification_aggregate_bool_exp:{
		count:"user_notification_aggregate_bool_exp_count"
	},
	user_notification_aggregate_bool_exp_count:{
		arguments:"user_notification_select_column",
		filter:"user_notification_bool_exp",
		predicate:"Int_comparison_exp"
	},
	user_notification_aggregate_fields:{
		count:{
			columns:"user_notification_select_column"
		}
	},
	user_notification_aggregate_order_by:{
		avg:"user_notification_avg_order_by",
		count:"order_by",
		max:"user_notification_max_order_by",
		min:"user_notification_min_order_by",
		stddev:"user_notification_stddev_order_by",
		stddev_pop:"user_notification_stddev_pop_order_by",
		stddev_samp:"user_notification_stddev_samp_order_by",
		sum:"user_notification_sum_order_by",
		var_pop:"user_notification_var_pop_order_by",
		var_samp:"user_notification_var_samp_order_by",
		variance:"user_notification_variance_order_by"
	},
	user_notification_arr_rel_insert_input:{
		data:"user_notification_insert_input",
		on_conflict:"user_notification_on_conflict"
	},
	user_notification_avg_order_by:{
		event_id:"order_by"
	},
	user_notification_bool_exp:{
		_and:"user_notification_bool_exp",
		_not:"user_notification_bool_exp",
		_or:"user_notification_bool_exp",
		created_at:"timestamptz_comparison_exp",
		error_message:"String_comparison_exp",
		event:"event_bool_exp",
		event_id:"Int_comparison_exp",
		id:"uuid_comparison_exp",
		status:"notification_status_t_comparison_exp",
		updated_at:"timestamptz_comparison_exp"
	},
	user_notification_constraint: "enum" as const,
	user_notification_inc_input:{

	},
	user_notification_insert_input:{
		created_at:"timestamptz",
		event:"event_obj_rel_insert_input",
		id:"uuid",
		status:"notification_status_t",
		updated_at:"timestamptz"
	},
	user_notification_max_order_by:{
		created_at:"order_by",
		error_message:"order_by",
		event_id:"order_by",
		id:"order_by",
		status:"order_by",
		updated_at:"order_by"
	},
	user_notification_min_order_by:{
		created_at:"order_by",
		error_message:"order_by",
		event_id:"order_by",
		id:"order_by",
		status:"order_by",
		updated_at:"order_by"
	},
	user_notification_on_conflict:{
		constraint:"user_notification_constraint",
		update_columns:"user_notification_update_column",
		where:"user_notification_bool_exp"
	},
	user_notification_order_by:{
		created_at:"order_by",
		error_message:"order_by",
		event:"event_order_by",
		event_id:"order_by",
		id:"order_by",
		status:"order_by",
		updated_at:"order_by"
	},
	user_notification_pk_columns_input:{
		id:"uuid"
	},
	user_notification_select_column: "enum" as const,
	user_notification_set_input:{
		created_at:"timestamptz",
		id:"uuid",
		status:"notification_status_t",
		updated_at:"timestamptz"
	},
	user_notification_stddev_order_by:{
		event_id:"order_by"
	},
	user_notification_stddev_pop_order_by:{
		event_id:"order_by"
	},
	user_notification_stddev_samp_order_by:{
		event_id:"order_by"
	},
	user_notification_stream_cursor_input:{
		initial_value:"user_notification_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	user_notification_stream_cursor_value_input:{
		created_at:"timestamptz",
		id:"uuid",
		status:"notification_status_t",
		updated_at:"timestamptz"
	},
	user_notification_sum_order_by:{
		event_id:"order_by"
	},
	user_notification_update_column: "enum" as const,
	user_notification_updates:{
		_inc:"user_notification_inc_input",
		_set:"user_notification_set_input",
		where:"user_notification_bool_exp"
	},
	user_notification_var_pop_order_by:{
		event_id:"order_by"
	},
	user_notification_var_samp_order_by:{
		event_id:"order_by"
	},
	user_notification_variance_order_by:{
		event_id:"order_by"
	},
	user_obj_rel_insert_input:{
		data:"user_insert_input",
		on_conflict:"user_on_conflict"
	},
	user_on_conflict:{
		constraint:"user_constraint",
		update_columns:"user_update_column",
		where:"user_bool_exp"
	},
	user_order_by:{
		calendar_id:"order_by",
		created_at:"order_by",
		display_name:"order_by",
		email_address:"order_by",
		event_shift_updated_aggregate:"event_shift_updated_aggregate_order_by",
		event_user_role_assignment_created_aggregate:"event_user_role_assignment_created_aggregate_order_by",
		events_aggregate:"event_aggregate_order_by",
		events_created_by_user_aggregate:"event_aggregate_order_by",
		external_id:"order_by",
		first_name:"order_by",
		group_membership_aggregate:"group_membership_aggregate_order_by",
		id:"order_by",
		last_name:"order_by",
		manager_email:"order_by",
		notes_aggregate:"note_aggregate_order_by",
		phone_number:"order_by",
		private_calendar_id:"order_by",
		record_status:"order_by",
		updated_at:"order_by",
		user_name:"order_by",
		user_role_assignments_aggregate:"user_role_assignment_aggregate_order_by",
		user_type:"order_by"
	},
	user_pk_columns_input:{
		id:"uuid"
	},
	user_role_assignment:{
		event_shift_created:{
			distinct_on:"event_shift_created_select_column",
			order_by:"event_shift_created_order_by",
			where:"event_shift_created_bool_exp"
		},
		event_shift_created_aggregate:{
			distinct_on:"event_shift_created_select_column",
			order_by:"event_shift_created_order_by",
			where:"event_shift_created_bool_exp"
		},
		event_user_role_assignment_created:{
			distinct_on:"event_user_role_assignment_created_select_column",
			order_by:"event_user_role_assignment_created_order_by",
			where:"event_user_role_assignment_created_bool_exp"
		},
		event_user_role_assignment_created_aggregate:{
			distinct_on:"event_user_role_assignment_created_select_column",
			order_by:"event_user_role_assignment_created_order_by",
			where:"event_user_role_assignment_created_bool_exp"
		},
		event_user_role_assignment_deleted:{
			distinct_on:"event_user_role_assignment_deleted_select_column",
			order_by:"event_user_role_assignment_deleted_order_by",
			where:"event_user_role_assignment_deleted_bool_exp"
		},
		event_user_role_assignment_deleted_aggregate:{
			distinct_on:"event_user_role_assignment_deleted_select_column",
			order_by:"event_user_role_assignment_deleted_order_by",
			where:"event_user_role_assignment_deleted_bool_exp"
		},
		event_user_role_assignment_updated:{
			distinct_on:"event_user_role_assignment_updated_select_column",
			order_by:"event_user_role_assignment_updated_order_by",
			where:"event_user_role_assignment_updated_bool_exp"
		},
		event_user_role_assignment_updated_aggregate:{
			distinct_on:"event_user_role_assignment_updated_select_column",
			order_by:"event_user_role_assignment_updated_order_by",
			where:"event_user_role_assignment_updated_bool_exp"
		},
		shifts:{
			distinct_on:"shift_select_column",
			order_by:"shift_order_by",
			where:"shift_bool_exp"
		},
		shifts_aggregate:{
			distinct_on:"shift_select_column",
			order_by:"shift_order_by",
			where:"shift_bool_exp"
		}
	},
	user_role_assignment_aggregate_bool_exp:{
		count:"user_role_assignment_aggregate_bool_exp_count"
	},
	user_role_assignment_aggregate_bool_exp_count:{
		arguments:"user_role_assignment_select_column",
		filter:"user_role_assignment_bool_exp",
		predicate:"Int_comparison_exp"
	},
	user_role_assignment_aggregate_fields:{
		count:{
			columns:"user_role_assignment_select_column"
		}
	},
	user_role_assignment_aggregate_order_by:{
		count:"order_by",
		max:"user_role_assignment_max_order_by",
		min:"user_role_assignment_min_order_by"
	},
	user_role_assignment_arr_rel_insert_input:{
		data:"user_role_assignment_insert_input",
		on_conflict:"user_role_assignment_on_conflict"
	},
	user_role_assignment_bool_exp:{
		_and:"user_role_assignment_bool_exp",
		_not:"user_role_assignment_bool_exp",
		_or:"user_role_assignment_bool_exp",
		created_at:"timestamptz_comparison_exp",
		event_shift_created:"event_shift_created_bool_exp",
		event_shift_created_aggregate:"event_shift_created_aggregate_bool_exp",
		event_user_role_assignment_created:"event_user_role_assignment_created_bool_exp",
		event_user_role_assignment_created_aggregate:"event_user_role_assignment_created_aggregate_bool_exp",
		event_user_role_assignment_deleted:"event_user_role_assignment_deleted_bool_exp",
		event_user_role_assignment_deleted_aggregate:"event_user_role_assignment_deleted_aggregate_bool_exp",
		event_user_role_assignment_updated:"event_user_role_assignment_updated_bool_exp",
		event_user_role_assignment_updated_aggregate:"event_user_role_assignment_updated_aggregate_bool_exp",
		id:"uuid_comparison_exp",
		record_status:"record_status_t_comparison_exp",
		shifts:"shift_bool_exp",
		shifts_aggregate:"shift_aggregate_bool_exp",
		team_role_assignment:"team_role_assignment_bool_exp",
		team_role_assignment_id:"uuid_comparison_exp",
		updated_at:"timestamptz_comparison_exp",
		user:"user_bool_exp",
		user_id:"uuid_comparison_exp"
	},
	user_role_assignment_constraint: "enum" as const,
	user_role_assignment_insert_input:{
		created_at:"timestamptz",
		event_shift_created:"event_shift_created_arr_rel_insert_input",
		event_user_role_assignment_created:"event_user_role_assignment_created_arr_rel_insert_input",
		event_user_role_assignment_deleted:"event_user_role_assignment_deleted_arr_rel_insert_input",
		event_user_role_assignment_updated:"event_user_role_assignment_updated_arr_rel_insert_input",
		id:"uuid",
		record_status:"record_status_t",
		shifts:"shift_arr_rel_insert_input",
		team_role_assignment:"team_role_assignment_obj_rel_insert_input",
		team_role_assignment_id:"uuid",
		updated_at:"timestamptz",
		user:"user_obj_rel_insert_input",
		user_id:"uuid"
	},
	user_role_assignment_max_order_by:{
		created_at:"order_by",
		id:"order_by",
		record_status:"order_by",
		team_role_assignment_id:"order_by",
		updated_at:"order_by",
		user_id:"order_by"
	},
	user_role_assignment_min_order_by:{
		created_at:"order_by",
		id:"order_by",
		record_status:"order_by",
		team_role_assignment_id:"order_by",
		updated_at:"order_by",
		user_id:"order_by"
	},
	user_role_assignment_obj_rel_insert_input:{
		data:"user_role_assignment_insert_input",
		on_conflict:"user_role_assignment_on_conflict"
	},
	user_role_assignment_on_conflict:{
		constraint:"user_role_assignment_constraint",
		update_columns:"user_role_assignment_update_column",
		where:"user_role_assignment_bool_exp"
	},
	user_role_assignment_order_by:{
		created_at:"order_by",
		event_shift_created_aggregate:"event_shift_created_aggregate_order_by",
		event_user_role_assignment_created_aggregate:"event_user_role_assignment_created_aggregate_order_by",
		event_user_role_assignment_deleted_aggregate:"event_user_role_assignment_deleted_aggregate_order_by",
		event_user_role_assignment_updated_aggregate:"event_user_role_assignment_updated_aggregate_order_by",
		id:"order_by",
		record_status:"order_by",
		shifts_aggregate:"shift_aggregate_order_by",
		team_role_assignment:"team_role_assignment_order_by",
		team_role_assignment_id:"order_by",
		updated_at:"order_by",
		user:"user_order_by",
		user_id:"order_by"
	},
	user_role_assignment_pk_columns_input:{
		id:"uuid"
	},
	user_role_assignment_select_column: "enum" as const,
	user_role_assignment_set_input:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		team_role_assignment_id:"uuid",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	user_role_assignment_stream_cursor_input:{
		initial_value:"user_role_assignment_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	user_role_assignment_stream_cursor_value_input:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		team_role_assignment_id:"uuid",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	user_role_assignment_update_column: "enum" as const,
	user_role_assignment_updates:{
		_set:"user_role_assignment_set_input",
		where:"user_role_assignment_bool_exp"
	},
	user_select_column: "enum" as const,
	user_set_input:{
		calendar_id:"uuid",
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		updated_at:"timestamptz"
	},
	user_shift_notification:{
		notification_events:{
			distinct_on:"user_shift_notification_event_select_column",
			order_by:"user_shift_notification_event_order_by",
			where:"user_shift_notification_event_bool_exp"
		},
		notification_events_aggregate:{
			distinct_on:"user_shift_notification_event_select_column",
			order_by:"user_shift_notification_event_order_by",
			where:"user_shift_notification_event_bool_exp"
		}
	},
	user_shift_notification_aggregate_fields:{
		count:{
			columns:"user_shift_notification_select_column"
		}
	},
	user_shift_notification_bool_exp:{
		_and:"user_shift_notification_bool_exp",
		_not:"user_shift_notification_bool_exp",
		_or:"user_shift_notification_bool_exp",
		created_at:"timestamptz_comparison_exp",
		created_by:"uuid_comparison_exp",
		end_time:"timestamptz_comparison_exp",
		id:"uuid_comparison_exp",
		is_recurring:"Boolean_comparison_exp",
		message:"String_comparison_exp",
		notification_events:"user_shift_notification_event_bool_exp",
		notification_events_aggregate:"user_shift_notification_event_aggregate_bool_exp",
		recurrence_end_date:"timestamptz_comparison_exp",
		recurrence_pattern:"String_comparison_exp",
		role_name:"String_comparison_exp",
		shift:"shift_bool_exp",
		shift_id:"uuid_comparison_exp",
		start_time:"timestamptz_comparison_exp",
		status:"notification_status_t_comparison_exp",
		team_name:"String_comparison_exp",
		type:"notification_type_t_comparison_exp",
		updated_at:"timestamptz_comparison_exp",
		user:"user_bool_exp",
		user_created_by:"user_bool_exp",
		user_id:"uuid_comparison_exp"
	},
	user_shift_notification_constraint: "enum" as const,
	user_shift_notification_event_aggregate_bool_exp:{
		count:"user_shift_notification_event_aggregate_bool_exp_count"
	},
	user_shift_notification_event_aggregate_bool_exp_count:{
		arguments:"user_shift_notification_event_select_column",
		filter:"user_shift_notification_event_bool_exp",
		predicate:"Int_comparison_exp"
	},
	user_shift_notification_event_aggregate_fields:{
		count:{
			columns:"user_shift_notification_event_select_column"
		}
	},
	user_shift_notification_event_aggregate_order_by:{
		avg:"user_shift_notification_event_avg_order_by",
		count:"order_by",
		max:"user_shift_notification_event_max_order_by",
		min:"user_shift_notification_event_min_order_by",
		stddev:"user_shift_notification_event_stddev_order_by",
		stddev_pop:"user_shift_notification_event_stddev_pop_order_by",
		stddev_samp:"user_shift_notification_event_stddev_samp_order_by",
		sum:"user_shift_notification_event_sum_order_by",
		var_pop:"user_shift_notification_event_var_pop_order_by",
		var_samp:"user_shift_notification_event_var_samp_order_by",
		variance:"user_shift_notification_event_variance_order_by"
	},
	user_shift_notification_event_arr_rel_insert_input:{
		data:"user_shift_notification_event_insert_input",
		on_conflict:"user_shift_notification_event_on_conflict"
	},
	user_shift_notification_event_avg_order_by:{
		event_id:"order_by"
	},
	user_shift_notification_event_bool_exp:{
		_and:"user_shift_notification_event_bool_exp",
		_not:"user_shift_notification_event_bool_exp",
		_or:"user_shift_notification_event_bool_exp",
		event:"event_bool_exp",
		event_id:"Int_comparison_exp",
		id:"uuid_comparison_exp",
		notification:"user_shift_notification_bool_exp",
		notification_id:"uuid_comparison_exp"
	},
	user_shift_notification_event_constraint: "enum" as const,
	user_shift_notification_event_inc_input:{

	},
	user_shift_notification_event_insert_input:{
		event:"event_obj_rel_insert_input",
		id:"uuid",
		notification:"user_shift_notification_obj_rel_insert_input",
		notification_id:"uuid"
	},
	user_shift_notification_event_max_order_by:{
		event_id:"order_by",
		id:"order_by",
		notification_id:"order_by"
	},
	user_shift_notification_event_min_order_by:{
		event_id:"order_by",
		id:"order_by",
		notification_id:"order_by"
	},
	user_shift_notification_event_on_conflict:{
		constraint:"user_shift_notification_event_constraint",
		update_columns:"user_shift_notification_event_update_column",
		where:"user_shift_notification_event_bool_exp"
	},
	user_shift_notification_event_order_by:{
		event:"event_order_by",
		event_id:"order_by",
		id:"order_by",
		notification:"user_shift_notification_order_by",
		notification_id:"order_by"
	},
	user_shift_notification_event_pk_columns_input:{
		id:"uuid"
	},
	user_shift_notification_event_select_column: "enum" as const,
	user_shift_notification_event_set_input:{
		id:"uuid",
		notification_id:"uuid"
	},
	user_shift_notification_event_stddev_order_by:{
		event_id:"order_by"
	},
	user_shift_notification_event_stddev_pop_order_by:{
		event_id:"order_by"
	},
	user_shift_notification_event_stddev_samp_order_by:{
		event_id:"order_by"
	},
	user_shift_notification_event_stream_cursor_input:{
		initial_value:"user_shift_notification_event_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	user_shift_notification_event_stream_cursor_value_input:{
		id:"uuid",
		notification_id:"uuid"
	},
	user_shift_notification_event_sum_order_by:{
		event_id:"order_by"
	},
	user_shift_notification_event_update_column: "enum" as const,
	user_shift_notification_event_updates:{
		_inc:"user_shift_notification_event_inc_input",
		_set:"user_shift_notification_event_set_input",
		where:"user_shift_notification_event_bool_exp"
	},
	user_shift_notification_event_var_pop_order_by:{
		event_id:"order_by"
	},
	user_shift_notification_event_var_samp_order_by:{
		event_id:"order_by"
	},
	user_shift_notification_event_variance_order_by:{
		event_id:"order_by"
	},
	user_shift_notification_insert_input:{
		created_at:"timestamptz",
		created_by:"uuid",
		end_time:"timestamptz",
		id:"uuid",
		notification_events:"user_shift_notification_event_arr_rel_insert_input",
		recurrence_end_date:"timestamptz",
		shift:"shift_obj_rel_insert_input",
		shift_id:"uuid",
		start_time:"timestamptz",
		status:"notification_status_t",
		type:"notification_type_t",
		updated_at:"timestamptz",
		user:"user_obj_rel_insert_input",
		user_created_by:"user_obj_rel_insert_input",
		user_id:"uuid"
	},
	user_shift_notification_obj_rel_insert_input:{
		data:"user_shift_notification_insert_input",
		on_conflict:"user_shift_notification_on_conflict"
	},
	user_shift_notification_on_conflict:{
		constraint:"user_shift_notification_constraint",
		update_columns:"user_shift_notification_update_column",
		where:"user_shift_notification_bool_exp"
	},
	user_shift_notification_order_by:{
		created_at:"order_by",
		created_by:"order_by",
		end_time:"order_by",
		id:"order_by",
		is_recurring:"order_by",
		message:"order_by",
		notification_events_aggregate:"user_shift_notification_event_aggregate_order_by",
		recurrence_end_date:"order_by",
		recurrence_pattern:"order_by",
		role_name:"order_by",
		shift:"shift_order_by",
		shift_id:"order_by",
		start_time:"order_by",
		status:"order_by",
		team_name:"order_by",
		type:"order_by",
		updated_at:"order_by",
		user:"user_order_by",
		user_created_by:"user_order_by",
		user_id:"order_by"
	},
	user_shift_notification_pk_columns_input:{
		id:"uuid"
	},
	user_shift_notification_select_column: "enum" as const,
	user_shift_notification_set_input:{
		created_at:"timestamptz",
		created_by:"uuid",
		end_time:"timestamptz",
		id:"uuid",
		recurrence_end_date:"timestamptz",
		shift_id:"uuid",
		start_time:"timestamptz",
		status:"notification_status_t",
		type:"notification_type_t",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	user_shift_notification_stream_cursor_input:{
		initial_value:"user_shift_notification_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	user_shift_notification_stream_cursor_value_input:{
		created_at:"timestamptz",
		created_by:"uuid",
		end_time:"timestamptz",
		id:"uuid",
		recurrence_end_date:"timestamptz",
		shift_id:"uuid",
		start_time:"timestamptz",
		status:"notification_status_t",
		type:"notification_type_t",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	user_shift_notification_update_column: "enum" as const,
	user_shift_notification_updates:{
		_set:"user_shift_notification_set_input",
		where:"user_shift_notification_bool_exp"
	},
	user_stream_cursor_input:{
		initial_value:"user_stream_cursor_value_input",
		ordering:"cursor_ordering"
	},
	user_stream_cursor_value_input:{
		calendar_id:"uuid",
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		updated_at:"timestamptz"
	},
	user_update_column: "enum" as const,
	user_updates:{
		_set:"user_set_input",
		where:"user_bool_exp"
	},
	uuid: `scalar.uuid` as const,
	uuid_comparison_exp:{
		_eq:"uuid",
		_gt:"uuid",
		_gte:"uuid",
		_in:"uuid",
		_lt:"uuid",
		_lte:"uuid",
		_neq:"uuid",
		_nin:"uuid"
	}
}

export const ReturnTypes: Record<string,any> = {
	cached:{
		ttl:"Int",
		refresh:"Boolean"
	},
	ClashedShiftsGroup:{
		shifts:"RosterShift"
	},
	FatigueReportShift:{
		endTime:"timestamptz",
		id:"String",
		isDerived:"Boolean",
		isNightShift:"Boolean",
		isRecurring:"Boolean",
		originalShiftId:"String",
		recurrenceEndDate:"timestamptz",
		recurrencePattern:"String",
		rootId:"String",
		startTime:"timestamptz",
		team:"FatigueShiftTeam",
		teamRoleName:"String"
	},
	FatigueShiftTeam:{
		id:"String",
		name:"String"
	},
	FatigueViolation:{
		dateKey:"String",
		report:"FatigueViolationReport"
	},
	FatigueViolationReport:{
		fatigueScore:"Int",
		requiredRestHours:"Int",
		shifts:"FatigueReportShift",
		violated:"Boolean"
	},
	NoteContent:{
		content:"String",
		date:"date",
		metadata:"NoteMetadata"
	},
	NoteMetadata:{
		shift:"NoteShiftMetadata"
	},
	NoteShiftChanges:{
		field:"String",
		from:"String",
		to:"String"
	},
	NoteShiftMetadata:{
		changes:"NoteShiftChanges"
	},
	QueryRosterResponse:{
		data:"TeamRoster",
		message:"String"
	},
	RelatedNote:{
		authorId:"String",
		authorName:"String",
		content:"String",
		createdAt:"timestamptz",
		date:"date",
		id:"String",
		metadata:"NoteMetadata",
		objectId:"String",
		updatedAt:"timestamptz"
	},
	RoleRoster:{
		roleGroup:"String",
		roleId:"String",
		roleName:"String",
		teamRoleAssignmentId:"String",
		users:"RosterUser",
		vacantShifts:"RosterShift"
	},
	RosterShift:{
		createdAt:"timestamptz",
		createdBy:"String",
		endTime:"timestamptz",
		id:"String",
		isDerived:"Boolean",
		isRecurring:"Boolean",
		originalShiftId:"String",
		recordStatus:"String",
		recurrenceEndDate:"timestamptz",
		recurrencePattern:"String",
		relatedNotes:"RelatedNote",
		rootId:"String",
		startTime:"timestamptz",
		status:"String",
		team:"RosterShiftTeam",
		teamRoleName:"String"
	},
	RosterShiftTeam:{
		id:"String",
		name:"String"
	},
	RosterUser:{
		email:"String",
		externalId:"String",
		firstName:"String",
		historic:"Boolean",
		lastName:"String",
		phoneNumber:"String",
		shifts:"RosterShift",
		userId:"String",
		userRoleAssignmentId:"String",
		userType:"String",
		username:"String"
	},
	SendEmailResponse:{
		errorMessage:"String",
		status:"String"
	},
	ShiftEvent:{
		eventCreatedAt:"String",
		eventCreatedBy:"String",
		roleGroup:"String",
		roleName:"String",
		shiftEndTime:"String",
		shiftEvent:"String",
		shiftId:"String",
		shiftIsRecurring:"Boolean",
		shiftNotes:"NoteContent",
		shiftRecurrenceEndDate:"String",
		shiftRecurrencePattern:"String",
		shiftStartTime:"String",
		shiftStatus:"String",
		teamIon:"String",
		teamName:"String",
		teamType:"String",
		userEmail:"String",
		userEmploymentType:"String",
		userFirstName:"String",
		userLastName:"String",
		username:"String"
	},
	ShiftPeriod:{
		end:"Int",
		start:"Int"
	},
	TeamRoster:{
		costObjectDescription:"String",
		dayShiftPeriod:"ShiftPeriod",
		internalOrderNumber:"String",
		roleRosters:"RoleRoster",
		teamId:"String",
		teamName:"String",
		teamRecordStatus:"String",
		teamType:"String"
	},
	UserFatigueViolationReport:{
		consecutiveShiftViolations:"FatigueViolation",
		maxShiftHoursViolations:"FatigueViolation",
		shiftRestGapViolations:"FatigueViolation",
		userId:"String",
		userShifts:"RosterShift"
	},
	UserShiftClashReport:{
		clashedShiftGroups:"ClashedShiftsGroup",
		userId:"String"
	},
	active_shift:{
		id:"uuid",
		shift:"shift",
		shift_id:"uuid",
		shift_type:"shift_type_t"
	},
	active_shift_aggregate:{
		aggregate:"active_shift_aggregate_fields",
		nodes:"active_shift"
	},
	active_shift_aggregate_fields:{
		count:"Int",
		max:"active_shift_max_fields",
		min:"active_shift_min_fields"
	},
	active_shift_max_fields:{
		id:"uuid",
		shift_id:"uuid",
		shift_type:"shift_type_t"
	},
	active_shift_min_fields:{
		id:"uuid",
		shift_id:"uuid",
		shift_type:"shift_type_t"
	},
	active_shift_mutation_response:{
		affected_rows:"Int",
		returning:"active_shift"
	},
	cost_object:{
		description:"String",
		event_cost_object_created:"event_cost_object_created",
		event_cost_object_created_aggregate:"event_cost_object_created_aggregate",
		event_cost_object_deleted:"event_cost_object_deleted",
		event_cost_object_deleted_aggregate:"event_cost_object_deleted_aggregate",
		event_cost_object_reactivated:"event_cost_object_reactivated",
		event_cost_object_reactivated_aggregate:"event_cost_object_reactivated_aggregate",
		event_cost_object_updated:"event_cost_object_updated",
		event_cost_object_updated_aggregate:"event_cost_object_updated_aggregate",
		id:"uuid",
		internal_order_number:"String",
		order_type:"String",
		owner_number:"String",
		record_status:"record_status_t",
		teams:"team",
		teams_aggregate:"team_aggregate"
	},
	cost_object_aggregate:{
		aggregate:"cost_object_aggregate_fields",
		nodes:"cost_object"
	},
	cost_object_aggregate_fields:{
		count:"Int",
		max:"cost_object_max_fields",
		min:"cost_object_min_fields"
	},
	cost_object_max_fields:{
		description:"String",
		id:"uuid",
		internal_order_number:"String",
		order_type:"String",
		owner_number:"String",
		record_status:"record_status_t"
	},
	cost_object_min_fields:{
		description:"String",
		id:"uuid",
		internal_order_number:"String",
		order_type:"String",
		owner_number:"String",
		record_status:"record_status_t"
	},
	cost_object_mutation_response:{
		affected_rows:"Int",
		returning:"cost_object"
	},
	date: `scalar.date` as const,
	event:{
		created_at:"timestamptz",
		created_by:"uuid",
		event_buffered_shift_ended:"event_buffered_shift_ended",
		event_buffered_shift_started:"event_buffered_shift_started",
		event_cost_object_created:"event_cost_object_created",
		event_cost_object_deleted:"event_cost_object_deleted",
		event_cost_object_reactivated:"event_cost_object_reactivated",
		event_cost_object_updated:"event_cost_object_updated",
		event_derived_shift_deleted:"event_derived_shift_deleted",
		event_derived_shift_updated:"event_derived_shift_updated",
		event_note_created:"event_note_created",
		event_note_deleted:"event_note_deleted",
		event_note_updated:"event_note_updated",
		event_recurring_shift_exception_created:"event_recurring_shift_exception_created",
		event_shift_created:"event_shift_created",
		event_shift_deleted:"event_shift_deleted",
		event_shift_ended:"event_shift_ended",
		event_shift_started:"event_shift_started",
		event_shift_updated:"event_shift_updated",
		event_team_created:"event_team_created",
		event_team_deleted:"event_team_deleted",
		event_team_reactivated:"event_team_reactivated",
		event_team_role_assignment_created:"event_team_role_assignment_created",
		event_team_role_assignment_deleted:"event_team_role_assignment_deleted",
		event_team_role_created:"event_team_role_created",
		event_team_role_deleted:"event_team_role_deleted",
		event_team_role_updated:"event_team_role_updated",
		event_team_updated:"event_team_updated",
		event_type:"event_type_t",
		event_user_created:"event_user_created",
		event_user_deleted:"event_user_deleted",
		event_user_role_assignment_created:"event_user_role_assignment_created",
		event_user_role_assignment_deleted:"event_user_role_assignment_deleted",
		event_user_role_assignment_updated:"event_user_role_assignment_updated",
		event_user_updated:"event_user_updated",
		external_id:"String",
		id:"Int",
		new:"jsonb",
		old:"jsonb",
		payload:"jsonb",
		team:"team",
		team_id:"uuid",
		user:"user",
		user_created_by:"user",
		user_id:"uuid",
		user_role_assignment_notifications:"user_notification",
		user_role_assignment_notifications_aggregate:"user_notification_aggregate"
	},
	event_aggregate:{
		aggregate:"event_aggregate_fields",
		nodes:"event"
	},
	event_aggregate_fields:{
		avg:"event_avg_fields",
		count:"Int",
		max:"event_max_fields",
		min:"event_min_fields",
		stddev:"event_stddev_fields",
		stddev_pop:"event_stddev_pop_fields",
		stddev_samp:"event_stddev_samp_fields",
		sum:"event_sum_fields",
		var_pop:"event_var_pop_fields",
		var_samp:"event_var_samp_fields",
		variance:"event_variance_fields"
	},
	event_avg_fields:{
		id:"Float"
	},
	event_buffered_shift_ended:{
		event:"event",
		id:"Int",
		shift:"shift",
		shift_id:"uuid"
	},
	event_buffered_shift_ended_aggregate:{
		aggregate:"event_buffered_shift_ended_aggregate_fields",
		nodes:"event_buffered_shift_ended"
	},
	event_buffered_shift_ended_aggregate_fields:{
		avg:"event_buffered_shift_ended_avg_fields",
		count:"Int",
		max:"event_buffered_shift_ended_max_fields",
		min:"event_buffered_shift_ended_min_fields",
		stddev:"event_buffered_shift_ended_stddev_fields",
		stddev_pop:"event_buffered_shift_ended_stddev_pop_fields",
		stddev_samp:"event_buffered_shift_ended_stddev_samp_fields",
		sum:"event_buffered_shift_ended_sum_fields",
		var_pop:"event_buffered_shift_ended_var_pop_fields",
		var_samp:"event_buffered_shift_ended_var_samp_fields",
		variance:"event_buffered_shift_ended_variance_fields"
	},
	event_buffered_shift_ended_avg_fields:{
		id:"Float"
	},
	event_buffered_shift_ended_max_fields:{
		id:"Int",
		shift_id:"uuid"
	},
	event_buffered_shift_ended_min_fields:{
		id:"Int",
		shift_id:"uuid"
	},
	event_buffered_shift_ended_mutation_response:{
		affected_rows:"Int",
		returning:"event_buffered_shift_ended"
	},
	event_buffered_shift_ended_stddev_fields:{
		id:"Float"
	},
	event_buffered_shift_ended_stddev_pop_fields:{
		id:"Float"
	},
	event_buffered_shift_ended_stddev_samp_fields:{
		id:"Float"
	},
	event_buffered_shift_ended_sum_fields:{
		id:"Int"
	},
	event_buffered_shift_ended_var_pop_fields:{
		id:"Float"
	},
	event_buffered_shift_ended_var_samp_fields:{
		id:"Float"
	},
	event_buffered_shift_ended_variance_fields:{
		id:"Float"
	},
	event_buffered_shift_started:{
		event:"event",
		id:"Int",
		shift:"shift",
		shift_id:"uuid"
	},
	event_buffered_shift_started_aggregate:{
		aggregate:"event_buffered_shift_started_aggregate_fields",
		nodes:"event_buffered_shift_started"
	},
	event_buffered_shift_started_aggregate_fields:{
		avg:"event_buffered_shift_started_avg_fields",
		count:"Int",
		max:"event_buffered_shift_started_max_fields",
		min:"event_buffered_shift_started_min_fields",
		stddev:"event_buffered_shift_started_stddev_fields",
		stddev_pop:"event_buffered_shift_started_stddev_pop_fields",
		stddev_samp:"event_buffered_shift_started_stddev_samp_fields",
		sum:"event_buffered_shift_started_sum_fields",
		var_pop:"event_buffered_shift_started_var_pop_fields",
		var_samp:"event_buffered_shift_started_var_samp_fields",
		variance:"event_buffered_shift_started_variance_fields"
	},
	event_buffered_shift_started_avg_fields:{
		id:"Float"
	},
	event_buffered_shift_started_max_fields:{
		id:"Int",
		shift_id:"uuid"
	},
	event_buffered_shift_started_min_fields:{
		id:"Int",
		shift_id:"uuid"
	},
	event_buffered_shift_started_mutation_response:{
		affected_rows:"Int",
		returning:"event_buffered_shift_started"
	},
	event_buffered_shift_started_stddev_fields:{
		id:"Float"
	},
	event_buffered_shift_started_stddev_pop_fields:{
		id:"Float"
	},
	event_buffered_shift_started_stddev_samp_fields:{
		id:"Float"
	},
	event_buffered_shift_started_sum_fields:{
		id:"Int"
	},
	event_buffered_shift_started_var_pop_fields:{
		id:"Float"
	},
	event_buffered_shift_started_var_samp_fields:{
		id:"Float"
	},
	event_buffered_shift_started_variance_fields:{
		id:"Float"
	},
	event_cost_object_created:{
		cost_object:"cost_object",
		cost_object_id:"uuid",
		description:"String",
		event:"event",
		id:"Int",
		internal_order_number:"String",
		order_type:"String",
		owner_number:"String",
		record_status:"record_status_t"
	},
	event_cost_object_created_aggregate:{
		aggregate:"event_cost_object_created_aggregate_fields",
		nodes:"event_cost_object_created"
	},
	event_cost_object_created_aggregate_fields:{
		avg:"event_cost_object_created_avg_fields",
		count:"Int",
		max:"event_cost_object_created_max_fields",
		min:"event_cost_object_created_min_fields",
		stddev:"event_cost_object_created_stddev_fields",
		stddev_pop:"event_cost_object_created_stddev_pop_fields",
		stddev_samp:"event_cost_object_created_stddev_samp_fields",
		sum:"event_cost_object_created_sum_fields",
		var_pop:"event_cost_object_created_var_pop_fields",
		var_samp:"event_cost_object_created_var_samp_fields",
		variance:"event_cost_object_created_variance_fields"
	},
	event_cost_object_created_avg_fields:{
		id:"Float"
	},
	event_cost_object_created_max_fields:{
		cost_object_id:"uuid",
		description:"String",
		id:"Int",
		internal_order_number:"String",
		order_type:"String",
		owner_number:"String",
		record_status:"record_status_t"
	},
	event_cost_object_created_min_fields:{
		cost_object_id:"uuid",
		description:"String",
		id:"Int",
		internal_order_number:"String",
		order_type:"String",
		owner_number:"String",
		record_status:"record_status_t"
	},
	event_cost_object_created_mutation_response:{
		affected_rows:"Int",
		returning:"event_cost_object_created"
	},
	event_cost_object_created_stddev_fields:{
		id:"Float"
	},
	event_cost_object_created_stddev_pop_fields:{
		id:"Float"
	},
	event_cost_object_created_stddev_samp_fields:{
		id:"Float"
	},
	event_cost_object_created_sum_fields:{
		id:"Int"
	},
	event_cost_object_created_var_pop_fields:{
		id:"Float"
	},
	event_cost_object_created_var_samp_fields:{
		id:"Float"
	},
	event_cost_object_created_variance_fields:{
		id:"Float"
	},
	event_cost_object_deleted:{
		cost_object:"cost_object",
		cost_object_id:"uuid",
		event:"event",
		id:"Int"
	},
	event_cost_object_deleted_aggregate:{
		aggregate:"event_cost_object_deleted_aggregate_fields",
		nodes:"event_cost_object_deleted"
	},
	event_cost_object_deleted_aggregate_fields:{
		avg:"event_cost_object_deleted_avg_fields",
		count:"Int",
		max:"event_cost_object_deleted_max_fields",
		min:"event_cost_object_deleted_min_fields",
		stddev:"event_cost_object_deleted_stddev_fields",
		stddev_pop:"event_cost_object_deleted_stddev_pop_fields",
		stddev_samp:"event_cost_object_deleted_stddev_samp_fields",
		sum:"event_cost_object_deleted_sum_fields",
		var_pop:"event_cost_object_deleted_var_pop_fields",
		var_samp:"event_cost_object_deleted_var_samp_fields",
		variance:"event_cost_object_deleted_variance_fields"
	},
	event_cost_object_deleted_avg_fields:{
		id:"Float"
	},
	event_cost_object_deleted_max_fields:{
		cost_object_id:"uuid",
		id:"Int"
	},
	event_cost_object_deleted_min_fields:{
		cost_object_id:"uuid",
		id:"Int"
	},
	event_cost_object_deleted_mutation_response:{
		affected_rows:"Int",
		returning:"event_cost_object_deleted"
	},
	event_cost_object_deleted_stddev_fields:{
		id:"Float"
	},
	event_cost_object_deleted_stddev_pop_fields:{
		id:"Float"
	},
	event_cost_object_deleted_stddev_samp_fields:{
		id:"Float"
	},
	event_cost_object_deleted_sum_fields:{
		id:"Int"
	},
	event_cost_object_deleted_var_pop_fields:{
		id:"Float"
	},
	event_cost_object_deleted_var_samp_fields:{
		id:"Float"
	},
	event_cost_object_deleted_variance_fields:{
		id:"Float"
	},
	event_cost_object_reactivated:{
		cost_object:"cost_object",
		cost_object_id:"uuid",
		event:"event",
		id:"Int"
	},
	event_cost_object_reactivated_aggregate:{
		aggregate:"event_cost_object_reactivated_aggregate_fields",
		nodes:"event_cost_object_reactivated"
	},
	event_cost_object_reactivated_aggregate_fields:{
		avg:"event_cost_object_reactivated_avg_fields",
		count:"Int",
		max:"event_cost_object_reactivated_max_fields",
		min:"event_cost_object_reactivated_min_fields",
		stddev:"event_cost_object_reactivated_stddev_fields",
		stddev_pop:"event_cost_object_reactivated_stddev_pop_fields",
		stddev_samp:"event_cost_object_reactivated_stddev_samp_fields",
		sum:"event_cost_object_reactivated_sum_fields",
		var_pop:"event_cost_object_reactivated_var_pop_fields",
		var_samp:"event_cost_object_reactivated_var_samp_fields",
		variance:"event_cost_object_reactivated_variance_fields"
	},
	event_cost_object_reactivated_avg_fields:{
		id:"Float"
	},
	event_cost_object_reactivated_max_fields:{
		cost_object_id:"uuid",
		id:"Int"
	},
	event_cost_object_reactivated_min_fields:{
		cost_object_id:"uuid",
		id:"Int"
	},
	event_cost_object_reactivated_mutation_response:{
		affected_rows:"Int",
		returning:"event_cost_object_reactivated"
	},
	event_cost_object_reactivated_stddev_fields:{
		id:"Float"
	},
	event_cost_object_reactivated_stddev_pop_fields:{
		id:"Float"
	},
	event_cost_object_reactivated_stddev_samp_fields:{
		id:"Float"
	},
	event_cost_object_reactivated_sum_fields:{
		id:"Int"
	},
	event_cost_object_reactivated_var_pop_fields:{
		id:"Float"
	},
	event_cost_object_reactivated_var_samp_fields:{
		id:"Float"
	},
	event_cost_object_reactivated_variance_fields:{
		id:"Float"
	},
	event_cost_object_updated:{
		cost_object:"cost_object",
		cost_object_id:"uuid",
		description:"String",
		event:"event",
		id:"Int",
		order_type:"String",
		owner_number:"String"
	},
	event_cost_object_updated_aggregate:{
		aggregate:"event_cost_object_updated_aggregate_fields",
		nodes:"event_cost_object_updated"
	},
	event_cost_object_updated_aggregate_fields:{
		avg:"event_cost_object_updated_avg_fields",
		count:"Int",
		max:"event_cost_object_updated_max_fields",
		min:"event_cost_object_updated_min_fields",
		stddev:"event_cost_object_updated_stddev_fields",
		stddev_pop:"event_cost_object_updated_stddev_pop_fields",
		stddev_samp:"event_cost_object_updated_stddev_samp_fields",
		sum:"event_cost_object_updated_sum_fields",
		var_pop:"event_cost_object_updated_var_pop_fields",
		var_samp:"event_cost_object_updated_var_samp_fields",
		variance:"event_cost_object_updated_variance_fields"
	},
	event_cost_object_updated_avg_fields:{
		id:"Float"
	},
	event_cost_object_updated_max_fields:{
		cost_object_id:"uuid",
		description:"String",
		id:"Int",
		order_type:"String",
		owner_number:"String"
	},
	event_cost_object_updated_min_fields:{
		cost_object_id:"uuid",
		description:"String",
		id:"Int",
		order_type:"String",
		owner_number:"String"
	},
	event_cost_object_updated_mutation_response:{
		affected_rows:"Int",
		returning:"event_cost_object_updated"
	},
	event_cost_object_updated_stddev_fields:{
		id:"Float"
	},
	event_cost_object_updated_stddev_pop_fields:{
		id:"Float"
	},
	event_cost_object_updated_stddev_samp_fields:{
		id:"Float"
	},
	event_cost_object_updated_sum_fields:{
		id:"Int"
	},
	event_cost_object_updated_var_pop_fields:{
		id:"Float"
	},
	event_cost_object_updated_var_samp_fields:{
		id:"Float"
	},
	event_cost_object_updated_variance_fields:{
		id:"Float"
	},
	event_derived_shift_deleted:{
		event:"event",
		exception_date:"timestamptz",
		id:"Int",
		recurring_shift_exception_id:"uuid",
		recurring_shift_id:"uuid",
		shift:"shift"
	},
	event_derived_shift_deleted_aggregate:{
		aggregate:"event_derived_shift_deleted_aggregate_fields",
		nodes:"event_derived_shift_deleted"
	},
	event_derived_shift_deleted_aggregate_fields:{
		avg:"event_derived_shift_deleted_avg_fields",
		count:"Int",
		max:"event_derived_shift_deleted_max_fields",
		min:"event_derived_shift_deleted_min_fields",
		stddev:"event_derived_shift_deleted_stddev_fields",
		stddev_pop:"event_derived_shift_deleted_stddev_pop_fields",
		stddev_samp:"event_derived_shift_deleted_stddev_samp_fields",
		sum:"event_derived_shift_deleted_sum_fields",
		var_pop:"event_derived_shift_deleted_var_pop_fields",
		var_samp:"event_derived_shift_deleted_var_samp_fields",
		variance:"event_derived_shift_deleted_variance_fields"
	},
	event_derived_shift_deleted_avg_fields:{
		id:"Float"
	},
	event_derived_shift_deleted_max_fields:{
		exception_date:"timestamptz",
		id:"Int",
		recurring_shift_exception_id:"uuid",
		recurring_shift_id:"uuid"
	},
	event_derived_shift_deleted_min_fields:{
		exception_date:"timestamptz",
		id:"Int",
		recurring_shift_exception_id:"uuid",
		recurring_shift_id:"uuid"
	},
	event_derived_shift_deleted_mutation_response:{
		affected_rows:"Int",
		returning:"event_derived_shift_deleted"
	},
	event_derived_shift_deleted_stddev_fields:{
		id:"Float"
	},
	event_derived_shift_deleted_stddev_pop_fields:{
		id:"Float"
	},
	event_derived_shift_deleted_stddev_samp_fields:{
		id:"Float"
	},
	event_derived_shift_deleted_sum_fields:{
		id:"Int"
	},
	event_derived_shift_deleted_var_pop_fields:{
		id:"Float"
	},
	event_derived_shift_deleted_var_samp_fields:{
		id:"Float"
	},
	event_derived_shift_deleted_variance_fields:{
		id:"Float"
	},
	event_derived_shift_updated:{
		end_time:"timestamptz",
		event:"event",
		exception_date:"timestamptz",
		id:"Int",
		note:"jsonb",
		recurring_shift:"shift",
		recurring_shift_exception_id:"uuid",
		recurring_shift_id:"uuid",
		shift:"shift",
		shift_id:"uuid",
		shift_status:"String",
		start_time:"timestamptz",
		team_role_assignment:"team_role_assignment",
		team_role_assignment_id:"uuid",
		user:"user",
		user_id:"uuid",
		user_role_assignment:"user_role_assignment",
		user_role_assignment_id:"uuid"
	},
	event_derived_shift_updated_aggregate:{
		aggregate:"event_derived_shift_updated_aggregate_fields",
		nodes:"event_derived_shift_updated"
	},
	event_derived_shift_updated_aggregate_fields:{
		avg:"event_derived_shift_updated_avg_fields",
		count:"Int",
		max:"event_derived_shift_updated_max_fields",
		min:"event_derived_shift_updated_min_fields",
		stddev:"event_derived_shift_updated_stddev_fields",
		stddev_pop:"event_derived_shift_updated_stddev_pop_fields",
		stddev_samp:"event_derived_shift_updated_stddev_samp_fields",
		sum:"event_derived_shift_updated_sum_fields",
		var_pop:"event_derived_shift_updated_var_pop_fields",
		var_samp:"event_derived_shift_updated_var_samp_fields",
		variance:"event_derived_shift_updated_variance_fields"
	},
	event_derived_shift_updated_avg_fields:{
		id:"Float"
	},
	event_derived_shift_updated_max_fields:{
		end_time:"timestamptz",
		exception_date:"timestamptz",
		id:"Int",
		recurring_shift_exception_id:"uuid",
		recurring_shift_id:"uuid",
		shift_id:"uuid",
		shift_status:"String",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_derived_shift_updated_min_fields:{
		end_time:"timestamptz",
		exception_date:"timestamptz",
		id:"Int",
		recurring_shift_exception_id:"uuid",
		recurring_shift_id:"uuid",
		shift_id:"uuid",
		shift_status:"String",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_derived_shift_updated_mutation_response:{
		affected_rows:"Int",
		returning:"event_derived_shift_updated"
	},
	event_derived_shift_updated_stddev_fields:{
		id:"Float"
	},
	event_derived_shift_updated_stddev_pop_fields:{
		id:"Float"
	},
	event_derived_shift_updated_stddev_samp_fields:{
		id:"Float"
	},
	event_derived_shift_updated_sum_fields:{
		id:"Int"
	},
	event_derived_shift_updated_var_pop_fields:{
		id:"Float"
	},
	event_derived_shift_updated_var_samp_fields:{
		id:"Float"
	},
	event_derived_shift_updated_variance_fields:{
		id:"Float"
	},
	event_max_fields:{
		created_at:"timestamptz",
		created_by:"uuid",
		event_type:"event_type_t",
		external_id:"String",
		id:"Int",
		team_id:"uuid",
		user_id:"uuid"
	},
	event_min_fields:{
		created_at:"timestamptz",
		created_by:"uuid",
		event_type:"event_type_t",
		external_id:"String",
		id:"Int",
		team_id:"uuid",
		user_id:"uuid"
	},
	event_mutation_response:{
		affected_rows:"Int",
		returning:"event"
	},
	event_note_created:{
		content:"jsonb",
		event:"event",
		event_shift_created:"event_shift_created",
		id:"Int",
		note:"note",
		note_id:"uuid",
		object_id:"uuid",
		related_event_id:"Int"
	},
	event_note_created_aggregate:{
		aggregate:"event_note_created_aggregate_fields",
		nodes:"event_note_created"
	},
	event_note_created_aggregate_fields:{
		avg:"event_note_created_avg_fields",
		count:"Int",
		max:"event_note_created_max_fields",
		min:"event_note_created_min_fields",
		stddev:"event_note_created_stddev_fields",
		stddev_pop:"event_note_created_stddev_pop_fields",
		stddev_samp:"event_note_created_stddev_samp_fields",
		sum:"event_note_created_sum_fields",
		var_pop:"event_note_created_var_pop_fields",
		var_samp:"event_note_created_var_samp_fields",
		variance:"event_note_created_variance_fields"
	},
	event_note_created_avg_fields:{
		id:"Float",
		related_event_id:"Float"
	},
	event_note_created_max_fields:{
		id:"Int",
		note_id:"uuid",
		object_id:"uuid",
		related_event_id:"Int"
	},
	event_note_created_min_fields:{
		id:"Int",
		note_id:"uuid",
		object_id:"uuid",
		related_event_id:"Int"
	},
	event_note_created_mutation_response:{
		affected_rows:"Int",
		returning:"event_note_created"
	},
	event_note_created_stddev_fields:{
		id:"Float",
		related_event_id:"Float"
	},
	event_note_created_stddev_pop_fields:{
		id:"Float",
		related_event_id:"Float"
	},
	event_note_created_stddev_samp_fields:{
		id:"Float",
		related_event_id:"Float"
	},
	event_note_created_sum_fields:{
		id:"Int",
		related_event_id:"Int"
	},
	event_note_created_var_pop_fields:{
		id:"Float",
		related_event_id:"Float"
	},
	event_note_created_var_samp_fields:{
		id:"Float",
		related_event_id:"Float"
	},
	event_note_created_variance_fields:{
		id:"Float",
		related_event_id:"Float"
	},
	event_note_deleted:{
		event:"event",
		id:"Int",
		note:"note",
		note_id:"uuid"
	},
	event_note_deleted_aggregate:{
		aggregate:"event_note_deleted_aggregate_fields",
		nodes:"event_note_deleted"
	},
	event_note_deleted_aggregate_fields:{
		avg:"event_note_deleted_avg_fields",
		count:"Int",
		max:"event_note_deleted_max_fields",
		min:"event_note_deleted_min_fields",
		stddev:"event_note_deleted_stddev_fields",
		stddev_pop:"event_note_deleted_stddev_pop_fields",
		stddev_samp:"event_note_deleted_stddev_samp_fields",
		sum:"event_note_deleted_sum_fields",
		var_pop:"event_note_deleted_var_pop_fields",
		var_samp:"event_note_deleted_var_samp_fields",
		variance:"event_note_deleted_variance_fields"
	},
	event_note_deleted_avg_fields:{
		id:"Float"
	},
	event_note_deleted_max_fields:{
		id:"Int",
		note_id:"uuid"
	},
	event_note_deleted_min_fields:{
		id:"Int",
		note_id:"uuid"
	},
	event_note_deleted_mutation_response:{
		affected_rows:"Int",
		returning:"event_note_deleted"
	},
	event_note_deleted_stddev_fields:{
		id:"Float"
	},
	event_note_deleted_stddev_pop_fields:{
		id:"Float"
	},
	event_note_deleted_stddev_samp_fields:{
		id:"Float"
	},
	event_note_deleted_sum_fields:{
		id:"Int"
	},
	event_note_deleted_var_pop_fields:{
		id:"Float"
	},
	event_note_deleted_var_samp_fields:{
		id:"Float"
	},
	event_note_deleted_variance_fields:{
		id:"Float"
	},
	event_note_updated:{
		content:"jsonb",
		event:"event",
		id:"Int",
		note:"note",
		note_id:"uuid"
	},
	event_note_updated_aggregate:{
		aggregate:"event_note_updated_aggregate_fields",
		nodes:"event_note_updated"
	},
	event_note_updated_aggregate_fields:{
		avg:"event_note_updated_avg_fields",
		count:"Int",
		max:"event_note_updated_max_fields",
		min:"event_note_updated_min_fields",
		stddev:"event_note_updated_stddev_fields",
		stddev_pop:"event_note_updated_stddev_pop_fields",
		stddev_samp:"event_note_updated_stddev_samp_fields",
		sum:"event_note_updated_sum_fields",
		var_pop:"event_note_updated_var_pop_fields",
		var_samp:"event_note_updated_var_samp_fields",
		variance:"event_note_updated_variance_fields"
	},
	event_note_updated_avg_fields:{
		id:"Float"
	},
	event_note_updated_max_fields:{
		id:"Int",
		note_id:"uuid"
	},
	event_note_updated_min_fields:{
		id:"Int",
		note_id:"uuid"
	},
	event_note_updated_mutation_response:{
		affected_rows:"Int",
		returning:"event_note_updated"
	},
	event_note_updated_stddev_fields:{
		id:"Float"
	},
	event_note_updated_stddev_pop_fields:{
		id:"Float"
	},
	event_note_updated_stddev_samp_fields:{
		id:"Float"
	},
	event_note_updated_sum_fields:{
		id:"Int"
	},
	event_note_updated_var_pop_fields:{
		id:"Float"
	},
	event_note_updated_var_samp_fields:{
		id:"Float"
	},
	event_note_updated_variance_fields:{
		id:"Float"
	},
	event_recurring_shift_exception_created:{
		event:"event",
		exception_date:"timestamptz",
		id:"Int",
		recurring_shift_exception_id:"uuid",
		shift:"shift",
		shift_id:"uuid"
	},
	event_recurring_shift_exception_created_aggregate:{
		aggregate:"event_recurring_shift_exception_created_aggregate_fields",
		nodes:"event_recurring_shift_exception_created"
	},
	event_recurring_shift_exception_created_aggregate_fields:{
		avg:"event_recurring_shift_exception_created_avg_fields",
		count:"Int",
		max:"event_recurring_shift_exception_created_max_fields",
		min:"event_recurring_shift_exception_created_min_fields",
		stddev:"event_recurring_shift_exception_created_stddev_fields",
		stddev_pop:"event_recurring_shift_exception_created_stddev_pop_fields",
		stddev_samp:"event_recurring_shift_exception_created_stddev_samp_fields",
		sum:"event_recurring_shift_exception_created_sum_fields",
		var_pop:"event_recurring_shift_exception_created_var_pop_fields",
		var_samp:"event_recurring_shift_exception_created_var_samp_fields",
		variance:"event_recurring_shift_exception_created_variance_fields"
	},
	event_recurring_shift_exception_created_avg_fields:{
		id:"Float"
	},
	event_recurring_shift_exception_created_max_fields:{
		exception_date:"timestamptz",
		id:"Int",
		recurring_shift_exception_id:"uuid",
		shift_id:"uuid"
	},
	event_recurring_shift_exception_created_min_fields:{
		exception_date:"timestamptz",
		id:"Int",
		recurring_shift_exception_id:"uuid",
		shift_id:"uuid"
	},
	event_recurring_shift_exception_created_mutation_response:{
		affected_rows:"Int",
		returning:"event_recurring_shift_exception_created"
	},
	event_recurring_shift_exception_created_stddev_fields:{
		id:"Float"
	},
	event_recurring_shift_exception_created_stddev_pop_fields:{
		id:"Float"
	},
	event_recurring_shift_exception_created_stddev_samp_fields:{
		id:"Float"
	},
	event_recurring_shift_exception_created_sum_fields:{
		id:"Int"
	},
	event_recurring_shift_exception_created_var_pop_fields:{
		id:"Float"
	},
	event_recurring_shift_exception_created_var_samp_fields:{
		id:"Float"
	},
	event_recurring_shift_exception_created_variance_fields:{
		id:"Float"
	},
	event_shift_created:{
		end_time:"timestamptz",
		event:"event",
		id:"Int",
		is_recurring:"Boolean",
		note:"jsonb",
		recurrence_end_date:"timestamptz",
		recurrence_pattern:"String",
		root_id:"uuid",
		shift:"shift",
		shift_id:"uuid",
		shift_status:"String",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user:"user",
		user_id:"uuid",
		user_role_assignment:"user_role_assignment",
		user_role_assignment_id:"uuid"
	},
	event_shift_created_aggregate:{
		aggregate:"event_shift_created_aggregate_fields",
		nodes:"event_shift_created"
	},
	event_shift_created_aggregate_fields:{
		avg:"event_shift_created_avg_fields",
		count:"Int",
		max:"event_shift_created_max_fields",
		min:"event_shift_created_min_fields",
		stddev:"event_shift_created_stddev_fields",
		stddev_pop:"event_shift_created_stddev_pop_fields",
		stddev_samp:"event_shift_created_stddev_samp_fields",
		sum:"event_shift_created_sum_fields",
		var_pop:"event_shift_created_var_pop_fields",
		var_samp:"event_shift_created_var_samp_fields",
		variance:"event_shift_created_variance_fields"
	},
	event_shift_created_avg_fields:{
		id:"Float"
	},
	event_shift_created_max_fields:{
		end_time:"timestamptz",
		id:"Int",
		recurrence_end_date:"timestamptz",
		recurrence_pattern:"String",
		root_id:"uuid",
		shift_id:"uuid",
		shift_status:"String",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_shift_created_min_fields:{
		end_time:"timestamptz",
		id:"Int",
		recurrence_end_date:"timestamptz",
		recurrence_pattern:"String",
		root_id:"uuid",
		shift_id:"uuid",
		shift_status:"String",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_shift_created_mutation_response:{
		affected_rows:"Int",
		returning:"event_shift_created"
	},
	event_shift_created_stddev_fields:{
		id:"Float"
	},
	event_shift_created_stddev_pop_fields:{
		id:"Float"
	},
	event_shift_created_stddev_samp_fields:{
		id:"Float"
	},
	event_shift_created_sum_fields:{
		id:"Int"
	},
	event_shift_created_var_pop_fields:{
		id:"Float"
	},
	event_shift_created_var_samp_fields:{
		id:"Float"
	},
	event_shift_created_variance_fields:{
		id:"Float"
	},
	event_shift_deleted:{
		event:"event",
		id:"Int",
		shift:"shift",
		shift_id:"uuid"
	},
	event_shift_deleted_aggregate:{
		aggregate:"event_shift_deleted_aggregate_fields",
		nodes:"event_shift_deleted"
	},
	event_shift_deleted_aggregate_fields:{
		avg:"event_shift_deleted_avg_fields",
		count:"Int",
		max:"event_shift_deleted_max_fields",
		min:"event_shift_deleted_min_fields",
		stddev:"event_shift_deleted_stddev_fields",
		stddev_pop:"event_shift_deleted_stddev_pop_fields",
		stddev_samp:"event_shift_deleted_stddev_samp_fields",
		sum:"event_shift_deleted_sum_fields",
		var_pop:"event_shift_deleted_var_pop_fields",
		var_samp:"event_shift_deleted_var_samp_fields",
		variance:"event_shift_deleted_variance_fields"
	},
	event_shift_deleted_avg_fields:{
		id:"Float"
	},
	event_shift_deleted_max_fields:{
		id:"Int",
		shift_id:"uuid"
	},
	event_shift_deleted_min_fields:{
		id:"Int",
		shift_id:"uuid"
	},
	event_shift_deleted_mutation_response:{
		affected_rows:"Int",
		returning:"event_shift_deleted"
	},
	event_shift_deleted_stddev_fields:{
		id:"Float"
	},
	event_shift_deleted_stddev_pop_fields:{
		id:"Float"
	},
	event_shift_deleted_stddev_samp_fields:{
		id:"Float"
	},
	event_shift_deleted_sum_fields:{
		id:"Int"
	},
	event_shift_deleted_var_pop_fields:{
		id:"Float"
	},
	event_shift_deleted_var_samp_fields:{
		id:"Float"
	},
	event_shift_deleted_variance_fields:{
		id:"Float"
	},
	event_shift_ended:{
		event:"event",
		id:"Int",
		shift:"shift",
		shift_id:"uuid"
	},
	event_shift_ended_aggregate:{
		aggregate:"event_shift_ended_aggregate_fields",
		nodes:"event_shift_ended"
	},
	event_shift_ended_aggregate_fields:{
		avg:"event_shift_ended_avg_fields",
		count:"Int",
		max:"event_shift_ended_max_fields",
		min:"event_shift_ended_min_fields",
		stddev:"event_shift_ended_stddev_fields",
		stddev_pop:"event_shift_ended_stddev_pop_fields",
		stddev_samp:"event_shift_ended_stddev_samp_fields",
		sum:"event_shift_ended_sum_fields",
		var_pop:"event_shift_ended_var_pop_fields",
		var_samp:"event_shift_ended_var_samp_fields",
		variance:"event_shift_ended_variance_fields"
	},
	event_shift_ended_avg_fields:{
		id:"Float"
	},
	event_shift_ended_max_fields:{
		id:"Int",
		shift_id:"uuid"
	},
	event_shift_ended_min_fields:{
		id:"Int",
		shift_id:"uuid"
	},
	event_shift_ended_mutation_response:{
		affected_rows:"Int",
		returning:"event_shift_ended"
	},
	event_shift_ended_stddev_fields:{
		id:"Float"
	},
	event_shift_ended_stddev_pop_fields:{
		id:"Float"
	},
	event_shift_ended_stddev_samp_fields:{
		id:"Float"
	},
	event_shift_ended_sum_fields:{
		id:"Int"
	},
	event_shift_ended_var_pop_fields:{
		id:"Float"
	},
	event_shift_ended_var_samp_fields:{
		id:"Float"
	},
	event_shift_ended_variance_fields:{
		id:"Float"
	},
	event_shift_started:{
		event:"event",
		id:"Int",
		shift:"shift",
		shift_id:"uuid"
	},
	event_shift_started_aggregate:{
		aggregate:"event_shift_started_aggregate_fields",
		nodes:"event_shift_started"
	},
	event_shift_started_aggregate_fields:{
		avg:"event_shift_started_avg_fields",
		count:"Int",
		max:"event_shift_started_max_fields",
		min:"event_shift_started_min_fields",
		stddev:"event_shift_started_stddev_fields",
		stddev_pop:"event_shift_started_stddev_pop_fields",
		stddev_samp:"event_shift_started_stddev_samp_fields",
		sum:"event_shift_started_sum_fields",
		var_pop:"event_shift_started_var_pop_fields",
		var_samp:"event_shift_started_var_samp_fields",
		variance:"event_shift_started_variance_fields"
	},
	event_shift_started_avg_fields:{
		id:"Float"
	},
	event_shift_started_max_fields:{
		id:"Int",
		shift_id:"uuid"
	},
	event_shift_started_min_fields:{
		id:"Int",
		shift_id:"uuid"
	},
	event_shift_started_mutation_response:{
		affected_rows:"Int",
		returning:"event_shift_started"
	},
	event_shift_started_stddev_fields:{
		id:"Float"
	},
	event_shift_started_stddev_pop_fields:{
		id:"Float"
	},
	event_shift_started_stddev_samp_fields:{
		id:"Float"
	},
	event_shift_started_sum_fields:{
		id:"Int"
	},
	event_shift_started_var_pop_fields:{
		id:"Float"
	},
	event_shift_started_var_samp_fields:{
		id:"Float"
	},
	event_shift_started_variance_fields:{
		id:"Float"
	},
	event_shift_updated:{
		end_time:"timestamptz",
		event:"event",
		id:"Int",
		is_recurring:"Boolean",
		note:"jsonb",
		recurrence_end_date:"timestamptz",
		recurrence_pattern:"String",
		shift:"shift",
		shift_id:"uuid",
		shift_status:"String",
		start_time:"timestamptz",
		team_role_assignment:"team_role_assignment",
		team_role_assignment_id:"uuid",
		user:"user",
		user_id:"uuid"
	},
	event_shift_updated_aggregate:{
		aggregate:"event_shift_updated_aggregate_fields",
		nodes:"event_shift_updated"
	},
	event_shift_updated_aggregate_fields:{
		avg:"event_shift_updated_avg_fields",
		count:"Int",
		max:"event_shift_updated_max_fields",
		min:"event_shift_updated_min_fields",
		stddev:"event_shift_updated_stddev_fields",
		stddev_pop:"event_shift_updated_stddev_pop_fields",
		stddev_samp:"event_shift_updated_stddev_samp_fields",
		sum:"event_shift_updated_sum_fields",
		var_pop:"event_shift_updated_var_pop_fields",
		var_samp:"event_shift_updated_var_samp_fields",
		variance:"event_shift_updated_variance_fields"
	},
	event_shift_updated_avg_fields:{
		id:"Float"
	},
	event_shift_updated_max_fields:{
		end_time:"timestamptz",
		id:"Int",
		recurrence_end_date:"timestamptz",
		recurrence_pattern:"String",
		shift_id:"uuid",
		shift_status:"String",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user_id:"uuid"
	},
	event_shift_updated_min_fields:{
		end_time:"timestamptz",
		id:"Int",
		recurrence_end_date:"timestamptz",
		recurrence_pattern:"String",
		shift_id:"uuid",
		shift_status:"String",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		user_id:"uuid"
	},
	event_shift_updated_mutation_response:{
		affected_rows:"Int",
		returning:"event_shift_updated"
	},
	event_shift_updated_stddev_fields:{
		id:"Float"
	},
	event_shift_updated_stddev_pop_fields:{
		id:"Float"
	},
	event_shift_updated_stddev_samp_fields:{
		id:"Float"
	},
	event_shift_updated_sum_fields:{
		id:"Int"
	},
	event_shift_updated_var_pop_fields:{
		id:"Float"
	},
	event_shift_updated_var_samp_fields:{
		id:"Float"
	},
	event_shift_updated_variance_fields:{
		id:"Float"
	},
	event_stddev_fields:{
		id:"Float"
	},
	event_stddev_pop_fields:{
		id:"Float"
	},
	event_stddev_samp_fields:{
		id:"Float"
	},
	event_sum_fields:{
		id:"Int"
	},
	event_team_created:{
		cost_object_description:"String",
		event:"event",
		id:"Int",
		internal_order_number:"String",
		name:"String",
		team_id:"uuid",
		team_role_assignments:"event_team_role_assignment_created",
		team_role_assignments_aggregate:"event_team_role_assignment_created_aggregate",
		team_settings:"jsonb",
		team_type:"String"
	},
	event_team_created_aggregate:{
		aggregate:"event_team_created_aggregate_fields",
		nodes:"event_team_created"
	},
	event_team_created_aggregate_fields:{
		avg:"event_team_created_avg_fields",
		count:"Int",
		max:"event_team_created_max_fields",
		min:"event_team_created_min_fields",
		stddev:"event_team_created_stddev_fields",
		stddev_pop:"event_team_created_stddev_pop_fields",
		stddev_samp:"event_team_created_stddev_samp_fields",
		sum:"event_team_created_sum_fields",
		var_pop:"event_team_created_var_pop_fields",
		var_samp:"event_team_created_var_samp_fields",
		variance:"event_team_created_variance_fields"
	},
	event_team_created_avg_fields:{
		id:"Float"
	},
	event_team_created_max_fields:{
		cost_object_description:"String",
		id:"Int",
		internal_order_number:"String",
		name:"String",
		team_id:"uuid",
		team_type:"String"
	},
	event_team_created_min_fields:{
		cost_object_description:"String",
		id:"Int",
		internal_order_number:"String",
		name:"String",
		team_id:"uuid",
		team_type:"String"
	},
	event_team_created_mutation_response:{
		affected_rows:"Int",
		returning:"event_team_created"
	},
	event_team_created_stddev_fields:{
		id:"Float"
	},
	event_team_created_stddev_pop_fields:{
		id:"Float"
	},
	event_team_created_stddev_samp_fields:{
		id:"Float"
	},
	event_team_created_sum_fields:{
		id:"Int"
	},
	event_team_created_var_pop_fields:{
		id:"Float"
	},
	event_team_created_var_samp_fields:{
		id:"Float"
	},
	event_team_created_variance_fields:{
		id:"Float"
	},
	event_team_deleted:{
		event:"event",
		id:"Int",
		reason:"String",
		team:"team",
		team_id:"uuid"
	},
	event_team_deleted_aggregate:{
		aggregate:"event_team_deleted_aggregate_fields",
		nodes:"event_team_deleted"
	},
	event_team_deleted_aggregate_fields:{
		avg:"event_team_deleted_avg_fields",
		count:"Int",
		max:"event_team_deleted_max_fields",
		min:"event_team_deleted_min_fields",
		stddev:"event_team_deleted_stddev_fields",
		stddev_pop:"event_team_deleted_stddev_pop_fields",
		stddev_samp:"event_team_deleted_stddev_samp_fields",
		sum:"event_team_deleted_sum_fields",
		var_pop:"event_team_deleted_var_pop_fields",
		var_samp:"event_team_deleted_var_samp_fields",
		variance:"event_team_deleted_variance_fields"
	},
	event_team_deleted_avg_fields:{
		id:"Float"
	},
	event_team_deleted_max_fields:{
		id:"Int",
		reason:"String",
		team_id:"uuid"
	},
	event_team_deleted_min_fields:{
		id:"Int",
		reason:"String",
		team_id:"uuid"
	},
	event_team_deleted_mutation_response:{
		affected_rows:"Int",
		returning:"event_team_deleted"
	},
	event_team_deleted_stddev_fields:{
		id:"Float"
	},
	event_team_deleted_stddev_pop_fields:{
		id:"Float"
	},
	event_team_deleted_stddev_samp_fields:{
		id:"Float"
	},
	event_team_deleted_sum_fields:{
		id:"Int"
	},
	event_team_deleted_var_pop_fields:{
		id:"Float"
	},
	event_team_deleted_var_samp_fields:{
		id:"Float"
	},
	event_team_deleted_variance_fields:{
		id:"Float"
	},
	event_team_reactivated:{
		event:"event",
		id:"Int",
		reason:"String",
		team:"team",
		team_id:"uuid"
	},
	event_team_reactivated_aggregate:{
		aggregate:"event_team_reactivated_aggregate_fields",
		nodes:"event_team_reactivated"
	},
	event_team_reactivated_aggregate_fields:{
		avg:"event_team_reactivated_avg_fields",
		count:"Int",
		max:"event_team_reactivated_max_fields",
		min:"event_team_reactivated_min_fields",
		stddev:"event_team_reactivated_stddev_fields",
		stddev_pop:"event_team_reactivated_stddev_pop_fields",
		stddev_samp:"event_team_reactivated_stddev_samp_fields",
		sum:"event_team_reactivated_sum_fields",
		var_pop:"event_team_reactivated_var_pop_fields",
		var_samp:"event_team_reactivated_var_samp_fields",
		variance:"event_team_reactivated_variance_fields"
	},
	event_team_reactivated_avg_fields:{
		id:"Float"
	},
	event_team_reactivated_max_fields:{
		id:"Int",
		reason:"String",
		team_id:"uuid"
	},
	event_team_reactivated_min_fields:{
		id:"Int",
		reason:"String",
		team_id:"uuid"
	},
	event_team_reactivated_mutation_response:{
		affected_rows:"Int",
		returning:"event_team_reactivated"
	},
	event_team_reactivated_stddev_fields:{
		id:"Float"
	},
	event_team_reactivated_stddev_pop_fields:{
		id:"Float"
	},
	event_team_reactivated_stddev_samp_fields:{
		id:"Float"
	},
	event_team_reactivated_sum_fields:{
		id:"Int"
	},
	event_team_reactivated_var_pop_fields:{
		id:"Float"
	},
	event_team_reactivated_var_samp_fields:{
		id:"Float"
	},
	event_team_reactivated_variance_fields:{
		id:"Float"
	},
	event_team_role_assignment_created:{
		event:"event",
		id:"Int",
		role:"team_role",
		team:"team",
		team_aggregate:"team_aggregate",
		team_id:"uuid",
		team_role_assignment:"team_role_assignment",
		team_role_assignment_id:"uuid",
		team_role_id:"uuid"
	},
	event_team_role_assignment_created_aggregate:{
		aggregate:"event_team_role_assignment_created_aggregate_fields",
		nodes:"event_team_role_assignment_created"
	},
	event_team_role_assignment_created_aggregate_fields:{
		avg:"event_team_role_assignment_created_avg_fields",
		count:"Int",
		max:"event_team_role_assignment_created_max_fields",
		min:"event_team_role_assignment_created_min_fields",
		stddev:"event_team_role_assignment_created_stddev_fields",
		stddev_pop:"event_team_role_assignment_created_stddev_pop_fields",
		stddev_samp:"event_team_role_assignment_created_stddev_samp_fields",
		sum:"event_team_role_assignment_created_sum_fields",
		var_pop:"event_team_role_assignment_created_var_pop_fields",
		var_samp:"event_team_role_assignment_created_var_samp_fields",
		variance:"event_team_role_assignment_created_variance_fields"
	},
	event_team_role_assignment_created_avg_fields:{
		id:"Float"
	},
	event_team_role_assignment_created_max_fields:{
		id:"Int",
		team_id:"uuid",
		team_role_assignment_id:"uuid",
		team_role_id:"uuid"
	},
	event_team_role_assignment_created_min_fields:{
		id:"Int",
		team_id:"uuid",
		team_role_assignment_id:"uuid",
		team_role_id:"uuid"
	},
	event_team_role_assignment_created_mutation_response:{
		affected_rows:"Int",
		returning:"event_team_role_assignment_created"
	},
	event_team_role_assignment_created_stddev_fields:{
		id:"Float"
	},
	event_team_role_assignment_created_stddev_pop_fields:{
		id:"Float"
	},
	event_team_role_assignment_created_stddev_samp_fields:{
		id:"Float"
	},
	event_team_role_assignment_created_sum_fields:{
		id:"Int"
	},
	event_team_role_assignment_created_var_pop_fields:{
		id:"Float"
	},
	event_team_role_assignment_created_var_samp_fields:{
		id:"Float"
	},
	event_team_role_assignment_created_variance_fields:{
		id:"Float"
	},
	event_team_role_assignment_deleted:{
		event:"event",
		id:"Int",
		team_role_assignment:"team_role_assignment",
		team_role_assignment_id:"uuid"
	},
	event_team_role_assignment_deleted_aggregate:{
		aggregate:"event_team_role_assignment_deleted_aggregate_fields",
		nodes:"event_team_role_assignment_deleted"
	},
	event_team_role_assignment_deleted_aggregate_fields:{
		avg:"event_team_role_assignment_deleted_avg_fields",
		count:"Int",
		max:"event_team_role_assignment_deleted_max_fields",
		min:"event_team_role_assignment_deleted_min_fields",
		stddev:"event_team_role_assignment_deleted_stddev_fields",
		stddev_pop:"event_team_role_assignment_deleted_stddev_pop_fields",
		stddev_samp:"event_team_role_assignment_deleted_stddev_samp_fields",
		sum:"event_team_role_assignment_deleted_sum_fields",
		var_pop:"event_team_role_assignment_deleted_var_pop_fields",
		var_samp:"event_team_role_assignment_deleted_var_samp_fields",
		variance:"event_team_role_assignment_deleted_variance_fields"
	},
	event_team_role_assignment_deleted_avg_fields:{
		id:"Float"
	},
	event_team_role_assignment_deleted_max_fields:{
		id:"Int",
		team_role_assignment_id:"uuid"
	},
	event_team_role_assignment_deleted_min_fields:{
		id:"Int",
		team_role_assignment_id:"uuid"
	},
	event_team_role_assignment_deleted_mutation_response:{
		affected_rows:"Int",
		returning:"event_team_role_assignment_deleted"
	},
	event_team_role_assignment_deleted_stddev_fields:{
		id:"Float"
	},
	event_team_role_assignment_deleted_stddev_pop_fields:{
		id:"Float"
	},
	event_team_role_assignment_deleted_stddev_samp_fields:{
		id:"Float"
	},
	event_team_role_assignment_deleted_sum_fields:{
		id:"Int"
	},
	event_team_role_assignment_deleted_var_pop_fields:{
		id:"Float"
	},
	event_team_role_assignment_deleted_var_samp_fields:{
		id:"Float"
	},
	event_team_role_assignment_deleted_variance_fields:{
		id:"Float"
	},
	event_team_role_created:{
		abbreviation:"String",
		event:"event",
		id:"Int",
		name:"String",
		read_only:"Boolean",
		role_group:"role_group_t",
		team_role_id:"uuid"
	},
	event_team_role_created_aggregate:{
		aggregate:"event_team_role_created_aggregate_fields",
		nodes:"event_team_role_created"
	},
	event_team_role_created_aggregate_fields:{
		avg:"event_team_role_created_avg_fields",
		count:"Int",
		max:"event_team_role_created_max_fields",
		min:"event_team_role_created_min_fields",
		stddev:"event_team_role_created_stddev_fields",
		stddev_pop:"event_team_role_created_stddev_pop_fields",
		stddev_samp:"event_team_role_created_stddev_samp_fields",
		sum:"event_team_role_created_sum_fields",
		var_pop:"event_team_role_created_var_pop_fields",
		var_samp:"event_team_role_created_var_samp_fields",
		variance:"event_team_role_created_variance_fields"
	},
	event_team_role_created_avg_fields:{
		id:"Float"
	},
	event_team_role_created_max_fields:{
		abbreviation:"String",
		id:"Int",
		name:"String",
		role_group:"role_group_t",
		team_role_id:"uuid"
	},
	event_team_role_created_min_fields:{
		abbreviation:"String",
		id:"Int",
		name:"String",
		role_group:"role_group_t",
		team_role_id:"uuid"
	},
	event_team_role_created_mutation_response:{
		affected_rows:"Int",
		returning:"event_team_role_created"
	},
	event_team_role_created_stddev_fields:{
		id:"Float"
	},
	event_team_role_created_stddev_pop_fields:{
		id:"Float"
	},
	event_team_role_created_stddev_samp_fields:{
		id:"Float"
	},
	event_team_role_created_sum_fields:{
		id:"Int"
	},
	event_team_role_created_var_pop_fields:{
		id:"Float"
	},
	event_team_role_created_var_samp_fields:{
		id:"Float"
	},
	event_team_role_created_variance_fields:{
		id:"Float"
	},
	event_team_role_deleted:{
		event:"event",
		id:"Int",
		team_role:"team_role",
		team_role_id:"uuid"
	},
	event_team_role_deleted_aggregate:{
		aggregate:"event_team_role_deleted_aggregate_fields",
		nodes:"event_team_role_deleted"
	},
	event_team_role_deleted_aggregate_fields:{
		avg:"event_team_role_deleted_avg_fields",
		count:"Int",
		max:"event_team_role_deleted_max_fields",
		min:"event_team_role_deleted_min_fields",
		stddev:"event_team_role_deleted_stddev_fields",
		stddev_pop:"event_team_role_deleted_stddev_pop_fields",
		stddev_samp:"event_team_role_deleted_stddev_samp_fields",
		sum:"event_team_role_deleted_sum_fields",
		var_pop:"event_team_role_deleted_var_pop_fields",
		var_samp:"event_team_role_deleted_var_samp_fields",
		variance:"event_team_role_deleted_variance_fields"
	},
	event_team_role_deleted_avg_fields:{
		id:"Float"
	},
	event_team_role_deleted_max_fields:{
		id:"Int",
		team_role_id:"uuid"
	},
	event_team_role_deleted_min_fields:{
		id:"Int",
		team_role_id:"uuid"
	},
	event_team_role_deleted_mutation_response:{
		affected_rows:"Int",
		returning:"event_team_role_deleted"
	},
	event_team_role_deleted_stddev_fields:{
		id:"Float"
	},
	event_team_role_deleted_stddev_pop_fields:{
		id:"Float"
	},
	event_team_role_deleted_stddev_samp_fields:{
		id:"Float"
	},
	event_team_role_deleted_sum_fields:{
		id:"Int"
	},
	event_team_role_deleted_var_pop_fields:{
		id:"Float"
	},
	event_team_role_deleted_var_samp_fields:{
		id:"Float"
	},
	event_team_role_deleted_variance_fields:{
		id:"Float"
	},
	event_team_role_updated:{
		abbreviation:"String",
		event:"event",
		id:"Int",
		name:"String",
		read_only:"Boolean",
		record_status:"record_status_t",
		role_group:"role_group_t",
		team_role:"team_role",
		team_role_id:"uuid"
	},
	event_team_role_updated_aggregate:{
		aggregate:"event_team_role_updated_aggregate_fields",
		nodes:"event_team_role_updated"
	},
	event_team_role_updated_aggregate_fields:{
		avg:"event_team_role_updated_avg_fields",
		count:"Int",
		max:"event_team_role_updated_max_fields",
		min:"event_team_role_updated_min_fields",
		stddev:"event_team_role_updated_stddev_fields",
		stddev_pop:"event_team_role_updated_stddev_pop_fields",
		stddev_samp:"event_team_role_updated_stddev_samp_fields",
		sum:"event_team_role_updated_sum_fields",
		var_pop:"event_team_role_updated_var_pop_fields",
		var_samp:"event_team_role_updated_var_samp_fields",
		variance:"event_team_role_updated_variance_fields"
	},
	event_team_role_updated_avg_fields:{
		id:"Float"
	},
	event_team_role_updated_max_fields:{
		abbreviation:"String",
		id:"Int",
		name:"String",
		record_status:"record_status_t",
		role_group:"role_group_t",
		team_role_id:"uuid"
	},
	event_team_role_updated_min_fields:{
		abbreviation:"String",
		id:"Int",
		name:"String",
		record_status:"record_status_t",
		role_group:"role_group_t",
		team_role_id:"uuid"
	},
	event_team_role_updated_mutation_response:{
		affected_rows:"Int",
		returning:"event_team_role_updated"
	},
	event_team_role_updated_stddev_fields:{
		id:"Float"
	},
	event_team_role_updated_stddev_pop_fields:{
		id:"Float"
	},
	event_team_role_updated_stddev_samp_fields:{
		id:"Float"
	},
	event_team_role_updated_sum_fields:{
		id:"Int"
	},
	event_team_role_updated_var_pop_fields:{
		id:"Float"
	},
	event_team_role_updated_var_samp_fields:{
		id:"Float"
	},
	event_team_role_updated_variance_fields:{
		id:"Float"
	},
	event_team_updated:{
		cost_object_description:"String",
		event:"event",
		id:"Int",
		internal_order_number:"String",
		name:"String",
		team:"team",
		team_id:"uuid",
		team_settings:"jsonb",
		team_type:"String"
	},
	event_team_updated_aggregate:{
		aggregate:"event_team_updated_aggregate_fields",
		nodes:"event_team_updated"
	},
	event_team_updated_aggregate_fields:{
		avg:"event_team_updated_avg_fields",
		count:"Int",
		max:"event_team_updated_max_fields",
		min:"event_team_updated_min_fields",
		stddev:"event_team_updated_stddev_fields",
		stddev_pop:"event_team_updated_stddev_pop_fields",
		stddev_samp:"event_team_updated_stddev_samp_fields",
		sum:"event_team_updated_sum_fields",
		var_pop:"event_team_updated_var_pop_fields",
		var_samp:"event_team_updated_var_samp_fields",
		variance:"event_team_updated_variance_fields"
	},
	event_team_updated_avg_fields:{
		id:"Float"
	},
	event_team_updated_max_fields:{
		cost_object_description:"String",
		id:"Int",
		internal_order_number:"String",
		name:"String",
		team_id:"uuid",
		team_type:"String"
	},
	event_team_updated_min_fields:{
		cost_object_description:"String",
		id:"Int",
		internal_order_number:"String",
		name:"String",
		team_id:"uuid",
		team_type:"String"
	},
	event_team_updated_mutation_response:{
		affected_rows:"Int",
		returning:"event_team_updated"
	},
	event_team_updated_stddev_fields:{
		id:"Float"
	},
	event_team_updated_stddev_pop_fields:{
		id:"Float"
	},
	event_team_updated_stddev_samp_fields:{
		id:"Float"
	},
	event_team_updated_sum_fields:{
		id:"Int"
	},
	event_team_updated_var_pop_fields:{
		id:"Float"
	},
	event_team_updated_var_samp_fields:{
		id:"Float"
	},
	event_team_updated_variance_fields:{
		id:"Float"
	},
	event_type_t: `scalar.event_type_t` as const,
	event_user_created:{
		display_name:"String",
		email_address:"String",
		event:"event",
		external_id:"String",
		first_name:"String",
		id:"Int",
		last_name:"String",
		manager_email:"String",
		phone_number:"String",
		user_id:"uuid",
		user_name:"String",
		user_type:"String"
	},
	event_user_created_aggregate:{
		aggregate:"event_user_created_aggregate_fields",
		nodes:"event_user_created"
	},
	event_user_created_aggregate_fields:{
		avg:"event_user_created_avg_fields",
		count:"Int",
		max:"event_user_created_max_fields",
		min:"event_user_created_min_fields",
		stddev:"event_user_created_stddev_fields",
		stddev_pop:"event_user_created_stddev_pop_fields",
		stddev_samp:"event_user_created_stddev_samp_fields",
		sum:"event_user_created_sum_fields",
		var_pop:"event_user_created_var_pop_fields",
		var_samp:"event_user_created_var_samp_fields",
		variance:"event_user_created_variance_fields"
	},
	event_user_created_avg_fields:{
		id:"Float"
	},
	event_user_created_max_fields:{
		display_name:"String",
		email_address:"String",
		external_id:"String",
		first_name:"String",
		id:"Int",
		last_name:"String",
		manager_email:"String",
		phone_number:"String",
		user_id:"uuid",
		user_name:"String",
		user_type:"String"
	},
	event_user_created_min_fields:{
		display_name:"String",
		email_address:"String",
		external_id:"String",
		first_name:"String",
		id:"Int",
		last_name:"String",
		manager_email:"String",
		phone_number:"String",
		user_id:"uuid",
		user_name:"String",
		user_type:"String"
	},
	event_user_created_mutation_response:{
		affected_rows:"Int",
		returning:"event_user_created"
	},
	event_user_created_stddev_fields:{
		id:"Float"
	},
	event_user_created_stddev_pop_fields:{
		id:"Float"
	},
	event_user_created_stddev_samp_fields:{
		id:"Float"
	},
	event_user_created_sum_fields:{
		id:"Int"
	},
	event_user_created_var_pop_fields:{
		id:"Float"
	},
	event_user_created_var_samp_fields:{
		id:"Float"
	},
	event_user_created_variance_fields:{
		id:"Float"
	},
	event_user_deleted:{
		event:"event",
		id:"Int",
		user_id:"uuid"
	},
	event_user_deleted_aggregate:{
		aggregate:"event_user_deleted_aggregate_fields",
		nodes:"event_user_deleted"
	},
	event_user_deleted_aggregate_fields:{
		avg:"event_user_deleted_avg_fields",
		count:"Int",
		max:"event_user_deleted_max_fields",
		min:"event_user_deleted_min_fields",
		stddev:"event_user_deleted_stddev_fields",
		stddev_pop:"event_user_deleted_stddev_pop_fields",
		stddev_samp:"event_user_deleted_stddev_samp_fields",
		sum:"event_user_deleted_sum_fields",
		var_pop:"event_user_deleted_var_pop_fields",
		var_samp:"event_user_deleted_var_samp_fields",
		variance:"event_user_deleted_variance_fields"
	},
	event_user_deleted_avg_fields:{
		id:"Float"
	},
	event_user_deleted_max_fields:{
		id:"Int",
		user_id:"uuid"
	},
	event_user_deleted_min_fields:{
		id:"Int",
		user_id:"uuid"
	},
	event_user_deleted_mutation_response:{
		affected_rows:"Int",
		returning:"event_user_deleted"
	},
	event_user_deleted_stddev_fields:{
		id:"Float"
	},
	event_user_deleted_stddev_pop_fields:{
		id:"Float"
	},
	event_user_deleted_stddev_samp_fields:{
		id:"Float"
	},
	event_user_deleted_sum_fields:{
		id:"Int"
	},
	event_user_deleted_var_pop_fields:{
		id:"Float"
	},
	event_user_deleted_var_samp_fields:{
		id:"Float"
	},
	event_user_deleted_variance_fields:{
		id:"Float"
	},
	event_user_role_assignment_created:{
		event:"event",
		event_team_role_assignment_created:"team_role_assignment",
		id:"Int",
		team_role_assignment_id:"uuid",
		user:"user",
		user_id:"uuid",
		user_role_assignment:"user_role_assignment",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_created_aggregate:{
		aggregate:"event_user_role_assignment_created_aggregate_fields",
		nodes:"event_user_role_assignment_created"
	},
	event_user_role_assignment_created_aggregate_fields:{
		avg:"event_user_role_assignment_created_avg_fields",
		count:"Int",
		max:"event_user_role_assignment_created_max_fields",
		min:"event_user_role_assignment_created_min_fields",
		stddev:"event_user_role_assignment_created_stddev_fields",
		stddev_pop:"event_user_role_assignment_created_stddev_pop_fields",
		stddev_samp:"event_user_role_assignment_created_stddev_samp_fields",
		sum:"event_user_role_assignment_created_sum_fields",
		var_pop:"event_user_role_assignment_created_var_pop_fields",
		var_samp:"event_user_role_assignment_created_var_samp_fields",
		variance:"event_user_role_assignment_created_variance_fields"
	},
	event_user_role_assignment_created_avg_fields:{
		id:"Float"
	},
	event_user_role_assignment_created_max_fields:{
		id:"Int",
		team_role_assignment_id:"uuid",
		user_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_created_min_fields:{
		id:"Int",
		team_role_assignment_id:"uuid",
		user_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_created_mutation_response:{
		affected_rows:"Int",
		returning:"event_user_role_assignment_created"
	},
	event_user_role_assignment_created_stddev_fields:{
		id:"Float"
	},
	event_user_role_assignment_created_stddev_pop_fields:{
		id:"Float"
	},
	event_user_role_assignment_created_stddev_samp_fields:{
		id:"Float"
	},
	event_user_role_assignment_created_sum_fields:{
		id:"Int"
	},
	event_user_role_assignment_created_var_pop_fields:{
		id:"Float"
	},
	event_user_role_assignment_created_var_samp_fields:{
		id:"Float"
	},
	event_user_role_assignment_created_variance_fields:{
		id:"Float"
	},
	event_user_role_assignment_deleted:{
		event:"event",
		id:"Int",
		user_role_assignment:"user_role_assignment",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_deleted_aggregate:{
		aggregate:"event_user_role_assignment_deleted_aggregate_fields",
		nodes:"event_user_role_assignment_deleted"
	},
	event_user_role_assignment_deleted_aggregate_fields:{
		avg:"event_user_role_assignment_deleted_avg_fields",
		count:"Int",
		max:"event_user_role_assignment_deleted_max_fields",
		min:"event_user_role_assignment_deleted_min_fields",
		stddev:"event_user_role_assignment_deleted_stddev_fields",
		stddev_pop:"event_user_role_assignment_deleted_stddev_pop_fields",
		stddev_samp:"event_user_role_assignment_deleted_stddev_samp_fields",
		sum:"event_user_role_assignment_deleted_sum_fields",
		var_pop:"event_user_role_assignment_deleted_var_pop_fields",
		var_samp:"event_user_role_assignment_deleted_var_samp_fields",
		variance:"event_user_role_assignment_deleted_variance_fields"
	},
	event_user_role_assignment_deleted_avg_fields:{
		id:"Float"
	},
	event_user_role_assignment_deleted_max_fields:{
		id:"Int",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_deleted_min_fields:{
		id:"Int",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_deleted_mutation_response:{
		affected_rows:"Int",
		returning:"event_user_role_assignment_deleted"
	},
	event_user_role_assignment_deleted_stddev_fields:{
		id:"Float"
	},
	event_user_role_assignment_deleted_stddev_pop_fields:{
		id:"Float"
	},
	event_user_role_assignment_deleted_stddev_samp_fields:{
		id:"Float"
	},
	event_user_role_assignment_deleted_sum_fields:{
		id:"Int"
	},
	event_user_role_assignment_deleted_var_pop_fields:{
		id:"Float"
	},
	event_user_role_assignment_deleted_var_samp_fields:{
		id:"Float"
	},
	event_user_role_assignment_deleted_variance_fields:{
		id:"Float"
	},
	event_user_role_assignment_updated:{
		event:"event",
		id:"Int",
		team_role_assignment:"team_role_assignment",
		team_role_assignment_id:"uuid",
		user_role_assignment:"user_role_assignment",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_updated_aggregate:{
		aggregate:"event_user_role_assignment_updated_aggregate_fields",
		nodes:"event_user_role_assignment_updated"
	},
	event_user_role_assignment_updated_aggregate_fields:{
		avg:"event_user_role_assignment_updated_avg_fields",
		count:"Int",
		max:"event_user_role_assignment_updated_max_fields",
		min:"event_user_role_assignment_updated_min_fields",
		stddev:"event_user_role_assignment_updated_stddev_fields",
		stddev_pop:"event_user_role_assignment_updated_stddev_pop_fields",
		stddev_samp:"event_user_role_assignment_updated_stddev_samp_fields",
		sum:"event_user_role_assignment_updated_sum_fields",
		var_pop:"event_user_role_assignment_updated_var_pop_fields",
		var_samp:"event_user_role_assignment_updated_var_samp_fields",
		variance:"event_user_role_assignment_updated_variance_fields"
	},
	event_user_role_assignment_updated_avg_fields:{
		id:"Float"
	},
	event_user_role_assignment_updated_max_fields:{
		id:"Int",
		team_role_assignment_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_updated_min_fields:{
		id:"Int",
		team_role_assignment_id:"uuid",
		user_role_assignment_id:"uuid"
	},
	event_user_role_assignment_updated_mutation_response:{
		affected_rows:"Int",
		returning:"event_user_role_assignment_updated"
	},
	event_user_role_assignment_updated_stddev_fields:{
		id:"Float"
	},
	event_user_role_assignment_updated_stddev_pop_fields:{
		id:"Float"
	},
	event_user_role_assignment_updated_stddev_samp_fields:{
		id:"Float"
	},
	event_user_role_assignment_updated_sum_fields:{
		id:"Int"
	},
	event_user_role_assignment_updated_var_pop_fields:{
		id:"Float"
	},
	event_user_role_assignment_updated_var_samp_fields:{
		id:"Float"
	},
	event_user_role_assignment_updated_variance_fields:{
		id:"Float"
	},
	event_user_updated:{
		display_name:"String",
		email_address:"String",
		event:"event",
		external_id:"String",
		first_name:"String",
		id:"Int",
		last_name:"String",
		manager_email:"String",
		phone_number:"String",
		user_id:"uuid",
		user_name:"String",
		user_type:"String"
	},
	event_user_updated_aggregate:{
		aggregate:"event_user_updated_aggregate_fields",
		nodes:"event_user_updated"
	},
	event_user_updated_aggregate_fields:{
		avg:"event_user_updated_avg_fields",
		count:"Int",
		max:"event_user_updated_max_fields",
		min:"event_user_updated_min_fields",
		stddev:"event_user_updated_stddev_fields",
		stddev_pop:"event_user_updated_stddev_pop_fields",
		stddev_samp:"event_user_updated_stddev_samp_fields",
		sum:"event_user_updated_sum_fields",
		var_pop:"event_user_updated_var_pop_fields",
		var_samp:"event_user_updated_var_samp_fields",
		variance:"event_user_updated_variance_fields"
	},
	event_user_updated_avg_fields:{
		id:"Float"
	},
	event_user_updated_max_fields:{
		display_name:"String",
		email_address:"String",
		external_id:"String",
		first_name:"String",
		id:"Int",
		last_name:"String",
		manager_email:"String",
		phone_number:"String",
		user_id:"uuid",
		user_name:"String",
		user_type:"String"
	},
	event_user_updated_min_fields:{
		display_name:"String",
		email_address:"String",
		external_id:"String",
		first_name:"String",
		id:"Int",
		last_name:"String",
		manager_email:"String",
		phone_number:"String",
		user_id:"uuid",
		user_name:"String",
		user_type:"String"
	},
	event_user_updated_mutation_response:{
		affected_rows:"Int",
		returning:"event_user_updated"
	},
	event_user_updated_stddev_fields:{
		id:"Float"
	},
	event_user_updated_stddev_pop_fields:{
		id:"Float"
	},
	event_user_updated_stddev_samp_fields:{
		id:"Float"
	},
	event_user_updated_sum_fields:{
		id:"Int"
	},
	event_user_updated_var_pop_fields:{
		id:"Float"
	},
	event_user_updated_var_samp_fields:{
		id:"Float"
	},
	event_user_updated_variance_fields:{
		id:"Float"
	},
	event_var_pop_fields:{
		id:"Float"
	},
	event_var_samp_fields:{
		id:"Float"
	},
	event_variance_fields:{
		id:"Float"
	},
	group:{
		created_at:"timestamptz",
		display_name:"String",
		group_membership:"group_membership",
		group_membership_aggregate:"group_membership_aggregate",
		id:"uuid",
		qualification:"qualification",
		qualifications:"qualification",
		qualifications_aggregate:"qualification_aggregate",
		record_status:"record_status_t",
		updated_at:"timestamptz"
	},
	group_aggregate:{
		aggregate:"group_aggregate_fields",
		nodes:"group"
	},
	group_aggregate_fields:{
		count:"Int",
		max:"group_max_fields",
		min:"group_min_fields"
	},
	group_max_fields:{
		created_at:"timestamptz",
		display_name:"String",
		id:"uuid",
		record_status:"record_status_t",
		updated_at:"timestamptz"
	},
	group_membership:{
		created_at:"timestamptz",
		group:"group",
		group_id:"uuid",
		id:"uuid",
		updated_at:"timestamptz",
		user:"user",
		user_id:"uuid"
	},
	group_membership_aggregate:{
		aggregate:"group_membership_aggregate_fields",
		nodes:"group_membership"
	},
	group_membership_aggregate_fields:{
		count:"Int",
		max:"group_membership_max_fields",
		min:"group_membership_min_fields"
	},
	group_membership_max_fields:{
		created_at:"timestamptz",
		group_id:"uuid",
		id:"uuid",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	group_membership_min_fields:{
		created_at:"timestamptz",
		group_id:"uuid",
		id:"uuid",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	group_membership_mutation_response:{
		affected_rows:"Int",
		returning:"group_membership"
	},
	group_min_fields:{
		created_at:"timestamptz",
		display_name:"String",
		id:"uuid",
		record_status:"record_status_t",
		updated_at:"timestamptz"
	},
	group_mutation_response:{
		affected_rows:"Int",
		returning:"group"
	},
	jsonb: `scalar.jsonb` as const,
	mutation_root:{
		delete_active_shift:"active_shift_mutation_response",
		delete_active_shift_by_pk:"active_shift",
		delete_cost_object:"cost_object_mutation_response",
		delete_cost_object_by_pk:"cost_object",
		delete_event:"event_mutation_response",
		delete_event_buffered_shift_ended:"event_buffered_shift_ended_mutation_response",
		delete_event_buffered_shift_ended_by_pk:"event_buffered_shift_ended",
		delete_event_buffered_shift_started:"event_buffered_shift_started_mutation_response",
		delete_event_buffered_shift_started_by_pk:"event_buffered_shift_started",
		delete_event_by_pk:"event",
		delete_event_cost_object_created:"event_cost_object_created_mutation_response",
		delete_event_cost_object_created_by_pk:"event_cost_object_created",
		delete_event_cost_object_deleted:"event_cost_object_deleted_mutation_response",
		delete_event_cost_object_deleted_by_pk:"event_cost_object_deleted",
		delete_event_cost_object_reactivated:"event_cost_object_reactivated_mutation_response",
		delete_event_cost_object_reactivated_by_pk:"event_cost_object_reactivated",
		delete_event_cost_object_updated:"event_cost_object_updated_mutation_response",
		delete_event_cost_object_updated_by_pk:"event_cost_object_updated",
		delete_event_derived_shift_deleted:"event_derived_shift_deleted_mutation_response",
		delete_event_derived_shift_deleted_by_pk:"event_derived_shift_deleted",
		delete_event_derived_shift_updated:"event_derived_shift_updated_mutation_response",
		delete_event_derived_shift_updated_by_pk:"event_derived_shift_updated",
		delete_event_note_created:"event_note_created_mutation_response",
		delete_event_note_created_by_pk:"event_note_created",
		delete_event_note_deleted:"event_note_deleted_mutation_response",
		delete_event_note_deleted_by_pk:"event_note_deleted",
		delete_event_note_updated:"event_note_updated_mutation_response",
		delete_event_note_updated_by_pk:"event_note_updated",
		delete_event_recurring_shift_exception_created:"event_recurring_shift_exception_created_mutation_response",
		delete_event_recurring_shift_exception_created_by_pk:"event_recurring_shift_exception_created",
		delete_event_shift_created:"event_shift_created_mutation_response",
		delete_event_shift_created_by_pk:"event_shift_created",
		delete_event_shift_deleted:"event_shift_deleted_mutation_response",
		delete_event_shift_deleted_by_pk:"event_shift_deleted",
		delete_event_shift_ended:"event_shift_ended_mutation_response",
		delete_event_shift_ended_by_pk:"event_shift_ended",
		delete_event_shift_started:"event_shift_started_mutation_response",
		delete_event_shift_started_by_pk:"event_shift_started",
		delete_event_shift_updated:"event_shift_updated_mutation_response",
		delete_event_shift_updated_by_pk:"event_shift_updated",
		delete_event_team_created:"event_team_created_mutation_response",
		delete_event_team_created_by_pk:"event_team_created",
		delete_event_team_deleted:"event_team_deleted_mutation_response",
		delete_event_team_deleted_by_pk:"event_team_deleted",
		delete_event_team_reactivated:"event_team_reactivated_mutation_response",
		delete_event_team_reactivated_by_pk:"event_team_reactivated",
		delete_event_team_role_assignment_created:"event_team_role_assignment_created_mutation_response",
		delete_event_team_role_assignment_created_by_pk:"event_team_role_assignment_created",
		delete_event_team_role_assignment_deleted:"event_team_role_assignment_deleted_mutation_response",
		delete_event_team_role_assignment_deleted_by_pk:"event_team_role_assignment_deleted",
		delete_event_team_role_created:"event_team_role_created_mutation_response",
		delete_event_team_role_created_by_pk:"event_team_role_created",
		delete_event_team_role_deleted:"event_team_role_deleted_mutation_response",
		delete_event_team_role_deleted_by_pk:"event_team_role_deleted",
		delete_event_team_role_updated:"event_team_role_updated_mutation_response",
		delete_event_team_role_updated_by_pk:"event_team_role_updated",
		delete_event_team_updated:"event_team_updated_mutation_response",
		delete_event_team_updated_by_pk:"event_team_updated",
		delete_event_user_created:"event_user_created_mutation_response",
		delete_event_user_created_by_pk:"event_user_created",
		delete_event_user_deleted:"event_user_deleted_mutation_response",
		delete_event_user_deleted_by_pk:"event_user_deleted",
		delete_event_user_role_assignment_created:"event_user_role_assignment_created_mutation_response",
		delete_event_user_role_assignment_created_by_pk:"event_user_role_assignment_created",
		delete_event_user_role_assignment_deleted:"event_user_role_assignment_deleted_mutation_response",
		delete_event_user_role_assignment_deleted_by_pk:"event_user_role_assignment_deleted",
		delete_event_user_role_assignment_updated:"event_user_role_assignment_updated_mutation_response",
		delete_event_user_role_assignment_updated_by_pk:"event_user_role_assignment_updated",
		delete_event_user_updated:"event_user_updated_mutation_response",
		delete_event_user_updated_by_pk:"event_user_updated",
		delete_group:"group_mutation_response",
		delete_group_by_pk:"group",
		delete_group_membership:"group_membership_mutation_response",
		delete_group_membership_by_pk:"group_membership",
		delete_note:"note_mutation_response",
		delete_note_by_pk:"note",
		delete_permissions_shift_config:"permissions_shift_config_mutation_response",
		delete_permissions_shift_config_by_pk:"permissions_shift_config",
		delete_permissions_team_config:"permissions_team_config_mutation_response",
		delete_permissions_team_config_by_pk:"permissions_team_config",
		delete_permissions_team_role_config:"permissions_team_role_config_mutation_response",
		delete_permissions_team_role_config_by_pk:"permissions_team_role_config",
		delete_qualification:"qualification_mutation_response",
		delete_qualification_by_pk:"qualification",
		delete_recurring_shift_exception:"recurring_shift_exception_mutation_response",
		delete_recurring_shift_exception_by_pk:"recurring_shift_exception",
		delete_shift:"shift_mutation_response",
		delete_shift_by_pk:"shift",
		delete_team:"team_mutation_response",
		delete_team_by_pk:"team",
		delete_team_role:"team_role_mutation_response",
		delete_team_role_assignment:"team_role_assignment_mutation_response",
		delete_team_role_assignment_by_pk:"team_role_assignment",
		delete_team_role_by_pk:"team_role",
		delete_user:"user_mutation_response",
		delete_user_by_pk:"user",
		delete_user_notification:"user_notification_mutation_response",
		delete_user_notification_by_pk:"user_notification",
		delete_user_role_assignment:"user_role_assignment_mutation_response",
		delete_user_role_assignment_by_pk:"user_role_assignment",
		delete_user_shift_notification:"user_shift_notification_mutation_response",
		delete_user_shift_notification_by_pk:"user_shift_notification",
		delete_user_shift_notification_event:"user_shift_notification_event_mutation_response",
		delete_user_shift_notification_event_by_pk:"user_shift_notification_event",
		insert_active_shift:"active_shift_mutation_response",
		insert_active_shift_one:"active_shift",
		insert_cost_object:"cost_object_mutation_response",
		insert_cost_object_one:"cost_object",
		insert_event:"event_mutation_response",
		insert_event_buffered_shift_ended:"event_buffered_shift_ended_mutation_response",
		insert_event_buffered_shift_ended_one:"event_buffered_shift_ended",
		insert_event_buffered_shift_started:"event_buffered_shift_started_mutation_response",
		insert_event_buffered_shift_started_one:"event_buffered_shift_started",
		insert_event_cost_object_created:"event_cost_object_created_mutation_response",
		insert_event_cost_object_created_one:"event_cost_object_created",
		insert_event_cost_object_deleted:"event_cost_object_deleted_mutation_response",
		insert_event_cost_object_deleted_one:"event_cost_object_deleted",
		insert_event_cost_object_reactivated:"event_cost_object_reactivated_mutation_response",
		insert_event_cost_object_reactivated_one:"event_cost_object_reactivated",
		insert_event_cost_object_updated:"event_cost_object_updated_mutation_response",
		insert_event_cost_object_updated_one:"event_cost_object_updated",
		insert_event_derived_shift_deleted:"event_derived_shift_deleted_mutation_response",
		insert_event_derived_shift_deleted_one:"event_derived_shift_deleted",
		insert_event_derived_shift_updated:"event_derived_shift_updated_mutation_response",
		insert_event_derived_shift_updated_one:"event_derived_shift_updated",
		insert_event_note_created:"event_note_created_mutation_response",
		insert_event_note_created_one:"event_note_created",
		insert_event_note_deleted:"event_note_deleted_mutation_response",
		insert_event_note_deleted_one:"event_note_deleted",
		insert_event_note_updated:"event_note_updated_mutation_response",
		insert_event_note_updated_one:"event_note_updated",
		insert_event_one:"event",
		insert_event_recurring_shift_exception_created:"event_recurring_shift_exception_created_mutation_response",
		insert_event_recurring_shift_exception_created_one:"event_recurring_shift_exception_created",
		insert_event_shift_created:"event_shift_created_mutation_response",
		insert_event_shift_created_one:"event_shift_created",
		insert_event_shift_deleted:"event_shift_deleted_mutation_response",
		insert_event_shift_deleted_one:"event_shift_deleted",
		insert_event_shift_ended:"event_shift_ended_mutation_response",
		insert_event_shift_ended_one:"event_shift_ended",
		insert_event_shift_started:"event_shift_started_mutation_response",
		insert_event_shift_started_one:"event_shift_started",
		insert_event_shift_updated:"event_shift_updated_mutation_response",
		insert_event_shift_updated_one:"event_shift_updated",
		insert_event_team_created:"event_team_created_mutation_response",
		insert_event_team_created_one:"event_team_created",
		insert_event_team_deleted:"event_team_deleted_mutation_response",
		insert_event_team_deleted_one:"event_team_deleted",
		insert_event_team_reactivated:"event_team_reactivated_mutation_response",
		insert_event_team_reactivated_one:"event_team_reactivated",
		insert_event_team_role_assignment_created:"event_team_role_assignment_created_mutation_response",
		insert_event_team_role_assignment_created_one:"event_team_role_assignment_created",
		insert_event_team_role_assignment_deleted:"event_team_role_assignment_deleted_mutation_response",
		insert_event_team_role_assignment_deleted_one:"event_team_role_assignment_deleted",
		insert_event_team_role_created:"event_team_role_created_mutation_response",
		insert_event_team_role_created_one:"event_team_role_created",
		insert_event_team_role_deleted:"event_team_role_deleted_mutation_response",
		insert_event_team_role_deleted_one:"event_team_role_deleted",
		insert_event_team_role_updated:"event_team_role_updated_mutation_response",
		insert_event_team_role_updated_one:"event_team_role_updated",
		insert_event_team_updated:"event_team_updated_mutation_response",
		insert_event_team_updated_one:"event_team_updated",
		insert_event_user_created:"event_user_created_mutation_response",
		insert_event_user_created_one:"event_user_created",
		insert_event_user_deleted:"event_user_deleted_mutation_response",
		insert_event_user_deleted_one:"event_user_deleted",
		insert_event_user_role_assignment_created:"event_user_role_assignment_created_mutation_response",
		insert_event_user_role_assignment_created_one:"event_user_role_assignment_created",
		insert_event_user_role_assignment_deleted:"event_user_role_assignment_deleted_mutation_response",
		insert_event_user_role_assignment_deleted_one:"event_user_role_assignment_deleted",
		insert_event_user_role_assignment_updated:"event_user_role_assignment_updated_mutation_response",
		insert_event_user_role_assignment_updated_one:"event_user_role_assignment_updated",
		insert_event_user_updated:"event_user_updated_mutation_response",
		insert_event_user_updated_one:"event_user_updated",
		insert_group:"group_mutation_response",
		insert_group_membership:"group_membership_mutation_response",
		insert_group_membership_one:"group_membership",
		insert_group_one:"group",
		insert_note:"note_mutation_response",
		insert_note_one:"note",
		insert_permissions_shift_config:"permissions_shift_config_mutation_response",
		insert_permissions_shift_config_one:"permissions_shift_config",
		insert_permissions_team_config:"permissions_team_config_mutation_response",
		insert_permissions_team_config_one:"permissions_team_config",
		insert_permissions_team_role_config:"permissions_team_role_config_mutation_response",
		insert_permissions_team_role_config_one:"permissions_team_role_config",
		insert_qualification:"qualification_mutation_response",
		insert_qualification_one:"qualification",
		insert_recurring_shift_exception:"recurring_shift_exception_mutation_response",
		insert_recurring_shift_exception_one:"recurring_shift_exception",
		insert_shift:"shift_mutation_response",
		insert_shift_one:"shift",
		insert_team:"team_mutation_response",
		insert_team_one:"team",
		insert_team_role:"team_role_mutation_response",
		insert_team_role_assignment:"team_role_assignment_mutation_response",
		insert_team_role_assignment_one:"team_role_assignment",
		insert_team_role_one:"team_role",
		insert_user:"user_mutation_response",
		insert_user_notification:"user_notification_mutation_response",
		insert_user_notification_one:"user_notification",
		insert_user_one:"user",
		insert_user_role_assignment:"user_role_assignment_mutation_response",
		insert_user_role_assignment_one:"user_role_assignment",
		insert_user_shift_notification:"user_shift_notification_mutation_response",
		insert_user_shift_notification_event:"user_shift_notification_event_mutation_response",
		insert_user_shift_notification_event_one:"user_shift_notification_event",
		insert_user_shift_notification_one:"user_shift_notification",
		update_active_shift:"active_shift_mutation_response",
		update_active_shift_by_pk:"active_shift",
		update_active_shift_many:"active_shift_mutation_response",
		update_cost_object:"cost_object_mutation_response",
		update_cost_object_by_pk:"cost_object",
		update_cost_object_many:"cost_object_mutation_response",
		update_event:"event_mutation_response",
		update_event_buffered_shift_ended:"event_buffered_shift_ended_mutation_response",
		update_event_buffered_shift_ended_by_pk:"event_buffered_shift_ended",
		update_event_buffered_shift_ended_many:"event_buffered_shift_ended_mutation_response",
		update_event_buffered_shift_started:"event_buffered_shift_started_mutation_response",
		update_event_buffered_shift_started_by_pk:"event_buffered_shift_started",
		update_event_buffered_shift_started_many:"event_buffered_shift_started_mutation_response",
		update_event_by_pk:"event",
		update_event_cost_object_created:"event_cost_object_created_mutation_response",
		update_event_cost_object_created_by_pk:"event_cost_object_created",
		update_event_cost_object_created_many:"event_cost_object_created_mutation_response",
		update_event_cost_object_deleted:"event_cost_object_deleted_mutation_response",
		update_event_cost_object_deleted_by_pk:"event_cost_object_deleted",
		update_event_cost_object_deleted_many:"event_cost_object_deleted_mutation_response",
		update_event_cost_object_reactivated:"event_cost_object_reactivated_mutation_response",
		update_event_cost_object_reactivated_by_pk:"event_cost_object_reactivated",
		update_event_cost_object_reactivated_many:"event_cost_object_reactivated_mutation_response",
		update_event_cost_object_updated:"event_cost_object_updated_mutation_response",
		update_event_cost_object_updated_by_pk:"event_cost_object_updated",
		update_event_cost_object_updated_many:"event_cost_object_updated_mutation_response",
		update_event_derived_shift_deleted:"event_derived_shift_deleted_mutation_response",
		update_event_derived_shift_deleted_by_pk:"event_derived_shift_deleted",
		update_event_derived_shift_deleted_many:"event_derived_shift_deleted_mutation_response",
		update_event_derived_shift_updated:"event_derived_shift_updated_mutation_response",
		update_event_derived_shift_updated_by_pk:"event_derived_shift_updated",
		update_event_derived_shift_updated_many:"event_derived_shift_updated_mutation_response",
		update_event_many:"event_mutation_response",
		update_event_note_created:"event_note_created_mutation_response",
		update_event_note_created_by_pk:"event_note_created",
		update_event_note_created_many:"event_note_created_mutation_response",
		update_event_note_deleted:"event_note_deleted_mutation_response",
		update_event_note_deleted_by_pk:"event_note_deleted",
		update_event_note_deleted_many:"event_note_deleted_mutation_response",
		update_event_note_updated:"event_note_updated_mutation_response",
		update_event_note_updated_by_pk:"event_note_updated",
		update_event_note_updated_many:"event_note_updated_mutation_response",
		update_event_recurring_shift_exception_created:"event_recurring_shift_exception_created_mutation_response",
		update_event_recurring_shift_exception_created_by_pk:"event_recurring_shift_exception_created",
		update_event_recurring_shift_exception_created_many:"event_recurring_shift_exception_created_mutation_response",
		update_event_shift_created:"event_shift_created_mutation_response",
		update_event_shift_created_by_pk:"event_shift_created",
		update_event_shift_created_many:"event_shift_created_mutation_response",
		update_event_shift_deleted:"event_shift_deleted_mutation_response",
		update_event_shift_deleted_by_pk:"event_shift_deleted",
		update_event_shift_deleted_many:"event_shift_deleted_mutation_response",
		update_event_shift_ended:"event_shift_ended_mutation_response",
		update_event_shift_ended_by_pk:"event_shift_ended",
		update_event_shift_ended_many:"event_shift_ended_mutation_response",
		update_event_shift_started:"event_shift_started_mutation_response",
		update_event_shift_started_by_pk:"event_shift_started",
		update_event_shift_started_many:"event_shift_started_mutation_response",
		update_event_shift_updated:"event_shift_updated_mutation_response",
		update_event_shift_updated_by_pk:"event_shift_updated",
		update_event_shift_updated_many:"event_shift_updated_mutation_response",
		update_event_team_created:"event_team_created_mutation_response",
		update_event_team_created_by_pk:"event_team_created",
		update_event_team_created_many:"event_team_created_mutation_response",
		update_event_team_deleted:"event_team_deleted_mutation_response",
		update_event_team_deleted_by_pk:"event_team_deleted",
		update_event_team_deleted_many:"event_team_deleted_mutation_response",
		update_event_team_reactivated:"event_team_reactivated_mutation_response",
		update_event_team_reactivated_by_pk:"event_team_reactivated",
		update_event_team_reactivated_many:"event_team_reactivated_mutation_response",
		update_event_team_role_assignment_created:"event_team_role_assignment_created_mutation_response",
		update_event_team_role_assignment_created_by_pk:"event_team_role_assignment_created",
		update_event_team_role_assignment_created_many:"event_team_role_assignment_created_mutation_response",
		update_event_team_role_assignment_deleted:"event_team_role_assignment_deleted_mutation_response",
		update_event_team_role_assignment_deleted_by_pk:"event_team_role_assignment_deleted",
		update_event_team_role_assignment_deleted_many:"event_team_role_assignment_deleted_mutation_response",
		update_event_team_role_created:"event_team_role_created_mutation_response",
		update_event_team_role_created_by_pk:"event_team_role_created",
		update_event_team_role_created_many:"event_team_role_created_mutation_response",
		update_event_team_role_deleted:"event_team_role_deleted_mutation_response",
		update_event_team_role_deleted_by_pk:"event_team_role_deleted",
		update_event_team_role_deleted_many:"event_team_role_deleted_mutation_response",
		update_event_team_role_updated:"event_team_role_updated_mutation_response",
		update_event_team_role_updated_by_pk:"event_team_role_updated",
		update_event_team_role_updated_many:"event_team_role_updated_mutation_response",
		update_event_team_updated:"event_team_updated_mutation_response",
		update_event_team_updated_by_pk:"event_team_updated",
		update_event_team_updated_many:"event_team_updated_mutation_response",
		update_event_user_created:"event_user_created_mutation_response",
		update_event_user_created_by_pk:"event_user_created",
		update_event_user_created_many:"event_user_created_mutation_response",
		update_event_user_deleted:"event_user_deleted_mutation_response",
		update_event_user_deleted_by_pk:"event_user_deleted",
		update_event_user_deleted_many:"event_user_deleted_mutation_response",
		update_event_user_role_assignment_created:"event_user_role_assignment_created_mutation_response",
		update_event_user_role_assignment_created_by_pk:"event_user_role_assignment_created",
		update_event_user_role_assignment_created_many:"event_user_role_assignment_created_mutation_response",
		update_event_user_role_assignment_deleted:"event_user_role_assignment_deleted_mutation_response",
		update_event_user_role_assignment_deleted_by_pk:"event_user_role_assignment_deleted",
		update_event_user_role_assignment_deleted_many:"event_user_role_assignment_deleted_mutation_response",
		update_event_user_role_assignment_updated:"event_user_role_assignment_updated_mutation_response",
		update_event_user_role_assignment_updated_by_pk:"event_user_role_assignment_updated",
		update_event_user_role_assignment_updated_many:"event_user_role_assignment_updated_mutation_response",
		update_event_user_updated:"event_user_updated_mutation_response",
		update_event_user_updated_by_pk:"event_user_updated",
		update_event_user_updated_many:"event_user_updated_mutation_response",
		update_group:"group_mutation_response",
		update_group_by_pk:"group",
		update_group_many:"group_mutation_response",
		update_group_membership:"group_membership_mutation_response",
		update_group_membership_by_pk:"group_membership",
		update_group_membership_many:"group_membership_mutation_response",
		update_note:"note_mutation_response",
		update_note_by_pk:"note",
		update_note_many:"note_mutation_response",
		update_permissions_shift_config:"permissions_shift_config_mutation_response",
		update_permissions_shift_config_by_pk:"permissions_shift_config",
		update_permissions_shift_config_many:"permissions_shift_config_mutation_response",
		update_permissions_team_config:"permissions_team_config_mutation_response",
		update_permissions_team_config_by_pk:"permissions_team_config",
		update_permissions_team_config_many:"permissions_team_config_mutation_response",
		update_permissions_team_role_config:"permissions_team_role_config_mutation_response",
		update_permissions_team_role_config_by_pk:"permissions_team_role_config",
		update_permissions_team_role_config_many:"permissions_team_role_config_mutation_response",
		update_qualification:"qualification_mutation_response",
		update_qualification_by_pk:"qualification",
		update_qualification_many:"qualification_mutation_response",
		update_recurring_shift_exception:"recurring_shift_exception_mutation_response",
		update_recurring_shift_exception_by_pk:"recurring_shift_exception",
		update_recurring_shift_exception_many:"recurring_shift_exception_mutation_response",
		update_shift:"shift_mutation_response",
		update_shift_by_pk:"shift",
		update_shift_many:"shift_mutation_response",
		update_team:"team_mutation_response",
		update_team_by_pk:"team",
		update_team_many:"team_mutation_response",
		update_team_role:"team_role_mutation_response",
		update_team_role_assignment:"team_role_assignment_mutation_response",
		update_team_role_assignment_by_pk:"team_role_assignment",
		update_team_role_assignment_many:"team_role_assignment_mutation_response",
		update_team_role_by_pk:"team_role",
		update_team_role_many:"team_role_mutation_response",
		update_user:"user_mutation_response",
		update_user_by_pk:"user",
		update_user_many:"user_mutation_response",
		update_user_notification:"user_notification_mutation_response",
		update_user_notification_by_pk:"user_notification",
		update_user_notification_many:"user_notification_mutation_response",
		update_user_role_assignment:"user_role_assignment_mutation_response",
		update_user_role_assignment_by_pk:"user_role_assignment",
		update_user_role_assignment_many:"user_role_assignment_mutation_response",
		update_user_shift_notification:"user_shift_notification_mutation_response",
		update_user_shift_notification_by_pk:"user_shift_notification",
		update_user_shift_notification_event:"user_shift_notification_event_mutation_response",
		update_user_shift_notification_event_by_pk:"user_shift_notification_event",
		update_user_shift_notification_event_many:"user_shift_notification_event_mutation_response",
		update_user_shift_notification_many:"user_shift_notification_mutation_response"
	},
	note:{
		content:"jsonb",
		created_at:"timestamptz",
		date:"date",
		event_note_created:"event_note_created",
		event_note_deleted:"event_note_deleted",
		event_note_deleted_aggregate:"event_note_deleted_aggregate",
		event_note_updated:"event_note_updated",
		event_note_updated_aggregate:"event_note_updated_aggregate",
		id:"uuid",
		object_id:"uuid",
		record_status:"record_status_t",
		shift:"shift",
		updated_at:"timestamptz",
		user:"user",
		user_id:"uuid"
	},
	note_aggregate:{
		aggregate:"note_aggregate_fields",
		nodes:"note"
	},
	note_aggregate_fields:{
		count:"Int",
		max:"note_max_fields",
		min:"note_min_fields"
	},
	note_max_fields:{
		created_at:"timestamptz",
		date:"date",
		id:"uuid",
		object_id:"uuid",
		record_status:"record_status_t",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	note_min_fields:{
		created_at:"timestamptz",
		date:"date",
		id:"uuid",
		object_id:"uuid",
		record_status:"record_status_t",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	note_mutation_response:{
		affected_rows:"Int",
		returning:"note"
	},
	notification_status_t: `scalar.notification_status_t` as const,
	notification_type_t: `scalar.notification_type_t` as const,
	permissions_shift:{
		action:"String",
		external_id:"String",
		target_entity:"String",
		target_entity_id:"uuid",
		team_role_assignment_id:"uuid"
	},
	permissions_shift_aggregate:{
		aggregate:"permissions_shift_aggregate_fields",
		nodes:"permissions_shift"
	},
	permissions_shift_aggregate_fields:{
		count:"Int",
		max:"permissions_shift_max_fields",
		min:"permissions_shift_min_fields"
	},
	permissions_shift_config:{
		action:"String",
		id:"uuid",
		is_power_user:"Boolean",
		team_role:"team_role",
		team_role_id:"uuid",
		team_type:"String"
	},
	permissions_shift_config_aggregate:{
		aggregate:"permissions_shift_config_aggregate_fields",
		nodes:"permissions_shift_config"
	},
	permissions_shift_config_aggregate_fields:{
		count:"Int",
		max:"permissions_shift_config_max_fields",
		min:"permissions_shift_config_min_fields"
	},
	permissions_shift_config_max_fields:{
		action:"String",
		id:"uuid",
		team_role_id:"uuid",
		team_type:"String"
	},
	permissions_shift_config_min_fields:{
		action:"String",
		id:"uuid",
		team_role_id:"uuid",
		team_type:"String"
	},
	permissions_shift_config_mutation_response:{
		affected_rows:"Int",
		returning:"permissions_shift_config"
	},
	permissions_shift_max_fields:{
		action:"String",
		external_id:"String",
		target_entity:"String",
		target_entity_id:"uuid",
		team_role_assignment_id:"uuid"
	},
	permissions_shift_min_fields:{
		action:"String",
		external_id:"String",
		target_entity:"String",
		target_entity_id:"uuid",
		team_role_assignment_id:"uuid"
	},
	permissions_team:{
		action:"String",
		external_id:"String",
		is_power_user:"Boolean",
		target_entity:"String",
		target_entity_id:"uuid",
		team_type:"String"
	},
	permissions_team_aggregate:{
		aggregate:"permissions_team_aggregate_fields",
		nodes:"permissions_team"
	},
	permissions_team_aggregate_fields:{
		count:"Int",
		max:"permissions_team_max_fields",
		min:"permissions_team_min_fields"
	},
	permissions_team_config:{
		action:"String",
		id:"uuid",
		is_power_user:"Boolean",
		team_role:"team_role",
		team_role_id:"uuid",
		team_type:"String"
	},
	permissions_team_config_aggregate:{
		aggregate:"permissions_team_config_aggregate_fields",
		nodes:"permissions_team_config"
	},
	permissions_team_config_aggregate_fields:{
		count:"Int",
		max:"permissions_team_config_max_fields",
		min:"permissions_team_config_min_fields"
	},
	permissions_team_config_max_fields:{
		action:"String",
		id:"uuid",
		team_role_id:"uuid",
		team_type:"String"
	},
	permissions_team_config_min_fields:{
		action:"String",
		id:"uuid",
		team_role_id:"uuid",
		team_type:"String"
	},
	permissions_team_config_mutation_response:{
		affected_rows:"Int",
		returning:"permissions_team_config"
	},
	permissions_team_max_fields:{
		action:"String",
		external_id:"String",
		target_entity:"String",
		target_entity_id:"uuid",
		team_type:"String"
	},
	permissions_team_min_fields:{
		action:"String",
		external_id:"String",
		target_entity:"String",
		target_entity_id:"uuid",
		team_type:"String"
	},
	permissions_team_role:{
		action:"String",
		external_id:"String",
		is_power_user:"Boolean",
		target_team_role_id:"uuid",
		team_id:"uuid"
	},
	permissions_team_role_aggregate:{
		aggregate:"permissions_team_role_aggregate_fields",
		nodes:"permissions_team_role"
	},
	permissions_team_role_aggregate_fields:{
		count:"Int",
		max:"permissions_team_role_max_fields",
		min:"permissions_team_role_min_fields"
	},
	permissions_team_role_assignment:{
		action:"String",
		external_id:"String",
		target_entity:"String",
		target_entity_id:"uuid",
		team_id:"uuid",
		team_role_id:"uuid"
	},
	permissions_team_role_assignment_aggregate:{
		aggregate:"permissions_team_role_assignment_aggregate_fields",
		nodes:"permissions_team_role_assignment"
	},
	permissions_team_role_assignment_aggregate_fields:{
		count:"Int",
		max:"permissions_team_role_assignment_max_fields",
		min:"permissions_team_role_assignment_min_fields"
	},
	permissions_team_role_assignment_max_fields:{
		action:"String",
		external_id:"String",
		target_entity:"String",
		target_entity_id:"uuid",
		team_id:"uuid",
		team_role_id:"uuid"
	},
	permissions_team_role_assignment_min_fields:{
		action:"String",
		external_id:"String",
		target_entity:"String",
		target_entity_id:"uuid",
		team_id:"uuid",
		team_role_id:"uuid"
	},
	permissions_team_role_config:{
		action:"String",
		id:"uuid",
		is_power_user:"Boolean",
		target_team_role_id:"uuid",
		teamRoleByTeamRoleId:"team_role",
		team_role:"team_role",
		team_role_id:"uuid",
		team_type:"String"
	},
	permissions_team_role_config_aggregate:{
		aggregate:"permissions_team_role_config_aggregate_fields",
		nodes:"permissions_team_role_config"
	},
	permissions_team_role_config_aggregate_fields:{
		count:"Int",
		max:"permissions_team_role_config_max_fields",
		min:"permissions_team_role_config_min_fields"
	},
	permissions_team_role_config_max_fields:{
		action:"String",
		id:"uuid",
		target_team_role_id:"uuid",
		team_role_id:"uuid",
		team_type:"String"
	},
	permissions_team_role_config_min_fields:{
		action:"String",
		id:"uuid",
		target_team_role_id:"uuid",
		team_role_id:"uuid",
		team_type:"String"
	},
	permissions_team_role_config_mutation_response:{
		affected_rows:"Int",
		returning:"permissions_team_role_config"
	},
	permissions_team_role_max_fields:{
		action:"String",
		external_id:"String",
		target_team_role_id:"uuid",
		team_id:"uuid"
	},
	permissions_team_role_min_fields:{
		action:"String",
		external_id:"String",
		target_team_role_id:"uuid",
		team_id:"uuid"
	},
	permissions_user_role_assignment:{
		action:"String",
		external_id:"String",
		target_entity:"String",
		target_entity_id:"uuid",
		team_role_assignment_id:"uuid"
	},
	permissions_user_role_assignment_aggregate:{
		aggregate:"permissions_user_role_assignment_aggregate_fields",
		nodes:"permissions_user_role_assignment"
	},
	permissions_user_role_assignment_aggregate_fields:{
		count:"Int",
		max:"permissions_user_role_assignment_max_fields",
		min:"permissions_user_role_assignment_min_fields"
	},
	permissions_user_role_assignment_max_fields:{
		action:"String",
		external_id:"String",
		target_entity:"String",
		target_entity_id:"uuid",
		team_role_assignment_id:"uuid"
	},
	permissions_user_role_assignment_min_fields:{
		action:"String",
		external_id:"String",
		target_entity:"String",
		target_entity_id:"uuid",
		team_role_assignment_id:"uuid"
	},
	qualification:{
		abbrev:"String",
		group:"group",
		group_id:"uuid",
		id:"uuid",
		name:"String",
		qualification_id:"String"
	},
	qualification_aggregate:{
		aggregate:"qualification_aggregate_fields",
		nodes:"qualification"
	},
	qualification_aggregate_fields:{
		count:"Int",
		max:"qualification_max_fields",
		min:"qualification_min_fields"
	},
	qualification_max_fields:{
		abbrev:"String",
		group_id:"uuid",
		id:"uuid",
		name:"String",
		qualification_id:"String"
	},
	qualification_min_fields:{
		abbrev:"String",
		group_id:"uuid",
		id:"uuid",
		name:"String",
		qualification_id:"String"
	},
	qualification_mutation_response:{
		affected_rows:"Int",
		returning:"qualification"
	},
	query_root:{
		active_shift:"active_shift",
		active_shift_aggregate:"active_shift_aggregate",
		active_shift_by_pk:"active_shift",
		cost_object:"cost_object",
		cost_object_aggregate:"cost_object_aggregate",
		cost_object_by_pk:"cost_object",
		event:"event",
		event_aggregate:"event_aggregate",
		event_buffered_shift_ended:"event_buffered_shift_ended",
		event_buffered_shift_ended_aggregate:"event_buffered_shift_ended_aggregate",
		event_buffered_shift_ended_by_pk:"event_buffered_shift_ended",
		event_buffered_shift_started:"event_buffered_shift_started",
		event_buffered_shift_started_aggregate:"event_buffered_shift_started_aggregate",
		event_buffered_shift_started_by_pk:"event_buffered_shift_started",
		event_by_pk:"event",
		event_cost_object_created:"event_cost_object_created",
		event_cost_object_created_aggregate:"event_cost_object_created_aggregate",
		event_cost_object_created_by_pk:"event_cost_object_created",
		event_cost_object_deleted:"event_cost_object_deleted",
		event_cost_object_deleted_aggregate:"event_cost_object_deleted_aggregate",
		event_cost_object_deleted_by_pk:"event_cost_object_deleted",
		event_cost_object_reactivated:"event_cost_object_reactivated",
		event_cost_object_reactivated_aggregate:"event_cost_object_reactivated_aggregate",
		event_cost_object_reactivated_by_pk:"event_cost_object_reactivated",
		event_cost_object_updated:"event_cost_object_updated",
		event_cost_object_updated_aggregate:"event_cost_object_updated_aggregate",
		event_cost_object_updated_by_pk:"event_cost_object_updated",
		event_derived_shift_deleted:"event_derived_shift_deleted",
		event_derived_shift_deleted_aggregate:"event_derived_shift_deleted_aggregate",
		event_derived_shift_deleted_by_pk:"event_derived_shift_deleted",
		event_derived_shift_updated:"event_derived_shift_updated",
		event_derived_shift_updated_aggregate:"event_derived_shift_updated_aggregate",
		event_derived_shift_updated_by_pk:"event_derived_shift_updated",
		event_note_created:"event_note_created",
		event_note_created_aggregate:"event_note_created_aggregate",
		event_note_created_by_pk:"event_note_created",
		event_note_deleted:"event_note_deleted",
		event_note_deleted_aggregate:"event_note_deleted_aggregate",
		event_note_deleted_by_pk:"event_note_deleted",
		event_note_updated:"event_note_updated",
		event_note_updated_aggregate:"event_note_updated_aggregate",
		event_note_updated_by_pk:"event_note_updated",
		event_recurring_shift_exception_created:"event_recurring_shift_exception_created",
		event_recurring_shift_exception_created_aggregate:"event_recurring_shift_exception_created_aggregate",
		event_recurring_shift_exception_created_by_pk:"event_recurring_shift_exception_created",
		event_shift_created:"event_shift_created",
		event_shift_created_aggregate:"event_shift_created_aggregate",
		event_shift_created_by_pk:"event_shift_created",
		event_shift_deleted:"event_shift_deleted",
		event_shift_deleted_aggregate:"event_shift_deleted_aggregate",
		event_shift_deleted_by_pk:"event_shift_deleted",
		event_shift_ended:"event_shift_ended",
		event_shift_ended_aggregate:"event_shift_ended_aggregate",
		event_shift_ended_by_pk:"event_shift_ended",
		event_shift_started:"event_shift_started",
		event_shift_started_aggregate:"event_shift_started_aggregate",
		event_shift_started_by_pk:"event_shift_started",
		event_shift_updated:"event_shift_updated",
		event_shift_updated_aggregate:"event_shift_updated_aggregate",
		event_shift_updated_by_pk:"event_shift_updated",
		event_team_created:"event_team_created",
		event_team_created_aggregate:"event_team_created_aggregate",
		event_team_created_by_pk:"event_team_created",
		event_team_deleted:"event_team_deleted",
		event_team_deleted_aggregate:"event_team_deleted_aggregate",
		event_team_deleted_by_pk:"event_team_deleted",
		event_team_reactivated:"event_team_reactivated",
		event_team_reactivated_aggregate:"event_team_reactivated_aggregate",
		event_team_reactivated_by_pk:"event_team_reactivated",
		event_team_role_assignment_created:"event_team_role_assignment_created",
		event_team_role_assignment_created_aggregate:"event_team_role_assignment_created_aggregate",
		event_team_role_assignment_created_by_pk:"event_team_role_assignment_created",
		event_team_role_assignment_deleted:"event_team_role_assignment_deleted",
		event_team_role_assignment_deleted_aggregate:"event_team_role_assignment_deleted_aggregate",
		event_team_role_assignment_deleted_by_pk:"event_team_role_assignment_deleted",
		event_team_role_created:"event_team_role_created",
		event_team_role_created_aggregate:"event_team_role_created_aggregate",
		event_team_role_created_by_pk:"event_team_role_created",
		event_team_role_deleted:"event_team_role_deleted",
		event_team_role_deleted_aggregate:"event_team_role_deleted_aggregate",
		event_team_role_deleted_by_pk:"event_team_role_deleted",
		event_team_role_updated:"event_team_role_updated",
		event_team_role_updated_aggregate:"event_team_role_updated_aggregate",
		event_team_role_updated_by_pk:"event_team_role_updated",
		event_team_updated:"event_team_updated",
		event_team_updated_aggregate:"event_team_updated_aggregate",
		event_team_updated_by_pk:"event_team_updated",
		event_user_created:"event_user_created",
		event_user_created_aggregate:"event_user_created_aggregate",
		event_user_created_by_pk:"event_user_created",
		event_user_deleted:"event_user_deleted",
		event_user_deleted_aggregate:"event_user_deleted_aggregate",
		event_user_deleted_by_pk:"event_user_deleted",
		event_user_role_assignment_created:"event_user_role_assignment_created",
		event_user_role_assignment_created_aggregate:"event_user_role_assignment_created_aggregate",
		event_user_role_assignment_created_by_pk:"event_user_role_assignment_created",
		event_user_role_assignment_deleted:"event_user_role_assignment_deleted",
		event_user_role_assignment_deleted_aggregate:"event_user_role_assignment_deleted_aggregate",
		event_user_role_assignment_deleted_by_pk:"event_user_role_assignment_deleted",
		event_user_role_assignment_updated:"event_user_role_assignment_updated",
		event_user_role_assignment_updated_aggregate:"event_user_role_assignment_updated_aggregate",
		event_user_role_assignment_updated_by_pk:"event_user_role_assignment_updated",
		event_user_updated:"event_user_updated",
		event_user_updated_aggregate:"event_user_updated_aggregate",
		event_user_updated_by_pk:"event_user_updated",
		group:"group",
		group_aggregate:"group_aggregate",
		group_by_pk:"group",
		group_membership:"group_membership",
		group_membership_aggregate:"group_membership_aggregate",
		group_membership_by_pk:"group_membership",
		note:"note",
		note_aggregate:"note_aggregate",
		note_by_pk:"note",
		permissions_shift:"permissions_shift",
		permissions_shift_aggregate:"permissions_shift_aggregate",
		permissions_shift_config:"permissions_shift_config",
		permissions_shift_config_aggregate:"permissions_shift_config_aggregate",
		permissions_shift_config_by_pk:"permissions_shift_config",
		permissions_team:"permissions_team",
		permissions_team_aggregate:"permissions_team_aggregate",
		permissions_team_config:"permissions_team_config",
		permissions_team_config_aggregate:"permissions_team_config_aggregate",
		permissions_team_config_by_pk:"permissions_team_config",
		permissions_team_role:"permissions_team_role",
		permissions_team_role_aggregate:"permissions_team_role_aggregate",
		permissions_team_role_assignment:"permissions_team_role_assignment",
		permissions_team_role_assignment_aggregate:"permissions_team_role_assignment_aggregate",
		permissions_team_role_config:"permissions_team_role_config",
		permissions_team_role_config_aggregate:"permissions_team_role_config_aggregate",
		permissions_team_role_config_by_pk:"permissions_team_role_config",
		permissions_user_role_assignment:"permissions_user_role_assignment",
		permissions_user_role_assignment_aggregate:"permissions_user_role_assignment_aggregate",
		qualification:"qualification",
		qualification_aggregate:"qualification_aggregate",
		qualification_by_pk:"qualification",
		queryShiftClashReport:"UserShiftClashReport",
		queryShiftEvent:"ShiftEvent",
		queryTeamRoster:"TeamRoster",
		queryTeamRosterAudit:"QueryRosterResponse",
		queryUserFatigueReport:"UserFatigueViolationReport",
		recurring_shift_exception:"recurring_shift_exception",
		recurring_shift_exception_aggregate:"recurring_shift_exception_aggregate",
		recurring_shift_exception_by_pk:"recurring_shift_exception",
		search_user:"user",
		search_user_aggregate:"user_aggregate",
		sendUserFeedback:"SendEmailResponse",
		shift:"shift",
		shift_aggregate:"shift_aggregate",
		shift_by_pk:"shift",
		shift_related_note:"shift_related_note",
		shift_related_note_aggregate:"shift_related_note_aggregate",
		team:"team",
		team_aggregate:"team_aggregate",
		team_by_pk:"team",
		team_role:"team_role",
		team_role_aggregate:"team_role_aggregate",
		team_role_assignment:"team_role_assignment",
		team_role_assignment_aggregate:"team_role_assignment_aggregate",
		team_role_assignment_by_pk:"team_role_assignment",
		team_role_by_pk:"team_role",
		user:"user",
		user_aggregate:"user_aggregate",
		user_by_pk:"user",
		user_notification:"user_notification",
		user_notification_aggregate:"user_notification_aggregate",
		user_notification_by_pk:"user_notification",
		user_role_assignment:"user_role_assignment",
		user_role_assignment_aggregate:"user_role_assignment_aggregate",
		user_role_assignment_by_pk:"user_role_assignment",
		user_shift_notification:"user_shift_notification",
		user_shift_notification_aggregate:"user_shift_notification_aggregate",
		user_shift_notification_by_pk:"user_shift_notification",
		user_shift_notification_event:"user_shift_notification_event",
		user_shift_notification_event_aggregate:"user_shift_notification_event_aggregate",
		user_shift_notification_event_by_pk:"user_shift_notification_event"
	},
	record_status_t: `scalar.record_status_t` as const,
	recurring_shift_exception:{
		exception_date:"timestamptz",
		id:"uuid",
		shift:"shift",
		shift_id:"uuid"
	},
	recurring_shift_exception_aggregate:{
		aggregate:"recurring_shift_exception_aggregate_fields",
		nodes:"recurring_shift_exception"
	},
	recurring_shift_exception_aggregate_fields:{
		count:"Int",
		max:"recurring_shift_exception_max_fields",
		min:"recurring_shift_exception_min_fields"
	},
	recurring_shift_exception_max_fields:{
		exception_date:"timestamptz",
		id:"uuid",
		shift_id:"uuid"
	},
	recurring_shift_exception_min_fields:{
		exception_date:"timestamptz",
		id:"uuid",
		shift_id:"uuid"
	},
	recurring_shift_exception_mutation_response:{
		affected_rows:"Int",
		returning:"recurring_shift_exception"
	},
	role_group_t: `scalar.role_group_t` as const,
	shift:{
		active_shift:"active_shift",
		active_shifts:"active_shift",
		active_shifts_aggregate:"active_shift_aggregate",
		created_at:"timestamptz",
		end_time:"timestamptz",
		event_buffered_shift_ended:"event_buffered_shift_ended",
		event_buffered_shift_ended_aggregate:"event_buffered_shift_ended_aggregate",
		event_buffered_shift_started:"event_buffered_shift_started",
		event_buffered_shift_started_aggregate:"event_buffered_shift_started_aggregate",
		event_derived_shift_deleted:"event_derived_shift_deleted",
		event_derived_shift_deleted_aggregate:"event_derived_shift_deleted_aggregate",
		event_derived_shift_updated:"event_derived_shift_updated",
		event_derived_shift_updated_recurring_shift:"event_derived_shift_updated",
		event_derived_shift_updated_recurring_shift_aggregate:"event_derived_shift_updated_aggregate",
		event_recurring_shift_exception_created:"event_recurring_shift_exception_created",
		event_recurring_shift_exception_created_aggregate:"event_recurring_shift_exception_created_aggregate",
		event_shift_created:"event_shift_created",
		event_shift_deleted:"event_shift_deleted",
		event_shift_deleted_aggregate:"event_shift_deleted_aggregate",
		event_shift_ended:"event_shift_ended",
		event_shift_ended_aggregate:"event_shift_ended_aggregate",
		event_shift_started:"event_shift_started",
		event_shift_started_aggregate:"event_shift_started_aggregate",
		event_shift_updated:"event_shift_updated",
		event_shift_updated_aggregate:"event_shift_updated_aggregate",
		id:"uuid",
		is_recurring:"Boolean",
		note:"note",
		note_aggregate:"note_aggregate",
		record_status:"record_status_t",
		recurrence_end_date:"timestamptz",
		recurrence_pattern:"String",
		recurring_shift_exceptions:"recurring_shift_exception",
		recurring_shift_exceptions_aggregate:"recurring_shift_exception_aggregate",
		related_notes:"shift_related_note",
		related_notes_aggregate:"shift_related_note_aggregate",
		root_id:"uuid",
		root_shift:"shift",
		shift_status:"String",
		start_time:"timestamptz",
		team_role_assignment:"team_role_assignment",
		team_role_assignment_id:"uuid",
		updated_at:"timestamptz",
		user_role_assignment:"user_role_assignment",
		user_role_assignment_id:"uuid"
	},
	shift_aggregate:{
		aggregate:"shift_aggregate_fields",
		nodes:"shift"
	},
	shift_aggregate_fields:{
		count:"Int",
		max:"shift_max_fields",
		min:"shift_min_fields"
	},
	shift_max_fields:{
		created_at:"timestamptz",
		end_time:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		recurrence_end_date:"timestamptz",
		recurrence_pattern:"String",
		root_id:"uuid",
		shift_status:"String",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		updated_at:"timestamptz",
		user_role_assignment_id:"uuid"
	},
	shift_min_fields:{
		created_at:"timestamptz",
		end_time:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		recurrence_end_date:"timestamptz",
		recurrence_pattern:"String",
		root_id:"uuid",
		shift_status:"String",
		start_time:"timestamptz",
		team_role_assignment_id:"uuid",
		updated_at:"timestamptz",
		user_role_assignment_id:"uuid"
	},
	shift_mutation_response:{
		affected_rows:"Int",
		returning:"shift"
	},
	shift_related_note:{
		content:"String",
		date:"date",
		metadata:"jsonb",
		note:"note",
		note_created_at:"timestamptz",
		note_id:"uuid",
		object_id:"uuid",
		shift_created_at:"timestamptz",
		shift_id:"uuid"
	},
	shift_related_note_aggregate:{
		aggregate:"shift_related_note_aggregate_fields",
		nodes:"shift_related_note"
	},
	shift_related_note_aggregate_fields:{
		count:"Int",
		max:"shift_related_note_max_fields",
		min:"shift_related_note_min_fields"
	},
	shift_related_note_max_fields:{
		content:"String",
		date:"date",
		note_created_at:"timestamptz",
		note_id:"uuid",
		object_id:"uuid",
		shift_created_at:"timestamptz",
		shift_id:"uuid"
	},
	shift_related_note_min_fields:{
		content:"String",
		date:"date",
		note_created_at:"timestamptz",
		note_id:"uuid",
		object_id:"uuid",
		shift_created_at:"timestamptz",
		shift_id:"uuid"
	},
	shift_type_t: `scalar.shift_type_t` as const,
	subscription_root:{
		active_shift:"active_shift",
		active_shift_aggregate:"active_shift_aggregate",
		active_shift_by_pk:"active_shift",
		active_shift_stream:"active_shift",
		cost_object:"cost_object",
		cost_object_aggregate:"cost_object_aggregate",
		cost_object_by_pk:"cost_object",
		cost_object_stream:"cost_object",
		event:"event",
		event_aggregate:"event_aggregate",
		event_buffered_shift_ended:"event_buffered_shift_ended",
		event_buffered_shift_ended_aggregate:"event_buffered_shift_ended_aggregate",
		event_buffered_shift_ended_by_pk:"event_buffered_shift_ended",
		event_buffered_shift_ended_stream:"event_buffered_shift_ended",
		event_buffered_shift_started:"event_buffered_shift_started",
		event_buffered_shift_started_aggregate:"event_buffered_shift_started_aggregate",
		event_buffered_shift_started_by_pk:"event_buffered_shift_started",
		event_buffered_shift_started_stream:"event_buffered_shift_started",
		event_by_pk:"event",
		event_cost_object_created:"event_cost_object_created",
		event_cost_object_created_aggregate:"event_cost_object_created_aggregate",
		event_cost_object_created_by_pk:"event_cost_object_created",
		event_cost_object_created_stream:"event_cost_object_created",
		event_cost_object_deleted:"event_cost_object_deleted",
		event_cost_object_deleted_aggregate:"event_cost_object_deleted_aggregate",
		event_cost_object_deleted_by_pk:"event_cost_object_deleted",
		event_cost_object_deleted_stream:"event_cost_object_deleted",
		event_cost_object_reactivated:"event_cost_object_reactivated",
		event_cost_object_reactivated_aggregate:"event_cost_object_reactivated_aggregate",
		event_cost_object_reactivated_by_pk:"event_cost_object_reactivated",
		event_cost_object_reactivated_stream:"event_cost_object_reactivated",
		event_cost_object_updated:"event_cost_object_updated",
		event_cost_object_updated_aggregate:"event_cost_object_updated_aggregate",
		event_cost_object_updated_by_pk:"event_cost_object_updated",
		event_cost_object_updated_stream:"event_cost_object_updated",
		event_derived_shift_deleted:"event_derived_shift_deleted",
		event_derived_shift_deleted_aggregate:"event_derived_shift_deleted_aggregate",
		event_derived_shift_deleted_by_pk:"event_derived_shift_deleted",
		event_derived_shift_deleted_stream:"event_derived_shift_deleted",
		event_derived_shift_updated:"event_derived_shift_updated",
		event_derived_shift_updated_aggregate:"event_derived_shift_updated_aggregate",
		event_derived_shift_updated_by_pk:"event_derived_shift_updated",
		event_derived_shift_updated_stream:"event_derived_shift_updated",
		event_note_created:"event_note_created",
		event_note_created_aggregate:"event_note_created_aggregate",
		event_note_created_by_pk:"event_note_created",
		event_note_created_stream:"event_note_created",
		event_note_deleted:"event_note_deleted",
		event_note_deleted_aggregate:"event_note_deleted_aggregate",
		event_note_deleted_by_pk:"event_note_deleted",
		event_note_deleted_stream:"event_note_deleted",
		event_note_updated:"event_note_updated",
		event_note_updated_aggregate:"event_note_updated_aggregate",
		event_note_updated_by_pk:"event_note_updated",
		event_note_updated_stream:"event_note_updated",
		event_recurring_shift_exception_created:"event_recurring_shift_exception_created",
		event_recurring_shift_exception_created_aggregate:"event_recurring_shift_exception_created_aggregate",
		event_recurring_shift_exception_created_by_pk:"event_recurring_shift_exception_created",
		event_recurring_shift_exception_created_stream:"event_recurring_shift_exception_created",
		event_shift_created:"event_shift_created",
		event_shift_created_aggregate:"event_shift_created_aggregate",
		event_shift_created_by_pk:"event_shift_created",
		event_shift_created_stream:"event_shift_created",
		event_shift_deleted:"event_shift_deleted",
		event_shift_deleted_aggregate:"event_shift_deleted_aggregate",
		event_shift_deleted_by_pk:"event_shift_deleted",
		event_shift_deleted_stream:"event_shift_deleted",
		event_shift_ended:"event_shift_ended",
		event_shift_ended_aggregate:"event_shift_ended_aggregate",
		event_shift_ended_by_pk:"event_shift_ended",
		event_shift_ended_stream:"event_shift_ended",
		event_shift_started:"event_shift_started",
		event_shift_started_aggregate:"event_shift_started_aggregate",
		event_shift_started_by_pk:"event_shift_started",
		event_shift_started_stream:"event_shift_started",
		event_shift_updated:"event_shift_updated",
		event_shift_updated_aggregate:"event_shift_updated_aggregate",
		event_shift_updated_by_pk:"event_shift_updated",
		event_shift_updated_stream:"event_shift_updated",
		event_stream:"event",
		event_team_created:"event_team_created",
		event_team_created_aggregate:"event_team_created_aggregate",
		event_team_created_by_pk:"event_team_created",
		event_team_created_stream:"event_team_created",
		event_team_deleted:"event_team_deleted",
		event_team_deleted_aggregate:"event_team_deleted_aggregate",
		event_team_deleted_by_pk:"event_team_deleted",
		event_team_deleted_stream:"event_team_deleted",
		event_team_reactivated:"event_team_reactivated",
		event_team_reactivated_aggregate:"event_team_reactivated_aggregate",
		event_team_reactivated_by_pk:"event_team_reactivated",
		event_team_reactivated_stream:"event_team_reactivated",
		event_team_role_assignment_created:"event_team_role_assignment_created",
		event_team_role_assignment_created_aggregate:"event_team_role_assignment_created_aggregate",
		event_team_role_assignment_created_by_pk:"event_team_role_assignment_created",
		event_team_role_assignment_created_stream:"event_team_role_assignment_created",
		event_team_role_assignment_deleted:"event_team_role_assignment_deleted",
		event_team_role_assignment_deleted_aggregate:"event_team_role_assignment_deleted_aggregate",
		event_team_role_assignment_deleted_by_pk:"event_team_role_assignment_deleted",
		event_team_role_assignment_deleted_stream:"event_team_role_assignment_deleted",
		event_team_role_created:"event_team_role_created",
		event_team_role_created_aggregate:"event_team_role_created_aggregate",
		event_team_role_created_by_pk:"event_team_role_created",
		event_team_role_created_stream:"event_team_role_created",
		event_team_role_deleted:"event_team_role_deleted",
		event_team_role_deleted_aggregate:"event_team_role_deleted_aggregate",
		event_team_role_deleted_by_pk:"event_team_role_deleted",
		event_team_role_deleted_stream:"event_team_role_deleted",
		event_team_role_updated:"event_team_role_updated",
		event_team_role_updated_aggregate:"event_team_role_updated_aggregate",
		event_team_role_updated_by_pk:"event_team_role_updated",
		event_team_role_updated_stream:"event_team_role_updated",
		event_team_updated:"event_team_updated",
		event_team_updated_aggregate:"event_team_updated_aggregate",
		event_team_updated_by_pk:"event_team_updated",
		event_team_updated_stream:"event_team_updated",
		event_user_created:"event_user_created",
		event_user_created_aggregate:"event_user_created_aggregate",
		event_user_created_by_pk:"event_user_created",
		event_user_created_stream:"event_user_created",
		event_user_deleted:"event_user_deleted",
		event_user_deleted_aggregate:"event_user_deleted_aggregate",
		event_user_deleted_by_pk:"event_user_deleted",
		event_user_deleted_stream:"event_user_deleted",
		event_user_role_assignment_created:"event_user_role_assignment_created",
		event_user_role_assignment_created_aggregate:"event_user_role_assignment_created_aggregate",
		event_user_role_assignment_created_by_pk:"event_user_role_assignment_created",
		event_user_role_assignment_created_stream:"event_user_role_assignment_created",
		event_user_role_assignment_deleted:"event_user_role_assignment_deleted",
		event_user_role_assignment_deleted_aggregate:"event_user_role_assignment_deleted_aggregate",
		event_user_role_assignment_deleted_by_pk:"event_user_role_assignment_deleted",
		event_user_role_assignment_deleted_stream:"event_user_role_assignment_deleted",
		event_user_role_assignment_updated:"event_user_role_assignment_updated",
		event_user_role_assignment_updated_aggregate:"event_user_role_assignment_updated_aggregate",
		event_user_role_assignment_updated_by_pk:"event_user_role_assignment_updated",
		event_user_role_assignment_updated_stream:"event_user_role_assignment_updated",
		event_user_updated:"event_user_updated",
		event_user_updated_aggregate:"event_user_updated_aggregate",
		event_user_updated_by_pk:"event_user_updated",
		event_user_updated_stream:"event_user_updated",
		group:"group",
		group_aggregate:"group_aggregate",
		group_by_pk:"group",
		group_membership:"group_membership",
		group_membership_aggregate:"group_membership_aggregate",
		group_membership_by_pk:"group_membership",
		group_membership_stream:"group_membership",
		group_stream:"group",
		note:"note",
		note_aggregate:"note_aggregate",
		note_by_pk:"note",
		note_stream:"note",
		permissions_shift:"permissions_shift",
		permissions_shift_aggregate:"permissions_shift_aggregate",
		permissions_shift_config:"permissions_shift_config",
		permissions_shift_config_aggregate:"permissions_shift_config_aggregate",
		permissions_shift_config_by_pk:"permissions_shift_config",
		permissions_shift_config_stream:"permissions_shift_config",
		permissions_shift_stream:"permissions_shift",
		permissions_team:"permissions_team",
		permissions_team_aggregate:"permissions_team_aggregate",
		permissions_team_config:"permissions_team_config",
		permissions_team_config_aggregate:"permissions_team_config_aggregate",
		permissions_team_config_by_pk:"permissions_team_config",
		permissions_team_config_stream:"permissions_team_config",
		permissions_team_role:"permissions_team_role",
		permissions_team_role_aggregate:"permissions_team_role_aggregate",
		permissions_team_role_assignment:"permissions_team_role_assignment",
		permissions_team_role_assignment_aggregate:"permissions_team_role_assignment_aggregate",
		permissions_team_role_assignment_stream:"permissions_team_role_assignment",
		permissions_team_role_config:"permissions_team_role_config",
		permissions_team_role_config_aggregate:"permissions_team_role_config_aggregate",
		permissions_team_role_config_by_pk:"permissions_team_role_config",
		permissions_team_role_config_stream:"permissions_team_role_config",
		permissions_team_role_stream:"permissions_team_role",
		permissions_team_stream:"permissions_team",
		permissions_user_role_assignment:"permissions_user_role_assignment",
		permissions_user_role_assignment_aggregate:"permissions_user_role_assignment_aggregate",
		permissions_user_role_assignment_stream:"permissions_user_role_assignment",
		qualification:"qualification",
		qualification_aggregate:"qualification_aggregate",
		qualification_by_pk:"qualification",
		qualification_stream:"qualification",
		recurring_shift_exception:"recurring_shift_exception",
		recurring_shift_exception_aggregate:"recurring_shift_exception_aggregate",
		recurring_shift_exception_by_pk:"recurring_shift_exception",
		recurring_shift_exception_stream:"recurring_shift_exception",
		search_user:"user",
		search_user_aggregate:"user_aggregate",
		shift:"shift",
		shift_aggregate:"shift_aggregate",
		shift_by_pk:"shift",
		shift_related_note:"shift_related_note",
		shift_related_note_aggregate:"shift_related_note_aggregate",
		shift_related_note_stream:"shift_related_note",
		shift_stream:"shift",
		team:"team",
		team_aggregate:"team_aggregate",
		team_by_pk:"team",
		team_role:"team_role",
		team_role_aggregate:"team_role_aggregate",
		team_role_assignment:"team_role_assignment",
		team_role_assignment_aggregate:"team_role_assignment_aggregate",
		team_role_assignment_by_pk:"team_role_assignment",
		team_role_assignment_stream:"team_role_assignment",
		team_role_by_pk:"team_role",
		team_role_stream:"team_role",
		team_stream:"team",
		user:"user",
		user_aggregate:"user_aggregate",
		user_by_pk:"user",
		user_notification:"user_notification",
		user_notification_aggregate:"user_notification_aggregate",
		user_notification_by_pk:"user_notification",
		user_notification_stream:"user_notification",
		user_role_assignment:"user_role_assignment",
		user_role_assignment_aggregate:"user_role_assignment_aggregate",
		user_role_assignment_by_pk:"user_role_assignment",
		user_role_assignment_stream:"user_role_assignment",
		user_shift_notification:"user_shift_notification",
		user_shift_notification_aggregate:"user_shift_notification_aggregate",
		user_shift_notification_by_pk:"user_shift_notification",
		user_shift_notification_event:"user_shift_notification_event",
		user_shift_notification_event_aggregate:"user_shift_notification_event_aggregate",
		user_shift_notification_event_by_pk:"user_shift_notification_event",
		user_shift_notification_event_stream:"user_shift_notification_event",
		user_shift_notification_stream:"user_shift_notification",
		user_stream:"user"
	},
	team:{
		cost_object:"cost_object",
		created_at:"timestamptz",
		event_team_deleted:"event_team_deleted",
		event_team_deleted_aggregate:"event_team_deleted_aggregate",
		event_team_reactivated:"event_team_reactivated",
		event_team_reactivated_aggregate:"event_team_reactivated_aggregate",
		event_team_updated:"event_team_updated",
		event_team_updated_aggregate:"event_team_updated_aggregate",
		events:"event",
		events_aggregate:"event_aggregate",
		id:"uuid",
		internal_order_number:"String",
		name:"String",
		record_status:"record_status_t",
		team_role_assignments:"team_role_assignment",
		team_role_assignments_aggregate:"team_role_assignment_aggregate",
		team_settings:"jsonb",
		team_type:"String",
		updated_at:"timestamptz"
	},
	team_aggregate:{
		aggregate:"team_aggregate_fields",
		nodes:"team"
	},
	team_aggregate_fields:{
		count:"Int",
		max:"team_max_fields",
		min:"team_min_fields"
	},
	team_max_fields:{
		created_at:"timestamptz",
		id:"uuid",
		internal_order_number:"String",
		name:"String",
		record_status:"record_status_t",
		team_type:"String",
		updated_at:"timestamptz"
	},
	team_min_fields:{
		created_at:"timestamptz",
		id:"uuid",
		internal_order_number:"String",
		name:"String",
		record_status:"record_status_t",
		team_type:"String",
		updated_at:"timestamptz"
	},
	team_mutation_response:{
		affected_rows:"Int",
		returning:"team"
	},
	team_role:{
		abbreviation:"String",
		created_at:"timestamptz",
		event_team_role_deleted:"event_team_role_deleted",
		event_team_role_deleted_aggregate:"event_team_role_deleted_aggregate",
		event_team_role_updated:"event_team_role_updated",
		event_team_role_updated_aggregate:"event_team_role_updated_aggregate",
		id:"uuid",
		name:"String",
		permissionsTeamRoleConfigsByTeamRoleId:"permissions_team_role_config",
		permissionsTeamRoleConfigsByTeamRoleId_aggregate:"permissions_team_role_config_aggregate",
		permissions_shift_configs:"permissions_shift_config",
		permissions_shift_configs_aggregate:"permissions_shift_config_aggregate",
		permissions_team_configs:"permissions_team_config",
		permissions_team_configs_aggregate:"permissions_team_config_aggregate",
		permissions_team_role:"permissions_team_role",
		permissions_team_role_aggregate:"permissions_team_role_aggregate",
		permissions_team_role_configs:"permissions_team_role_config",
		permissions_team_role_configs_aggregate:"permissions_team_role_config_aggregate",
		read_only:"Boolean",
		record_status:"record_status_t",
		role_group:"role_group_t",
		team_role_assignment:"team_role_assignment",
		team_role_assignment_aggregate:"team_role_assignment_aggregate",
		updated_at:"timestamptz"
	},
	team_role_aggregate:{
		aggregate:"team_role_aggregate_fields",
		nodes:"team_role"
	},
	team_role_aggregate_fields:{
		count:"Int",
		max:"team_role_max_fields",
		min:"team_role_min_fields"
	},
	team_role_assignment:{
		created_at:"timestamptz",
		event_shift_updated:"event_shift_updated",
		event_shift_updated_aggregate:"event_shift_updated_aggregate",
		event_team_role_assignment_created:"event_team_role_assignment_created",
		event_team_role_assignment_created_aggregate:"event_team_role_assignment_created_aggregate",
		event_team_role_assignment_deleted:"event_team_role_assignment_deleted",
		event_team_role_assignment_deleted_aggregate:"event_team_role_assignment_deleted_aggregate",
		event_user_role_assignment_created:"event_user_role_assignment_created",
		event_user_role_assignment_created_aggregate:"event_user_role_assignment_created_aggregate",
		event_user_role_assignment_updated:"event_user_role_assignment_updated",
		event_user_role_assignment_updated_aggregate:"event_user_role_assignment_updated_aggregate",
		id:"uuid",
		record_status:"record_status_t",
		shifts:"shift",
		shifts_aggregate:"shift_aggregate",
		team:"team",
		team_id:"uuid",
		team_role:"team_role",
		team_role_id:"uuid",
		updated_at:"timestamptz",
		user_role_assignments:"user_role_assignment",
		user_role_assignments_aggregate:"user_role_assignment_aggregate"
	},
	team_role_assignment_aggregate:{
		aggregate:"team_role_assignment_aggregate_fields",
		nodes:"team_role_assignment"
	},
	team_role_assignment_aggregate_fields:{
		count:"Int",
		max:"team_role_assignment_max_fields",
		min:"team_role_assignment_min_fields"
	},
	team_role_assignment_max_fields:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		team_id:"uuid",
		team_role_id:"uuid",
		updated_at:"timestamptz"
	},
	team_role_assignment_min_fields:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		team_id:"uuid",
		team_role_id:"uuid",
		updated_at:"timestamptz"
	},
	team_role_assignment_mutation_response:{
		affected_rows:"Int",
		returning:"team_role_assignment"
	},
	team_role_max_fields:{
		abbreviation:"String",
		created_at:"timestamptz",
		id:"uuid",
		name:"String",
		record_status:"record_status_t",
		role_group:"role_group_t",
		updated_at:"timestamptz"
	},
	team_role_min_fields:{
		abbreviation:"String",
		created_at:"timestamptz",
		id:"uuid",
		name:"String",
		record_status:"record_status_t",
		role_group:"role_group_t",
		updated_at:"timestamptz"
	},
	team_role_mutation_response:{
		affected_rows:"Int",
		returning:"team_role"
	},
	timestamptz: `scalar.timestamptz` as const,
	user:{
		calendar_id:"uuid",
		created_at:"timestamptz",
		display_name:"String",
		email_address:"String",
		event_shift_updated:"event_shift_updated",
		event_shift_updated_aggregate:"event_shift_updated_aggregate",
		event_user_role_assignment_created:"event_user_role_assignment_created",
		event_user_role_assignment_created_aggregate:"event_user_role_assignment_created_aggregate",
		events:"event",
		events_aggregate:"event_aggregate",
		events_created_by_user:"event",
		events_created_by_user_aggregate:"event_aggregate",
		external_id:"String",
		first_name:"String",
		group_membership:"group_membership",
		group_membership_aggregate:"group_membership_aggregate",
		id:"uuid",
		last_name:"String",
		manager_email:"String",
		notes:"note",
		notes_aggregate:"note_aggregate",
		phone_number:"String",
		private_calendar_id:"uuid",
		record_status:"record_status_t",
		updated_at:"timestamptz",
		user_name:"String",
		user_role_assignments:"user_role_assignment",
		user_role_assignments_aggregate:"user_role_assignment_aggregate",
		user_type:"String"
	},
	user_aggregate:{
		aggregate:"user_aggregate_fields",
		nodes:"user"
	},
	user_aggregate_fields:{
		count:"Int",
		max:"user_max_fields",
		min:"user_min_fields"
	},
	user_max_fields:{
		calendar_id:"uuid",
		created_at:"timestamptz",
		display_name:"String",
		email_address:"String",
		external_id:"String",
		first_name:"String",
		id:"uuid",
		last_name:"String",
		manager_email:"String",
		phone_number:"String",
		private_calendar_id:"uuid",
		record_status:"record_status_t",
		updated_at:"timestamptz",
		user_name:"String",
		user_type:"String"
	},
	user_min_fields:{
		calendar_id:"uuid",
		created_at:"timestamptz",
		display_name:"String",
		email_address:"String",
		external_id:"String",
		first_name:"String",
		id:"uuid",
		last_name:"String",
		manager_email:"String",
		phone_number:"String",
		private_calendar_id:"uuid",
		record_status:"record_status_t",
		updated_at:"timestamptz",
		user_name:"String",
		user_type:"String"
	},
	user_mutation_response:{
		affected_rows:"Int",
		returning:"user"
	},
	user_notification:{
		created_at:"timestamptz",
		error_message:"String",
		event:"event",
		event_id:"Int",
		id:"uuid",
		status:"notification_status_t",
		updated_at:"timestamptz"
	},
	user_notification_aggregate:{
		aggregate:"user_notification_aggregate_fields",
		nodes:"user_notification"
	},
	user_notification_aggregate_fields:{
		avg:"user_notification_avg_fields",
		count:"Int",
		max:"user_notification_max_fields",
		min:"user_notification_min_fields",
		stddev:"user_notification_stddev_fields",
		stddev_pop:"user_notification_stddev_pop_fields",
		stddev_samp:"user_notification_stddev_samp_fields",
		sum:"user_notification_sum_fields",
		var_pop:"user_notification_var_pop_fields",
		var_samp:"user_notification_var_samp_fields",
		variance:"user_notification_variance_fields"
	},
	user_notification_avg_fields:{
		event_id:"Float"
	},
	user_notification_max_fields:{
		created_at:"timestamptz",
		error_message:"String",
		event_id:"Int",
		id:"uuid",
		status:"notification_status_t",
		updated_at:"timestamptz"
	},
	user_notification_min_fields:{
		created_at:"timestamptz",
		error_message:"String",
		event_id:"Int",
		id:"uuid",
		status:"notification_status_t",
		updated_at:"timestamptz"
	},
	user_notification_mutation_response:{
		affected_rows:"Int",
		returning:"user_notification"
	},
	user_notification_stddev_fields:{
		event_id:"Float"
	},
	user_notification_stddev_pop_fields:{
		event_id:"Float"
	},
	user_notification_stddev_samp_fields:{
		event_id:"Float"
	},
	user_notification_sum_fields:{
		event_id:"Int"
	},
	user_notification_var_pop_fields:{
		event_id:"Float"
	},
	user_notification_var_samp_fields:{
		event_id:"Float"
	},
	user_notification_variance_fields:{
		event_id:"Float"
	},
	user_role_assignment:{
		created_at:"timestamptz",
		event_shift_created:"event_shift_created",
		event_shift_created_aggregate:"event_shift_created_aggregate",
		event_user_role_assignment_created:"event_user_role_assignment_created",
		event_user_role_assignment_created_aggregate:"event_user_role_assignment_created_aggregate",
		event_user_role_assignment_deleted:"event_user_role_assignment_deleted",
		event_user_role_assignment_deleted_aggregate:"event_user_role_assignment_deleted_aggregate",
		event_user_role_assignment_updated:"event_user_role_assignment_updated",
		event_user_role_assignment_updated_aggregate:"event_user_role_assignment_updated_aggregate",
		id:"uuid",
		record_status:"record_status_t",
		shifts:"shift",
		shifts_aggregate:"shift_aggregate",
		team_role_assignment:"team_role_assignment",
		team_role_assignment_id:"uuid",
		updated_at:"timestamptz",
		user:"user",
		user_id:"uuid"
	},
	user_role_assignment_aggregate:{
		aggregate:"user_role_assignment_aggregate_fields",
		nodes:"user_role_assignment"
	},
	user_role_assignment_aggregate_fields:{
		count:"Int",
		max:"user_role_assignment_max_fields",
		min:"user_role_assignment_min_fields"
	},
	user_role_assignment_max_fields:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		team_role_assignment_id:"uuid",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	user_role_assignment_min_fields:{
		created_at:"timestamptz",
		id:"uuid",
		record_status:"record_status_t",
		team_role_assignment_id:"uuid",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	user_role_assignment_mutation_response:{
		affected_rows:"Int",
		returning:"user_role_assignment"
	},
	user_shift_notification:{
		created_at:"timestamptz",
		created_by:"uuid",
		end_time:"timestamptz",
		id:"uuid",
		is_recurring:"Boolean",
		message:"String",
		notification_events:"user_shift_notification_event",
		notification_events_aggregate:"user_shift_notification_event_aggregate",
		recurrence_end_date:"timestamptz",
		recurrence_pattern:"String",
		role_name:"String",
		shift:"shift",
		shift_id:"uuid",
		start_time:"timestamptz",
		status:"notification_status_t",
		team_name:"String",
		type:"notification_type_t",
		updated_at:"timestamptz",
		user:"user",
		user_created_by:"user",
		user_id:"uuid"
	},
	user_shift_notification_aggregate:{
		aggregate:"user_shift_notification_aggregate_fields",
		nodes:"user_shift_notification"
	},
	user_shift_notification_aggregate_fields:{
		count:"Int",
		max:"user_shift_notification_max_fields",
		min:"user_shift_notification_min_fields"
	},
	user_shift_notification_event:{
		event:"event",
		event_id:"Int",
		id:"uuid",
		notification:"user_shift_notification",
		notification_id:"uuid"
	},
	user_shift_notification_event_aggregate:{
		aggregate:"user_shift_notification_event_aggregate_fields",
		nodes:"user_shift_notification_event"
	},
	user_shift_notification_event_aggregate_fields:{
		avg:"user_shift_notification_event_avg_fields",
		count:"Int",
		max:"user_shift_notification_event_max_fields",
		min:"user_shift_notification_event_min_fields",
		stddev:"user_shift_notification_event_stddev_fields",
		stddev_pop:"user_shift_notification_event_stddev_pop_fields",
		stddev_samp:"user_shift_notification_event_stddev_samp_fields",
		sum:"user_shift_notification_event_sum_fields",
		var_pop:"user_shift_notification_event_var_pop_fields",
		var_samp:"user_shift_notification_event_var_samp_fields",
		variance:"user_shift_notification_event_variance_fields"
	},
	user_shift_notification_event_avg_fields:{
		event_id:"Float"
	},
	user_shift_notification_event_max_fields:{
		event_id:"Int",
		id:"uuid",
		notification_id:"uuid"
	},
	user_shift_notification_event_min_fields:{
		event_id:"Int",
		id:"uuid",
		notification_id:"uuid"
	},
	user_shift_notification_event_mutation_response:{
		affected_rows:"Int",
		returning:"user_shift_notification_event"
	},
	user_shift_notification_event_stddev_fields:{
		event_id:"Float"
	},
	user_shift_notification_event_stddev_pop_fields:{
		event_id:"Float"
	},
	user_shift_notification_event_stddev_samp_fields:{
		event_id:"Float"
	},
	user_shift_notification_event_sum_fields:{
		event_id:"Int"
	},
	user_shift_notification_event_var_pop_fields:{
		event_id:"Float"
	},
	user_shift_notification_event_var_samp_fields:{
		event_id:"Float"
	},
	user_shift_notification_event_variance_fields:{
		event_id:"Float"
	},
	user_shift_notification_max_fields:{
		created_at:"timestamptz",
		created_by:"uuid",
		end_time:"timestamptz",
		id:"uuid",
		message:"String",
		recurrence_end_date:"timestamptz",
		recurrence_pattern:"String",
		role_name:"String",
		shift_id:"uuid",
		start_time:"timestamptz",
		status:"notification_status_t",
		team_name:"String",
		type:"notification_type_t",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	user_shift_notification_min_fields:{
		created_at:"timestamptz",
		created_by:"uuid",
		end_time:"timestamptz",
		id:"uuid",
		message:"String",
		recurrence_end_date:"timestamptz",
		recurrence_pattern:"String",
		role_name:"String",
		shift_id:"uuid",
		start_time:"timestamptz",
		status:"notification_status_t",
		team_name:"String",
		type:"notification_type_t",
		updated_at:"timestamptz",
		user_id:"uuid"
	},
	user_shift_notification_mutation_response:{
		affected_rows:"Int",
		returning:"user_shift_notification"
	},
	uuid: `scalar.uuid` as const
}

export const Ops = {
query: "query_root" as const,
	mutation: "mutation_root" as const,
	subscription: "subscription_root" as const
}